export enum Employer {
  '12Technologies' = '12_TECHNOLOGIES',
  '3M' = '3M',
  AbbottLabs = 'ABBOTT_LABS',
  Acc = 'ACC',
  Accenture = 'ACCENTURE',
  AdvancedMicroDevices = 'ADVANCED_MICRO_DEVICES',
  Aisd = 'AISD',
  AlleganyBoardOfEducation = 'ALLEGANY_BOARD_OF_EDUCATION',
  AlisalSchoolDistrict = 'ALISAL_SCHOOL_DISTRICT',
  Amazon = 'AMAZON',
  Amd = 'AMD',
  AolTimeWarnerAustinCablevision = 'AOL_TIME_WARNER_AUSTIN_CABLEVISION',
  AppleComputers = 'APPLE_COMPUTERS',
  AppleInc = 'APPLE_INC',
  AppliedMaterials = 'APPLIED_MATERIALS',
  Ara = 'ARA',
  Arc = 'ARC',
  AscensionHealth = 'ASCENSION_HEALTH',
  ATT = 'AT&T',
  AttorneyGeneral = 'ATTORNEY_GENERAL',
  ATTWireless = 'ATT_WIRELESS',
  AustinCommunityCollege = 'AUSTIN_COMMUNITY_COLLEGE',
  AustinIndependentSchoolDistrict = 'AUSTIN_INDEPENDENT_SCHOOL_DISTRICT',
  AustinIsd = 'AUSTIN_ISD',
  AustinRadiologicalAssociation = 'AUSTIN_RADIOLOGICAL_ASSOCIATION',
  AustinRegionalClinic = 'AUSTIN_REGIONAL_CLINIC',
  AustinStateHospital = 'AUSTIN_STATE_HOSPITAL',
  BankOfAmerica = 'BANK_OF_AMERICA',
  BastropIsd = 'BASTROP_ISD',
  BeitzelCorporation = 'BEITZEL_CORPORATION',
  BernardusLodge = 'BERNARDUS_LODGE',
  Bisd = 'BISD',
  BrackenridgeHospital = 'BRACKENRIDGE_HOSPITAL',
  CalAmWater = 'CAL_AM_WATER',
  CalifDeptOfParksAndRec = 'CALIF_DEPT_OF_PARKS_AND_REC',
  CaliforniaDeptOfCorrections = 'CALIFORNIA_DEPT_OF_CORRECTIONS',
  CanterburyWoods = 'CANTERBURY_WOODS',
  CapitalMetro = 'CAPITAL_METRO',
  CarmelHillsCareCenter = 'CARMEL_HILLS_CARE_CENTER',
  CarmelRealtyCompany = 'CARMEL_REALTY_COMPANY',
  CarmelUnifiedSchoolDistrict = 'CARMEL_UNIFIED_SCHOOL_DISTRICT',
  CarmelValleyManor = 'CARMEL_VALLEY_MANOR',
  CarmelValleyRanch = 'CARMEL_VALLEY_RANCH',
  CenteneCorporation = 'CENTENE_CORPORATION',
  CharlesSchwab = 'CHARLES_SCHWAB',
  CharterCommunications = 'CHARTER_COMMUNICATIONS',
  Child = 'CHILD',
  CiscoSystems = 'CISCO_SYSTEMS',
  CityOfAustin = 'CITY_OF_AUSTIN',
  CityOfCarmel = 'CITY_OF_CARMEL',
  CityOfMonterey = 'CITY_OF_MONTEREY',
  CityOfPacificGrove = 'CITY_OF_PACIFIC_GROVE',
  CityOfSalinas = 'CITY_OF_SALINAS',
  CityOfSeaside = 'CITY_OF_SEASIDE',
  ClinicalPathologyLabratories = 'CLINICAL_PATHOLOGY_LABRATORIES',
  Cms = 'CMS',
  CSX = 'CSX',
  CommHospitalOfTheMontereyPeninsula = 'COMM_HOSPITAL_OF_THE_MONTEREY_PENINSULA',
  CommunityCare = 'COMMUNITY_CARE',
  CostcoSandCity = 'COSTCO_SAND_CITY',
  CostcoWholesale = 'COSTCO_WHOLESALE',
  CountyOfMonterey = 'COUNTY_OF_MONTEREY',
  CovenantManagementSystems = 'COVENANT_MANAGEMENT_SYSTEMS',
  Cpl = 'CPL',
  CSUMB = 'CSUMB',
  CVS = 'CVS',
  CvsPharmacy = 'CVS_PHARMACY',
  CypressHealthcarePartners = 'CYPRESS_HEALTHCARE_PARTNERS',
  CypressRidgeHealthCenter = 'CYPRESS_RIDGE_HEALTH_CENTER',
  DefenseLanguageInstitute = 'DEFENSE_LANGUAGE_INSTITUTE',
  DefenseManpowerDataCTRDOD = 'DEFENSE_MANPOWER_DATA_CTR_DOD',
  DellChildrensMedicalCenter = 'DELL_CHILDRENS_MEDICAL_CENTER',
  DellComputer = 'DELL_COMPUTER',
  DelValleIsd = 'DEL_VALLE_ISD',
  DepartmentOfHumanServices = 'DEPARTMENT_OF_HUMAN_SERVICES',
  DepartmentOfPublicSafety = 'DEPARTMENT_OF_PUBLIC_SAFETY',
  DepartmentOfVeteransAffairs = 'DEPARTMENT_OF_VETERANS_AFFAIRS',
  DeptOfVeteransAffairs = 'DEPT_OF_VETERANS_AFFAIRS',
  DioceseOfMonterey = 'DIOCESE_OF_MONTEREY',
  DoctorsOnDutyLighthouse = 'DOCTORS_ON_DUTY_LIGHTHOUSE',
  EanesIsd = 'EANES_ISD',
  EbayCom = 'EBAY_COM',
  EmersonProcessManagement = 'EMERSON_PROCESS_MANAGEMENT',
  Ercot = 'ERCOT',
  Facebook = 'FACEBOOK',
  FarmersInsuranceGroupInc = 'FARMERS_INSURANCE_GROUP_INC',
  FederalEmployees = 'FEDERAL_EMPLOYEES',
  FederalExpress = 'FEDERAL_EXPRESS',
  FederalGovernment = 'FEDERAL_GOVERNMENT',
  Fedex = 'FEDEX',
  FleetNumerical = 'FLEET_NUMERICAL',
  Flextronics = 'FLEXTRONICS',
  Freescale = 'FREESCALE',
  GarrettRegionalMedicalCenter = 'GARRETT_REGIONAL_MEDICAL_CENTER',
  GatewayCenterInc = 'GATEWAY_CENTER_INC',
  GeneralMotors = 'GENERAL_MOTORS',
  Gm = 'GM',
  GoodwillIndustries = 'GOODWILL_INDUSTRIES',
  Google = 'GOOGLE',
  GraniteConstruction = 'GRANITE_CONSTRUCTION',
  GraniteRock = 'GRANITE_ROCK',
  HartnellCollege = 'HARTNELL_COLLEGE',
  HaysCisd = 'HAYS_CISD',
  HaysConsolidatedIsd = 'HAYS_CONSOLIDATED_ISD',
  HaysIsd = 'HAYS_ISD',
  HcaHealthcare = 'HCA_HEALTHCARE',
  HealthAndHumanServicesCommission = 'HEALTH_AND_HUMAN_SERVICES_COMMISSION',
  Heb = 'HEB',
  HebGrocery = 'HEB_GROCERY',
  HewlettPackardCo = 'HEWLETT_PACKARD_CO',
  Hhs = 'HHS',
  HomeDepot = 'HOME_DEPOT',
  Homemakers = 'HOMEMAKERS',
  Hospira = 'HOSPIRA',
  HospitalCorporationOfAmerica = 'HOSPITAL_CORPORATION_OF_AMERICA',
  Hp = 'HP',
  HuttoIsd = 'HUTTO_ISD',
  HyattCarmelHighlandsInn = 'HYATT_CARMEL_HIGHLANDS_INN',
  HyattRegencyHotel = 'HYATT_REGENCY_HOTEL',
  HyattRegencyMonterey = 'HYATT_REGENCY_MONTEREY',
  IBMCorporation = 'IBM_CORPORATION',
  Indeed = 'INDEED',
  InHomeSupportiveServicesIHSS = 'IN_HOME_SUPPORTIVE_SERVICES_IHSS',
  Insperity = 'INSPERITY',
  IntelCorp = 'INTEL_CORP',
  InterimInc = 'INTERIM_INC',
  InternalRevenueService = 'INTERNAL_REVENUE_SERVICE',
  IRS = 'IRS',
  JpMorganChase = 'JP_MORGAN_CHASE',
  LakeTravisIsd = 'LAKE_TRAVIS_ISD',
  LanguageLine = 'LANGUAGE_LINE',
  Lcra = 'LCRA',
  LeanderIsd = 'LEANDER_ISD',
  LowerColoradoRiverAuthority = 'LOWER_COLORADO_RIVER_AUTHORITY',
  Lowes = 'LOWES',
  Luckys = 'LUCKYS',
  MacysMonterey = 'MACYS_MONTEREY',
  ManorIsd = 'MANOR_ISD',
  MarriotMonterey = 'MARRIOTT_MONTEREY',
  Maximus = 'MAXIMUS',
  McDonalds = 'MCDONALDS',
  MiddleburyInstituteOfIntlStudy = 'MIDDLEBURY_INSTITUTE_OF_INTL_STUDY',
  MonGeneralHospital = 'MON_GENERAL_HOSPITAL',
  MontageHealth = 'MONTAGE_HEALTH',
  MontageMedicalGroupMMG = 'MONTAGE_MEDICAL_GROUP_MMG',
  MontereyBayAquarium = 'MONTEREY_BAY_AQUARIUM',
  MontereyCountyHealthDept = 'MONTEREY_COUNTY_HEALTH_DEPT',
  MontereyCountyOfficeOfEducation = 'MONTEREY_COUNTY_OFFICE_OF_EDUCATION',
  MontereyCountySheriffDept = 'MONTEREY_COUNTY_SHERIFF_DEPT',
  MontereyCountySocialServices = 'MONTEREY_COUNTY_SOCIAL_SERVICES',
  MontereyPeninsulaCollege = 'MONTEREY_PENINSULA_COLLEGE',
  MontereyPeninsulaCountryClub = 'MONTEREY_PENINSULA_COUNTRY_CLUB',
  MontereyPeninsulaSurgeryCenter = 'MONTEREY_PENINSULA_SURGERY_CENTER',
  MontereyPeninsulaUSD = 'MONTEREY_PENINSULA_USD',
  MontereyPlazaHotel = 'MONTEREY_PLAZA_HOTEL',
  MontereySalinasTransit = 'MONTEREY_SALINAS_TRANSIT',
  Motorola = 'MOTOROLA',
  MountainLaurelMedicalCenter = 'MOUNTAIN_LAUREL_MEDICAL_CENTER',
  NationalInstruments = 'NATIONAL_INSTRUMENTS',
  NatividadHospital = 'NATIVIDAD_HOSPITAL',
  NavalPostgraduateSchool = 'NAVAL_POSTGRADUATE_SCHOOL',
  NorthCountySchool = 'NORTH_COUNTY_SCHOOL',
  NorthropGrumman = 'NORTHROP_GRUMMAN',
  NotBeingUsedAtThisTime = 'NOT_BEING_USED_AT_THIS_TIME',
  NPGSCivilian = 'NPGS_CIVILIAN',
  NxpSemiconductors = 'NXP_SEMICONDUCTORS',
  OracleCorporation = 'ORACLE_CORPORATION',
  Other = 'OTHER',
  PacificGasAndElectric = 'PACIFIC_GAS_AND_ELECTRIC',
  PacificGroveUnifiedSchoolDistrict = 'PACIFIC_GROVE_UNIFIED_SCHOOL_DISTRICT',
  PajaroSchoolDistrict = 'PAJARO_SCHOOL_DISTRICT',
  PebbleBeachCommunitySrvcs = 'PEBBLE_BEACH_COMMUNITY_SRVCS',
  PebbleBeachCompany = 'PEBBLE_BEACH_COMPANY',
  PflugervilleIsd = 'PFLUGERVILLE_ISD',
  PortolaPlazaHotel = 'PORTOLA_PLAZA_HOTEL',
  PostRanchInn = 'POST_RANCH_INN',
  PresidioCivilian = 'PRESIDIO_CIVILIAN',
  ProgressiveInsurance = 'PROGRESSIVE_INSURANCE',
  ProjectConcordiaUniversity = 'PROJECT_CONCORDIA_UNIVERSITY',
  QuailLodge = 'QUAIL_LODGE',
  RoundRockIsd = 'ROUND_ROCK_ISD',
  Rrisd = 'RRISD',
  Safeway = 'SAFEWAY',
  SalinasElemSchoolDistrict = 'SALINAS_ELEM_SCHOOL_DISTRICT',
  SalinasHighSchoolDistrict = 'SALINAS_HIGH_SCHOOL_DISTRICT',
  SalinasValleyMemorialHospital = 'SALINAS_VALLEY_MEMORIAL_HOSPITAL',
  SalinasValleyStatePrison = 'SALINAS_VALLEY_STATE_PRISON',
  Samsung = 'SAMSUNG',
  SantaCatalinaSchool = 'SANTA_CATALINA_SCHOOL',
  SantaLuciaPreserve = 'SANTA_LUCIA_PRESERVE',
  SantaRitaSchoolDistrict = 'SANTA_RITA_SCHOOL_DISTRICT',
  SetonHealthcareNetwork = 'SETON_HEALTHCARE_NETWORK',
  SetonMedicalCenter = 'SETON_MEDICAL_CENTER',
  SetonNetwork = 'SETON_NETWORK',
  SetonNorthwestHospital = 'SETON_NORTHWEST_HOSPITAL',
  SocialSecurityOfficeSalinas = 'SOCIAL_SECURITY_OFFICE_SALINAS',
  SoledadPrisonCTF = 'SOLEDAD_PRISON_CTF',
  SoledadUnifiedSchooldDistrict = 'SOLEDAD_UNIFIED_SCHOOL_DISTRICT',
  Spansion = 'SPANSION',
  Starbucks = 'STARBUCKS',
  StarbucksCoffee = 'STARBUCKS_COFFEE',
  StateFarmInsurance = 'STATE_FARM_INSURANCE',
  StateOfTexas = 'STATE_OF_TEXAS',
  StateOfTexasERS = 'STATE_OF_TEXAS_ERS',
  StateRetired = 'STATE_RETIRED',
  StDavidsHospital = 'ST_DAVIDS_HOSPITAL',
  StDavidsMedicalCenter = 'ST_DAVIDS_MEDICAL_CENTER',
  StEdwardsUniversity = 'ST_EDWARDS_UNIVERSITY',
  StevensonSchool = 'STEVENSON_SCHOOL',
  TanimuraAndAntle = 'TANIMURA_AND_ANTLE',
  Target = 'TARGET',
  TaylorFarms = 'TAYLOR_FARMS',
  TeachersRetirementSystem = 'TEACHERS_RETIREMENT_SYSTEM',
  Tesla = 'TESLA',
  TexasDepartmentOfHumanServices = 'TEXAS_DEPARTMENT_OF_HUMAN_SERVICES',
  TexasDepartmentOfPublicTransportation = 'TEXAS_DEPARTMENT_OF_PUBLIC_TRANSPORTATION',
  TexasDeptOfHumanServices = 'TEXAS_DEPT_OF_HUMAN_SERVICES',
  TexasDeptOfHwyPublicTra = 'TEXAS_DEPT_OF_HWY_PUBLIC_TRA',
  TexasGuaranteedStudentLoans = 'TEXAS_GUARANTEED_STUDENT_LOANS',
  TexasMutualInsuranceCompany = 'TEXAS_MUTUAL_INSURANCE_COMPANY',
  TexasOncology = 'TEXAS_ONCOLOGY',
  TexasStateUniversity = 'TEXAS_STATE_UNIVERSITY',
  TheHomeDepot = 'THE_HOME_DEPOT',
  TimeWarnerCable = 'TIME_WARNER_CABLE',
  TraderJoes = 'TRADER_JOES',
  TravisCounty = 'TRAVIS_COUNTY',
  TravisCountySheriffsDept = 'TRAVIS_COUNTY_SHERIFFS_DEPT',
  TrinetGroupInc = 'TRINET_GROUP_INC',
  Trs = 'TRS',
  TxGuaranteeStudentLoan = 'TX_GUARANTEE_STUDENT_LOAN',
  UCSantaCruz = 'UC_SANTA_CRUZ',
  UnitedStatesPostalService = 'UNITED_STATES_POSTAL_SERVICE',
  UniversityOfTexas = 'UNIVERSITY_OF_TEXAS',
  UPS = 'UPS',
  USAirForce = 'US_AIR_FORCE',
  USArmy = 'US_ARMY',
  USCoastGuard = 'US_COAST_GUARD',
  USMarines = 'US_MARINES',
  USNavy = 'US_NAVY',
  UsPostalService = 'US_POSTAL_SERVICE',
  Ut = 'UT',
  VentanaInn = 'VENTANA_INN',
  VeteransAdministration = 'VETERANS_ADMINISTRATION',
  VisaInternational = 'VISA_INTERNATIONAL',
  VisitingNurseAssociation = 'VISITING_NURSE_ASSOCIATION',
  Walgreens = 'WALGREENS',
  Walmart = 'WALMART',
  WellsFargo = 'WELLS_FARGO',
  WholeFoodsMarket = 'WHOLE_FOODS_MARKET',
  WilliamsonCounty = 'WILLIAMSON_COUNTY',

  // list below this line needs to be mapped 1-to-1 in EHR
  '711IvyStWaynesboro' = '711_IVY_ST_WAYNESBORO',
  '711JeffersonHwyStaunton' = '711_JEFFERSON_HWY_STAUNTON',
  '711NColterStStaunton' = '711_N_COLTER_ST_STAUNTON',
  '711RosserAveWaynesboro' = '711_ROSSER_AVE_WAYNESBORO',
  '711Verona' = '711_VERONA',
  '711WMainStWaynesboro' = '711_W_MAIN_ST_WAYNESBORO',
  '7ThDayAdventistChurch' = '7TH_DAY_ADVENTIST_CHURCH',
  AbfFreightSystemInc = 'ABF_FREIGHT_SYSTEM_INC',
  AccoridusHealthAtWaynesboro = 'ACCORIDUS_HEALTH_AT_WAYNESBORO',
  AccutecBlades = 'ACCUTEC_BLADES',
  AceHardware = 'ACE_HARDWARE',
  Adecco = 'ADECCO',
  AdiaEmploymentService = 'ADIA_EMPLOYMENT_SERVICE',
  ADMobileHomes = 'A_D_MOBILE_HOMES',
  AdomInc = 'ADOM_INC',
  AdvanceAutoPartsFishersvill = 'ADVANCE_AUTO_PARTS_FISHERSVILL',
  AdvanceAutoPartsStaunton = 'ADVANCE_AUTO_PARTS_STAUNTON',
  AdvanceAutoPartsStuartsDra = 'ADVANCE_AUTO_PARTS_STUARTS_DRA',
  AdvanceAutoPartsWaynesboro = 'ADVANCE_AUTO_PARTS_WAYNESBORO',
  AdvancedDrainage = 'ADVANCED_DRAINAGE',
  AgmarkIntermodalSystems = 'AGMARK_INTERMODAL_SYSTEMS',
  AircoIndustrialGases = 'AIRCO_INDUSTRIAL_GASES',
  AirLandRealEstate = 'AIR_LAND_REAL_ESTATE',
  AJDevelopmentAndExcavating = 'A_J_DEVELOPMENT_AND_EXCAVATING',
  Aldi = 'ALDI',
  AllansonLdPropertyManagemen = 'ALLANSON_LD_PROPERTY_MANAGEMEN',
  AllenYohoElectric = 'ALLEN_YOHO_ELECTRIC',
  AlliedCashAdvance = 'ALLIED_CASH_ADVANCE',
  AlliedExterminatingCoInc = 'ALLIED_EXTERMINATING_CO_INC',
  AlliedHomeMortgage = 'ALLIED_HOME_MORTGAGE',
  AlliedReadyMix = 'ALLIED_READY_MIX',
  AlsCab = 'ALS_CAB',
  AmericanFibersYard = 'AMERICAN_FIBERS_YARD',
  AmericanHardwoodIndustries = 'AMERICAN_HARDWOOD_INDUSTRIES',
  AmericanOfVirginia = 'AMERICAN_OF_VIRGINIA',
  AmericanRealEstate = 'AMERICAN_REAL_ESTATE',
  AmocoWaynesboro = 'AMOCO_WAYNESBORO',
  AnchorPharmacy = 'ANCHOR_PHARMACY',
  AnytimeFitnessStaunton = 'ANYTIME_FITNESS_STAUNTON',
  AnytimeFitnessWaynesboro = 'ANYTIME_FITNESS_WAYNESBORO',
  ApplebeesStaunton = 'APPLEBEES_STAUNTON',
  ApplebeesWaynesboro = 'APPLEBEES_WAYNESBORO',
  ArbysStaunton = 'ARBYS_STAUNTON',
  ArbysStuartsDraft = 'ARBYS_STUARTS_DRAFT',
  ArbysWaynesboro = 'ARBYS_WAYNESBORO',
  AreaWideProtective = 'AREA_WIDE_PROTECTIVE',
  ArehartAndAssociates = 'AREHART_AND_ASSOCIATES',
  AshleyHomeFurniture = 'ASHLEY_HOME_FURNITURE',
  AsplundhTreeExpertCo = 'ASPLUNDH_TREE_EXPERT_CO',
  AssociatedPhysicians = 'ASSOCIATED_PHYSICIANS',
  AstraZeneca = 'ASTRA_ZENECA',
  AtkinsAutomotiveCorp = 'ATKINS_AUTOMOTIVE_CORP',
  AtkinsAutomotiveWaynesboro = 'ATKINS_AUTOMOTIVE_WAYNESBORO',
  AtlanticUnionBankStaAugus = 'ATLANTIC_UNION_BANK_STA_AUGUS',
  AtlanticUnionBankStaBever = 'ATLANTIC_UNION_BANK_STA_BEVER',
  AtlanticUnionBankStaJacks = 'ATLANTIC_UNION_BANK_STA_JACKS',
  AtlanticUnionBankStuDraft = 'ATLANTIC_UNION_BANK_STU_DRAFT',
  AtlanticUnionBankVerona = 'ATLANTIC_UNION_BANK_VERONA',
  AtlanticUnionBankWaynesbor = 'ATLANTIC_UNION_BANK_WAYNESBOR',
  AugCountyGovernmentCenter = 'AUG_COUNTY_GOVERNMENT_CENTER',
  AugustaCleanersAndTailors = 'AUGUSTA_CLEANERS_AND_TAILORS',
  AugustaCoOpFarmBureau = 'AUGUSTA_CO_OP_FARM_BUREAU',
  AugustaCorrectionalCenter = 'AUGUSTA_CORRECTIONAL_CENTER',
  AugustaCoSchools = 'AUGUSTA_CO_SCHOOLS',
  AugustaCoServiceAuthority = 'AUGUSTA_CO_SERVICE_AUTHORITY',
  AugustaCoSheriffsDept = 'AUGUSTA_CO_SHERIFFS_DEPT',
  AugustaCountyFireDepartment = 'AUGUSTA_COUNTY_FIRE_DEPARTMENT',
  AugustaExcavatingCo = 'AUGUSTA_EXCAVATING_CO',
  AugustaExpoland = 'AUGUSTA_EXPOLAND',
  AugustaFarmBureauInsCo = 'AUGUSTA_FARM_BUREAU_INS_CO',
  AugustaGlassAndMirror = 'AUGUSTA_GLASS_AND_MIRROR',
  AugustaHealth = 'AUGUSTA_HEALTH',
  AugustaHealthcareForWomen = 'AUGUSTA_HEALTHCARE_FOR_WOMEN',
  AugustaLumberAndSupplyCo = 'AUGUSTA_LUMBER_AND_SUPPLY_CO',
  AugustaLumberCoWaynesboro = 'AUGUSTA_LUMBER_CO_WAYNESBORO',
  AugustaMutualInsuranceCo = 'AUGUSTA_MUTUAL_INSURANCE_CO',
  AugustaNursingAndRehabCtr = 'AUGUSTA_NURSING_AND_REHAB_CTR',
  AugustaOrthopedicSurgery = 'AUGUSTA_ORTHOPEDIC_SURGERY',
  AugustaPediatrics = 'AUGUSTA_PEDIATRICS',
  AugustaPetroleumSouthernSts = 'AUGUSTA_PETROLEUM_SOUTHERN_STS',
  AugustaPsychologicalAssoc = 'AUGUSTA_PSYCHOLOGICAL_ASSOC',
  AugustaStauntonHealthDept = 'AUGUSTA_STAUNTON_HEALTH_DEPT',
  AugustaSteelCorporation = 'AUGUSTA_STEEL_CORPORATION',
  AugustaUtilities = 'AUGUSTA_UTILITIES',
  AutozoneStaunton = 'AUTOZONE_STAUNTON',
  AutozoneWaynesboro = 'AUTOZONE_WAYNESBORO',
  Avintiv = 'AVINTIV',
  AWBuildingSupply = 'A_W_BUILDING_SUPPLY',
  BaberEnterprises = 'BABER_ENTERPRISES',
  BakerBrothersInc = 'BAKER_BROTHERS_INC',
  BallAdvancedTechnology = 'BALL_ADVANCED_TECHNOLOGY',
  BankOfAmericaStaunton = 'BANK_OF_AMERICA_STAUNTON',
  BankOfAmericaWaynesboro = 'BANK_OF_AMERICA_WAYNESBORO',
  BantaCorp = 'BANTA_CORP',
  BargerInsurance = 'BARGER_INSURANCE',
  BartlettTreeExperts = 'BARTLETT_TREE_EXPERTS',
  BasicCityLuncheonette = 'BASIC_CITY_LUNCHEONETTE',
  BathAndBodyWorksStaunton = 'BATH_AND_BODY_WORKS_STAUNTON',
  BathCountySchoolBoard = 'BATH_COUNTY_SCHOOL_BOARD',
  BaugherChevroletBuickInc = 'BAUGHER_CHEVROLET_BUICK_INC',
  BbtBankChurchvilleBranch = 'BBT_BANK_CHURCHVILLE_BRANCH',
  BbtCentralAveBranch = 'BBT_CENTRAL_AVE_BRANCH',
  BbtHopemanPkwyBranch = 'BBT_HOPEMAN_PKWY_BRANCH',
  BbtInsuranceServicesWayne = 'BBT_INSURANCE_SERVICES_WAYNE',
  BbtStuartsDraftBranch = 'BBT_STUARTS_DRAFT_BRANCH',
  BedBathBeyondHarrisonburg = 'BED_BATH_BEYOND_HARRISONBURG',
  BedBathBeyondWaynesboro = 'BED_BATH_BEYOND_WAYNESBORO',
  BelkStauntonMall = 'BELK_STAUNTON_MALL',
  BerrangPontiacCadillac = 'BERRANG_PONTIAC_CADILLAC',
  BerryPlastics = 'BERRY_PLASTICS',
  BestBuys = 'BEST_BUYS',
  BestWestern = 'BEST_WESTERN',
  BigLots1417Waynesboro = 'BIG_LOTS_1417_WAYNESBORO',
  BigLots276Staunton = 'BIG_LOTS_276_STAUNTON',
  BigOTreeService = 'BIG_O_TREE_SERVICE',
  BloomakerUsa = 'BLOOMAKER_USA',
  BlueMountainBrewery = 'BLUE_MOUNTAIN_BREWERY',
  BlueRidgeAreaFoodBank = 'BLUE_RIDGE_AREA_FOOD_BANK',
  BlueRidgeBeverageCompany = 'BLUE_RIDGE_BEVERAGE_COMPANY',
  BlueRidgeBuildersSupply = 'BLUE_RIDGE_BUILDERS_SUPPLY',
  BlueRidgeCommunityCollege = 'BLUE_RIDGE_COMMUNITY_COLLEGE',
  BlueRidgeLumberCo = 'BLUE_RIDGE_LUMBER_CO',
  BlueRidgePathologist = 'BLUE_RIDGE_PATHOLOGIST',
  BlueRidgePediatrics = 'BLUE_RIDGE_PEDIATRICS',
  BlueRidgeRadiologist = 'BLUE_RIDGE_RADIOLOGIST',
  BlueRidgeSheetMetalCoInc = 'BLUE_RIDGE_SHEET_METAL_CO_INC',
  BoarsHeadInn = 'BOARS_HEAD_INN',
  BojanglesStaunton = 'BOJANGLES_STAUNTON',
  BooksAMillion = 'BOOKS_A_MILLION',
  BotkinPlumbingAndHeating = 'BOTKIN_PLUMBING_AND_HEATING',
  Boyers72Degrees = 'BOYERS_72_DEGREES',
  BoyScoutsOfAmerica = 'BOY_SCOUTS_OF_AMERICA',
  BradleyInsuranceServices = 'BRADLEY_INSURANCE_SERVICES',
  BranchHighwaysInc = 'BRANCH_HIGHWAYS_INC',
  BridgewaterCollege = 'BRIDGEWATER_COLLEGE',
  BridgewaterHomeInc = 'BRIDGEWATER_HOME_INC',
  BrightviewAtBaldwinPark = 'BRIGHTVIEW_AT_BALDWIN_PARK',
  BrookdaleSeniorLiving = 'BROOKDALE_SENIOR_LIVING',
  BrownExcavating = 'BROWN_EXCAVATING',
  BudgetInnStaunton = 'BUDGET_INN_STAUNTON',
  BudgetInnWaynesboro = 'BUDGET_INN_WAYNESBORO',
  BuenaVistaPublicSchools = 'BUENA_VISTA_PUBLIC_SCHOOLS',
  BuffaloWildWings = 'BUFFALO_WILD_WINGS',
  BurgerKingGreenvilleAveSta = 'BURGER_KING_GREENVILLE_AVE_STA',
  BurgerKingRichmondAveStaun = 'BURGER_KING_RICHMOND_AVE_STAUN',
  BurgerKingVerona = 'BURGER_KING_VERONA',
  BurgerKingWaynesboro = 'BURGER_KING_WAYNESBORO',
  BurgersShakesAndThings = 'BURGERS_SHAKES_AND_THINGS',
  BurrisRefrigeration = 'BURRIS_REFRIGERATION',
  ByersStreetBistro = 'BYERS_STREET_BISTRO',
  CadenceCorporation = 'CADENCE_CORPORATION',
  CampbellsSepticTankSvs = 'CAMPBELLS_SEPTIC_TANK_SVS',
  CAndCWeldingCo = 'C_AND_C_WELDING_CO',
  CanteenVendingServices = 'CANTEEN_VENDING_SERVICES',
  CardinalHouse = 'CARDINAL_HOUSE',
  CareAdvantage = 'CARE_ADVANTAGE',
  CargillInc = 'CARGILL_INC',
  CarrsTireService = 'CARRS_TIRE_SERVICE',
  CarterMachineryCoInc = 'CARTER_MACHINERY_CO_INC',
  CatoFashions = 'CATO_FASHIONS',
  CentralSecurity = 'CENTRAL_SECURITY',
  CentralTireCorp = 'CENTRAL_TIRE_CORP',
  CentralVaLawnGardenCenter = 'CENTRAL_VA_LAWN_GARDEN_CENTER',
  CentralVaRentJeffersonHwy = 'CENTRAL_VA_RENT_JEFFERSON_HWY',
  CentralVaRentWMainSt = 'CENTRAL_VA_RENT_W_MAIN_ST',
  CentralVirginiaRentalFisher = 'CENTRAL_VIRGINIA_RENTAL_FISHER',
  CentralVirginiaRentalStaunt = 'CENTRAL_VIRGINIA_RENTAL_STAUNT',
  CerroFabrication = 'CERRO_FABRICATION',
  CharlieObaughWaynesboro = 'CHARLIE_OBAUGH_WAYNESBORO',
  ChesterFarms = 'CHESTER_FARMS',
  ChevrontsSupplyCo = 'CHEVRONTS_SUPPLY_CO',
  ChickFilAStaunton = 'CHICK_FIL_A_STAUNTON',
  ChickFilAWaynesboro = 'CHICK_FIL_A_WAYNESBORO',
  ChilisGrillAndBar = 'CHILIS_GRILL_AND_BAR',
  Cintas = 'CINTAS',
  CityNationalBankRaphine = 'CITY_NATIONAL_BANK_RAPHINE',
  CityNationalBankStaCentral = 'CITY_NATIONAL_BANK_STA_CENTRAL',
  CityNationalBankStaCommWa = 'CITY_NATIONAL_BANK_STA_COMM_WA',
  CityNationalBankStuartsDra = 'CITY_NATIONAL_BANK_STUARTS_DRA',
  CityNationalBankVerona = 'CITY_NATIONAL_BANK_VERONA',
  CityNationalBankWaynesboro = 'CITY_NATIONAL_BANK_WAYNESBORO',
  ClaytonHomesHarrisonburg = 'CLAYTON_HOMES_HARRISONBURG',
  ClaytonHomesStuartsDraft = 'CLAYTON_HOMES_STUARTS_DRAFT',
  CocaColaBottlingCompany = 'COCA_COLA_BOTTLING_COMPANY',
  ComcastStaunton = 'COMCAST_STAUNTON',
  Comdial = 'COMDIAL',
  ComfortInn = 'COMFORT_INN',
  CommonwealthCenterChildren = 'COMMONWEALTH_CENTER_CHILDREN',
  CommonwealthGasServicesInc = 'COMMONWEALTH_GAS_SERVICES_INC',
  CommunityBank = 'COMMUNITY_BANK',
  CommunityFellowshipChurch = 'COMMUNITY_FELLOWSHIP_CHURCH',
  CommunityLivingServices = 'COMMUNITY_LIVING_SERVICES',
  ComputerConcepts = 'COMPUTER_CONCEPTS',
  ComsonicsInc = 'COMSONICS_INC',
  ConcourseCafeRestaurant = 'CONCOURSE_CAFE_RESTAURANT',
  ConWaySouthernExpress = 'CON_WAY_SOUTHERN_EXPRESS',
  CookOutWayneWMainSt = 'COOK_OUT_WAYNE_W_MAIN_ST',
  Coors = 'COORS',
  CornerstoneJanitorial = 'CORNERSTONE_JANITORIAL',
  Costco = 'COSTCO',
  CountryCookinRestaurant = 'COUNTRY_COOKIN_RESTAURANT',
  CountyOfAlbemarle = 'COUNTY_OF_ALBEMARLE',
  CoxConstruction = 'COX_CONSTRUCTION',
  CrackerBarrell = 'CRACKER_BARRELL',
  CrackerBarrellWaynesboro = 'CRACKER_BARRELL_WAYNESBORO',
  CrosBCrestFarms = 'CROS_B_CREST_FARMS',
  CrosbyTruckingCompany = 'CROSBY_TRUCKING_COMPANY',
  CrozetInsurance = 'CROZET_INSURANCE',
  CvsBarterbrookRd = 'CVS_BARTERBROOK_RD',
  CvsBroadStWaynesboro = 'CVS_BROAD_ST_WAYNESBORO',
  CvsChurchvilleAveStaunton = 'CVS_CHURCHVILLE_AVE_STAUNTON',
  CvsMainStWaynesboro = 'CVS_MAIN_ST_WAYNESBORO',
  Daikin = 'DAIKIN',
  DairyQueenStuartsDraft = 'DAIRY_QUEEN_STUARTS_DRAFT',
  DairyQueenVerona = 'DAIRY_QUEEN_VERONA',
  DanoneNorthAmerica = 'DANONE_NORTH_AMERICA',
  DanonewaveFoods = 'DANONEWAVE_FOODS',
  DavesHeatingAndCooling = 'DAVES_HEATING_AND_COOLING',
  DaviCommunications = 'DAVI_COMMUNICATIONS',
  DaysInnStaunton = 'DAYS_INN_STAUNTON',
  DaysInnWaynesboro = 'DAYS_INN_WAYNESBORO',
  DeanSteelErectionCoInc = 'DEAN_STEEL_ERECTION_CO_INC',
  DegeschAmericaInc = 'DEGESCH_AMERICA_INC',
  DelmarsBodyShop = 'DELMARS_BODY_SHOP',
  DepartmentOfAgriculture = 'DEPARTMENT_OF_AGRICULTURE',
  DepotGrille = 'DEPOT_GRILLE',
  DevilsBackboneBrewCoLexing = 'DEVILS_BACKBONE_BREW_CO_LEXING',
  DevilsBackboneBrewCoRosela = 'DEVILS_BACKBONE_BREW_CO_ROSELA',
  DillonAcContractor = 'DILLON_AC_CONTRACTOR',
  Disabled = 'DISABLED',
  DiversifiedCommunications = 'DIVERSIFIED_COMMUNICATIONS',
  DixieGasAndOil = 'DIXIE_GAS_AND_OIL',
  DodsonBroExterminatingCo = 'DODSON_BRO_EXTERMINATING_CO',
  DollarTreeStaunton = 'DOLLAR_TREE_STAUNTON',
  DollarTreeWaynesboro = 'DOLLAR_TREE_WAYNESBORO',
  DollerGeneralCrimora = 'DOLLER_GENERAL_CRIMORA',
  DollerGeneralGreenville = 'DOLLER_GENERAL_GREENVILLE',
  DollerGeneralStaunton = 'DOLLER_GENERAL_STAUNTON',
  DollerGeneralStauntonGreenv = 'DOLLER_GENERAL_STAUNTON_GREENV',
  DollerGeneralStauntonWBeve = 'DOLLER_GENERAL_STAUNTON_W_BEVE',
  DollerGeneralVerona = 'DOLLER_GENERAL_VERONA',
  DollerGeneralWayneBroadSt = 'DOLLER_GENERAL_WAYNE_BROAD_ST',
  DollerGeneralWayneHopemanP = 'DOLLER_GENERAL_WAYNE_HOPEMAN_P',
  DollTreeLeeJacksonStaunton = 'DOLL_TREE_LEE_JACKSON_STAUNTON',
  DollTreeWMainWaynesboro = 'DOLL_TREE_W_MAIN_WAYNESBORO',
  DominionOutdoors = 'DOMINION_OUTDOORS',
  DominionPower = 'DOMINION_POWER',
  DominosPizzaStaunton = 'DOMINOS_PIZZA_STAUNTON',
  DominosPizzaStuartsDraft = 'DOMINOS_PIZZA_STUARTS_DRAFT',
  DominosPizzaWaynesboro = 'DOMINOS_PIZZA_WAYNESBORO',
  DrakeFr = 'DRAKE_FR',
  DriversBrothersNurseries = 'DRIVERS_BROTHERS_NURSERIES',
  DrPepperBottlingCompany = 'DR_PEPPER_BOTTLING_COMPANY',
  DscLogistics = 'DSC_LOGISTICS',
  DunhamBush = 'DUNHAM_BUSH',
  DupCreditUnionAugStBranch = 'DUP_CREDIT_UNION_AUG_ST_BRANCH',
  DupCreditUnionCommWayBrnc = 'DUP_CREDIT_UNION_COMM_WAY_BRNC',
  DupontCreditUnionDupontBlv = 'DUPONT_CREDIT_UNION_DUPONT_BLV',
  DupontCreditUnionEBroadSt = 'DUPONT_CREDIT_UNION_E_BROAD_ST',
  DupontCreditUnionLucyLane = 'DUPONT_CREDIT_UNION_LUCY_LANE',
  DupontCreditUnionWMainSt = 'DUPONT_CREDIT_UNION_W_MAIN_ST',
  DynamicAviation = 'DYNAMIC_AVIATION',
  EAndEPlumbing = 'E_AND_E_PLUMBING',
  EaversBrothers = 'EAVERS_BROTHERS',
  EaversGuyCExcavating = 'EAVERS_GUY_C_EXCAVATING',
  EaversTireProFishersville = 'EAVERS_TIRE_PRO_FISHERSVILLE',
  EaversTireProStuartsDraft = 'EAVERS_TIRE_PRO_STUARTS_DRAFT',
  EcholsBrothers = 'ECHOLS_BROTHERS',
  EconoLodge = 'ECONO_LODGE',
  EducationAndTrainingCorp = 'EDUCATION_AND_TRAINING_CORP',
  EdwardsTrucking = 'EDWARDS_TRUCKING',
  EfcoCorp = 'EFCO_CORP',
  EilandJohnDDistributors = 'EILAND_JOHN_D_DISTRIBUTORS',
  Electrolux = 'ELECTROLUX',
  ElliottChevrolet = 'ELLIOTT_CHEVROLET',
  ElPuertoStaunton = 'EL_PUERTO_STAUNTON',
  ElPuertoWaynesboro = 'EL_PUERTO_WAYNESBORO',
  Emergicare = 'EMERGICARE',
  EnvoyHealthcareWasRuxton = 'ENVOY_HEALTHCARE_WAS_RUXTON',
  ErieInsurance = 'ERIE_INSURANCE',
  EstesExpressLines = 'ESTES_EXPRESS_LINES',
  EtterFuneralHome = 'ETTER_FUNERAL_HOME',
  ExpressPersonnelServicees = 'EXPRESS_PERSONNEL_SERVICEES',
  EyeoneCharlottesville = 'EYEONE_CHARLOTTESVILLE',
  EyeoneCovington = 'EYEONE_COVINGTON',
  EyeoneFishersville = 'EYEONE_FISHERSVILLE',
  EyeoneStauntonCommRoad = 'EYEONE_STAUNTON_COMM_ROAD',
  EyeoneStauntonNAugustaSt = 'EYEONE_STAUNTON_N_AUGUSTA_ST',
  EyeoneWaynesboro = 'EYEONE_WAYNESBORO',
  FactoryAntiqueMall = 'FACTORY_ANTIQUE_MALL',
  FairfieldInn = 'FAIRFIELD_INN',
  FairfieldSkanskaInc = 'FAIRFIELD_SKANSKA_INC',
  FamilyBarberAndBeautyShop = 'FAMILY_BARBER_AND_BEAUTY_SHOP',
  FamilyDollarStoreStaunton = 'FAMILY_DOLLAR_STORE_STAUNTON',
  FamilyDollarStuartsDraft = 'FAMILY_DOLLAR_STUARTS_DRAFT',
  FamilyDollarWaynesboro = 'FAMILY_DOLLAR_WAYNESBORO',
  FashionGallery = 'FASHION_GALLERY',
  FaulknerConstructionCompany = 'FAULKNER_CONSTRUCTION_COMPANY',
  FederatedAutoPartsStaunton = 'FEDERATED_AUTO_PARTS_STAUNTON',
  FedExFishersville = 'FED_EX_FISHERSVILLE',
  FencoInc = 'FENCO_INC',
  FergusonMetalFabrication = 'FERGUSON_METAL_FABRICATION',
  FirehouseSubs = 'FIREHOUSE_SUBS',
  FirstBankAndTrustStaunton = 'FIRST_BANK_AND_TRUST_STAUNTON',
  FirstBankAndTrustVerona = 'FIRST_BANK_AND_TRUST_VERONA',
  FirstBankAndTrustWaynesbor = 'FIRST_BANK_AND_TRUST_WAYNESBOR',
  FirstCitizenBankBridgewater = 'FIRST_CITIZEN_BANK_BRIDGEWATER',
  FirstCitizenBankGrottoes = 'FIRST_CITIZEN_BANK_GROTTOES',
  FirstCitizenBankVerona = 'FIRST_CITIZEN_BANK_VERONA',
  FirstCitizenBankWeyersCave = 'FIRST_CITIZEN_BANK_WEYERS_CAVE',
  FirstCitizensBankHburg = 'FIRST_CITIZENS_BANK_HBURG',
  FirstCitizensBankWboro = 'FIRST_CITIZENS_BANK_WBORO',
  FirstUnionBankStaunton = 'FIRST_UNION_BANK_STAUNTON',
  FirstUnionBankVerona = 'FIRST_UNION_BANK_VERONA',
  FishburneMilitarySchool = 'FISHBURNE_MILITARY_SCHOOL',
  FisherAutoPartsChurchville = 'FISHER_AUTO_PARTS_CHURCHVILLE',
  FisherAutoPartsCrozet = 'FISHER_AUTO_PARTS_CROZET',
  FisherAutoPartsGreenville = 'FISHER_AUTO_PARTS_GREENVILLE',
  FisherAutoPartsGrottoes = 'FISHER_AUTO_PARTS_GROTTOES',
  FisherAutoPartsMorrisMill = 'FISHER_AUTO_PARTS_MORRIS_MILL',
  FisherAutoPartsNellysford = 'FISHER_AUTO_PARTS_NELLYSFORD',
  FisherAutoPartsStatlerBlvd = 'FISHER_AUTO_PARTS_STATLER_BLVD',
  FisherAutoPartsStuartsDraf = 'FISHER_AUTO_PARTS_STUARTS_DRAF',
  FisherAutoPartsVerona = 'FISHER_AUTO_PARTS_VERONA',
  FisherAutoPartsWaynesboro = 'FISHER_AUTO_PARTS_WAYNESBORO',
  FishersvillePostOffice = 'FISHERSVILLE_POST_OFFICE',
  FitzgeraldTireServices = 'FITZGERALD_TIRE_SERVICES',
  FlintInkCorp = 'FLINT_INK_CORP',
  FoodLionFishersville = 'FOOD_LION_FISHERSVILLE',
  FoodLionGrottoes = 'FOOD_LION_GROTTOES',
  FoodLionHopemanParkway = 'FOOD_LION_HOPEMAN_PARKWAY',
  FoodLionNCoalterStreet = 'FOOD_LION_N_COALTER_STREET',
  FoodLionOrchardHillCenter = 'FOOD_LION_ORCHARD_HILL_CENTER',
  FoodLionStuartsDraft = 'FOOD_LION_STUARTS_DRAFT',
  FoodLionVerona = 'FOOD_LION_VERONA',
  FoodLionWBeverlyStreet = 'FOOD_LION_W_BEVERLY_STREET',
  FriendshipIndustries = 'FRIENDSHIP_INDUSTRIES',
  FritoLay = 'FRITO_LAY',
  FrontierCommunityBank = 'FRONTIER_COMMUNITY_BANK',
  FrontierCultureMuseum = 'FRONTIER_CULTURE_MUSEUM',
  GatewayEnterprises = 'GATEWAY_ENTERPRISES',
  GarrettCountyBoardOfEducation = 'GARRETT_COUNTY_BOARD_OF_EDUCATION',
  GarrettCountyGovernment = 'GARRETT_COUNTY_GOVERNMENT',
  GeFanuc = 'GE_FANUC',
  GoldenCorral = 'GOLDEN_CORRAL',
  GoodwillStaunton = 'GOODWILL_STAUNTON',
  GoodwillVerona = 'GOODWILL_VERONA',
  GoodwillWaynesboro = 'GOODWILL_WAYNESBORO',
  GoodysFamilyClothingInc = 'GOODYS_FAMILY_CLOTHING_INC',
  GrahamPackaging = 'GRAHAM_PACKAGING',
  GrandPianoFurnitureStaunton = 'GRAND_PIANO_FURNITURE_STAUNTON',
  GrandPianoFurnitureWaynesb = 'GRAND_PIANO_FURNITURE_WAYNESB',
  GraphicPackaging = 'GRAPHIC_PACKAGING',
  GreenvilleColdSprings = 'GREENVILLE_COLD_SPRINGS',
  HairCutteryWayneLucyLane = 'HAIR_CUTTERY_WAYNE_LUCY_LANE',
  HairCutteryWayneTownCenter = 'HAIR_CUTTERY_WAYNE_TOWN_CENTER',
  HajocaCorporation = 'HAJOCA_CORPORATION',
  HarbourFreight = 'HARBOUR_FREIGHT',
  HardeesNCentralAvenue = 'HARDEES_N_CENTRAL_AVENUE',
  HardeesVerona = 'HARDEES_VERONA',
  HardeesWindmillSquare = 'HARDEES_WINDMILL_SQUARE',
  HardeesWMainStWaynesboro = 'HARDEES_W_MAIN_ST_WAYNESBORO',
  HarrisonburgCitySchools = 'HARRISONBURG_CITY_SCHOOLS',
  HarrisonburgNissanInc = 'HARRISONBURG_NISSAN_INC',
  HathawayPaperCompany = 'HATHAWAY_PAPER_COMPANY',
  HawpeDouglasCpa = 'HAWPE_DOUGLAS_CPA',
  HdtExpentionarySystems = 'HDT_EXPENTIONARY_SYSTEMS',
  HenryFuneralHomeInc = 'HENRY_FUNERAL_HOME_INC',
  HersheyChocolate = 'HERSHEY_CHOCOLATE',
  HersheyTireInc = 'HERSHEY_TIRE_INC',
  HillsideResidentialLiving = 'HILLSIDE_RESIDENTIAL_LIVING',
  HiTechSalon = 'HI_TECH_SALON',
  HolidayInnConfCenter = 'HOLIDAY_INN_CONF_CENTER',
  HolidayInnExpressWboro = 'HOLIDAY_INN_EXPRESS_WBORO',
  HollistersInc = 'HOLLISTERS_INC',
  HomeAwayFromHomeDogGroomi = 'HOME_AWAY_FROM_HOME_DOG_GROOMI',
  HomeDepot4645Hburg = 'HOME_DEPOT_4645_HBURG',
  HomeInsteadSeniorCare = 'HOME_INSTEAD_SENIOR_CARE',
  HomeIvCare = 'HOME_IV_CARE',
  HomesteadMaterialHandling = 'HOMESTEAD_MATERIAL_HANDLING',
  HomesteadResort = 'HOMESTEAD_RESORT',
  HometownGrillAndBuffet = 'HOMETOWN_GRILL_AND_BUFFET',
  HospiceOfPiedmond = 'HOSPICE_OF_PIEDMOND',
  HouffTransfer = 'HOUFF_TRANSFER',
  HumphriesPressInc = 'HUMPHRIES_PRESS_INC',
  IndependentTermiteAndPest = 'INDEPENDENT_TERMITE_AND_PEST',
  IndustrialFabricatorsOfVa = 'INDUSTRIAL_FABRICATORS_OF_VA',
  IndustrialMachineWorksInc = 'INDUSTRIAL_MACHINE_WORKS_INC',
  InglesideHotelAndMotel = 'INGLESIDE_HOTEL_AND_MOTEL',
  InnAtAfton = 'INN_AT_AFTON',
  Innkeeper = 'INNKEEPER',
  InnovativeRefrigerationSyste = 'INNOVATIVE_REFRIGERATION_SYSTE',
  InterimHealthCareOfFishers = 'INTERIM_HEALTH_CARE_OF_FISHERS',
  InterimHealthcareOfVerona = 'INTERIM_HEALTHCARE_OF_VERONA',
  InterstateMufflersInc = 'INTERSTATE_MUFFLERS_INC',
  IntrepidHomeHealth = 'INTREPID_HOME_HEALTH',
  JamesMadisonUniversity = 'JAMES_MADISON_UNIVERSITY',
  JamesRiverEquipment = 'JAMES_RIVER_EQUIPMENT',
  JBHuntTransportServices = 'J_B_HUNT_TRANSPORT_SERVICES',
  JenkinsSecurityServicesInc = 'JENKINS_SECURITY_SERVICES_INC',
  JgmCoach = 'JGM_COACH',
  JiffyLube = 'JIFFY_LUBE',
  JimSneadFord = 'JIM_SNEAD_FORD',
  KathysRestaurantStaunton = 'KATHYS_RESTAURANT_STAUNTON',
  KdhNursingAndRehabCenter = 'KDH_NURSING_AND_REHAB_CENTER',
  KdpInc = 'KDP_INC',
  KenBridgeCorp = 'KEN_BRIDGE_CORP',
  KentuckyFriedChicken = 'KENTUCKY_FRIED_CHICKEN',
  KisamoreLumber = 'KISAMORE_LUMBER',
  KitchinCookdPotatoChipCo = 'KITCHIN_COOKD_POTATO_CHIP_CO',
  KlannInc = 'KLANN_INC',
  KlineMayRealty = 'KLINE_MAY_REALTY',
  KlinesDairyBar = 'KLINES_DAIRY_BAR',
  Kmart = 'KMART',
  KnoppEnterpriseInc = 'KNOPP_ENTERPRISE_INC',
  Kohls = 'KOHLS',
  KrispyKremeDoughnutCorp = 'KRISPY_KREME_DOUGHNUT_CORP',
  KrogersStaunton = 'KROGERS_STAUNTON',
  KrogersWaynesboro = 'KROGERS_WAYNESBORO',
  LawrenceTransferStorageCo = 'LAWRENCE_TRANSFER_STORAGE_CO',
  LeesHeatingAndCooling = 'LEES_HEATING_AND_COOLING',
  LehighPortlandCementCo = 'LEHIGH_PORTLAND_CEMENT_CO',
  LibertyPointBehavioralHealt = 'LIBERTY_POINT_BEHAVIORAL_HEALT',
  LiphartSteelCompany = 'LIPHART_STEEL_COMPANY',
  LittleCaesarsPizzaStaunton = 'LITTLE_CAESARS_PIZZA_STAUNTON',
  LittleCaesarsPizzaWaynesbor = 'LITTLE_CAESARS_PIZZA_WAYNESBOR',
  LittleCaesarsWaynesboro = 'LITTLE_CAESARS_WAYNESBORO',
  LittleMariasPizzaAndSubs = 'LITTLE_MARIAS_PIZZA_AND_SUBS',
  Lofton = 'LOFTON',
  LongJohnSilversStaunton = 'LONG_JOHN_SILVERS_STAUNTON',
  LongJohnSilversWaynesboro = 'LONG_JOHN_SILVERS_WAYNESBORO',
  LowesStaunton = 'LOWES_STAUNTON',
  LowesWaynesboro = 'LOWES_WAYNESBORO',
  Loyalton = 'LOYALTON',
  LuckQuarriesInc = 'LUCK_QUARRIES_INC',
  LumosWayneBroadSt = 'LUMOS_WAYNE_BROAD_ST',
  LumosWayneMainSt = 'LUMOS_WAYNE_MAIN_ST',
  Mancon = 'MANCON',
  ManpowerStauntonOffice = 'MANPOWER_STAUNTON_OFFICE',
  MarchInc = 'MARCH_INC',
  MariasPizza = 'MARIAS_PIZZA',
  MarinerFinance = 'MARINER_FINANCE',
  MarshallsInc = 'MARSHALLS_INC',
  MarthaJeffersonHospital = 'MARTHA_JEFFERSON_HOSPITAL',
  Martins6226Staunton = 'MARTINS_6226_STAUNTON',
  Martins6285Waynesboro = 'MARTINS_6285_WAYNESBORO',
  Martins6285WaynesboroVa = 'MARTINS_6285_WAYNESBORO_VA',
  Martins6424Harrisonburg = 'MARTINS_6424_HARRISONBURG',
  Martins6426StauntonVa = 'MARTINS_6426_STAUNTON_VA',
  MaryBaldwinUniversity = 'MARY_BALDWIN_UNIVERSITY',
  MassakiJapeneseSteakhouse = 'MASSAKI_JAPENESE_STEAKHOUSE',
  MassanuttenVacationsLlc = 'MASSANUTTEN_VACATIONS_LLC',
  MassanuttenVocationalCenter = 'MASSANUTTEN_VOCATIONAL_CENTER',
  McalistersDeli = 'MCALISTERS_DELI',
  McclungDesignwritePrinting = 'MCCLUNG_DESIGNWRITE_PRINTING',
  McdonaldsFishersville = 'MCDONALDS_FISHERSVILLE',
  McdonaldsStaunCochranParkwa = 'MCDONALDS_STAUN_COCHRAN_PARKWA',
  McdonaldsStaunGreenville = 'MCDONALDS_STAUN_GREENVILLE',
  McdonaldsStaunJeffersonHwy = 'MCDONALDS_STAUN_JEFFERSON_HWY',
  McdonaldsVerona = 'MCDONALDS_VERONA',
  McdonaldsWaynesboro1501 = 'MCDONALDS_WAYNESBORO_1501',
  McdonaldsWaynesboro720 = 'MCDONALDS_WAYNESBORO_720',
  McdonoughDodgeInc = 'MCDONOUGH_DODGE_INC',
  McdonoughToyota = 'MCDONOUGH_TOYOTA',
  MckeesBaking = 'MCKEES_BAKING',
  McquayAafInc = 'MCQUAY_AAF_INC',
  MeadeTrucking = 'MEADE_TRUCKING',
  Meadwestvaco = 'MEADWESTVACO',
  MedExpress = 'MED_EXPRESS',
  MedicalCenterPharmacy = 'MEDICAL_CENTER_PHARMACY',
  MerchantTireAndAutoStaunto = 'MERCHANT_TIRE_AND_AUTO_STAUNTO',
  Merck = 'MERCK',
  MesserLandscapeIncNursery = 'MESSER_LANDSCAPE_INC_NURSERY',
  MetFabInternational = 'MET_FAB_INTERNATIONAL',
  MgIndustriesGasProducts = 'MG_INDUSTRIES_GAS_PRODUCTS',
  MichaelsArtsAndCrafts = 'MICHAELS_ARTS_AND_CRAFTS',
  MiddleRiverRegionalJail = 'MIDDLE_RIVER_REGIONAL_JAIL',
  MillmontGreenhouse = 'MILLMONT_GREENHOUSE',
  MillStreetGrill = 'MILL_STREET_GRILL',
  ModineManufacturingCo = 'MODINE_MANUFACTURING_CO',
  MoffettPaving = 'MOFFETT_PAVING',
  Mohawk = 'MOHAWK',
  MohawkWaynesboroDivision = 'MOHAWK_WAYNESBORO_DIVISION',
  MooreBrothers = 'MOORE_BROTHERS',
  MooreBusinessFormsInc = 'MOORE_BUSINESS_FORMS_INC',
  MooresBuildingSupplies = 'MOORES_BUILDING_SUPPLIES',
  MorningStarFoods = 'MORNING_STAR_FOODS',
  Mundy = 'MUNDY',
  MuntersDeschampTechnologies = 'MUNTERS_DESCHAMP_TECHNOLOGIES',
  MusicTodayCrozet = 'MUSIC_TODAY_CROZET',
  MysticIslandTransportation = 'MYSTIC_ISLAND_TRANSPORTATION',
  NationalLinenService = 'NATIONAL_LINEN_SERVICE',
  NelsonCountyPublicSchools = 'NELSON_COUNTY_PUBLIC_SCHOOLS',
  NeumanAluminum = 'NEUMAN_ALUMINUM',
  NewBeginnings = 'NEW_BEGINNINGS',
  NewsVirginian = 'NEWS_VIRGINIAN',
  Nibco = 'NIBCO',
  NielsonConstructionCompany = 'NIELSON_CONSTRUCTION_COMPANY',
  NotEmployed = 'NOT_EMPLOYED',
  OakGroveManor = 'OAK_GROVE_MANOR',
  OakwoodHomes = 'OAKWOOD_HOMES',
  ObaughCharlieStaunton = 'OBAUGH_CHARLIE_STAUNTON',
  ObjectiveIndustries = 'OBJECTIVE_INDUSTRIES',
  OfficeImageSmart = 'OFFICE_IMAGE_SMART',
  OldDominionFreightLine = 'OLD_DOMINION_FREIGHT_LINE',
  OreillyAutoParts = 'OREILLY_AUTO_PARTS',
  OutbackSteakhouseWaynesboro = 'OUTBACK_STEAKHOUSE_WAYNESBORO',
  OverniteTransportation = 'OVERNITE_TRANSPORTATION',
  PackagingCorpHarrisonburg = 'PACKAGING_CORP_HARRISONBURG',
  PackagingServices = 'PACKAGING_SERVICES',
  Pactiv = 'PACTIV',
  PAndDInteriorsInc = 'P_AND_D_INTERIORS_INC',
  PaneraBreadWaynesboro = 'PANERA_BREAD_WAYNESBORO',
  PapaJohnsPizzaStaGreenvill = 'PAPA_JOHNS_PIZZA_STA_GREENVILL',
  PapaJohnsPizzaWayPoplarAv = 'PAPA_JOHNS_PIZZA_WAY_POPLAR_AV',
  PaulObaughFordChrysler = 'PAUL_OBAUGH_FORD_CHRYSLER',
  PDInteriorsInc = 'P_D_INTERIORS_INC',
  PeeblesDeptStore = 'PEEBLES_DEPT_STORE',
  PenneyJCCompanyInc = 'PENNEY_J_C_COMPANY_INC',
  PennyPlate = 'PENNY_PLATE',
  PeoplePlacesInc = 'PEOPLE_PLACES_INC',
  Perdue = 'PERDUE',
  Petsmart = 'PETSMART',
  PetsNPals = 'PETS_N_PALS',
  PilgrimsPrideCorp = 'PILGRIMS_PRIDE_CORP',
  PizzaHutGreenvilleAvenue = 'PIZZA_HUT_GREENVILLE_AVENUE',
  PizzaHutNorthCoalterSt = 'PIZZA_HUT_NORTH_COALTER_ST',
  PizzaHutWaynesboro = 'PIZZA_HUT_WAYNESBORO',
  PlanetFitnessWaynesboro = 'PLANET_FITNESS_WAYNESBORO',
  PleckerConstructionCompany = 'PLECKER_CONSTRUCTION_COMPANY',
  PlygemAlcoaHomeExteriors = 'PLYGEM_ALCOA_HOME_EXTERIORS',
  PoindexterAndSchorschAttorn = 'POINDEXTER_AND_SCHORSCH_ATTORN',
  PpiTimeZeroInc = 'PPI_TIME_ZERO_INC',
  PrecisionFabricatorsInc = 'PRECISION_FABRICATORS_INC',
  ProbationAndParoleDist12 = 'PROBATION_AND_PAROLE_DIST_12',
  ProperityManagement = 'PROPERITY_MANAGEMENT',
  RayCarrTireStaunton = 'RAY_CARR_TIRE_STAUNTON',
  RayCarTireWaynesboro = 'RAY_CAR_TIRE_WAYNESBORO',
  ReadyIce = 'READY_ICE',
  RealEstateIii = 'REAL_ESTATE_III',
  RedLobsterStaunton = 'RED_LOBSTER_STAUNTON',
  RemaxRealtyWaynesboro = 'REMAX_REALTY_WAYNESBORO',
  RemaxStaunton = 'REMAX_STAUNTON',
  ReoDistributionServicesInc = 'REO_DISTRIBUTION_SERVICES_INC',
  Retired = 'RETIRED',
  RexnorCorp = 'REXNOR_CORP',
  RiddlebergerBrothersInc = 'RIDDLEBERGER_BROTHERS_INC',
  RiteAidStauntonNCoalterSt = 'RITE_AID_STAUNTON_N_COALTER_ST',
  RiteAidStauntonWBeverley = 'RITE_AID_STAUNTON_W_BEVERLEY',
  RiteAidStuartsDraft = 'RITE_AID_STUARTS_DRAFT',
  RiteAidVerona = 'RITE_AID_VERONA',
  RiteAidWaynesboro = 'RITE_AID_WAYNESBORO',
  RobertsOxygenCoInc = 'ROBERTS_OXYGEN_CO_INC',
  RockbridgeCountySchools = 'ROCKBRIDGE_COUNTY_SCHOOLS',
  RockbridgeFarmersCoOp = 'ROCKBRIDGE_FARMERS_CO_OP',
  RockinghamCoPublicSchools = 'ROCKINGHAM_CO_PUBLIC_SCHOOLS',
  RockinghamMemorialHospital = 'ROCKINGHAM_MEMORIAL_HOSPITAL',
  RockysGoldAndSilver = 'ROCKYS_GOLD_AND_SILVER',
  RosesWaynesboro = 'ROSES_WAYNESBORO',
  RossDressForLess = 'ROSS_DRESS_FOR_LESS',
  RowesFamilyRestaurant = 'ROWES_FAMILY_RESTAURANT',
  RubyTuesday = 'RUBY_TUESDAY',
  RuleHonda = 'RULE_HONDA',
  RuxtonHealthcare = 'RUXTON_HEALTHCARE',
  SallyBeautyStaunton2947 = 'SALLY_BEAUTY_STAUNTON_2947',
  SallyBeautyWaynesboro3606 = 'SALLY_BEAUTY_WAYNESBORO_3606',
  SAndWHomeAppliances = 'S_AND_W_HOME_APPLIANCES',
  SchewelFurnitureCoStaunton = 'SCHEWEL_FURNITURE_CO_STAUNTON',
  SchewelFurntitureWaynesboro = 'SCHEWEL_FURNTITURE_WAYNESBORO',
  ScottosItalianRestaurant = 'SCOTTOS_ITALIAN_RESTAURANT',
  SelfEmployed = 'SELF_EMPLOYED',
  SentryFoodMartStaunton = 'SENTRY_FOOD_MART_STAUNTON',
  SharpShopper = 'SHARP_SHOPPER',
  SheetzFishersville = 'SHEETZ_FISHERSVILLE',
  SheetzStaunton = 'SHEETZ_STAUNTON',
  SheetzStuartsDraft = 'SHEETZ_STUARTS_DRAFT',
  SheetzWaynesboro = 'SHEETZ_WAYNESBORO',
  ShenandoahNursingHome = 'SHENANDOAH_NURSING_HOME',
  ShenandoahRecycling = 'SHENANDOAH_RECYCLING',
  ShenandoahSharedHospitalSer = 'SHENANDOAH_SHARED_HOSPITAL_SER',
  ShenandoahValleySocialServ = 'SHENANDOAH_VALLEY_SOCIAL_SERV',
  ShenandoahValleySocialServi = 'SHENANDOAH_VALLEY_SOCIAL_SERVI',
  ShenandoahValleySurgical = 'SHENANDOAH_VALLEY_SURGICAL',
  Shentel = 'SHENTEL',
  ShenValleyElctricMtCrawfor = 'SHEN_VALLEY_ELCTRIC_MT_CRAWFOR',
  ShenValleyJuvenileDetenHme = 'SHEN_VALLEY_JUVENILE_DETEN_HME',
  ShenVallOrthoAndSportsMed = 'SHEN_VALL_ORTHO_AND_SPORTS_MED',
  SherwinWilliamsCoStaunton = 'SHERWIN_WILLIAMS_CO_STAUNTON',
  SherwinWilliamsCoWaynesboro = 'SHERWIN_WILLIAMS_CO_WAYNESBORO',
  ShickelCorporation = 'SHICKEL_CORPORATION',
  ShoffnerIndustries = 'SHOFFNER_INDUSTRIES',
  ShortCircuitElectronics = 'SHORT_CIRCUIT_ELECTRONICS',
  ShueyAgency = 'SHUEY_AGENCY',
  SidelinesCafe = 'SIDELINES_CAFE',
  SimmonsRoofing = 'SIMMONS_ROOFING',
  SiteResources = 'SITE_RESOURCES',
  SmartStart = 'SMART_START',
  SmileyTileStaunton = 'SMILEY_TILE_STAUNTON',
  SouthernElectric = 'SOUTHERN_ELECTRIC',
  SouthernStainlessEquipment = 'SOUTHERN_STAINLESS_EQUIPMENT',
  SouthernStates = 'SOUTHERN_STATES',
  SouthRiverComplex = 'SOUTH_RIVER_COMPLEX',
  SouthRiverRestaurant = 'SOUTH_RIVER_RESTAURANT',
  Spca = 'SPCA',
  SpecialtyBladesInc = 'SPECIALTY_BLADES_INC',
  Sprint = 'SPRINT',
  StanleyInsurance = 'STANLEY_INSURANCE',
  StaplesStaunton = 'STAPLES_STAUNTON',
  StarbucksStaunton = 'STARBUCKS_STAUNTON',
  StarbucksWayneRosserAve = 'STARBUCKS_WAYNE_ROSSER_AVE',
  StarbucksWayneTownCntr = 'STARBUCKS_WAYNE_TOWN_CNTR',
  StateFarmInsuranceAgency = 'STATE_FARM_INSURANCE_AGENCY',
  StauntonAugustaJuvenileCour = 'STAUNTON_AUGUSTA_JUVENILE_COUR',
  StauntonCityOf = 'STAUNTON_CITY_OF',
  StauntonCitySchools = 'STAUNTON_CITY_SCHOOLS',
  StauntonCountryClub = 'STAUNTON_COUNTRY_CLUB',
  StauntonDailyNewsLeader = 'STAUNTON_DAILY_NEWS_LEADER',
  StauntonFrozenFood = 'STAUNTON_FROZEN_FOOD',
  StauntonMachineWorks = 'STAUNTON_MACHINE_WORKS',
  StauntonMallFaisonMngmtSvs = 'STAUNTON_MALL_FAISON_MNGMT_SVS',
  StauntonPlumbingAndHeating = 'STAUNTON_PLUMBING_AND_HEATING',
  StauntonPoliceDepartment = 'STAUNTON_POLICE_DEPARTMENT',
  StauntonPostOfficeNAugust = 'STAUNTON_POST_OFFICE_N_AUGUST',
  StauntonRecreationalDept = 'STAUNTON_RECREATIONAL_DEPT',
  StauntonSteamLaundry = 'STAUNTON_STEAM_LAUNDRY',
  StauntonTractor = 'STAUNTON_TRACTOR',
  StauntonVeteransOpClinic = 'STAUNTON_VETERANS_OP_CLINIC',
  StauntonWrecking = 'STAUNTON_WRECKING',
  SteakNShake = 'STEAK_N_SHAKE',
  StellarOne = 'STELLAR_ONE',
  StevenToyota = 'STEVEN_TOYOTA',
  StLukesAssistedCareLiving = 'ST_LUKES_ASSISTED_CARE_LIVING',
  StonewallJacksonHospital = 'STONEWALL_JACKSON_HOSPITAL',
  StonewallJacksonHotel = 'STONEWALL_JACKSON_HOTEL',
  StopIn = 'STOP_IN',
  StuartHall = 'STUART_HALL',
  StuartsDraftChristianHome = 'STUARTS_DRAFT_CHRISTIAN_HOME',
  StuartsDraftFamilyPractice = 'STUARTS_DRAFT_FAMILY_PRACTICE',
  SubwayGreenvilleAvenue = 'SUBWAY_GREENVILLE_AVENUE',
  SummitSquare = 'SUMMIT_SQUARE',
  SunlitePlastics = 'SUNLITE_PLASTICS',
  SunspotsStudios = 'SUNSPOTS_STUDIOS',
  SuntrustBeverleyStBranch = 'SUNTRUST_BEVERLEY_ST_BRANCH',
  SuntrustBroadStBranch = 'SUNTRUST_BROAD_ST_BRANCH',
  Super8MotelStaunton = 'SUPER_8_MOTEL_STAUNTON',
  SuperShoes = 'SUPER_SHOES',
  SurrattTireInc = 'SURRATT_TIRE_INC',
  SwannConstructionCompany = 'SWANN_CONSTRUCTION_COMPANY',
  SyscoFoodServicesOfVa = 'SYSCO_FOOD_SERVICES_OF_VA',
  TacoBell = 'TACO_BELL',
  TacoBellOfWaynesboro = 'TACO_BELL_OF_WAYNESBORO',
  TacoBellStaunton = 'TACO_BELL_STAUNTON',
  TailgateGrill = 'TAILGATE_GRILL',
  TargetDistributionCenter = 'TARGET_DISTRIBUTION_CENTER',
  TargetStoreWaynesboro = 'TARGET_STORE_WAYNESBORO',
  TasteeFreezeChurchvilleVa = 'TASTEE_FREEZE_CHURCHVILLE_VA',
  TasteeFreezeWBeverly = 'TASTEE_FREEZE_W_BEVERLY',
  TexasSteakhouseAndSaloon = 'TEXAS_STEAKHOUSE_AND_SALOON',
  TheBradfordCompany = 'THE_BRADFORD_COMPANY',
  TheCheeseShop = 'THE_CHEESE_SHOP',
  TheFishingPigFarmville = 'THE_FISHING_PIG_FARMVILLE',
  TheFishingPigWaynesboro = 'THE_FISHING_PIG_WAYNESBORO',
  TheHomeDepotStore4654 = 'THE_HOME_DEPOT_STORE_4654',
  TheLegacyAtNorthAugusta = 'THE_LEGACY_AT_NORTH_AUGUSTA',
  TheLodgeAtOldTrail = 'THE_LODGE_AT_OLD_TRAIL',
  TheLycraCompany = 'THE_LYCRA_COMPANY',
  ThePilotTravelCenter = 'THE_PILOT_TRAVEL_CENTER',
  ThePurpleFoot = 'THE_PURPLE_FOOT',
  TireMart = 'TIRE_MART',
  TjMaxx = 'TJ_MAXX',
  ToddBrothersContractors = 'TODD_BROTHERS_CONTRACTORS',
  TransitMixConcreteCo = 'TRANSIT_MIX_CONCRETE_CO',
  TransportationPatient = 'TRANSPORTATION_PATIENT',
  TransprintUsa = 'TRANSPRINT_USA',
  TruckEnterprisesInc = 'TRUCK_ENTERPRISES_INC',
  TruckThermoKing = 'TRUCK_THERMO_KING',
  TycoElectronics = 'TYCO_ELECTRONICS',
  TycoElectronicsMtSidney = 'TYCO_ELECTRONICS_MT_SIDNEY',
  TysonFoodsInc = 'TYSON_FOODS_INC',
  Unemployed = 'UNEMPLOYED',
  UnifiIncStauntonPlant = 'UNIFI_INC_STAUNTON_PLANT',
  UnionFirstBankStaunton = 'UNION_FIRST_BANK_STAUNTON',
  UnionFirstBankStuartsDra = 'UNION_FIRST_BANK_STUARTS_DRA',
  UnionFirstBankWaynesboro = 'UNION_FIRST_BANK_WAYNESBORO',
  UnitedParcelServiceCville = 'UNITED_PARCEL_SERVICE_CVILLE',
  UnitedParcelServiceFisvill = 'UNITED_PARCEL_SERVICE_FISVILL',
  UniversalImpactStaunton = 'UNIVERSAL_IMPACT_STAUNTON',
  UniversalImpactWaynesboro = 'UNIVERSAL_IMPACT_WAYNESBORO',
  UniversityOfVirginia = 'UNIVERSITY_OF_VIRGINIA',
  Unknown = 'UNKNOWN',
  UPMC = 'UPMC',
  Usda = 'USDA',
  USPostalServiceBlueGrass = 'U_S_POSTAL_SERVICE_BLUE_GRASS',
  VaAbcStoreStateStStaunton = 'VA_ABC_STORE_STATE_ST_STAUNTON',
  VaAbcStoreStuartsDraft = 'VA_ABC_STORE_STUARTS_DRAFT',
  VaAbcStoreVerona = 'VA_ABC_STORE_VERONA',
  VaAbcStoreWaynesboro = 'VA_ABC_STORE_WAYNESBORO',
  VaAugustaCorrectionalCenter = 'VA_AUGUSTA_CORRECTIONAL_CENTER',
  VaDepartOfHealthLexington = 'VA_DEPART_OF_HEALTH/LEXINGTON',
  VaDeptGameInlandFisheries = 'VA_DEPT_GAME_INLAND_FISHERIES',
  VaDeptOfRehabilitativeSvs = 'VA_DEPT_OF_REHABILITATIVE_SVS',
  VaDeptOfTransporationVdot = 'VA_DEPT_OF_TRANSPORATION_VDOT',
  VaDmvStaunton = 'VA_DMV_STAUNTON',
  VaDmvWaynesboro = 'VA_DMV_WAYNESBORO',
  VailesBrotherInc = 'VAILES_BROTHER_INC',
  ValleyBlox = 'VALLEY_BLOX',
  ValleyBuildingSupply = 'VALLEY_BUILDING_SUPPLY',
  ValleyCommunityServices = 'VALLEY_COMMUNITY_SERVICES',
  ValleyCraneAndRigging = 'VALLEY_CRANE_AND_RIGGING',
  ValleyCreditService = 'VALLEY_CREDIT_SERVICE',
  ValleyHonda = 'VALLEY_HONDA',
  ValleyMission = 'VALLEY_MISSION',
  ValleyNissan = 'VALLEY_NISSAN',
  ValleyOfficeMachinesEquip = 'VALLEY_OFFICE_MACHINES_EQUIP',
  ValleyOilCorporation = 'VALLEY_OIL_CORPORATION',
  ValleyPool = 'VALLEY_POOL',
  ValleyPoolSpaStaunton = 'VALLEY_POOL_SPA_STAUNTON',
  ValleyPrecisionInc = 'VALLEY_PRECISION_INC',
  ValleyProgramForAgingSvs = 'VALLEY_PROGRAM_FOR_AGING_SVS',
  ValleystarCreditUnion = 'VALLEYSTAR_CREDIT_UNION',
  ValleyVocTechCenter = 'VALLEY_VOC_TECH_CENTER',
  VanWykInc = 'VAN_WYK_INC',
  VaSchoolForDeafAndBlind = 'VA_SCHOOL_FOR_DEAF_&_BLIND',
  VectorIndustriesInc = 'VECTOR_INDUSTRIES_INC',
  Verizon = 'VERIZON',
  VillageGardenCenter = 'VILLAGE_GARDEN_CENTER',
  VirginiaAbcStoreGreenAve = 'VIRGINIA_ABC_STORE_GREEN_AVE',
  VirginiaDeptOfMentalHealth = 'VIRGINIA_DEPT_OF_MENTAL_HEALTH',
  VirginiaEmploymentCommission = 'VIRGINIA_EMPLOYMENT_COMMISSION',
  VirginiaFrameBuilderSuppl = 'VIRGINIA_FRAME_BUILDER_SUPPL',
  VirginiaHorseCenter = 'VIRGINIA_HORSE_CENTER',
  VirginiaMetalcrafters = 'VIRGINIA_METALCRAFTERS',
  VirginiaMilitaryInstitute = 'VIRGINIA_MILITARY_INSTITUTE',
  VirginiaPanelCorp = 'VIRGINIA_PANEL_CORP',
  VirginiaRegionalTransit = 'VIRGINIA_REGIONAL_TRANSIT',
  VirginiaStatePolice = 'VIRGINIA_STATE_POLICE',
  WaffleHouseStaunton = 'WAFFLE_HOUSE_STAUNTON',
  WaffleHouseWaynesboro = 'WAFFLE_HOUSE_WAYNESBORO',
  WalkerManufacturingCo = 'WALKER_MANUFACTURING_CO',
  WallaceCharlesDds = 'WALLACE_CHARLES_DDS',
  WalmartDistributionCenter = 'WALMART_DISTRIBUTION_CENTER',
  WalmartGordonsvilleVa = 'WALMART_GORDONSVILLE_VA',
  WalmartHarrisonburgBurgess = 'WALMART_HARRISONBURG_BURGESS',
  WalmartHarrisonburgJohnWayl = 'WALMART_HARRISONBURG_JOHN_WAYL',
  WalmartLexington = 'WALMART_LEXINGTON',
  WalmartNeighborMarketHburg = 'WALMART_NEIGHBOR_MARKET_HBURG',
  WalmartNeighborMarketWayne = 'WALMART_NEIGHBOR_MARKET_WAYNE',
  WalMartOfStaunton = 'WAL_MART_OF_STAUNTON',
  WalMartOfWaynesboro = 'WAL_MART_OF_WAYNESBORO',
  WashingtonAndLeeUniversity = 'WASHINGTON_AND_LEE_UNIVERSITY',
  WayneLanes = 'WAYNE_LANES',
  WaynesboroCityOf = 'WAYNESBORO_CITY_OF',
  WaynesboroCitySchools = 'WAYNESBORO_CITY_SCHOOLS',
  WaynesboroCityShop = 'WAYNESBORO_CITY_SHOP',
  WaynesboroCountyClub = 'WAYNESBORO_COUNTY_CLUB',
  WaynesboroFireDepartment = 'WAYNESBORO_FIRE_DEPARTMENT',
  WaynesboroFirstAidCrew = 'WAYNESBORO_FIRST_AID_CREW',
  WaynesboroHealthDept = 'WAYNESBORO_HEALTH_DEPT',
  WaynesboroLandscapeGarden = 'WAYNESBORO_LANDSCAPE_GARDEN',
  WaynesboroManor = 'WAYNESBORO_MANOR',
  WaynesboroNewsVirginian = 'WAYNESBORO_NEWS_VIRGINIAN',
  WaynesboroNurseries = 'WAYNESBORO_NURSERIES',
  WaynesboroPostOffice = 'WAYNESBORO_POST_OFFICE',
  WaynesboroPostOffPkStation = 'WAYNESBORO_POST_OFF_PK_STATION',
  WebsterAndWebster = 'WEBSTER_AND_WEBSTER',
  WelderSupply = 'WELDER_SUPPLY',
  WellsFargoRoanokeOffice = 'WELLS_FARGO_ROANOKE_OFFICE',
  WellsFargoWaynesboro = 'WELLS_FARGO_WAYNESBORO',
  WendysFamilyRestaurant = 'WENDYS_FAMILY_RESTAURANT',
  WendysFishersville = 'WENDYS_FISHERSVILLE',
  WendysStaunton = 'WENDYS_STAUNTON',
  WendysVerona = 'WENDYS_VERONA',
  WendysWaynesboro = 'WENDYS_WAYNESBORO',
  WesternStateHospital = 'WESTERN_STATE_HOSPITAL',
  WesthillsCompany = 'WESTHILLS_COMPANY',
  WestSandAndGravelCoInc = 'WEST_SAND_AND_GRAVEL_CO_INC',
  WestwoodAnimalHospital = 'WESTWOOD_ANIMAL_HOSPITAL',
  WetselSeedCompany = 'WETSEL_SEED_COMPANY',
  WheatleyMotorCarCompany = 'WHEATLEY_MOTOR_CAR_COMPANY',
  WhitesellsSalesAndService = 'WHITESELLS_SALES_AND_SERVICE',
  WhitesTruckStop = 'WHITES_TRUCK_STOP',
  WildlifeCenterOfVirginia = 'WILDLIFE_CENTER_OF_VIRGINIA',
  WilhelmInsuranceCompany = 'WILHELM_INSURANCE_COMPANY',
  WillowTreeAcademy = 'WILLOW_TREE_ACADEMY',
  WilsonTruckingCo = 'WILSON_TRUCKING_CO',
  WilsonWorkforceRehabCenter = 'WILSON_WORKFORCE_REHAB_CENTER',
  WineJBAndSonsContractors = 'WINE_J_B_AND_SONS_CONTRACTORS',
  WintergreenPoliceDept = 'WINTERGREEN_POLICE_DEPT',
  WintergreenResort = 'WINTERGREEN_RESORT',
  WniIndustrialServices = 'WNI_INDUSTRIAL_SERVICES',
  WVUMedicine = 'WVU_MEDICINE',
  WoodForestNationalBank = 'WOOD_FOREST_NATIONAL_BANK',
  WtonOgdenBroadcastingOfVa = 'WTON_OGDEN_BROADCASTING_OF_VA',
  WvirTv = 'WVIR_TV',
  YanceyLumberyard = 'YANCEY_LUMBERYARD',
  YellowFreightSysIncStaunto = 'YELLOW_FREIGHT_SYS_INC_STAUNTO',
  YellowRoadwayCorporation = 'YELLOW_ROADWAY_CORPORATION',
  YmcaStaunton = 'YMCA_STAUNTON',
  YmcaWaynesboro = 'YMCA_WAYNESBORO',
  ZeusDigitalTheater = 'ZEUS_DIGITAL_THEATER',

  // the list below this line was added for chesapeake regional
  '1Plumber40' = '1_PLUMBER40',
  '1Plumber4UInc' = '1_PLUMBER_4_U_INC',
  '1stImpressions' = '1ST_IMPRESSIONS',
  '1stVirginia' = '1ST_VIRGINIA',
  '24Roadside' = '24_ROADSIDE',
  '2ndsInBuildingMaterials,In' = '2NDS_IN_BUILDING_MATERIALS,_IN',
  '5MTruckingLlc' = '5_M_TRUCKING_LLC',
  '7-11' = '7-11',
  '7-11MaidStreet' = '7-11_MAID_STREET',
  '7-eleven' = '7-ELEVEN',
  '717-7901AlishaOkToContact' = '717-7901_ALISHA_OK_TO_CONTACT',
  '717ParkingEnterprise' = '717_PARKING_ENTERPRISE',
  '757-295-1457Juan-son2ndCont' = '757-295-1457_JUAN-SON_2ND_CONT',
  '757-546-2490' = '757-546-2490',
  '757Crave' = '757_CRAVE',
  '7CitiesLawnMaintenanceLlc' = '7_CITIES_LAWN_MAINTENANCE_LLC',
  'A&AInsurance&Investments' = 'A_&_A_INSURANCE_&_INVESTMENTS',
  'A&AInsuranceAndInvestments' = 'A_&_A_INSURANCE_AND_INVESTMENTS',
  'A&ESearsRepair' = 'A_&_E_SEARS_REPAIR',
  'A&IProducts' = 'A_&_I_PRODUCTS',
  'A&eMovingAndStorage' = 'A&E_MOVING_AND_STORAGE',
  'A&eTechnologies' = 'A_&E_TECHNOLOGIES',
  'A&lTransit' = 'A&L_TRANSIT',
  'A.j.Gators' = 'A.J._GATORS',
  'A.r.Chesson' = 'A.R._CHESSON',
  'ACreative' = 'A_CREATIVE',
  'AGlawmorousPetPawlor' = 'A_GLAWMOROUS_PET_PAWLOR',
  'AHelpingHand' = 'A_HELPING_HAND',
  'AJGators' = 'A_J_GATORS',
  'APerfectPetSitter' = 'A_PERFECT_PET_SITTER',
  'AStatewideInc' = 'A_STATEWIDE_INC',
  'ATeamPlumbingOnc' = 'A_TEAM_PLUMBING_ONC',
  'ATeamShipRepair' = 'A_TEAM_SHIP_REPAIR',
  'Aaa' = 'AAA',
  'AaaaSelfStorage' = 'AAAA_SELF_STORAGE',
  'AamcoTransmission' = 'AAMCO_TRANSMISSION',
  'AarAirlift' = 'AAR_AIRLIFT',
  'Aarcorp' = 'AARCORP',
  'Aard' = 'AARD',
  'Aarp' = 'AARP',
  'AbaWellAndSepticService' = 'ABA_WELL_AND_SEPTIC_SERVICE',
  'Abaccus' = 'ABACCUS',
  'AbacusStaffingServices' = 'ABACUS_STAFFING_SERVICES',
  'AbacusTemp' = 'ABACUS_TEMP',
  'AbalonPestControl' = 'ABALON_PEST_CONTROL',
  'AbbeyHorwitzDds' = 'ABBEY_HORWITZ_DDS',
  'Abbvie' = 'ABBVIE',
  'Abc' = 'ABC',
  'Abc-assistantManager' = 'ABC-ASSISTANT_MANAGER',
  'AbcSupplyCo.' = 'ABC_SUPPLY_CO.',
  'Abercombie,Simmons&Gillett.' = 'ABERCOMBIE,_SIMMONS_&_GILLETT.',
  'Abercrombie,Simmons,Gillette' = 'ABERCROMBIE,_SIMMONS,_GILLETTE',
  'AbesMobileRepair' = 'ABES_MOBILE_REPAIR',
  'AbilitiesRegionalDisabilities' = 'ABILITIES_REGIONAL_DISABILITIES',
  'AbmBuilding' = 'ABM_BUILDING',
  'AbmIndustries' = 'ABM_INDUSTRIES',
  'AbnbFcu' = 'ABNB_FCU',
  'AbnbFederalCreditUnion' = 'ABNB_FEDERAL_CREDIT_UNION',
  'Acadamy' = 'ACADAMY',
  'Academi' = 'ACADEMI',
  'AcademiTrainingCenter' = 'ACADEMI_TRAINING_CENTER',
  'AcademieDeBallet' = 'ACADEMIE_DE_BALLET',
  'AcademyTrainingCtr' = 'ACADEMY_TRAINING_CTR',
  'AccessAidsCare' = 'ACCESS_AIDS_CARE',
  'AccessPartnership' = 'ACCESS_PARTNERSHIP',
  'Acclimatize' = 'ACCLIMATIZE',
  'AccountingPrincipals' = 'ACCOUNTING_PRINCIPALS',
  'AccurateDraftingInc' = 'ACCURATE_DRAFTING_INC',
  'AccursreCourierExpress' = 'ACCURSRE_COURIER_EXPRESS',
  'AceSheetMetalWorks' = 'ACE_SHEET_METAL_WORKS',
  'AcepexCorp' = 'ACEPEX_CORP',
  'AcfEnviromental' = 'ACF_ENVIROMENTAL',
  'Aclj' = 'ACLJ',
  'Acosta' = 'ACOSTA',
  'AcostaRetail' = 'ACOSTA_RETAIL',
  'AcostaSales&Marketing' = 'ACOSTA_SALES_&_MARKETING',
  'AcredaleAnimalHospital' = 'ACREDALE_ANIMAL_HOSPITAL',
  'AcrylicDesign&Fabrication' = 'ACRYLIC_DESIGN_&_FABRICATION',
  'Acs' = 'ACS',
  'AcselCorp' = 'ACSEL_CORP',
  'AdiConstruction' = 'ADI_CONSTRUCTION',
  'Adj' = 'ADJ',
  'Adp' = 'ADP',
  'AdrianBuildersGroup' = 'ADRIAN_BUILDERS_GROUP',
  'AdroitUtilitiesInc' = 'ADROIT_UTILITIES_INC',
  'Ads,Inc' = 'ADS,_INC',
  'Adt,llc' = 'ADT,LLC',
  'AdultProbation&Parole' = 'ADULT_PROBATION_&_PAROLE',
  'AdvanceAauto' = 'ADVANCE_AAUTO',
  'AdvanceAuto' = 'ADVANCE_AUTO',
  'AdvanceAutoParts' = 'ADVANCE_AUTO_PARTS',
  'AdvanceTitle&Abstract,Inc' = 'ADVANCE_TITLE_&_ABSTRACT,_INC',
  'AdvancedAeroMedicalInc' = 'ADVANCED_AERO_MEDICAL_INC',
  'AdvancedEngServices' = 'ADVANCED_ENG_SERVICES',
  'AdvancedFootAndAnkleCare' = 'ADVANCED_FOOT_AND_ANKLE_CARE',
  'AdvancedTechnologiesInc' = 'ADVANCED_TECHNOLOGIES_INC',
  'AdvancedWaterproofing&Rest' = 'ADVANCED_WATERPROOFING_&_REST',
  'AdvantageHeatingAndCooling' = 'ADVANTAGE_HEATING_AND_COOLING',
  'AdvantageInvesting,Inc.' = 'ADVANTAGE_INVESTING,_INC.',
  'AdventureBmw' = 'ADVENTURE_BMW',
  'Aec' = 'AEC',
  'AecNarrow' = 'AEC_NARROW',
  'AecNarrowFabricsOfVa' = 'AEC_NARROW_FABRICS_OF_VA',
  'Aecom' = 'AECOM',
  'AegeanPool' = 'AEGEAN_POOL',
  'AegeanPools,Inc' = 'AEGEAN_POOLS,_INC',
  'AeroPestControl' = 'AERO_PEST_CONTROL',
  'Aerotek' = 'AEROTEK',
  'Aetna/Coventry' = 'AETNA_/_COVENTRY',
  'AetnaInsulatedWireCo' = 'AETNA_INSULATED_WIRE_CO',
  'Afbs' = 'AFBS',
  'Afc' = 'AFC',
  'AffordableAutoGlass' = 'AFFORDABLE_AUTO_GLASS',
  'AffordableDentu' = 'AFFORDABLE_DENTU',
  'AffordableDentures' = 'AFFORDABLE_DENTURES',
  'AffordableEngneeringServices' = 'AFFORDABLE_ENGNEERING_SERVICES',
  'AfiniteInc' = 'AFINITE_INC',
  'Aflac' = 'AFLAC',
  'AfordableDentures' = 'AFORDABLE_DENTURES',
  'AgcarolinaFarmcredit' = 'AGCAROLINA_FARMCREDIT',
  'AgentWallSystemsInc' = 'AGENT_WALL_SYSTEMS_INC',
  'Agfm' = 'AGFM',
  'Agi' = 'AGI',
  'AglResources' = 'AGL_RESOURCES',
  'AgriumCropProductionSvcs' = 'AGRIUM_CROP_PRODUCTION_SVCS',
  'AgviqLlc' = 'AGVIQ_LLC',
  'AhpConstructionLlc' = 'AHP_CONSTRUCTION_LLC',
  'AimcoReflections' = 'AIMCO_REFLECTIONS',
  'AinPlastics' = 'AIN_PLASTICS',
  'AirConditioningSpecialist' = 'AIR_CONDITIONING_SPECIALIST',
  'AirHandlersMechanical' = 'AIR_HANDLERS_MECHANICAL',
  'AirMethodsCorp' = 'AIR_METHODS_CORP',
  'AirSystemsInc' = 'AIR_SYSTEMS_INC',
  'AirSystemsIntl' = 'AIR_SYSTEMS_INTL',
  'AirWisconsin' = 'AIR_WISCONSIN',
  'AirWisconsinAirlinesCorp' = 'AIR_WISCONSIN_AIRLINES_CORP',
  'AirshipMovementService' = 'AIRSHIP_MOVEMENT_SERVICE',
  'Ait' = 'AIT',
  'AjGators' = 'AJ_GATORS',
  'AjGatorsSportsBarsFrill' = 'AJ_GATORS_SPORTS_BARS_FRILL',
  'AjWright' = 'AJ_WRIGHT',
  'AkAutoGroup' = 'AK_AUTO_GROUP',
  'AkimaTechnicalSolutions' = 'AKIMA_TECHNICAL_SOLUTIONS',
  'Al-anonFamilyGroup' = 'AL-ANON_FAMILY_GROUP',
  'AlFornoPizzeria' = 'AL_FORNO_PIZZERIA',
  'AlanticResearch' = 'ALANTIC_RESEARCH',
  'AlaskaTankerCo' = 'ALASKA_TANKER_CO',
  'AlbamarleDist.Co' = 'ALBAMARLE_DIST._CO',
  'AlbanoCleaners' = 'ALBANO_CLEANERS',
  'Albanos' = 'ALBANOS',
  'AlbemarlSchool' = 'ALBEMARL_SCHOOL',
  'Albemarle' = 'ALBEMARLE',
  'AlbemarleAlliance' = 'ALBEMARLE_ALLIANCE',
  'AlbemarleChiropractorOffices' = 'ALBEMARLE_CHIROPRACTOR_OFFICES',
  'AlbemarleCommission' = 'ALBEMARLE_COMMISSION',
  'AlbemarleCommissionerOffice' = 'ALBEMARLE_COMMISSIONER_OFFICE',
  'AlbemarleDistributing' = 'ALBEMARLE_DISTRIBUTING',
  'AlbemarleElectric' = 'ALBEMARLE_ELECTRIC',
  'AlbemarleEmc' = 'ALBEMARLE_EMC',
  'AlbemarleEyeCenter' = 'ALBEMARLE_EYE_CENTER',
  'AlbemarleFabricAndFloor' = 'ALBEMARLE_FABRIC_AND_FLOOR',
  'AlbemarleHealth' = 'ALBEMARLE_HEALTH',
  'AlbemarleHealthDepartment' = 'ALBEMARLE_HEALTH_DEPARTMENT',
  'AlbemarleHealthService' = 'ALBEMARLE_HEALTH_SERVICE',
  'AlbemarleHomeCare' = 'ALBEMARLE_HOME_CARE',
  'AlbemarleHopeLine' = 'ALBEMARLE_HOPE_LINE',
  'AlbemarleHopeline' = 'ALBEMARLE_HOPELINE',
  'AlbemarleHospice' = 'ALBEMARLE_HOSPICE',
  'AlbemarleHospit' = 'ALBEMARLE_HOSPIT',
  'AlbemarleHospital' = 'ALBEMARLE_HOSPITAL',
  'AlbemarleHospitalAuthority,Inc' = 'ALBEMARLE_HOSPITAL_AUTHORITY,_INC',
  'AlbemarleHospitalFoundation' = 'ALBEMARLE_HOSPITAL_FOUNDATION',
  'AlbemarleNephrology' = 'ALBEMARLE_NEPHROLOGY',
  'AlbemarleOrthoticsAndProsthetics' = 'ALBEMARLE_ORTHOTICS_AND_PROSTHETICS',
  'AlbemarlePropane' = 'ALBEMARLE_PROPANE',
  'AlbemarlePulmonaryMed' = 'ALBEMARLE_PULMONARY_MED',
  'AlbemarleReg.HealthServices' = 'ALBEMARLE_REG._HEALTH_SERVICES',
  'AlbemarleRegionalHealth' = 'ALBEMARLE_REGIONAL_HEALTH',
  'AlbemarleRegionalHealthServices' = 'ALBEMARLE_REGIONAL_HEALTH_SERVICES',
  'AlbemarleSchoolOfTheArts' = 'ALBEMARLE_SCHOOL_OF_THE_ARTS',
  'AlbemarleSmartStartPartnership' = 'ALBEMARLE_SMART_START_PARTNERSHIP',
  'AlbemarleTreeServiceInc' = 'ALBEMARLE_TREE_SERVICE_INC',
  'AlbermarleAllianceForChildren&Families' = 'ALBERMARLE_ALLIANCE_FOR_CHILDREN_&_FAMILIES',
  'AlbermarleEnt,Asthma&Aller' = 'ALBERMARLE_ENT,_ASTHMA_&_ALLER',
  'AlbermarleHospital' = 'ALBERMARLE_HOSPITAL',
  'AlbermarleRegionalHealthSers' = 'ALBERMARLE_REGIONAL_HEALTH_SERS',
  'AlbermarleRegionalHealthSres.' = 'ALBERMARLE_REGIONAL_HEALTH_SRES.',
  'AldrichEngineering' = 'ALDRICH_ENGINEERING',
  'AlexanderBaptistChurch' = 'ALEXANDER_BAPTIST_CHURCH',
  'AlfaLavalInc' = 'ALFA_LAVAL_INC',
  'AlightSolutions' = 'ALIGHT_SOLUTIONS',
  'AlionScience&Technology' = 'ALION_SCIENCE_&_TECHNOLOGY',
  'AlionScience' = 'ALION_SCIENCE',
  'AlionScienceAndTech' = 'ALION_SCIENCE_AND_TECH',
  'AllAboutYouHairSalon' = 'ALL_ABOUT_YOU_HAIR_SALON',
  'AllAroundTowing' = 'ALL_AROUND_TOWING',
  'AllForOneHomeHealthcare' = 'ALL_FOR_ONE_HOME_HEALTHCARE',
  'AllHeartHomeHealth' = 'ALL_HEART_HOME_HEALTH',
  'AllHeartHomeHealth/hospice' = 'ALL_HEART_HOME_HEALTH/HOSPICE',
  'AllMotiveInc' = 'ALL_MOTIVE_INC',
  'AllPartsPoolAndSpa' = 'ALL_PARTS_POOL_AND_SPA',
  'AllProLandscapeSvcsInc' = 'ALL_PRO_LANDSCAPE_SVCS_INC',
  'AllProsRealEstate' = 'ALL_PROS_REAL_ESTATE',
  'AllProsRealty' = 'ALL_PROS_REALTY',
  'Allegis' = 'ALLEGIS',
  'AllfirstLlc' = 'ALLFIRST_LLC',
  'AllianceEngineering' = 'ALLIANCE_ENGINEERING',
  'AllianceMaterialsHandling' = 'ALLIANCE_MATERIALS_HANDLING',
  'AlliantInsuranceServices' = 'ALLIANT_INSURANCE_SERVICES',
  'AllianzPartners' = 'ALLIANZ_PARTNERS',
  'AlliedConcreteProducts' = 'ALLIED_CONCRETE_PRODUCTS',
  'AlliedForces' = 'ALLIED_FORCES',
  'AlliedInstructionalServices' = 'ALLIED_INSTRUCTIONAL_SERVICES',
  'AlliedSystems' = 'ALLIED_SYSTEMS',
  'AlliedTechGroup' = 'ALLIED_TECH_GROUP',
  'AlliedTransportationCo' = 'ALLIED_TRANSPORTATION_CO',
  'AlliedUniversal' = 'ALLIED_UNIVERSAL',
  'AlliedVanLines' = 'ALLIED_VAN_LINES',
  'AllstarHealth/centuraCollege' = 'ALLSTAR_HEALTH/CENTURA_COLLEGE',
  'Allstate' = 'ALLSTATE',
  'AllstateEquipment' = 'ALLSTATE_EQUIPMENT',
  'AllstateInsuran' = 'ALLSTATE_INSURAN',
  'AllureTheSalon' = 'ALLURE_THE_SALON',
  'Alsco' = 'ALSCO',
  'Alside' = 'ALSIDE',
  'AlutiigLlc' = 'ALUTIIG_LLC',
  'AlutiiqLlc' = 'ALUTIIQ_LLC',
  'Alutiq' = 'ALUTIQ',
  'Alvis&CheesebrewInc' = 'ALVIS_&_CHEESEBREW_INC',
  'AlwaysStylin' = 'ALWAYS_STYLIN',
  'AmaricanInternationalSchoolOfAbuji' = 'AMARICAN_INTERNATIONAL_SCHOOL_OF_ABUJI',
  'AmbroseFurniture' = 'AMBROSE_FURNITURE',
  'AmcSpecialty' = 'AMC_SPECIALTY',
  'AmedsysHomeHealth' = 'AMEDSYS_HOME_HEALTH',
  'AmenSaveMatgage' = 'AMEN_SAVE_MATGAGE',
  'Amentum' = 'AMENTUM',
  'AmericaSignatureFurniture' = 'AMERICA_SIGNATURE_FURNITURE',
  'AmericanAirlines' = 'AMERICAN_AIRLINES',
  'AmericanAuto&Alignment' = 'AMERICAN_AUTO_&_ALIGNMENT',
  'AmericanAutoAuction' = 'AMERICAN_AUTO_AUCTION',
  'AmericanCenterForLaw&Justice' = 'AMERICAN_CENTER_FOR_LAW_&_JUSTICE',
  'AmericanConstructionServices' = 'AMERICAN_CONSTRUCTION_SERVICES',
  'AmericanEngineering' = 'AMERICAN_ENGINEERING',
  'AmericanExpress' = 'AMERICAN_EXPRESS',
  'AmericanFunds' = 'AMERICAN_FUNDS',
  'AmericanGfmCor' = 'AMERICAN_GFM_COR',
  'AmericanHealthLaboratory' = 'AMERICAN_HEALTH_LABORATORY',
  'AmericanInc' = 'AMERICAN_INC',
  'AmericanInsulation' = 'AMERICAN_INSULATION',
  'AmericanPileDriving' = 'AMERICAN_PILE_DRIVING',
  'AmericanRedCross' = 'AMERICAN_RED_CROSS',
  'AmericanRedcross' = 'AMERICAN_REDCROSS',
  'AmericanSeniorCare' = 'AMERICAN_SENIOR_CARE',
  'AmericanSystem' = 'AMERICAN_SYSTEM',
  'Americgroup' = 'AMERICGROUP',
  'Americom/centricData' = 'AMERICOM/CENTRIC_DATA',
  'Americomm' = 'AMERICOMM',
  'Amerigroup' = 'AMERIGROUP',
  'AmerigroupCommunityCare' = 'AMERIGROUP_COMMUNITY_CARE',
  'AmerigroupCorp' = 'AMERIGROUP_CORP',
  'AmerigroupCorporation' = 'AMERIGROUP_CORPORATION',
  'Amerivivor&Assoc' = 'AMERIVIVOR_&_ASSOC',
  'AmfBowlingCenters' = 'AMF_BOWLING_CENTERS',
  'AmfBowlingWorldwide' = 'AMF_BOWLING_WORLDWIDE',
  'AmnAviationInst' = 'AMN_AVIATION_INST',
  'AmnHelthcare' = 'AMN_HELTHCARE',
  'AmpmorElectricCorp' = 'AMPMOR_ELECTRIC_CORP',
  'AmsLlc' = 'AMS_LLC',
  'Amsec' = 'AMSEC',
  'AmsecLlc' = 'AMSEC_LLC',
  'AnchorCanteen/beachFord' = 'ANCHOR_CANTEEN/BEACH_FORD',
  'AndersenLogistics' = 'ANDERSEN_LOGISTICS',
  'AndersonConstruction' = 'ANDERSON_CONSTRUCTION',
  'Andreas' = 'ANDREAS',
  'AndreasPizza' = 'ANDREAS_PIZZA',
  'AndrewG.Wiggin,P.c.' = 'ANDREW_G._WIGGIN,_P.C.',
  'AndyWise' = 'ANDY_WISE',
  'AngelAdvancedTechnologies' = 'ANGEL_ADVANCED_TECHNOLOGIES',
  'AngelaNManzPc' = 'ANGELA_N_MANZ_PC',
  'AngiesHouseOfBeauty' = 'ANGIES_HOUSE_OF_BEAUTY',
  'AnieshCorp' = 'ANIESH_CORP',
  'AnimalAdventure' = 'ANIMAL_ADVENTURE',
  'AnimalLoversAsst.League' = 'ANIMAL_LOVERS_ASST._LEAGUE',
  'AnimalMedicalClinic' = 'ANIMAL_MEDICAL_CLINIC',
  'AnnsHalmark' = 'ANNS_HALMARK',
  'AntechSystems,Inc.' = 'ANTECH_SYSTEMS,_INC.',
  'AnteonCorp' = 'ANTEON_CORP',
  'AnthemBc' = 'ANTHEM_BC',
  'AnthemHealthkeepers' = 'ANTHEM_HEALTHKEEPERS',
  'AnthemInc' = 'ANTHEM_INC',
  'AntiqueDealer' = 'ANTIQUE_DEALER',
  'AnzellAutomotive' = 'ANZELL_AUTOMOTIVE',
  'ApexSystems' = 'APEX_SYSTEMS',
  'ApiTechnicalSvcs' = 'API_TECHNICAL_SVCS',
  'ApogeeSolutions' = 'APOGEE_SOLUTIONS',
  'Apollo,Inc' = 'APOLLO,_INC',
  'ApostlesLutheran' = 'APOSTLES_LUTHERAN',
  'Apple' = 'APPLE',
  'AppleDoorSystems' = 'APPLE_DOOR_SYSTEMS',
  'AppleTreeKids' = 'APPLE_TREE_KIDS',
  'AppleTreeLearningCenter' = 'APPLE_TREE_LEARNING_CENTER',
  'Applebees' = 'APPLEBEES',
  'Applebees/Kohls' = 'APPLEBEES/_KOHLS',
  'AppleoneEmployementAgency' = 'APPLEONE_EMPLOYEMENT_AGENCY',
  'AppletreeLearningCenter' = 'APPLETREE_LEARNING_CENTER',
  'AppliedGlobalTech' = 'APPLIED_GLOBAL_TECH',
  'ApriaHealthcare' = 'APRIA_HEALTHCARE',
  'AquaRestaurant' = 'AQUA_RESTAURANT',
  'AramarkCorp' = 'ARAMARK_CORP',
  'Arc3Gases' = 'ARC_3_GASES',
  'ArcherWestern' = 'ARCHER_WESTERN',
  'ArchitechturalGraphicsInc' = 'ARCHITECHTURAL_GRAPHICS_INC',
  'ArchitecturalGraphics' = 'ARCHITECTURAL_GRAPHICS',
  'AreoCare' = 'AREO_CARE',
  'ArkieChristianPreschool' = 'ARKIE_CHRISTIAN_PRESCHOOL',
  'ArkieDayCare' = 'ARKIE_DAY_CARE',
  'ArkieDaycare' = 'ARKIE_DAYCARE',
  'ArlingtonProperties' = 'ARLINGTON_PROPERTIES',
  'ArmadaHoffler' = 'ARMADA_HOFFLER',
  'ArmelEnterprisesInc' = 'ARMEL_ENTERPRISES_INC',
  'ArmorCorrectionalHealthServices' = 'ARMOR_CORRECTIONAL_HEALTH_SERVICES',
  'Army' = 'ARMY',
  'ArreffTerminalsInc' = 'ARREFF_TERMINALS_INC',
  'ArribaCorp' = 'ARRIBA_CORP',
  'ArrowHeadFarms' = 'ARROW_HEAD_FARMS',
  'ArsInc' = 'ARS_INC',
  'ArtesianAquafarms' = 'ARTESIAN_AQUAFARMS',
  'ArtisanMarble&Tile' = 'ARTISAN_MARBLE_&_TILE',
  'ArvonStaffing' = 'ARVON_STAFFING',
  'Ascap' = 'ASCAP',
  'Ascensus' = 'ASCENSUS',
  'AsphaltRoads&Materials' = 'ASPHALT_ROADS_&_MATERIALS',
  'AsphaltRoads' = 'ASPHALT_ROADS',
  'AssociatedBuildersAndContractors-va' = 'ASSOCIATED_BUILDERS_AND_CONTRACTORS-VA',
  'AssociatedDistributors' = 'ASSOCIATED_DISTRIBUTORS',
  'Asthma&AllergySpecialists' = 'ASTHMA_&_ALLERGY_SPECIALISTS',
  'AstrusInsuranceSolutions' = 'ASTRUS_INSURANCE_SOLUTIONS',
  'AtYourService' = 'AT_YOUR_SERVICE',
  'Atemps' = 'ATEMPS',
  'Ati' = 'ATI',
  'AtkinsContracting' = 'ATKINS_CONTRACTING',
  'AtlanticAnesthesia' = 'ATLANTIC_ANESTHESIA',
  'AtlanticBayMortgage' = 'ATLANTIC_BAY_MORTGAGE',
  'AtlanticBayMortgageGroup' = 'ATLANTIC_BAY_MORTGAGE_GROUP',
  'AtlanticCoastal' = 'ATLANTIC_COASTAL',
  'AtlanticCoastalContractors' = 'ATLANTIC_COASTAL_CONTRACTORS',
  'AtlanticCommTe' = 'ATLANTIC_COMM_TE',
  'AtlanticEnvironmental' = 'ATLANTIC_ENVIRONMENTAL',
  'AtlanticFabrication&BoilerServices' = 'ATLANTIC_FABRICATION_&_BOILER_SERVICES',
  'AtlanticFinancialService' = 'ATLANTIC_FINANCIAL_SERVICE',
  'AtlanticFinancialServices' = 'ATLANTIC_FINANCIAL_SERVICES',
  'AtlanticFoot&AnkleCenter' = 'ATLANTIC_FOOT_&_ANKLE_CENTER',
  'AtlanticFoundations' = 'ATLANTIC_FOUNDATIONS',
  'AtlanticHeatingAndCooling' = 'ATLANTIC_HEATING_AND_COOLING',
  'AtlanticLiftSystems' = 'ATLANTIC_LIFT_SYSTEMS',
  'AtlanticNeuroServices' = 'ATLANTIC_NEURO_SERVICES',
  'AtlanticOrthopedic' = 'ATLANTIC_ORTHOPEDIC',
  'AtlanticPainManagement' = 'ATLANTIC_PAIN_MANAGEMENT',
  'AtlanticPaperstock' = 'ATLANTIC_PAPERSTOCK',
  'AtlanticProtectionSecurity' = 'ATLANTIC_PROTECTION_SECURITY',
  'AtlanticPsychSvcs' = 'ATLANTIC_PSYCH_SVCS',
  'AtlanticPulmonology' = 'ATLANTIC_PULMONOLOGY',
  'AtlanticRealty' = 'ATLANTIC_REALTY',
  'AtlanticSewage' = 'ATLANTIC_SEWAGE',
  'AtlanticShores' = 'ATLANTIC_SHORES',
  'AtlanticShoresBapChurch' = 'ATLANTIC_SHORES_BAP_CHURCH',
  'AtlanticShoresChristianSchl' = 'ATLANTIC_SHORES_CHRISTIAN_SCHL',
  'AtlanticShoresChristianScho' = 'ATLANTIC_SHORES_CHRISTIAN_SCHO',
  'AtlanticSpecialist' = 'ATLANTIC_SPECIALIST',
  'AtlanticTire' = 'ATLANTIC_TIRE',
  'AtlanticTrucking' = 'ATLANTIC_TRUCKING',
  'AtlanticUnionBank' = 'ATLANTIC_UNION_BANK',
  'AtlasExpress' = 'ATLAS_EXPRESS',
  'AtriaSeniorLiving' = 'ATRIA_SENIOR_LIVING',
  'Ats' = 'ATS',
  'AtwoodFamilyMedical' = 'ATWOOD_FAMILY_MEDICAL',
  'AtwoodFamilyMedicalCenter' = 'ATWOOD_FAMILY_MEDICAL_CENTER',
  'AusgarTechnologies' = 'AUSGAR_TECHNOLOGIES',
  'AustinElectric' = 'AUSTIN_ELECTRIC',
  'AutoBanksCarRepair' = 'AUTO_BANKS_CAR_REPAIR',
  'AutoPartsInternational' = 'AUTO_PARTS_INTERNATIONAL',
  'AutoTruckSouth' = 'AUTO_TRUCK_SOUTH',
  'AutoValue' = 'AUTO_VALUE',
  'AutoZone' = 'AUTO_ZONE',
  'AutocraftUpholstery' = 'AUTOCRAFT_UPHOLSTERY',
  'AutomastersOfAsheboro' = 'AUTOMASTERS_OF_ASHEBORO',
  'Autozone' = 'AUTOZONE',
  'AutumnCare' = 'AUTUMN_CARE',
  'AutumnCareChesapeake' = 'AUTUMN_CARE_CHESAPEAKE',
  'AutumnCareOfChesapeake' = 'AUTUMN_CARE_OF_CHESAPEAKE',
  'AutumnCareOfPorthsmouth' = 'AUTUMN_CARE_OF_PORTHSMOUTH',
  'AuxiliarySystem' = 'AUXILIARY_SYSTEM',
  'AuxiliarySystems,Inc' = 'AUXILIARY_SYSTEMS,_INC',
  'AuxiliarySystemsInc' = 'AUXILIARY_SYSTEMS_INC',
  'AuxillarySystems,Inc' = 'AUXILLARY_SYSTEMS,_INC',
  'AvalonBay' = 'AVALON_BAY',
  'AvianEngineers' = 'AVIAN_ENGINEERS',
  'AvisBudgetGp' = 'AVIS_BUDGET_GP',
  'AvisBudgetGroup' = 'AVIS_BUDGET_GROUP',
  'AvmacLlc' = 'AVMAC_LLC',
  'Avoler' = 'AVOLER',
  'Avon' = 'AVON',
  'AvonRepresentative' = 'AVON_REPRESENTATIVE',
  'AvueTechnologies' = 'AVUE_TECHNOLOGIES',
  'AxialAdvisoryGroup' = 'AXIAL_ADVISORY_GROUP',
  'AyersCeramicTile&Marble' = 'AYERS_CERAMIC_TILE_&_MARBLE',
  'AzarsNaturalFoods' = 'AZARS_NATURAL_FOODS',
  'B&MContractors' = 'B_&_M_CONTRACTORS',
  'B&WPropertiesLlc' = 'B_&_W_PROPERTIES_LLC',
  'B&bHose&Rubber' = 'B&B_HOSE_&_RUBBER',
  'B&mContractors' = 'B&M_CONTRACTORS',
  'B+sEnterprise' = 'B+S_ENTERPRISE',
  'BabiesRUs' = 'BABIES_R_US',
  'BackCountry' = 'BACK_COUNTRY',
  'BackusFord,Inc' = 'BACKUS_FORD,_INC',
  'BaeSymptoms' = 'BAE_SYMPTOMS',
  'BaeSystems' = 'BAE_SYSTEMS',
  'BaeSystemsNorfolkShipRpr' = 'BAE_SYSTEMS_NORFOLK_SHIP_RPR',
  'BageIndustries' = 'BAGE_INDUSTRIES',
  'BahamaBreeze' = 'BAHAMA_BREEZE',
  'Bailey&SonCon' = 'BAILEY_&_SON_CON',
  'BakeFresh' = 'BAKE_FRESH',
  'BakerRoofing' = 'BAKER_ROOFING',
  'BakersCrust' = 'BAKERS_CRUST',
  'BalfordBeatty' = 'BALFORD_BEATTY',
  'BalfourOfTidewater' = 'BALFOUR_OF_TIDEWATER',
  'BallentineInc' = 'BALLENTINE_INC',
  'Bank@lantec' = 'BANK_@LANTEC',
  'BankOfCommonwealth' = 'BANK_OF_COMMONWEALTH',
  'BankOfCurrituc' = 'BANK_OF_CURRITUC',
  'BankOfHamptonRoads' = 'BANK_OF_HAMPTON_ROADS',
  'BankOfTheCommonwealth' = 'BANK_OF_THE_COMMONWEALTH',
  'BaptistBibleFellowshipInten.' = 'BAPTIST_BIBLE_FELLOWSHIP_INTEN.',
  'BareFootKids' = 'BARE_FOOT_KIDS',
  'BarkersTrucking' = 'BARKERS_TRUCKING',
  'BarkleyPlumbing' = 'BARKLEY_PLUMBING',
  'Barlow&RiddickPc' = 'BARLOW_&_RIDDICK_PC',
  'BarnHillContractingComp' = 'BARN_HILL_CONTRACTING_COMP',
  'BarnhillContractingCo' = 'BARNHILL_CONTRACTING_CO',
  'BaronsPub' = 'BARONS_PUB',
  'BarrierBlandRe' = 'BARRIER_BLAND_RE',
  'BarrierIslandS' = 'BARRIER_ISLAND_S',
  'BarrierIslandStation' = 'BARRIER_ISLAND_STATION',
  'BarristersOfVa' = 'BARRISTERS_OF_VA',
  'BarrowConstruction' = 'BARROW_CONSTRUCTION',
  'BarrysWalnutIsland' = 'BARRYS_WALNUT_ISLAND',
  'BasfChemical' = 'BASF_CHEMICAL',
  'BashamBuildersInc' = 'BASHAM_BUILDERS_INC',
  'BasicConstructionCo' = 'BASIC_CONSTRUCTION_CO',
  'BasicCopper' = 'BASIC_COPPER',
  'Basnight' = 'BASNIGHT',
  'BasnightKinser' = 'BASNIGHT_KINSER',
  'BasnightLandAndLawn' = 'BASNIGHT_LAND_AND_LAWN',
  'BassProShops' = 'BASS_PRO_SHOPS',
  'BattlefieldGolfClub' = 'BATTLEFIELD_GOLF_CLUB',
  'BattlefieldMedicalAssoc' = 'BATTLEFIELD_MEDICAL_ASSOC',
  'BauerCompressorsInc.' = 'BAUER_COMPRESSORS_INC.',
  'BayAreaMovers' = 'BAY_AREA_MOVERS',
  'BayAssociates' = 'BAY_ASSOCIATES',
  'BayDisposal' = 'BAY_DISPOSAL',
  'BayDisposalAndRecycling' = 'BAY_DISPOSAL_AND_RECYCLING',
  'BayElectricCorp' = 'BAY_ELECTRIC_CORP',
  'BayFirst' = 'BAY_FIRST',
  'BayPainting' = 'BAY_PAINTING',
  'BayWestTransport' = 'BAY_WEST_TRANSPORT',
  'BayfirstSolutions' = 'BAYFIRST_SOLUTIONS',
  'BayshoreConcret' = 'BAYSHORE_CONCRET',
  'BaysideHealth' = 'BAYSIDE_HEALTH',
  'BaysideHospital' = 'BAYSIDE_HOSPITAL',
  'BaysideRecreationCenter' = 'BAYSIDE_RECREATION_CENTER',
  'BaysideVilliageDaySchool' = 'BAYSIDE_VILLIAGE_DAY_SCHOOL',
  'BaystalePoolSupplies' = 'BAYSTALE_POOL_SUPPLIES',
  'BaystateFoodSupplies' = 'BAYSTATE_FOOD_SUPPLIES',
  'BayviewDentalLab' = 'BAYVIEW_DENTAL_LAB',
  'BayviewPhysicians' = 'BAYVIEW_PHYSICIANS',
  'BayviewPlazaPharmacy' = 'BAYVIEW_PLAZA_PHARMACY',
  'BaywestTransportation' = 'BAYWEST_TRANSPORTATION',
  'BazonCox&Assoc.' = 'BAZON_COX_&_ASSOC.',
  'Bb&t' = 'BB&T',
  'Bcf' = 'BCF',
  'BdoUsa,Llp' = 'BDO_USA,_LLP',
  'BeachDentalCenter' = 'BEACH_DENTAL_CENTER',
  'BeachMarine' = 'BEACH_MARINE',
  'BeachMarineServices' = 'BEACH_MARINE_SERVICES',
  'BeachMartInc' = 'BEACH_MART_INC',
  'BeachOrthotics' = 'BEACH_ORTHOTICS',
  'BeachPackaging' = 'BEACH_PACKAGING',
  'BeachPetHosp' = 'BEACH_PET_HOSP',
  'BeachTherapy&Consulting' = 'BEACH_THERAPY_&_CONSULTING',
  'BeachTiresAndService' = 'BEACH_TIRES_AND_SERVICE',
  'BeaconHealth' = 'BEACON_HEALTH',
  'BealeFlooringInc' = 'BEALE_FLOORING_INC',
  'Beamon&JohnsonInc' = 'BEAMON_&_JOHNSON_INC',
  'BeamonJohnson' = 'BEAMON_JOHNSON',
  'BearDrug' = 'BEAR_DRUG',
  'BearGardenInc.' = 'BEAR_GARDEN_INC.',
  'Bec' = 'BEC',
  'Beco' = 'BECO',
  'BectonDickson' = 'BECTON_DICKSON',
  'BeforeAndAfterBeautySalon' = 'BEFORE_AND_AFTER_BEAUTY_SALON',
  'BelangerAppraisals' = 'BELANGER_APPRAISALS',
  'Belfor' = 'BELFOR',
  'BelkDeptStore' = 'BELK_DEPT_STORE',
  'BellNursery' = 'BELL_NURSERY',
  'BellsMillAutoCare' = 'BELLS_MILL_AUTO_CARE',
  'BenchmarkDevelo' = 'BENCHMARK_DEVELO',
  'BencoDental' = 'BENCO_DENTAL',
  'BeneficialInsurance' = 'BENEFICIAL_INSURANCE',
  'BenjaminHouse' = 'BENJAMIN_HOUSE',
  'BenjaminHouseInc' = 'BENJAMIN_HOUSE_INC',
  'Bennett&ZydronPc' = 'BENNETT_&_ZYDRON_PC',
  'BennettNursery' = 'BENNETT_NURSERY',
  'BennettsCreekNursery' = 'BENNETTS_CREEK_NURSERY',
  'BeriteCounty' = 'BERITE_COUNTY',
  'BerkhimerLawPc' = 'BERKHIMER_LAW_PC',
  'BerkleyMachineWorksLlc' = 'BERKLEY_MACHINE_WORKS_LLC',
  'BestBuy' = 'BEST_BUY',
  'BestDependable' = 'BEST_DEPENDABLE',
  'BestUniforms' = 'BEST_UNIFORMS',
  'Bestcuts' = 'BESTCUTS',
  'BethLorenz' = 'BETH_LORENZ',
  'BethShelomHome' = 'BETH_SHELOM_HOME',
  'BethSholomVillage' = 'BETH_SHOLOM_VILLAGE',
  'BethalBaptistChurch' = 'BETHAL_BAPTIST_CHURCH',
  'BethanyBasic' = 'BETHANY_BASIC',
  'BethelBaptistChurch' = 'BETHEL_BAPTIST_CHURCH',
  'BevinsRoofing' = 'BEVINS_ROOFING',
  'BevnonInc' = 'BEVNON_INC',
  'BfpInternationa' = 'BFP_INTERNATIONA',
  'Bfpe' = 'BFPE',
  'BhhsTowneRealty' = 'BHHS_TOWNE_REALTY',
  'BiblewayChurchOfGod' = 'BIBLEWAY_CHURCH_OF_GOD',
  'BigAlsMuffler&Brake' = 'BIG_ALS_MUFFLER_&_BRAKE',
  'BigAlsMufflers&Brakes' = 'BIG_ALS_MUFFLERS_&_BRAKES',
  'BigBucksRecycling' = 'BIG_BUCKS_RECYCLING',
  'BigDaddyDrayage' = 'BIG_DADDY_DRAYAGE',
  'BigIslandSmoothie' = 'BIG_ISLAND_SMOOTHIE',
  'BigLots' = 'BIG_LOTS',
  'Biggs,Cadillac,Buick,Gmc' = 'BIGGS,_CADILLAC,_BUICK,_GMC',
  'BiggsCaddy' = 'BIGGS_CADDY',
  'BikeShop' = 'BIKE_SHOP',
  'BillBeamon&Assoc' = 'BILL_BEAMON_&_ASSOC',
  'BillieReid&Sons,Inc' = 'BILLIE_REID_&_SONS,_INC',
  'BinswangerGlass' = 'BINSWANGER_GLASS',
  'BirdAutoServices' = 'BIRD_AUTO_SERVICES',
  'BirdiesInc' = 'BIRDIES_INC',
  'BirdsongPeanuts' = 'BIRDSONG_PEANUTS',
  'BishopSullivanCatholicHs' = 'BISHOP_SULLIVAN_CATHOLIC_HS',
  'BjsWholesale' = 'BJS_WHOLESALE',
  'BlackAndWhiteCab' = 'BLACK_AND_WHITE_CAB',
  'BlackGoldFarms' = 'BLACK_GOLD_FARMS',
  'BlackHorseCarriers' = 'BLACK_HORSE_CARRIERS',
  'Blackwater' = 'BLACKWATER',
  'BlackwaterElectric' = 'BLACKWATER_ELECTRIC',
  'BlackwaterElectrical' = 'BLACKWATER_ELECTRICAL',
  'BlackwaterTraining' = 'BLACKWATER_TRAINING',
  'BlackwaterUsa' = 'BLACKWATER_USA',
  'BlackwellPreschool+Kindergarten' = 'BLACKWELL_PRESCHOOL_+_KINDERGARTEN',
  'BladenPetro' = 'BLADEN_PETRO',
  'BlakesElectrical' = 'BLAKES_ELECTRICAL',
  'Blockbuster' = 'BLOCKBUSTER',
  'Bloom' = 'BLOOM',
  'BlueBellCreameries' = 'BLUE_BELL_CREAMERIES',
  'BlueStaffing' = 'BLUE_STAFFING',
  'BlueSteelFabraction' = 'BLUE_STEEL_FABRACTION',
  'BlueridgeGeneral' = 'BLUERIDGE_GENERAL',
  'BmfFabrication' = 'BMF_FABRICATION',
  'Bms' = 'BMS',
  'Bna' = 'BNA',
  'BoarsheadProvisions' = 'BOARSHEAD_PROVISIONS',
  'BobsAcService' = 'BOBS_AC_SERVICE',
  'BobsGrill' = 'BOBS_GRILL',
  'BobsGunShop' = 'BOBS_GUN_SHOP',
  'Boddie-noellEnterprises' = 'BODDIE-NOELL_ENTERPRISES',
  'Boddie-noellEnterprises,Inc.' = 'BODDIE-NOELL_ENTERPRISES,_INC.',
  'BoddieNoell' = 'BODDIE_NOELL',
  'Boeing' = 'BOEING',
  'Bojangles' = 'BOJANGLES',
  'BonSecourHospital' = 'BON_SECOUR_HOSPITAL',
  'BonSecourMedCtr' = 'BON_SECOUR_MED_CTR',
  'BonSecours' = 'BON_SECOURS',
  'BonSecoursAndMedicalSolutions' = 'BON_SECOURS_AND_MEDICAL_SOLUTIONS',
  'BonSecoursMaryviewBehavioralMedicine' = 'BON_SECOURS_MARYVIEW_BEHAVIORAL_MEDICINE',
  'BonSecoursMaryviewHospital' = 'BON_SECOURS_MARYVIEW_HOSPITAL',
  'BonSecoursMaryviewNursingCareCenter' = 'BON_SECOURS_MARYVIEW_NURSING_CARE_CENTER',
  'BonSecoursMercyDepaulMedicalCenter' = 'BON_SECOURS_MERCY_DEPAUL_MEDICAL_CENTER',
  'BonSecoursMercyHealth' = 'BON_SECOURS_MERCY_HEALTH',
  'BonSecoursSurgeryCenter' = 'BON_SECOURS_SURGERY_CENTER',
  'BonbomRealtyInc' = 'BONBOM_REALTY_INC',
  'BonneyBrightFarms' = 'BONNEY_BRIGHT_FARMS',
  'BonneyBrightSa' = 'BONNEY_BRIGHT_SA',
  'BonneyBrightSandCo' = 'BONNEY_BRIGHT_SAND_CO',
  'BonniePlants' = 'BONNIE_PLANTS',
  'BoozAllenHamilton' = 'BOOZ_ALLEN_HAMILTON',
  'BorderStation' = 'BORDER_STATION',
  'BoschPowerTools' = 'BOSCH_POWER_TOOLS',
  'BossSawyer' = 'BOSS_SAWYER',
  'BotanicalLandscape' = 'BOTANICAL_LANDSCAPE',
  'BoulevardJewler' = 'BOULEVARD_JEWLER',
  'BowCreekGolfCourse' = 'BOW_CREEK_GOLF_COURSE',
  'Bp' = 'BP',
  'Bpas' = 'BPAS',
  'BradWardGal-o-mineCharters' = 'BRAD_WARD_GAL-O-MINE_CHARTERS',
  'BranchHealthClinic' = 'BRANCH_HEALTH_CLINIC',
  'BrandonMiddleSchool' = 'BRANDON_MIDDLE_SCHOOL',
  'BrankleyEnterprisesInc' = 'BRANKLEY_ENTERPRISES_INC',
  'BrendlyBeach' = 'BRENDLY_BEACH',
  'BrentwoodVeterinary' = 'BRENTWOOD_VETERINARY',
  'BressPawn' = 'BRESS_PAWN',
  'BrianCenter' = 'BRIAN_CENTER',
  'BrianMElm,Llc' = 'BRIAN_M_ELM,_LLC',
  'BriarwoodForestProducts' = 'BRIARWOOD_FOREST_PRODUCTS',
  'BridgeToLearning' = 'BRIDGE_TO_LEARNING',
  'BrinkdyBeach' = 'BRINKDY_BEACH',
  'Brinker-chilis' = 'BRINKER-CHILIS',
  'BristolParkLlc' = 'BRISTOL_PARK_LLC',
  'BrittainKleinInc' = 'BRITTAIN_KLEIN_INC',
  'BrixxWoodFirePizza' = 'BRIXX_WOOD_FIRE_PIZZA',
  'BroadDicisionsInc' = 'BROAD_DICISIONS_INC',
  'BroncoFederalCreditUnion' = 'BRONCO_FEDERAL_CREDIT_UNION',
  'BrownPlumbing&Septic' = 'BROWN_PLUMBING_&_SEPTIC',
  'BruinBuysLlc' = 'BRUIN_BUYS_LLC',
  'BrumseyAndBrumsey' = 'BRUMSEY_AND_BRUMSEY',
  'Bryant&StrattonCollege' = 'BRYANT_&_STRATTON_COLLEGE',
  'BryantContracting,Inc' = 'BRYANT_CONTRACTING,_INC',
  'BsMaryview' = 'BS_MARYVIEW',
  'BtAmericasInc' = 'BT_AMERICAS_INC',
  'BtConferencing' = 'BT_CONFERENCING',
  'Bttw' = 'BTTW',
  'BttwWarranty' = 'BTTW_WARRANTY',
  'BuddGroup' = 'BUDD_GROUP',
  'BudgetMobilOutboardRepair' = 'BUDGET_MOBIL_OUTBOARD_REPAIR',
  'BuffaloWildWing' = 'BUFFALO_WILD_WING',
  'BuildersMutual' = 'BUILDERS_MUTUAL',
  'BuildingMaintenanceServices' = 'BUILDING_MAINTENANCE_SERVICES',
  'BuiltToLast' = 'BUILT_TO_LAST',
  'BurgerBustersLlc' = 'BURGER_BUSTERS_LLC',
  'BurgerKing' = 'BURGER_KING',
  'Burgess&niple,Inc' = 'BURGESS_&NIPLE,_INC',
  'BurlingtonCoatFactory' = 'BURLINGTON_COAT_FACTORY',
  'BurtonLumberCorp' = 'BURTON_LUMBER_CORP',
  'BuschGardensWmsbg' = 'BUSCH_GARDENS_WMSBG',
  'BuschLlc' = 'BUSCH_LLC',
  'BuschManufacturer' = 'BUSCH_MANUFACTURER',
  'BushConstructionCorp' = 'BUSH_CONSTRUCTION_CORP',
  'BuskeysChill&Grill' = 'BUSKEYS_CHILL_&_GRILL',
  'BusyBeeDaycare' = 'BUSY_BEE_DAYCARE',
  'BuxtonUnitedMethodistPrschl' = 'BUXTON_UNITED_METHODIST_PRSCHL',
  'BylerPlumbing&Heating' = 'BYLER_PLUMBING_&_HEATING',
  'BylerPlumbing' = 'BYLER_PLUMBING',
  'BylerPlumbingAndHeating' = 'BYLER_PLUMBING_AND_HEATING',
  'C&MSiteAndUtilityContractor' = 'C_&_M_SITE_AND_UTILITY_CONTRACTOR',
  'C+cCarpetCare' = 'C+C_CARPET_CARE',
  'CAPerryAndSon' = 'C_A_PERRY_AND_SON',
  'CFAdamsBrokerage' = 'C_F_ADAMS_BROKERAGE',
  'CPSchools' = 'C_P_SCHOOLS',
  'Cabbies' = 'CABBIES',
  'CabinFeverCommunications' = 'CABIN_FEVER_COMMUNICATIONS',
  'CabinetsToGo' = 'CABINETS_TO_GO',
  'Caci' = 'CACI',
  'CaciEnterpriseSolutions' = 'CACI_ENTERPRISE_SOLUTIONS',
  'CaciFederalInc' = 'CACI_FEDERAL_INC',
  'CaciFieldsServ' = 'CACI_FIELDS_SERV',
  'CalCartageCo' = 'CAL_CARTAGE_CO',
  'CaliforniaPizzaKitchen' = 'CALIFORNIA_PIZZA_KITCHEN',
  'Caliper' = 'CALIPER',
  'CaliperInc' = 'CALIPER_INC',
  'CalvaryFloors,Llc' = 'CALVARY_FLOORS,_LLC',
  'CalvaryRevivalChurch' = 'CALVARY_REVIVAL_CHURCH',
  'CalveryEvangelicalChurch' = 'CALVERY_EVANGELICAL_CHURCH',
  'CambridgeIntlSystems' = 'CAMBRIDGE_INTL_SYSTEMS',
  'CamdenCoClerk' = 'CAMDEN_CO_CLERK',
  'CamdenCoHighS' = 'CAMDEN_CO_HIGH_S',
  'CamdenCoSchools' = 'CAMDEN_CO_SCHOOLS',
  'CamdenCounty' = 'CAMDEN_COUNTY',
  'CamdenCountyBoardOfElections' = 'CAMDEN_COUNTY_BOARD_OF_ELECTIONS',
  'CamdenCountyHighSchool' = 'CAMDEN_COUNTY_HIGH_SCHOOL',
  'CamdenCountyOffices' = 'CAMDEN_COUNTY_OFFICES',
  'CamdenCountySchool' = 'CAMDEN_COUNTY_SCHOOL',
  'CamdenCountySchools' = 'CAMDEN_COUNTY_SCHOOLS',
  'CamdenCountySheriffsOffice' = 'CAMDEN_COUNTY_SHERIFFS_OFFICE',
  'CamdenHighSchool' = 'CAMDEN_HIGH_SCHOOL',
  'CamdenMiddleSchool' = 'CAMDEN_MIDDLE_SCHOOL',
  'CamdenPublicSchools' = 'CAMDEN_PUBLIC_SCHOOLS',
  'CamdenUmc' = 'CAMDEN_UMC',
  'CancerSpecOfTidewater' = 'CANCER_SPEC_OF_TIDEWATER',
  'CancerSpecialistsOfTidewater' = 'CANCER_SPECIALISTS_OF_TIDEWATER',
  'CanonIts' = 'CANON_ITS',
  'CanonVaInc' = 'CANON_VA_INC',
  'CapSourceSolutions' = 'CAP_SOURCE_SOLUTIONS',
  'CapeFearTrucking' = 'CAPE_FEAR_TRUCKING',
  'CapeHatterasEmc' = 'CAPE_HATTERAS_EMC',
  'CapeHenryAssocInc' = 'CAPE_HENRY_ASSOC_INC',
  'CapeHenryCollegiateSchool' = 'CAPE_HENRY_COLLEGIATE_SCHOOL',
  'CapeManagement' = 'CAPE_MANAGEMENT',
  'CapilerInc' = 'CAPILER_INC',
  'CapitalAreaTesting' = 'CAPITAL_AREA_TESTING',
  'CapitalCareLlc' = 'CAPITAL_CARE_LLC',
  'CapitalElectric' = 'CAPITAL_ELECTRIC',
  'CapitalGroup' = 'CAPITAL_GROUP',
  'CapitalGroupCompanies' = 'CAPITAL_GROUP_COMPANIES',
  'CapitalOne' = 'CAPITAL_ONE',
  'CapitalTristateEleDistribut' = 'CAPITAL_TRISTATE_ELE_DISTRIBUT',
  'CaptailFordRockyMt' = 'CAPTAIL_FORD_ROCKY_MT',
  'CarMax' = 'CAR_MAX',
  'CarStruction' = 'CAR_STRUCTION',
  'CarahsoftTech' = 'CARAHSOFT_TECH',
  'CardinalCanteen' = 'CARDINAL_CANTEEN',
  'CardinalLogistics' = 'CARDINAL_LOGISTICS',
  'CardinalMessanger' = 'CARDINAL_MESSANGER',
  'CardiologyConsultants' = 'CARDIOLOGY_CONSULTANTS',
  'CardiologyConsultantsLtd' = 'CARDIOLOGY_CONSULTANTS_LTD',
  'CardiovascularA' = 'CARDIOVASCULAR_A',
  'CardiovascularAssociates' = 'CARDIOVASCULAR_ASSOCIATES',
  'Caregiver' = 'CAREGIVER',
  'Carhart' = 'CARHART',
  'CaribbeanPools' = 'CARIBBEAN_POOLS',
  'Carmax' = 'CARMAX',
  'CarnerstoneHomeMortgage' = 'CARNERSTONE_HOME_MORTGAGE',
  'CarolinaDesignsRealty' = 'CAROLINA_DESIGNS_REALTY',
  'CarolinaEastRealEstate' = 'CAROLINA_EAST_REAL_ESTATE',
  'CarolinaHouseO' = 'CAROLINA_HOUSE_O',
  'CarolinaSurgicalCare' = 'CAROLINA_SURGICAL_CARE',
  'CarolineThrasher' = 'CAROLINE_THRASHER',
  'CarpenterSelfEmployed' = 'CARPENTER_SELF_EMPLOYED',
  'CarpetConnection' = 'CARPET_CONNECTION',
  'CarpetDiscount' = 'CARPET_DISCOUNT',
  'CarpetInstallation' = 'CARPET_INSTALLATION',
  'CarpetWorld' = 'CARPET_WORLD',
  'CarpetsByJcLaw' = 'CARPETS_BY_JC_LAW',
  'Carquest' = 'CARQUEST',
  'CarrierEnterprise' = 'CARRIER_ENTERPRISE',
  'CarringtonPlaceOfChesapeake' = 'CARRINGTON_PLACE_OF_CHESAPEAKE',
  'CarrollTrucking' = 'CARROLL_TRUCKING',
  'CarsUsa' = 'CARS_USA',
  'Carscope' = 'CARSCOPE',
  'CarsonAndRomm' = 'CARSON_AND_ROMM',
  'CarterMachinery' = 'CARTER_MACHINERY',
  'CartersCountryCorner' = 'CARTERS_COUNTRY_CORNER',
  'CartersCountryStore' = 'CARTERS_COUNTRY_STORE',
  'CartwrightFarm' = 'CARTWRIGHT_FARM',
  'CartwrightLawnServices' = 'CARTWRIGHT_LAWN_SERVICES',
  'CarverCemetary' = 'CARVER_CEMETARY',
  'CasaDecostanzoPizzarie' = 'CASA_DECOSTANZO_PIZZARIE',
  'CascadePools' = 'CASCADE_POOLS',
  'CashAdvanceCtrsOfVa' = 'CASH_ADVANCE_CTRS_OF_VA',
  'CasseltonConsultantsInc' = 'CASSELTON_CONSULTANTS_INC',
  'CassidyTurley' = 'CASSIDY_TURLEY',
  'Cast&crew' = 'CAST&CREW',
  'CatalfamoAndAssociates' = 'CATALFAMO_AND_ASSOCIATES',
  'CatalinaCylinders' = 'CATALINA_CYLINDERS',
  'CathiLaderberg&Assoc' = 'CATHI_LADERBERG_&_ASSOC',
  'CatholicCharitiesOfEasternVa' = 'CATHOLIC_CHARITIES_OF_EASTERN_VA',
  'CatholicDioceseOfRichmond' = 'CATHOLIC_DIOCESE_OF_RICHMOND',
  'CavalierAutoGroup' = 'CAVALIER_AUTO_GROUP',
  'CavalierFord' = 'CAVALIER_FORD',
  'CavalierFordGreenbrier' = 'CAVALIER_FORD_GREENBRIER',
  'CavalierFordLincoln' = 'CAVALIER_FORD_LINCOLN',
  'Cbn' = 'CBN',
  'CbnNews' = 'CBN_NEWS',
  'Cbre' = 'CBRE',
  'Ccm' = 'CCM',
  'Ccmsi' = 'CCMSI',
  'Ccs' = 'CCS',
  'Ccsmi-ncoshr' = 'CCSMI-NCOSHR',
  'Cd1Marine' = 'CD_1_MARINE',
  'CdgIn.' = 'CDG_IN.',
  'Cdi' = 'CDI',
  'CdiHeadStart' = 'CDI_HEAD_START',
  'CdiMarineCo' = 'CDI_MARINE_CO',
  'CdiMarineCompany' = 'CDI_MARINE_COMPANY',
  'CdsContractors' = 'CDS_CONTRACTORS',
  'CdsaDamNeck' = 'CDSA_DAM_NECK',
  'Cdsi' = 'CDSI',
  'CdyneCorporation' = 'CDYNE_CORPORATION',
  'CeSampleConstr' = 'CE_SAMPLE_CONSTR',
  'CeThurstonAndSons' = 'CE_THURSTON_AND_SONS',
  'CedarManor' = 'CEDAR_MANOR',
  'CedarPointCountryClub' = 'CEDAR_POINT_COUNTRY_CLUB',
  'CedarRoadsAssemblyOfGod' = 'CEDAR_ROADS_ASSEMBLY_OF_GOD',
  'Cegedim' = 'CEGEDIM',
  'CenterForArthritis' = 'CENTER_FOR_ARTHRITIS',
  'CenterForCommDevInc' = 'CENTER_FOR_COMM_DEV_INC',
  'CentervilleSchool' = 'CENTERVILLE_SCHOOL',
  'CentralElemSch' = 'CENTRAL_ELEM_SCH',
  'CentralPlumbing&Heating' = 'CENTRAL_PLUMBING_&_HEATING',
  'CentralWholesal' = 'CENTRAL_WHOLESAL',
  'CentralWholesaleSupplyCorp' = 'CENTRAL_WHOLESALE_SUPPLY_CORP',
  'CentricCommunications' = 'CENTRIC_COMMUNICATIONS',
  'CenturaCollege' = 'CENTURA_COLLEGE',
  'Century21NachmanRealty' = 'CENTURY_21_NACHMAN_REALTY',
  'CenturyConcreteServices' = 'CENTURY_CONCRETE_SERVICES',
  'CenturyLink' = 'CENTURY_LINK',
  'Centurylink' = 'CENTURYLINK',
  'CesproInc' = 'CESPRO_INC',
  'Cfd' = 'CFD',
  'Cfs' = 'CFS',
  'Cgfc' = 'CGFC',
  'Cgh' = 'CGH',
  'CghEr' = 'CGH_ER',
  'Ch2mHill' = 'CH2M_HILL',
  'ChamHill' = 'CHAM_HILL',
  'ChampionLandAndLawn' = 'CHAMPION_LAND_AND_LAWN',
  'ChandlerRealty' = 'CHANDLER_REALTY',
  'ChanellosPizza' = 'CHANELLOS_PIZZA',
  'ChangesCitySpa' = 'CHANGES_CITY_SPA',
  'ChangesHairstyling' = 'CHANGES_HAIRSTYLING',
  'ChannelAdvisorCorp' = 'CHANNEL_ADVISOR_CORP',
  'CharisSupportService' = 'CHARIS_SUPPORT_SERVICE',
  'CharlesHWardInc' = 'CHARLES_H_WARD_INC',
  'CharlieAndersonBuilder' = 'CHARLIE_ANDERSON_BUILDER',
  'CharterCrt' = 'CHARTER_CRT',
  'ChartwayBank' = 'CHARTWAY_BANK',
  'ChartwayFcu' = 'CHARTWAY_FCU',
  'ChartwayFederalCreditUnion' = 'CHARTWAY_FEDERAL_CREDIT_UNION',
  'CheapeakeDiaCenter' = 'CHEAPEAKE_DIA_CENTER',
  'CheapeakePublicSchools' = 'CHEAPEAKE_PUBLIC_SCHOOLS',
  'CheasapeakePublicSchools' = 'CHEASAPEAKE_PUBLIC_SCHOOLS',
  'CheaspeakePublicSchools' = 'CHEASPEAKE_PUBLIC_SCHOOLS',
  'CheckIntoCash' = 'CHECK_INTO_CASH',
  'Checker' = 'CHECKER',
  'CheckeredFlag' = 'CHECKERED_FLAG',
  'CheckeredFlagMotorCarCo' = 'CHECKERED_FLAG_MOTOR_CAR_CO',
  'CheckeredFlagN' = 'CHECKERED_FLAG_N',
  'ChenMed' = 'CHEN_MED',
  'ChensBrothers,Inc' = 'CHENS_BROTHERS,_INC',
  'CherokeeMedical' = 'CHEROKEE_MEDICAL',
  'CherryBekestAndHolland' = 'CHERRY_BEKEST_AND_HOLLAND',
  'ChesGenHos' = 'CHES_GEN_HOS',
  'ChesHosp' = 'CHES_HOSP',
  'ChesPublicSchools' = 'CHES_PUBLIC_SCHOOLS',
  'ChesapBoardOfEdOscarSmith' = 'CHESAP_BOARD_OF_ED_OSCAR_SMITH',
  'ChesapCareFreeClinic' = 'CHESAP_CARE_FREE_CLINIC',
  'ChesapPublicSchools' = 'CHESAP_PUBLIC_SCHOOLS',
  'ChesapeakRegional' = 'CHESAPEAK_REGIONAL',
  'ChesapeakeAnimalHospital' = 'CHESAPEAKE_ANIMAL_HOSPITAL',
  'ChesapeakeAutoCenter' = 'CHESAPEAKE_AUTO_CENTER',
  'ChesapeakeBayEnt' = 'CHESAPEAKE_BAY_ENT',
  'ChesapeakeBayHelicopters' = 'CHESAPEAKE_BAY_HELICOPTERS',
  'ChesapeakeBoardOfEducation' = 'CHESAPEAKE_BOARD_OF_EDUCATION',
  'ChesapeakeCarCenter' = 'CHESAPEAKE_CAR_CENTER',
  'ChesapeakeCitySchool' = 'CHESAPEAKE_CITY_SCHOOL',
  'ChesapeakeCitySchools' = 'CHESAPEAKE_CITY_SCHOOLS',
  'ChesapeakeCoinOp' = 'CHESAPEAKE_COIN_OP',
  'ChesapeakeCommonwealthAttorn' = 'CHESAPEAKE_COMMONWEALTH_ATTORN',
  'ChesapeakeCommonwealthsAttorney' = 'CHESAPEAKE_COMMONWEALTHS_ATTORNEY',
  'ChesapeakeControls' = 'CHESAPEAKE_CONTROLS',
  'ChesapeakeCwa' = 'CHESAPEAKE_CWA',
  'ChesapeakeDeptOfHumanSvcs' = 'CHESAPEAKE_DEPT_OF_HUMAN_SVCS',
  'ChesapeakeExpressway' = 'CHESAPEAKE_EXPRESSWAY',
  'ChesapeakeFenceCo' = 'CHESAPEAKE_FENCE_CO',
  'ChesapeakeFireDepartment' = 'CHESAPEAKE_FIRE_DEPARTMENT',
  'ChesapeakeFoodService' = 'CHESAPEAKE_FOOD_SERVICE',
  'ChesapeakeFoot&Ankle' = 'CHESAPEAKE_FOOT_&_ANKLE',
  'ChesapeakeGenHosp' = 'CHESAPEAKE_GEN_HOSP',
  'ChesapeakeGener' = 'CHESAPEAKE_GENER',
  'ChesapeakeGeneral' = 'CHESAPEAKE_GENERAL',
  'ChesapeakeGeneralHospital' = 'CHESAPEAKE_GENERAL_HOSPITAL',
  'ChesapeakeGolfCourse' = 'CHESAPEAKE_GOLF_COURSE',
  'ChesapeakeHealt' = 'CHESAPEAKE_HEALT',
  'ChesapeakeHealth&Rehab' = 'CHESAPEAKE_HEALTH_&_REHAB',
  'ChesapeakeHealth&RehabCtr' = 'CHESAPEAKE_HEALTH_&_REHAB_CTR',
  'ChesapeakeHealth' = 'CHESAPEAKE_HEALTH',
  'ChesapeakeHealthAndRehab' = 'CHESAPEAKE_HEALTH_AND_REHAB',
  'ChesapeakeHomeImprovement' = 'CHESAPEAKE_HOME_IMPROVEMENT',
  'ChesapeakeHomes' = 'CHESAPEAKE_HOMES',
  'ChesapeakeHumanServices' = 'CHESAPEAKE_HUMAN_SERVICES',
  'ChesapeakeInternists' = 'CHESAPEAKE_INTERNISTS',
  'ChesapeakeJuvenileCourt' = 'CHESAPEAKE_JUVENILE_COURT',
  'ChesapeakeLibrary' = 'CHESAPEAKE_LIBRARY',
  'ChesapeakeMedicalCenter' = 'CHESAPEAKE_MEDICAL_CENTER',
  'ChesapeakeMosquitoControl' = 'CHESAPEAKE_MOSQUITO_CONTROL',
  'ChesapeakeMotessoriSchool' = 'CHESAPEAKE_MOTESSORI_SCHOOL',
  'ChesapeakePediatrics' = 'CHESAPEAKE_PEDIATRICS',
  'ChesapeakePlace' = 'CHESAPEAKE_PLACE',
  'ChesapeakePolice' = 'CHESAPEAKE_POLICE',
  'ChesapeakePoliceDepartment' = 'CHESAPEAKE_POLICE_DEPARTMENT',
  'ChesapeakePoliceDept' = 'CHESAPEAKE_POLICE_DEPT',
  'ChesapeakePubli' = 'CHESAPEAKE_PUBLI',
  'ChesapeakePublicDefender' = 'CHESAPEAKE_PUBLIC_DEFENDER',
  'ChesapeakePublicSchool' = 'CHESAPEAKE_PUBLIC_SCHOOL',
  'ChesapeakePublicSchools' = 'CHESAPEAKE_PUBLIC_SCHOOLS',
  'ChesapeakePublicSchoolsGb' = 'CHESAPEAKE_PUBLIC_SCHOOLS_GB',
  'ChesapeakeRadiologists' = 'CHESAPEAKE_RADIOLOGISTS',
  'ChesapeakeRadiologistsLtd' = 'CHESAPEAKE_RADIOLOGISTS_LTD',
  'ChesapeakeRedevelopHousing' = 'CHESAPEAKE_REDEVELOP_HOUSING',
  'ChesapeakeRegional' = 'CHESAPEAKE_REGIONAL',
  'ChesapeakeRegionalHealth&Rehab' = 'CHESAPEAKE_REGIONAL_HEALTH_&_REHAB',
  'ChesapeakeRegionalHealthcare' = 'CHESAPEAKE_REGIONAL_HEALTHCARE',
  'ChesapeakeRegionalHomeSvcs' = 'CHESAPEAKE_REGIONAL_HOME_SVCS',
  'ChesapeakeRegionalHospital' = 'CHESAPEAKE_REGIONAL_HOSPITAL',
  'ChesapeakeRegionalMedCtr' = 'CHESAPEAKE_REGIONAL_MED_CTR',
  'ChesapeakeRegionalMedical' = 'CHESAPEAKE_REGIONAL_MEDICAL',
  'ChesapeakeRegionalMedicalCe' = 'CHESAPEAKE_REGIONAL_MEDICAL_CE',
  'ChesapeakeRegionalMedicalCenter' = 'CHESAPEAKE_REGIONAL_MEDICAL_CENTER',
  'ChesapeakeRegionalMedicalCn' = 'CHESAPEAKE_REGIONAL_MEDICAL_CN',
  'ChesapeakeRegionalMedicalCt' = 'CHESAPEAKE_REGIONAL_MEDICAL_CT',
  'ChesapeakeRegionalMedicalGropu' = 'CHESAPEAKE_REGIONAL_MEDICAL_GROPU',
  'ChesapeakeRegionalMedicalGroup' = 'CHESAPEAKE_REGIONAL_MEDICAL_GROUP',
  'ChesapeakeRehab' = 'CHESAPEAKE_REHAB',
  'ChesapeakeSchool' = 'CHESAPEAKE_SCHOOL',
  'ChesapeakeSchoolBoard' = 'CHESAPEAKE_SCHOOL_BOARD',
  'ChesapeakeSchoolDistrict' = 'CHESAPEAKE_SCHOOL_DISTRICT',
  'ChesapeakeSchoolSystem' = 'CHESAPEAKE_SCHOOL_SYSTEM',
  'ChesapeakeSchools' = 'CHESAPEAKE_SCHOOLS',
  'ChesapeakeSecepCenter' = 'CHESAPEAKE_SECEP_CENTER',
  'ChesapeakeServiceSystem' = 'CHESAPEAKE_SERVICE_SYSTEM',
  'ChesapeakeServiceSystems' = 'CHESAPEAKE_SERVICE_SYSTEMS',
  'ChesapeakeServiceSystems,Inc' = 'CHESAPEAKE_SERVICE_SYSTEMS,_INC',
  'ChesapeakeServiceSystemsInc' = 'CHESAPEAKE_SERVICE_SYSTEMS_INC',
  'ChesapeakeServicesSystems' = 'CHESAPEAKE_SERVICES_SYSTEMS',
  'ChesapeakeSheriffOffice' = 'CHESAPEAKE_SHERIFF_OFFICE',
  'ChesapeakeSheriffsDept' = 'CHESAPEAKE_SHERIFFS_DEPT',
  'ChesapeakeSheriffsOfc' = 'CHESAPEAKE_SHERIFFS_OFC',
  'ChesapeakeSocialServices' = 'CHESAPEAKE_SOCIAL_SERVICES',
  'ChesapeakeSurgicalSpecialists' = 'CHESAPEAKE_SURGICAL_SPECIALISTS',
  'ChesapeakeSvcsInc' = 'CHESAPEAKE_SVCS_INC',
  'ChesapeakeTileCo.' = 'CHESAPEAKE_TILE_CO.',
  'ChesapeakeTransportationDept' = 'CHESAPEAKE_TRANSPORTATION_DEPT',
  'ChesapeakeVa/co' = 'CHESAPEAKE_VA/CO',
  'ChesapeakeVeinCenter' = 'CHESAPEAKE_VEIN_CENTER',
  'ChesapeakeVocationalCenter' = 'CHESAPEAKE_VOCATIONAL_CENTER',
  'ChesapeakeWasteSolutions' = 'CHESAPEAKE_WASTE_SOLUTIONS',
  'ChesapeakeWomensCare' = 'CHESAPEAKE_WOMENS_CARE',
  'ChespPostalService' = 'CHESP_POSTAL_SERVICE',
  'ChespPublicSchools' = 'CHESP_PUBLIC_SCHOOLS',
  'ChespRegMedCtr' = 'CHESP_REG_MED_CTR',
  'ChespSheriffsOffice' = 'CHESP_SHERIFFS_OFFICE',
  'ChespakeakeMosquitoControl' = 'CHESPAKEAKE_MOSQUITO_CONTROL',
  'ChespeakePublicSchool' = 'CHESPEAKE_PUBLIC_SCHOOL',
  'ChespeakeRegionalMedicalCenter' = 'CHESPEAKE_REGIONAL_MEDICAL_CENTER',
  'Chick-filA' = 'CHICK-FIL_A',
  'ChickFilA' = 'CHICK_FIL_A',
  'ChickFilet' = 'CHICK_FILET',
  'ChildAndFamilySupportServices' = 'CHILD_AND_FAMILY_SUPPORT_SERVICES',
  'ChildrensHospKngDaughters' = 'CHILDRENS_HOSP_KNG_DAUGHTERS',
  'ChildrensSpecialtyGroup' = 'CHILDRENS_SPECIALTY_GROUP',
  'ChildtimeLearningCenter' = 'CHILDTIME_LEARNING_CENTER',
  'ChipOfVa' = 'CHIP_OF_VA',
  'Chkd' = 'CHKD',
  'ChkdCaseMgmt' = 'CHKD_CASE_MGMT',
  'ChkdDevelopmentResources' = 'CHKD_DEVELOPMENT_RESOURCES',
  'ChkdPedSpecialist' = 'CHKD_PED_SPECIALIST',
  'ChkdTidewaterChildrensAssoc' = 'CHKD_TIDEWATER_CHILDRENS_ASSOC',
  'ChocollageBakery' = 'CHOCOLLAGE_BAKERY',
  'ChosenPeopleMinistries' = 'CHOSEN_PEOPLE_MINISTRIES',
  'ChowanCountySeniorCenter' = 'CHOWAN_COUNTY_SENIOR_CENTER',
  'ChowanRiver' = 'CHOWAN_RIVER',
  'ChowanRiverNursingAndRehab' = 'CHOWAN_RIVER_NURSING_AND_REHAB',
  'ChowanSeniorCenter' = 'CHOWAN_SENIOR_CENTER',
  'ChrisCorp' = 'CHRIS_CORP',
  'ChristChurch' = 'CHRIST_CHURCH',
  'ChristGospelChurch' = 'CHRIST_GOSPEL_CHURCH',
  'ChristTheKingSchool' = 'CHRIST_THE_KING_SCHOOL',
  'ChristianBroadcastingNetwork' = 'CHRISTIAN_BROADCASTING_NETWORK',
  'ChristianPsychotherapyServices' = 'CHRISTIAN_PSYCHOTHERAPY_SERVICES',
  'ChristopherNewportUniv' = 'CHRISTOPHER_NEWPORT_UNIV',
  'Chubb&SonInsurance' = 'CHUBB_&_SON_INSURANCE',
  'Chubb' = 'CHUBB',
  'ChubbGroupInsurance' = 'CHUBB_GROUP_INSURANCE',
  'ChubbInsCo' = 'CHUBB_INS_CO',
  'ChubbInsurance' = 'CHUBB_INSURANCE',
  'ChubbsInsurance' = 'CHUBBS_INSURANCE',
  'ChucksMechanical' = 'CHUCKS_MECHANICAL',
  'ChugachGovernmentSolutions.Llc' = 'CHUGACH_GOVERNMENT_SOLUTIONS._LLC',
  'ChugachIndInc' = 'CHUGACH_IND_INC',
  'ChurchOfNewBegings' = 'CHURCH_OF_NEW_BEGINGS',
  'ChurchlandOb/gynOfVa.Pc' = 'CHURCHLAND_OB/GYN_OF_VA._PC',
  'ChurchlandPsychAssoc' = 'CHURCHLAND_PSYCH_ASSOC',
  'CiaInsurance' = 'CIA_INSURANCE',
  'Ciccotti&Buckley' = 'CICCOTTI&_BUCKLEY',
  'Ciccotti&buckley' = 'CICCOTTI&BUCKLEY',
  'CiderTire' = 'CIDER_TIRE',
  'CignaGroupInc' = 'CIGNA_GROUP_INC',
  'Cimquest' = 'CIMQUEST',
  'CindyKitchen' = 'CINDY_KITCHEN',
  'CindysKitchen' = 'CINDYS_KITCHEN',
  'CintasCorporation' = 'CINTAS_CORPORATION',
  'Cirs' = 'CIRS',
  'CitOfElizabethCity' = 'CIT_OF_ELIZABETH_CITY',
  'CitadelOfElizabethCity' = 'CITADEL_OF_ELIZABETH_CITY',
  'Citco' = 'CITCO',
  'CitiBank' = 'CITI_BANK',
  'Citibank' = 'CITIBANK',
  'Citigroup' = 'CITIGROUP',
  'CityBeverageCo,Inc.' = 'CITY_BEVERAGE_CO,_INC.',
  'CityBeverageCo.' = 'CITY_BEVERAGE_CO.',
  'CityBrevage' = 'CITY_BREVAGE',
  'CityDeli' = 'CITY_DELI',
  'CityOfCamden' = 'CITY_OF_CAMDEN',
  'CityOfChes.FireDepartment' = 'CITY_OF_CHES._FIRE_DEPARTMENT',
  'CityOfChesDeptOfUtilities' = 'CITY_OF_CHES_DEPT_OF_UTILITIES',
  'CityOfChesPublicUtilities' = 'CITY_OF_CHES_PUBLIC_UTILITIES',
  'CityOfChesapea' = 'CITY_OF_CHESAPEA',
  'CityOfChesapeake' = 'CITY_OF_CHESAPEAKE',
  'CityOfChesapeake/treasuresOffice' = 'CITY_OF_CHESAPEAKE/TREASURES_OFFICE',
  'CityOfChesapeakeFireDept' = 'CITY_OF_CHESAPEAKE_FIRE_DEPT',
  'CityOfChesapeakePoliceDept' = 'CITY_OF_CHESAPEAKE_POLICE_DEPT',
  'CityOfChesapeakePublicSchl' = 'CITY_OF_CHESAPEAKE_PUBLIC_SCHL',
  'CityOfChesapeakeSchools' = 'CITY_OF_CHESAPEAKE_SCHOOLS',
  'CityOfChesapeakeSheriffsOffice' = 'CITY_OF_CHESAPEAKE_SHERIFFS_OFFICE',
  'CityOfChesapreak' = 'CITY_OF_CHESAPREAK',
  'CityOfChespFireDept' = 'CITY_OF_CHESP_FIRE_DEPT',
  'CityOfChespeake' = 'CITY_OF_CHESPEAKE',
  'CityOfElizCity' = 'CITY_OF_ELIZ_CITY',
  'CityOfElizabeth' = 'CITY_OF_ELIZABETH',
  'CityOfElizabethCity' = 'CITY_OF_ELIZABETH_CITY',
  'CityOfElizabethCityContract' = 'CITY_OF_ELIZABETH_CITY_CONTRACT',
  'CityOfElizabethCityFireDept' = 'CITY_OF_ELIZABETH_CITY_FIRE_DEPT',
  'CityOfElizabethCityFireDept.' = 'CITY_OF_ELIZABETH_CITY_FIRE_DEPT.',
  'CityOfElizabethCitySeniorCenter' = 'CITY_OF_ELIZABETH_CITY_SENIOR_CENTER',
  'CityOfFranklin' = 'CITY_OF_FRANKLIN',
  'CityOfFranklinPublicSchool' = 'CITY_OF_FRANKLIN_PUBLIC_SCHOOL',
  'CityOfHampton' = 'CITY_OF_HAMPTON',
  'CityOfNewportNews' = 'CITY_OF_NEWPORT_NEWS',
  'CityOfNorfolk' = 'CITY_OF_NORFOLK',
  'CityOfNorfolkCommissionOf' = 'CITY_OF_NORFOLK_COMMISSION_OF',
  'CityOfNorfolkPolice' = 'CITY_OF_NORFOLK_POLICE',
  'CityOfNorfolkPoliceDept' = 'CITY_OF_NORFOLK_POLICE_DEPT',
  'CityOfNorfolkPublicHealth' = 'CITY_OF_NORFOLK_PUBLIC_HEALTH',
  'CityOfNorfolkPublicWorks' = 'CITY_OF_NORFOLK_PUBLIC_WORKS',
  'CityOfNorfolkUtilitiesDept' = 'CITY_OF_NORFOLK_UTILITIES_DEPT',
  'CityOfPortsmou' = 'CITY_OF_PORTSMOU',
  'CityOfPortsmouth' = 'CITY_OF_PORTSMOUTH',
  'CityOfPortsmouth,PublicUtilities' = 'CITY_OF_PORTSMOUTH,_PUBLIC_UTILITIES',
  'CityOfPortsmouthPublicSchools' = 'CITY_OF_PORTSMOUTH_PUBLIC_SCHOOLS',
  'CityOfPortsmouthSchools' = 'CITY_OF_PORTSMOUTH_SCHOOLS',
  'CityOfQuincy' = 'CITY_OF_QUINCY',
  'CityOfSuffolk' = 'CITY_OF_SUFFOLK',
  'CityOfSuffolkFireDept' = 'CITY_OF_SUFFOLK_FIRE_DEPT',
  'CityOfVa.Beac' = 'CITY_OF_VA._BEAC',
  'CityOfVab' = 'CITY_OF_VAB',
  'CityOfVabPublicUtilities' = 'CITY_OF_VAB_PUBLIC_UTILITIES',
  'CityOfVbWasteManagement' = 'CITY_OF_VB_WASTE_MANAGEMENT',
  'CityOfVirginiaBeachFireDepartment' = 'CITY_OF_VIRGINIA_BEACH_FIRE_DEPARTMENT',
  'CityWideServices' = 'CITY_WIDE_SERVICES',
  'CivilServiceUsNavy' = 'CIVIL_SERVICE_US_NAVY',
  'CivilServiceUsn' = 'CIVIL_SERVICE_USN',
  'CivilServices' = 'CIVIL_SERVICES',
  'CivilSvc' = 'CIVIL_SVC',
  'ClPincus' = 'CL_PINCUS',
  'Clancy-TheysConstructionCo' = 'CLANCY_-_THEYS_CONSTRUCTION_CO',
  'ClarityCleaning' = 'CLARITY_CLEANING',
  'ClarkNexsen' = 'CLARK_NEXSEN',
  'ClarkNissen' = 'CLARK_NISSEN',
  'ClassicHairDesigns' = 'CLASSIC_HAIR_DESIGNS',
  'ClassicalConversations' = 'CLASSICAL_CONVERSATIONS',
  'ClcTrucking' = 'CLC_TRUCKING',
  'CleanTeam' = 'CLEAN_TEAM',
  'CleansHomes' = 'CLEANS_HOMES',
  'CliffordBrown&Co' = 'CLIFFORD_BROWN_&_CO',
  'ClinicalR/sAssocOfTdwtr' = 'CLINICAL_R/S_ASSOC_OF_TDWTR',
  'Cma-cgmAmerica' = 'CMA-CGM_AMERICA',
  'CmaCgmAmerica' = 'CMA_CGM_AMERICA',
  'CmaCgmAmericas' = 'CMA_CGM_AMERICAS',
  'CmdrFleetForcesCmd' = 'CMDR_FLEET_FORCES_CMD',
  'Cmg/pediatriSpecialists' = 'CMG/PEDIATRI_SPECIALISTS',
  'CmitSolutions' = 'CMIT_SOLUTIONS',
  'CmjPositiveChangeLlc' = 'CMJ_POSITIVE_CHANGE_LLC',
  'Cmmd' = 'CMMD',
  'CmrLlc' = 'CMR_LLC',
  'CoPhysical' = 'CO_PHYSICAL',
  'Coa' = 'COA',
  'CoachFactoryStore' = 'COACH_FACTORY_STORE',
  'CoastGaurd' = 'COAST_GAURD',
  'CoastGuardExchange' = 'COAST_GUARD_EXCHANGE',
  'CoastGuardFinanceCenter' = 'COAST_GUARD_FINANCE_CENTER',
  'CoastGuardFinanceCneter' = 'COAST_GUARD_FINANCE_CNETER',
  'CoastPools&SpasLlc' = 'COAST_POOLS_&_SPAS_LLC',
  'CoastalAccents' = 'COASTAL_ACCENTS',
  'CoastalAgrobusiness' = 'COASTAL_AGROBUSINESS',
  'CoastalCarolinaFamilyPractice' = 'COASTAL_CAROLINA_FAMILY_PRACTICE',
  'CoastalCommConstrCo' = 'COASTAL_COMM_CONSTR_CO',
  'CoastalDrilling' = 'COASTAL_DRILLING',
  'CoastalEquineVetSvc' = 'COASTAL_EQUINE_VET_SVC',
  'CoastalEyeCenter' = 'COASTAL_EYE_CENTER',
  'CoastalFamilyChurch' = 'COASTAL_FAMILY_CHURCH',
  'CoastalFireProtection' = 'COASTAL_FIRE_PROTECTION',
  'CoastalInvestment' = 'COASTAL_INVESTMENT',
  'CoastalKaraokeInc' = 'COASTAL_KARAOKE_INC',
  'CoastalLtg&Supply' = 'COASTAL_LTG_&_SUPPLY',
  'CoastalMasonry' = 'COASTAL_MASONRY',
  'CoastalMechanicalAndElectricalServices' = 'COASTAL_MECHANICAL_AND_ELECTRICAL_SERVICES',
  'CoastalMechanicalSystems' = 'COASTAL_MECHANICAL_SYSTEMS',
  'CoastalPediatrics' = 'COASTAL_PEDIATRICS',
  'CoastalPrecastSystem' = 'COASTAL_PRECAST_SYSTEM',
  'CoastalPrecastSyt' = 'COASTAL_PRECAST_SYT',
  'CoastalRehab' = 'COASTAL_REHAB',
  'CoastalTrainingTechnologies' = 'COASTAL_TRAINING_TECHNOLOGIES',
  'CoastwideMarineService' = 'COASTWIDE_MARINE_SERVICE',
  'Cobham' = 'COBHAM',
  'Coca-cola' = 'COCA-COLA',
  'Coca-colaEnterp' = 'COCA-COLA_ENTERP',
  'Coca-colaFreshments' = 'COCA-COLA_FRESHMENTS',
  'CocaCola' = 'COCA_COLA',
  'CognizantTechSolutionsUsCorp' = 'COGNIZANT_TECH_SOLUTIONS_US_CORP',
  'Cognosante/uscg' = 'COGNOSANTE/USCG',
  'CoinjockBaptistChurch' = 'COINJOCK_BAPTIST_CHURCH',
  'CoinjockMarina' = 'COINJOCK_MARINA',
  'Colby&Co' = 'COLBY_&_CO',
  'ColdwellBanker' = 'COLDWELL_BANKER',
  'ColdwellBankerRealtor' = 'COLDWELL_BANKER_REALTOR',
  'ColeElectric' = 'COLE_ELECTRIC',
  'Coleman&Assoc' = 'COLEMAN_&_ASSOC',
  'ColemansHeating' = 'COLEMANS_HEATING',
  'ColingtonFireDept' = 'COLINGTON_FIRE_DEPT',
  'ColingtonPizza' = 'COLINGTON_PIZZA',
  'CollegeOfAlbemerle' = 'COLLEGE_OF_ALBEMERLE',
  'CollegeOfTheAlbemarle' = 'COLLEGE_OF_THE_ALBEMARLE',
  'CollegeStudent' = 'COLLEGE_STUDENT',
  'CollinsMachineWorks' = 'COLLINS_MACHINE_WORKS',
  'ColonialChevrolet' = 'COLONIAL_CHEVROLET',
  'ColonialCrossingResorts' = 'COLONIAL_CROSSING_RESORTS',
  'ColonialDowns' = 'COLONIAL_DOWNS',
  'ColonialElectrical' = 'COLONIAL_ELECTRICAL',
  'ColonialFordTruckOfTidewater' = 'COLONIAL_FORD_TRUCK_OF_TIDEWATER',
  'ColonialShipyard' = 'COLONIAL_SHIPYARD',
  'ColonialWebbContractors' = 'COLONIAL_WEBB_CONTRACTORS',
  'ColonnaShipYard' = 'COLONNA_SHIP_YARD',
  'ColonnaShipyard' = 'COLONNA_SHIPYARD',
  'ColonnasShipyar' = 'COLONNAS_SHIPYAR',
  'ColonnasShipyard' = 'COLONNAS_SHIPYARD',
  'ColonnasShipyardInc' = 'COLONNAS_SHIPYARD_INC',
  'ColonyTire' = 'COLONY_TIRE',
  'ColonyTireCorp' = 'COLONY_TIRE_CORP',
  'ColonyTireInc' = 'COLONY_TIRE_INC',
  'ComfortInnOnTheOcean' = 'COMFORT_INN_ON_THE_OCEAN',
  'ComfortSolutions' = 'COMFORT_SOLUTIONS',
  'ComfortSuites' = 'COMFORT_SUITES',
  'ComfortSystemsOfVa' = 'COMFORT_SYSTEMS_OF_VA',
  'CommanderNnwc' = 'COMMANDER_NNWC',
  'CommercialFishman' = 'COMMERCIAL_FISHMAN',
  'CommercialMetalsCo' = 'COMMERCIAL_METALS_CO',
  'CommercialReadyMixProducts' = 'COMMERCIAL_READY_MIX_PRODUCTS',
  'CommonwealthOfVa' = 'COMMONWEALTH_OF_VA',
  'CommonwealthOfVa/abcBoard' = 'COMMONWEALTH_OF_VA/ABC_BOARD',
  'CommonwealthRailRoad' = 'COMMONWEALTH_RAIL_ROAD',
  'CommonwealthSeniorLiving' = 'COMMONWEALTH_SENIOR_LIVING',
  'CommonwealthVascularInstitute' = 'COMMONWEALTH_VASCULAR_INSTITUTE',
  'CommonwealthWoodPreservers' = 'COMMONWEALTH_WOOD_PRESERVERS',
  'CommuintyHospice' = 'COMMUINTY_HOSPICE',
  'CommunityAlternatives' = 'COMMUNITY_ALTERNATIVES',
  'CommunityCareClinicOfDare' = 'COMMUNITY_CARE_CLINIC_OF_DARE',
  'CommunityCareOfNc' = 'COMMUNITY_CARE_OF_NC',
  'CommunityGroup' = 'COMMUNITY_GROUP',
  'CommunitySolutions' = 'COMMUNITY_SOLUTIONS',
  'Commvault' = 'COMMVAULT',
  'Comoptevfor' = 'COMOPTEVFOR',
  'CompQSoft' = 'COMP_Q_SOFT',
  'CompassEnergy' = 'COMPASS_ENERGY',
  'CompassYouth&FamilySvcs' = 'COMPASS_YOUTH_&_FAMILY_SVCS',
  'CompassYouthAndFamilyServices' = 'COMPASS_YOUTH_AND_FAMILY_SERVICES',
  'CompassionateCare' = 'COMPASSIONATE_CARE',
  'CompletePaintingServices' = 'COMPLETE_PAINTING_SERVICES',
  'CompoConstructionCo.' = 'COMPO_CONSTRUCTION_CO.',
  'Compqsoft' = 'COMPQSOFT',
  'ComprehensivePsychSvcs' = 'COMPREHENSIVE_PSYCH_SVCS',
  'ComprintMilCommunications' = 'COMPRINT_MIL_COMMUNICATIONS',
  'ComputerSciencesCorp' = 'COMPUTER_SCIENCES_CORP',
  'ConWayFrieght' = 'CON_WAY_FRIEGHT',
  'Concordia' = 'CONCORDIA',
  'ConcretePipe&Prod' = 'CONCRETE_PIPE_&_PROD',
  'ConcursiveCorporation' = 'CONCURSIVE_CORPORATION',
  'Conduent' = 'CONDUENT',
  'Conmaco' = 'CONMACO',
  'ConmedHealthcareMgmt' = 'CONMED_HEALTHCARE_MGMT',
  'ConnectionsEducation' = 'CONNECTIONS_EDUCATION',
  'ConniesKids' = 'CONNIES_KIDS',
  'ConsociateHealth-taylor' = 'CONSOCIATE_HEALTH_-TAYLOR',
  'ConstellisHoldingsLlc' = 'CONSTELLIS_HOLDINGS_LLC',
  'ConstellisLlc' = 'CONSTELLIS_LLC',
  'Construction' = 'CONSTRUCTION',
  'ConstructionSup' = 'CONSTRUCTION_SUP',
  'ConsulateHealthcareCorp' = 'CONSULATE_HEALTHCARE_CORP',
  'Consultant' = 'CONSULTANT',
  'ConsultantHealthcare' = 'CONSULTANT_HEALTHCARE',
  'ConsumerDirectNetwork' = 'CONSUMER_DIRECT_NETWORK',
  'ConsumerPortfolioServ' = 'CONSUMER_PORTFOLIO_SERV',
  'ConsumerRecoveryAssoc' = 'CONSUMER_RECOVERY_ASSOC',
  'ContainerMaintenance' = 'CONTAINER_MAINTENANCE',
  'ContainerPortG' = 'CONTAINER_PORT_G',
  'ContainerportGroup' = 'CONTAINERPORT_GROUP',
  'ContinentalPools' = 'CONTINENTAL_POOLS',
  'ContractCommunicationsInc' = 'CONTRACT_COMMUNICATIONS_INC',
  'Contractor' = 'CONTRACTOR',
  'ControlledConditionsCorp.' = 'CONTROLLED_CONDITIONS_CORP.',
  'ConyersElectricalServices' = 'CONYERS_ELECTRICAL_SERVICES',
  'CookeCommunications' = 'COOKE_COMMUNICATIONS',
  'CooperVision' = 'COOPER_VISION',
  'CorasBeauty' = 'CORAS_BEAUTY',
  'CordiContracting' = 'CORDI_CONTRACTING',
  'CoreAndMain' = 'CORE_AND_MAIN',
  'CoreDrilling' = 'CORE_DRILLING',
  'CoreysAutomotiveRepair' = 'COREYS_AUTOMOTIVE_REPAIR',
  'CorinthianCollege' = 'CORINTHIAN_COLLEGE',
  'CorinthianCollegesInc' = 'CORINTHIAN_COLLEGES_INC',
  'CorollaClassic' = 'COROLLA_CLASSIC',
  'CorollaLightCommunityAssoc' = 'COROLLA_LIGHT_COMMUNITY_ASSOC',
  'CosmeticSurgeryCenter' = 'COSMETIC_SURGERY_CENTER',
  'CostPlusWorldMarket' = 'COST_PLUS_WORLD_MARKET',
  'CostaAzul' = 'COSTA_AZUL',
  'CostalNcRealty' = 'COSTAL_NC_REALTY',
  'CostarGroup' = 'COSTAR_GROUP',
  'CostcoPharmacy' = 'COSTCO_PHARMACY',
  'Cota' = 'COTA',
  'CottonGin' = 'COTTON_GIN',
  'CountryView' = 'COUNTRY_VIEW',
  'County' = 'COUNTY',
  'CountyOfCamden' = 'COUNTY_OF_CAMDEN',
  'CountyOfCurrituck' = 'COUNTY_OF_CURRITUCK',
  'CountyOfCurrituckFireEms' = 'COUNTY_OF_CURRITUCK_FIRE_EMS',
  'CountyOfDare' = 'COUNTY_OF_DARE',
  'CountyOfTehama' = 'COUNTY_OF_TEHAMA',
  'CourtHouseCafe' = 'COURT_HOUSE_CAFE',
  'Cova' = 'COVA',
  'Coverall' = 'COVERALL',
  'CowenSystemsLlc' = 'COWEN_SYSTEMS_LLC',
  'Cox' = 'COX',
  'CoxBusiness' = 'COX_BUSINESS',
  'CoxCable' = 'COX_CABLE',
  'CoxCommunicatio' = 'COX_COMMUNICATIO',
  'CoxCommunications' = 'COX_COMMUNICATIONS',
  'CoxCommunications,Inc' = 'COX_COMMUNICATIONS,_INC',
  'CoxEnterprizes' = 'COX_ENTERPRIZES',
  'Cpg,Inc' = 'CPG,_INC',
  'CrabbysResturant' = 'CRABBYS_RESTURANT',
  'CrackerBarrel' = 'CRACKER_BARREL',
  'CraftAirServices' = 'CRAFT_AIR_SERVICES',
  'CraigPlumbing' = 'CRAIG_PLUMBING',
  'CreativeHairdressers' = 'CREATIVE_HAIRDRESSERS',
  'Crescent' = 'CRESCENT',
  'CrescentBank&Trust' = 'CRESCENT_BANK_&_TRUST',
  'CrescentBankAndTrust' = 'CRESCENT_BANK_AND_TRUST',
  'CrescentRecovery' = 'CRESCENT_RECOVERY',
  'CrescomBank' = 'CRESCOM_BANK',
  'CresentBank' = 'CRESENT_BANK',
  'CrestwoodIntermediateSchool' = 'CRESTWOOD_INTERMEDIATE_SCHOOL',
  'CrewCutlersLandscaping' = 'CREW_CUTLERS_LANDSCAPING',
  'Crha' = 'CRHA',
  'Crmc&Sentara' = 'CRMC_&_SENTARA',
  'Crmc' = 'CRMC',
  'Crmc(cedarManor)' = 'CRMC_(CEDAR_MANOR)',
  'Crmc/crhcs' = 'CRMC/CRHCS',
  'CrmcBreastCenter' = 'CRMC_BREAST_CENTER',
  'CrmcCathLab' = 'CRMC_CATH_LAB',
  'CrmcEr' = 'CRMC_ER',
  'Crmf' = 'CRMF',
  'Crmg' = 'CRMG',
  'CroftonDivingCorp' = 'CROFTON_DIVING_CORP',
  'CrossCutters' = 'CROSS_CUTTERS',
  'CrossRealty' = 'CROSS_REALTY',
  'CrossRoadsFuel' = 'CROSS_ROADS_FUEL',
  'CrossroadCleaners' = 'CROSSROAD_CLEANERS',
  'CrossroadsFuelServiceInc' = 'CROSSROADS_FUEL_SERVICE_INC',
  'CrossroadsFuelServicesInc' = 'CROSSROADS_FUEL_SERVICES_INC',
  'Crothell' = 'CROTHELL',
  'CrowleyLiberatore&Ryan' = 'CROWLEY_LIBERATORE_&_RYAN',
  'CrowleyMaritime' = 'CROWLEY_MARITIME',
  'Crpc' = 'CRPC',
  'Crps' = 'CRPS',
  'Crsa' = 'CRSA',
  'CruzAssociates' = 'CRUZ_ASSOCIATES',
  'CrystalSteel' = 'CRYSTAL_STEEL',
  'CsHinesInc' = 'CS_HINES_INC',
  'CsLighting' = 'CS_LIGHTING',
  'Csc' = 'CSC',
  'Csengineering' = 'CSENGINEERING',
  'Csra' = 'CSRA',
  'Css' = 'CSS',
  'CstoInc' = 'CSTO_INC',
  'CsxTransportationInc' = 'CSX_TRANSPORTATION_INC',
  'CtrCorp' = 'CTR_CORP',
  'CtrForArthritis' = 'CTR_FOR_ARTHRITIS',
  'Ctvl' = 'CTVL',
  'CurrCoDeptSoc' = 'CURR_CO_DEPT_SOC',
  'CurrCoSchool' = 'CURR_CO_SCHOOL',
  'CurrCoSchools' = 'CURR_CO_SCHOOLS',
  'CurrictuckPublicSchools' = 'CURRICTUCK_PUBLIC_SCHOOLS',
  'CurriteckCounty' = 'CURRITECK_COUNTY',
  'CurritickCoPublicSchools' = 'CURRITICK_CO_PUBLIC_SCHOOLS',
  'CurritockTowing' = 'CURRITOCK_TOWING',
  'CurrituckAbc' = 'CURRITUCK_ABC',
  'CurrituckAnimalShelter' = 'CURRITUCK_ANIMAL_SHELTER',
  'CurrituckAreaHoldings' = 'CURRITUCK_AREA_HOLDINGS',
  'CurrituckBdOfEduc' = 'CURRITUCK_BD_OF_EDUC',
  'CurrituckBoardOfEducation' = 'CURRITUCK_BOARD_OF_EDUCATION',
  'CurrituckCarClinic' = 'CURRITUCK_CAR_CLINIC',
  'CurrituckCo' = 'CURRITUCK_CO',
  'CurrituckCo.Schools' = 'CURRITUCK_CO._SCHOOLS',
  'CurrituckCo.SheriffsOffice' = 'CURRITUCK_CO._SHERIFFS_OFFICE',
  'CurrituckCoBoa' = 'CURRITUCK_CO_BOA',
  'CurrituckCoDepOfTrans' = 'CURRITUCK_CO_DEP_OF_TRANS',
  'CurrituckCoDss' = 'CURRITUCK_CO_DSS',
  'CurrituckCoSch' = 'CURRITUCK_CO_SCH',
  'CurrituckCoSchool' = 'CURRITUCK_CO_SCHOOL',
  'CurrituckCoSchools' = 'CURRITUCK_CO_SCHOOLS',
  'CurrituckCoShe' = 'CURRITUCK_CO_SHE',
  'CurrituckCountry' = 'CURRITUCK_COUNTRY',
  'CurrituckCounty' = 'CURRITUCK_COUNTY',
  'CurrituckCounty911' = 'CURRITUCK_COUNTY_911',
  'CurrituckCountyAbc' = 'CURRITUCK_COUNTY_ABC',
  'CurrituckCountyClerksOffice' = 'CURRITUCK_COUNTY_CLERKS_OFFICE',
  'CurrituckCountyGov.' = 'CURRITUCK_COUNTY_GOV.',
  'CurrituckCountyHighSchool' = 'CURRITUCK_COUNTY_HIGH_SCHOOL',
  'CurrituckCountyLibrary' = 'CURRITUCK_COUNTY_LIBRARY',
  'CurrituckCountySchools' = 'CURRITUCK_COUNTY_SCHOOLS',
  'CurrituckCountySheriffsDept' = 'CURRITUCK_COUNTY_SHERIFFS_DEPT',
  'CurrituckCountySheriffsOffi' = 'CURRITUCK_COUNTY_SHERIFFS_OFFI',
  'CurrituckCountySherriff' = 'CURRITUCK_COUNTY_SHERRIFF',
  'CurrituckCountySocialServices' = 'CURRITUCK_COUNTY_SOCIAL_SERVICES',
  'CurrituckCoutyPublicSchools' = 'CURRITUCK_COUTY_PUBLIC_SCHOOLS',
  'CurrituckCtyDeptOfSocSvcs' = 'CURRITUCK_CTY_DEPT_OF_SOC_SVCS',
  'CurrituckCtySchoolsSystem' = 'CURRITUCK_CTY_SCHOOLS_SYSTEM',
  'CurrituckDental' = 'CURRITUCK_DENTAL',
  'CurrituckDeptS' = 'CURRITUCK_DEPT_S',
  'CurrituckDss' = 'CURRITUCK_DSS',
  'CurrituckEms' = 'CURRITUCK_EMS',
  'CurrituckFireAndEms' = 'CURRITUCK_FIRE_AND_EMS',
  'CurrituckFireDept' = 'CURRITUCK_FIRE_DEPT',
  'CurrituckGrain' = 'CURRITUCK_GRAIN',
  'CurrituckHighSchool' = 'CURRITUCK_HIGH_SCHOOL',
  'CurrituckHouse' = 'CURRITUCK_HOUSE',
  'CurrituckIntern' = 'CURRITUCK_INTERN',
  'CurrituckInternal' = 'CURRITUCK_INTERNAL',
  'CurrituckInternalMedicine' = 'CURRITUCK_INTERNAL_MEDICINE',
  'CurrituckPublicSchools' = 'CURRITUCK_PUBLIC_SCHOOLS',
  'CurrituckSand' = 'CURRITUCK_SAND',
  'CurrituckSandCompany' = 'CURRITUCK_SAND_COMPANY',
  'CurrituckSchool' = 'CURRITUCK_SCHOOL',
  'CurrituckSchools' = 'CURRITUCK_SCHOOLS',
  'CurrituckSherif' = 'CURRITUCK_SHERIF',
  'CurrituckSheriffsDept' = 'CURRITUCK_SHERIFFS_DEPT',
  'CurrituckSheriffsDept.' = 'CURRITUCK_SHERIFFS_DEPT.',
  'CurrituckSheriffsOffice' = 'CURRITUCK_SHERIFFS_OFFICE',
  'CurrituckSherriffsOffice' = 'CURRITUCK_SHERRIFFS_OFFICE',
  'CurrituckSports' = 'CURRITUCK_SPORTS',
  'CurtisKeyPlumbing' = 'CURTIS_KEY_PLUMBING',
  'Curves' = 'CURVES',
  'CurvesOfFairfield' = 'CURVES_OF_FAIRFIELD',
  'CustomClosetAndSpecialtiesInc' = 'CUSTOM_CLOSET_AND_SPECIALTIES_INC',
  'CustomKitchens' = 'CUSTOM_KITCHENS',
  'CustomMetalAndWelding' = 'CUSTOM_METAL_AND_WELDING',
  'CustomRenovations' = 'CUSTOM_RENOVATIONS',
  'CustomStoneCo' = 'CUSTOM_STONE_CO',
  'CustomWelding' = 'CUSTOM_WELDING',
  'CuttinLoose' = 'CUTTIN_LOOSE',
  'Cval' = 'CVAL',
  'CvsHealth' = 'CVS_HEALTH',
  'CypressCreekGrill' = 'CYPRESS_CREEK_GRILL',
  'D&dMRepairsAndMoving' = 'D&D_M_REPAIRS_AND_MOVING',
  'D&eAutoParts' = 'D&E_AUTO_PARTS',
  'DacsIncorp' = 'DACS_INCORP',
  'DailyAdvance' = 'DAILY_ADVANCE',
  'DaleCounty' = 'DALE_COUNTY',
  'DaleOldWreckerService' = 'DALE_OLD_WRECKER_SERVICE',
  'DaltonEdge' = 'DALTON_EDGE',
  'DamothTrane' = 'DAMOTH_TRANE',
  'Damuth' = 'DAMUTH',
  'DamuthTrane' = 'DAMUTH_TRANE',
  'DanQuinlan' = 'DAN_QUINLAN',
  'DancingGoatCafe' = 'DANCING_GOAT_CAFE',
  'DansServiceCenter' = 'DANS_SERVICE_CENTER',
  'DareCounty' = 'DARE_COUNTY',
  'DareCountyAbcBoard' = 'DARE_COUNTY_ABC_BOARD',
  'DareCountyAttyMgrOfc' = 'DARE_COUNTY_ATTY_MGR_OFC',
  'DareCountyBoardOfEducation' = 'DARE_COUNTY_BOARD_OF_EDUCATION',
  'DareCountyDetentionCenter' = 'DARE_COUNTY_DETENTION_CENTER',
  'DareCountyEms' = 'DARE_COUNTY_EMS',
  'DareCountyHealthDepartment' = 'DARE_COUNTY_HEALTH_DEPARTMENT',
  'DareCountyLibrary' = 'DARE_COUNTY_LIBRARY',
  'DareCountyPlanning' = 'DARE_COUNTY_PLANNING',
  'DareCountyPublicSchools' = 'DARE_COUNTY_PUBLIC_SCHOOLS',
  'DareCountySchools' = 'DARE_COUNTY_SCHOOLS',
  'DareCountyTourismBoard' = 'DARE_COUNTY_TOURISM_BOARD',
  'DareCountyWater' = 'DARE_COUNTY_WATER',
  'DareCtyBoardOfEducation' = 'DARE_CTY_BOARD_OF_EDUCATION',
  'DareHeartCenter' = 'DARE_HEART_CENTER',
  'Dareware/acePools&Spas' = 'DAREWARE/ACE_POOLS_&_SPAS',
  'DarewareCorp' = 'DAREWARE_CORP',
  'DaveCoRecycling' = 'DAVE_CO_RECYCLING',
  'Davenport' = 'DAVENPORT',
  'DavesCabinet,Inc' = 'DAVES_CABINET,_INC',
  'DavesCabinet,inc' = 'DAVES_CABINET,INC',
  'DavesCabinetInc' = 'DAVES_CABINET_INC',
  'DavidWaddell&lindaGeorgeMd' = 'DAVID_WADDELL&LINDA_GEORGE_MD',
  'DavidWright' = 'DAVID_WRIGHT',
  'Davita' = 'DAVITA',
  'DavitaDialysisCo' = 'DAVITA_DIALYSIS_CO',
  'DavitaInc' = 'DAVITA_INC',
  'DaysInn' = 'DAYS_INN',
  'DcPowell-Cna' = 'DC_POWELL-_CNA',
  'DcmcBaltimore' = 'DCMC_BALTIMORE',
  'DdlOmniEngineering' = 'DDL_OMNI_ENGINEERING',
  'DeAuto' = 'DE_AUTO',
  'DeAutoTramission' = 'DE_AUTO_TRAMISSION',
  'DeKirbyInc' = 'DE_KIRBY_INC',
  'DealerTire' = 'DEALER_TIRE',
  'DealerTrack' = 'DEALER_TRACK',
  'DebbieSmith' = 'DEBBIE_SMITH',
  'DebbiesCleaningCottages' = 'DEBBIES_CLEANING_COTTAGES',
  'DebbiesPetParlor' = 'DEBBIES_PET_PARLOR',
  'DecaCommissary' = 'DECA_COMMISSARY',
  'DecisionTechnonologiesInc' = 'DECISION_TECHNONOLOGIES_INC',
  'DeckerLawFirm' = 'DECKER_LAW_FIRM',
  'DecoSecurity' = 'DECO_SECURITY',
  'DecoSecuritySy' = 'DECO_SECURITY_SY',
  'DeepCreekBaptistChurch' = 'DEEP_CREEK_BAPTIST_CHURCH',
  'DeepCreekRealt' = 'DEEP_CREEK_REALT',
  'DeepCreekSecep' = 'DEEP_CREEK_SECEP',
  'DeepCreekUnitedMethodistChurchPreschool' = 'DEEP_CREEK_UNITED_METHODIST_CHURCH_PRESCHOOL',
  'DeerPark' = 'DEER_PARK',
  'DeerfieldCorrectionalCenter' = 'DEERFIELD_CORRECTIONAL_CENTER',
  'DefenseCommissaryAgency' = 'DEFENSE_COMMISSARY_AGENCY',
  'DefenseDistDepot' = 'DEFENSE_DIST_DEPOT',
  'DefenseDistribution' = 'DEFENSE_DISTRIBUTION',
  'DefenseInformationSystemsAg' = 'DEFENSE_INFORMATION_SYSTEMS_AG',
  'DefenseLogistic' = 'DEFENSE_LOGISTIC',
  'DefenseLogisticAgencyPortsmouthNavalShipyard' = 'DEFENSE_LOGISTIC_AGENCY_PORTSMOUTH_NAVAL_SHIPYARD',
  'DefenseLogisticsAgency' = 'DEFENSE_LOGISTICS_AGENCY',
  'DeggellerAttractionsInc' = 'DEGGELLER_ATTRACTIONS_INC',
  'DelReySystem' = 'DEL_REY_SYSTEM',
  'DeloitteTouche,Llc' = 'DELOITTE_TOUCHE,_LLC',
  'DelphiniusEngineering' = 'DELPHINIUS_ENGINEERING',
  'DelphinosEngineering' = 'DELPHINOS_ENGINEERING',
  'Delphinus' = 'DELPHINUS',
  'DelphinusEngInc' = 'DELPHINUS_ENG_INC',
  'DelphinusEngineering' = 'DELPHINUS_ENGINEERING',
  'DelphinusEngineeringInc' = 'DELPHINUS_ENGINEERING_INC',
  'DeltaAirlines' = 'DELTA_AIRLINES',
  'DeltaOncology' = 'DELTA_ONCOLOGY',
  'DendriteInternational' = 'DENDRITE_INTERNATIONAL',
  'DentalTransformations' = 'DENTAL_TRANSFORMATIONS',
  'DepOfCorr' = 'DEP_OF_CORR',
  'DepartmentOfCorrections' = 'DEPARTMENT_OF_CORRECTIONS',
  'DepartmentOfDefense' = 'DEPARTMENT_OF_DEFENSE',
  'DepartmentOfHomelandSecurity' = 'DEPARTMENT_OF_HOMELAND_SECURITY',
  'DepartmentOfLabor' = 'DEPARTMENT_OF_LABOR',
  'DepartmentOfNavy' = 'DEPARTMENT_OF_NAVY',
  'DepartmentOfPublicWorks' = 'DEPARTMENT_OF_PUBLIC_WORKS',
  'DepartmentOfTheArmy' = 'DEPARTMENT_OF_THE_ARMY',
  'Depaul' = 'DEPAUL',
  'DepaulMedicalCenter' = 'DEPAUL_MEDICAL_CENTER',
  'Dept.OfCommerc' = 'DEPT._OF_COMMERC',
  'Dept.OfCorrect' = 'DEPT._OF_CORRECT',
  'Dept.OfHomelandSecurity' = 'DEPT._OF_HOMELAND_SECURITY',
  'Dept.OfVeteransAffairs' = 'DEPT._OF_VETERANS_AFFAIRS',
  'DeptOfAirForce' = 'DEPT_OF_AIR_FORCE',
  'DeptOfArmy' = 'DEPT_OF_ARMY',
  'DeptOfCorrectionalEducation' = 'DEPT_OF_CORRECTIONAL_EDUCATION',
  'DeptOfCorrections' = 'DEPT_OF_CORRECTIONS',
  'DeptOfDefNavyCivilService' = 'DEPT_OF_DEF_NAVY_CIVIL_SERVICE',
  'DeptOfDefence' = 'DEPT_OF_DEFENCE',
  'DeptOfDefense' = 'DEPT_OF_DEFENSE',
  'DeptOfDefenseGs11' = 'DEPT_OF_DEFENSE_GS11',
  'DeptOfDenense/navyExch' = 'DEPT_OF_DENENSE/NAVY_EXCH',
  'DeptOfHomelandSecurity' = 'DEPT_OF_HOMELAND_SECURITY',
  'DeptOfHomelandSecurity/Fema' = 'DEPT_OF_HOMELAND_SECURITY/_FEMA',
  'DeptOfHomelandSecurityCoas' = 'DEPT_OF_HOMELAND_SECURITY_COAS',
  'DeptOfJustice' = 'DEPT_OF_JUSTICE',
  'DeptOfJuvenileJustice' = 'DEPT_OF_JUVENILE_JUSTICE',
  'DeptOfLabor&Industry' = 'DEPT_OF_LABOR_&_INDUSTRY',
  'DeptOfMilitaryAffairs' = 'DEPT_OF_MILITARY_AFFAIRS',
  'DeptOfNavy' = 'DEPT_OF_NAVY',
  'DeptOfNavyCdsaDamNeck' = 'DEPT_OF_NAVY_CDSA_DAM_NECK',
  'DeptOfRehab' = 'DEPT_OF_REHAB',
  'DeptOfSocialServices' = 'DEPT_OF_SOCIAL_SERVICES',
  'DeptOfTheArmy' = 'DEPT_OF_THE_ARMY',
  'DeptOfTheNavy' = 'DEPT_OF_THE_NAVY',
  'DeptOfTranspor' = 'DEPT_OF_TRANSPOR',
  'DeptOfUtilitiesCityOfChes' = 'DEPT_OF_UTILITIES_CITY_OF_CHES',
  'DeptOfVeterans' = 'DEPT_OF_VETERANS',
  'DeptPfNavy' = 'DEPT_PF_NAVY',
  'DeputyClerk' = 'DEPUTY_CLERK',
  'DesignsByJo,Inc' = 'DESIGNS_BY_JO,_INC',
  'DesignsInc' = 'DESIGNS_INC',
  'DfPartickInc' = 'DF_PARTICK_INC',
  'DfiSystems' = 'DFI_SYSTEMS',
  'Dfmc' = 'DFMC',
  'Dhl' = 'DHL',
  'Dhs/tsa' = 'DHS/TSA',
  'Dhs/uscg' = 'DHS/USCG',
  'DhsCustoms&BorderProt' = 'DHS_CUSTOMS_&_BORDER_PROT',
  'DiDarioSalonAndSpa' = 'DI_DARIO_SALON_AND_SPA',
  'Dia' = 'DIA',
  'DiaAdvertising' = 'DIA_ADVERTISING',
  'DiamondBeautySupply' = 'DIAMOND_BEAUTY_SUPPLY',
  'DiamondCareServicesCorp' = 'DIAMOND_CARE_SERVICES_CORP',
  'DiamondDeatailing' = 'DIAMOND_DEATAILING',
  'DiamondGlazing' = 'DIAMOND_GLAZING',
  'DiamondbackSignals' = 'DIAMONDBACK_SIGNALS',
  'DiamondsDirect' = 'DIAMONDS_DIRECT',
  'DianasHairDesigns' = 'DIANAS_HAIR_DESIGNS',
  'Dickerson&SmithAttyAtLaw' = 'DICKERSON_&_SMITH_ATTY_AT_LAW',
  'DidlakeInc' = 'DIDLAKE_INC',
  'Digestive&LiverDiseaseSpecialists' = 'DIGESTIVE_&_LIVER_DISEASE_SPECIALISTS',
  'Dillards' = 'DILLARDS',
  'DillonPlastering' = 'DILLON_PLASTERING',
  'DirectHomeCare' = 'DIRECT_HOME_CARE',
  'DirectInHomeCare' = 'DIRECT_IN_HOME_CARE',
  'DirtyDicksCrabHouse' = 'DIRTY_DICKS_CRAB_HOUSE',
  'Disability' = 'DISABILITY',
  'Disabilty' = 'DISABILTY',
  'Disable' = 'DISABLE',
  'DisabledRetired' = 'DISABLED_RETIRED',
  'DisabledVet' = 'DISABLED_VET',
  'DiscountPlumbing' = 'DISCOUNT_PLUMBING',
  'DiscountTire' = 'DISCOUNT_TIRE',
  'DisharoonBuilde' = 'DISHAROON_BUILDE',
  'Disney' = 'DISNEY',
  'DistributionConstruction' = 'DISTRIBUTION_CONSTRUCTION',
  'DistrictAttorneyOffice' = 'DISTRICT_ATTORNEY_OFFICE',
  'Div.OfChildDevelopment&EarlyEducation' = 'DIV._OF_CHILD_DEVELOPMENT_&_EARLY_EDUCATION',
  'DivarisPropertyMgtCorp' = 'DIVARIS_PROPERTY_MGT_CORP',
  'DixieAutoParts' = 'DIXIE_AUTO_PARTS',
  'DixieTruckingInc' = 'DIXIE_TRUCKING_INC',
  'DlEngineering' = 'DL_ENGINEERING',
  'DlaDistribution' = 'DLA_DISTRIBUTION',
  'DmbStrategic' = 'DMB_STRATEGIC',
  'Docupak' = 'DOCUPAK',
  'Dod' = 'DOD',
  'Dod/don' = 'DOD/DON',
  'DodBmvMedical' = 'DOD_BMV_MEDICAL',
  'DodDepartmentOfTheNavy' = 'DOD_DEPARTMENT_OF_THE_NAVY',
  'DodFire' = 'DOD_FIRE',
  'DodJointStaff' = 'DOD_JOINT_STAFF',
  'DodNavfacMidlant' = 'DOD_NAVFAC_MIDLANT',
  'DodNavy' = 'DOD_NAVY',
  'DodNmcp' = 'DOD_NMCP',
  'DodUsNavy' = 'DOD_US_NAVY',
  'DodsonPestControl' = 'DODSON_PEST_CONTROL',
  'Doj' = 'DOJ',
  'DollarGeneral' = 'DOLLAR_GENERAL',
  'DollarTree' = 'DOLLAR_TREE',
  'DollarTree,Inc' = 'DOLLAR_TREE,_INC',
  'DollarTreeCorp' = 'DOLLAR_TREE_CORP',
  'DollarTreeCorporate' = 'DOLLAR_TREE_CORPORATE',
  'DollarTreeInc' = 'DOLLAR_TREE_INC',
  'DollarTreeStore' = 'DOLLAR_TREE_STORE',
  'DollarTreeStores' = 'DOLLAR_TREE_STORES',
  'DollarTreeStoresInc' = 'DOLLAR_TREE_STORES_INC',
  'DollarTreeeDistribution' = 'DOLLAR_TREEE_DISTRIBUTION',
  'DolphinIntlInc' = 'DOLPHIN_INTL_INC',
  'DomesticEngineer' = 'DOMESTIC_ENGINEER',
  'DomesticFuels&Lubes,Inc.' = 'DOMESTIC_FUELS_&_LUBES,_INC.',
  'DomesticFuelsAndLubes' = 'DOMESTIC_FUELS_AND_LUBES',
  'DominionDedicated' = 'DOMINION_DEDICATED',
  'DominionDisposalInc' = 'DOMINION_DISPOSAL_INC',
  'DominionEnergy' = 'DOMINION_ENERGY',
  'DominionEnergy-SurryNuclearPowerStation' = 'DOMINION_ENERGY-_SURRY_NUCLEAR_POWER_STATION',
  'DominionEnterprises' = 'DOMINION_ENTERPRISES',
  'DominionGolf' = 'DOMINION_GOLF',
  'DominionNational' = 'DOMINION_NATIONAL',
  'DominionNcPower' = 'DOMINION_NC_POWER',
  'DominionPathology' = 'DOMINION_PATHOLOGY',
  'DominionPowering&Sealing' = 'DOMINION_POWERING_&_SEALING',
  'DominionTerminals' = 'DOMINION_TERMINALS',
  'DominionVaPower' = 'DOMINION_VA_POWER',
  'DominionVirginiaPower' = 'DOMINION_VIRGINIA_POWER',
  'DominoesPizza' = 'DOMINOES_PIZZA',
  'Dominos' = 'DOMINOS',
  'DominosPizza' = 'DOMINOS_PIZZA',
  'DonaldEvansDpm' = 'DONALD_EVANS_DPM',
  'DonaldHolmes' = 'DONALD_HOLMES',
  'DonaldStroud' = 'DONALD_STROUD',
  'DonsMobileGlass' = 'DONS_MOBILE_GLASS',
  'DoorEngineeringCorp' = 'DOOR_ENGINEERING_CORP',
  'DosTransportation' = 'DOS_TRANSPORTATION',
  'DouchellLlc' = 'DOUCHELL_LLC',
  'DoveCountry' = 'DOVE_COUNTRY',
  'Dr.Challa' = 'DR._CHALLA',
  'Dr.DavidGraham' = 'DR._DAVID_GRAHAM',
  'Dr.Fernandez' = 'DR._FERNANDEZ',
  'Dr.GUgy' = 'DR._G_UGY',
  'Dr.Habeeb' = 'DR._HABEEB',
  'Dr.JavaidPerwaiz' = 'DR._JAVAID_PERWAIZ',
  'Dr.Konikoff' = 'DR._KONIKOFF',
  'Dr.NabilTadros' = 'DR._NABIL_TADROS',
  'Dr.Perwaiz' = 'DR._PERWAIZ',
  'Dr.PeterAdams' = 'DR._PETER_ADAMS',
  'Dr.Radin' = 'DR._RADIN',
  'Dr.RichardTynaw' = 'DR._RICHARD_TYNAW',
  'Dr.RodRogge' = 'DR._ROD_ROGGE',
  'Dr.StevenPowers' = 'DR._STEVEN_POWERS',
  'Dr.TraceyOliver' = 'DR._TRACEY_OLIVER',
  'DrBlack' = 'DR_BLACK',
  'DrCarwell' = 'DR_CARWELL',
  'DrDarrellLBoyce' = 'DR_DARRELL_L_BOYCE',
  'DrMorgan' = 'DR_MORGAN',
  'DrShivarPeluso&Andersen' = 'DR_SHIVAR_PELUSO_&_ANDERSEN',
  'DrTanyaBrown' = 'DR_TANYA_BROWN',
  'DrTanyaBrownDds' = 'DR_TANYA_BROWN_DDS',
  'DrWilliamTrolenburg,dds' = 'DR_WILLIAM_TROLENBURG,DDS',
  'DragasCompanies' = 'DRAGAS_COMPANIES',
  'Dream' = 'DREAM',
  'DressBarn' = 'DRESS_BARN',
  'Dresser-randCo' = 'DRESSER-RAND_CO',
  'DroceseOfRaleigh' = 'DROCESE_OF_RALEIGH',
  'Drs' = 'DRS',
  'Drs-tsi' = 'DRS-TSI',
  'DrsDowningAndAusbandDds' = 'DRS_DOWNING_AND_AUSBAND_DDS',
  'DrsTech' = 'DRS_TECH',
  'DrsTechnologies' = 'DRS_TECHNOLOGIES',
  'DrsTechnologies,Inc' = 'DRS_TECHNOLOGIES,_INC',
  'DruckerAndFalk' = 'DRUCKER_AND_FALK',
  'DruckerAnfFalk' = 'DRUCKER_ANF_FALK',
  'DrummondAmerica' = 'DRUMMOND_AMERICA',
  'DsiRdSystem' = 'DSI_RD_SYSTEM',
  'Dtudent' = 'DTUDENT',
  'DuckDonuts' = 'DUCK_DONUTS',
  'DuckOutfitters' = 'DUCK_OUTFITTERS',
  'DuckThru' = 'DUCK_THRU',
  'DuckThruFoodStores' = 'DUCK_THRU_FOOD_STORES',
  'DuncanPlumbing' = 'DUNCAN_PLUMBING',
  'DunnavantWelding&Steel' = 'DUNNAVANT_WELDING_&_STEEL',
  'Dupont' = 'DUPONT',
  'DwanPaint' = 'DWAN_PAINT',
  'DynCorp' = 'DYN_CORP',
  'DynamicTowing' = 'DYNAMIC_TOWING',
  'DynamicTowtruckMnfgCo' = 'DYNAMIC_TOWTRUCK_MNFG_CO',
  'DynaricInc' = 'DYNARIC_INC',
  'DynebicsInc' = 'DYNEBICS_INC',
  'DzAtlantic' = 'DZ_ATLANTIC',
  'E&cEnterprises' = 'E&C_ENTERPRISES',
  'E.c.StateUniversity' = 'E.C._STATE_UNIVERSITY',
  'E.c/pasquotankPublicSchools' = 'E.C/PASQUOTANK_PUBLIC_SCHOOLS',
  'E.tGresham' = 'E.T_GRESHAM',
  'EAndJSelectiveSalon' = 'E_AND_J_SELECTIVE_SALON',
  'ECPasquatankSchools' = 'E_C_PASQUATANK_SCHOOLS',
  'EagleCreekBarAndGrill' = 'EAGLE_CREEK_BAR_AND_GRILL',
  'EagleCreekGolfClub&Grill' = 'EAGLE_CREEK_GOLF_CLUB_&_GRILL',
  'EagleCreekGolfClubAnGrill' = 'EAGLE_CREEK_GOLF_CLUB_AN_GRILL',
  'EagleCreekGolfCourse' = 'EAGLE_CREEK_GOLF_COURSE',
  'EagleMart' = 'EAGLE_MART',
  'EagleStarUsa' = 'EAGLE_STAR_USA',
  'EaheartIndustrialCorp' = 'EAHEART_INDUSTRIAL_CORP',
  'EaheartIndustrialService' = 'EAHEART_INDUSTRIAL_SERVICE',
  'EarlIndustries' = 'EARL_INDUSTRIES',
  'EarnestCoalterDds' = 'EARNEST_COALTER_DDS',
  'EasstCarolinaBank' = 'EASST_CAROLINA_BANK',
  'EastAlbemarleRegionalLibrary' = 'EAST_ALBEMARLE_REGIONAL_LIBRARY',
  'EastC.hCore' = 'EAST_C.H_CORE',
  'EastCardiovascularSpecialist' = 'EAST_CARDIOVASCULAR_SPECIALIST',
  'EastCardiovascularSpecialists' = 'EAST_CARDIOVASCULAR_SPECIALISTS',
  'EastCarolina' = 'EAST_CAROLINA',
  'EastCarolinaBa' = 'EAST_CAROLINA_BA',
  'EastCarolinaBehavioralHealth' = 'EAST_CAROLINA_BEHAVIORAL_HEALTH',
  'EastCarolinaUniversity' = 'EAST_CAROLINA_UNIVERSITY',
  'EastCarolineTruck' = 'EAST_CAROLINE_TRUCK',
  'EastCoastAbatement&Demolition' = 'EAST_COAST_ABATEMENT_&_DEMOLITION',
  'EastCoastAbatementCo' = 'EAST_COAST_ABATEMENT_CO',
  'EastCoastAppliance' = 'EAST_COAST_APPLIANCE',
  'EastCoastAutoTransport' = 'EAST_COAST_AUTO_TRANSPORT',
  'EastCoastDemo' = 'EAST_COAST_DEMO',
  'EastCoastDemolition' = 'EAST_COAST_DEMOLITION',
  'EastCoastFireProtectionInc' = 'EAST_COAST_FIRE_PROTECTION_INC',
  'EastCoastLawn&Garden' = 'EAST_COAST_LAWN_&_GARDEN',
  'EastCoastRepair&Fabrication' = 'EAST_COAST_REPAIR_&_FABRICATION',
  'EastCoastSteelFabrication' = 'EAST_COAST_STEEL_FABRICATION',
  'EastCoastTruck&Trailer' = 'EAST_COAST_TRUCK_&_TRAILER',
  'EastCoastValveService' = 'EAST_COAST_VALVE_SERVICE',
  'EastMississippiHospital' = 'EAST_MISSISSIPPI_HOSPITAL',
  'EasternCommercialServices' = 'EASTERN_COMMERCIAL_SERVICES',
  'EasternDermatolgy' = 'EASTERN_DERMATOLGY',
  'EasternDermatology' = 'EASTERN_DERMATOLOGY',
  'EasternShoreAmbulance' = 'EASTERN_SHORE_AMBULANCE',
  'EasternShoreAnimalHospital' = 'EASTERN_SHORE_ANIMAL_HOSPITAL',
  'EasternShoreStateHospital' = 'EASTERN_SHORE_STATE_HOSPITAL',
  'EasternVaEnt' = 'EASTERN_VA_ENT',
  'EasternVaEyeAssoc' = 'EASTERN_VA_EYE_ASSOC',
  'EasternVaMedicalSchool' = 'EASTERN_VA_MEDICAL_SCHOOL',
  'EasternVirginiaEyeAssociates' = 'EASTERN_VIRGINIA_EYE_ASSOCIATES',
  'EcFireDepartment' = 'EC_FIRE_DEPARTMENT',
  'EcPoliceDepartment' = 'EC_POLICE_DEPARTMENT',
  'EcStateUniversity' = 'EC_STATE_UNIVERSITY',
  'Ecc' = 'ECC',
  'Eccps' = 'ECCPS',
  'Ecms' = 'ECMS',
  'EconomicImprovementCouncil' = 'ECONOMIC_IMPROVEMENT_COUNCIL',
  'EcpiColleges' = 'ECPI_COLLEGES',
  'EcpiUniversityMci' = 'ECPI_UNIVERSITY_MCI',
  'Ecpps' = 'ECPPS',
  'Ecpps(northside)' = 'ECPPS_(NORTHSIDE)',
  'Ecps' = 'ECPS',
  'Ecsu' = 'ECSU',
  'EctTracking' = 'ECT_TRACKING',
  'EcuHealth' = 'ECU_HEALTH',
  'EdenfieldDentistry' = 'EDENFIELD_DENTISTRY',
  'EdgeAndAssocPc' = 'EDGE_AND_ASSOC_PC',
  'EdgewaterConstruction' = 'EDGEWATER_CONSTRUCTION',
  'EdgewaterConstructionService' = 'EDGEWATER_CONSTRUCTION_SERVICE',
  'Edinburgh' = 'EDINBURGH',
  'EdmarcHospiceForChildren' = 'EDMARC_HOSPICE_FOR_CHILDREN',
  'EdsElectric' = 'EDS_ELECTRIC',
  'EdwardHabeebMd' = 'EDWARD_HABEEB_MD',
  'EdwardLeeLewis,Jr' = 'EDWARD_LEE_LEWIS,_JR',
  'Eg&GTechnicalServices' = 'EG_&_G_TECHNICAL_SERVICES',
  'EgglestonService' = 'EGGLESTON_SERVICE',
  'EgglestonServices' = 'EGGLESTON_SERVICES',
  'Eic' = 'EIC',
  'ElMiller' = 'EL_MILLER',
  'Elans' = 'ELANS',
  'ElbowRoadFarms' = 'ELBOW_ROAD_FARMS',
  'ElderCare' = 'ELDER_CARE',
  'Elec.EquipmentCo' = 'ELEC._EQUIPMENT_CO',
  'ElectricMotor' = 'ELECTRIC_MOTOR',
  'ElectricMotorA' = 'ELECTRIC_MOTOR_A',
  'ElectricMotorContracting' = 'ELECTRIC_MOTOR_CONTRACTING',
  'ElectronicSystemsInc' = 'ELECTRONIC_SYSTEMS_INC',
  'ElectronicSystemsXeroxCo' = 'ELECTRONIC_SYSTEMS_XEROX_CO',
  'ElevanceHealth' = 'ELEVANCE_HEALTH',
  'EliteContractingGroup' = 'ELITE_CONTRACTING_GROUP',
  'ElizCity-pasquotankBrdOfEd' = 'ELIZ_CITY-PASQUOTANK_BRD_OF_ED',
  'ElizCityMiddle' = 'ELIZ_CITY_MIDDLE',
  'ElizCitySchools' = 'ELIZ_CITY_SCHOOLS',
  'ElizCitySheriffDeputy' = 'ELIZ_CITY_SHERIFF_DEPUTY',
  'ElizCityStateUniv' = 'ELIZ_CITY_STATE_UNIV',
  'ElizCityStateUniversity' = 'ELIZ_CITY_STATE_UNIVERSITY',
  'ElizaRiverTerminal' = 'ELIZA_RIVER_TERMINAL',
  'ElizabethArden' = 'ELIZABETH_ARDEN',
  'ElizabethCity/pasquatankCountySchools' = 'ELIZABETH_CITY/PASQUATANK_COUNTY_SCHOOLS',
  'ElizabethCityBrick' = 'ELIZABETH_CITY_BRICK',
  'ElizabethCityCottonMill' = 'ELIZABETH_CITY_COTTON_MILL',
  'ElizabethCityFireDepartment' = 'ELIZABETH_CITY_FIRE_DEPARTMENT',
  'ElizabethCityFireDept.' = 'ELIZABETH_CITY_FIRE_DEPT.',
  'ElizabethCityHealthAndRehabilitation' = 'ELIZABETH_CITY_HEALTH_AND_REHABILITATION',
  'ElizabethCityHeath&Rehab' = 'ELIZABETH_CITY_HEATH_&_REHAB',
  'ElizabethCityHousingAuthority' = 'ELIZABETH_CITY_HOUSING_AUTHORITY',
  'ElizabethCityParksAndRec' = 'ELIZABETH_CITY_PARKS_AND_REC',
  'ElizabethCityPasquotanicSchools' = 'ELIZABETH_CITY_PASQUOTANIC_SCHOOLS',
  'ElizabethCityPasquotankPubl' = 'ELIZABETH_CITY_PASQUOTANK_PUBL',
  'ElizabethCityPasquotankPublicSchoold' = 'ELIZABETH_CITY_PASQUOTANK_PUBLIC_SCHOOLD',
  'ElizabethCityPasquotankPublicSchools' = 'ELIZABETH_CITY_PASQUOTANK_PUBLIC_SCHOOLS',
  'ElizabethCityPoliceDept' = 'ELIZABETH_CITY_POLICE_DEPT',
  'ElizabethCityRehab' = 'ELIZABETH_CITY_REHAB',
  'ElizabethCityS' = 'ELIZABETH_CITY_S',
  'ElizabethCitySchools' = 'ELIZABETH_CITY_SCHOOLS',
  'ElizabethCityStataUniversity' = 'ELIZABETH_CITY_STATA_UNIVERSITY',
  'ElizabethCityStatePolice' = 'ELIZABETH_CITY_STATE_POLICE',
  'ElizabethCityStateUniv' = 'ELIZABETH_CITY_STATE_UNIV',
  'ElizabethCityStateUniversity' = 'ELIZABETH_CITY_STATE_UNIVERSITY',
  'ElizabethCityStateUnversity' = 'ELIZABETH_CITY_STATE_UNVERSITY',
  'ElizabethCityStateUnvrsty' = 'ELIZABETH_CITY_STATE_UNVRSTY',
  'ElizabethCityUniversity' = 'ELIZABETH_CITY_UNIVERSITY',
  'ElizabethRiverCrossings' = 'ELIZABETH_RIVER_CROSSINGS',
  'ElizabethRiverMechanical' = 'ELIZABETH_RIVER_MECHANICAL',
  'ElizabethRiverTunnels' = 'ELIZABETH_RIVER_TUNNELS',
  'ElmarkPainting' = 'ELMARK_PAINTING',
  'Embarq' = 'EMBARQ',
  'EmbracingGodMinistries' = 'EMBRACING_GOD_MINISTRIES',
  'Emc' = 'EMC',
  'EmergentLlc' = 'EMERGENT_LLC',
  'EmgCorp' = 'EMG_CORP',
  'EmpireHospitality' = 'EMPIRE_HOSPITALITY',
  'EmpireMachinery' = 'EMPIRE_MACHINERY',
  'Employer' = 'EMPLOYER',
  'Ems' = 'EMS',
  'Ems/fireCurrCo' = 'EMS/FIRE_CURR_CO',
  'EmsIndustrial' = 'EMS_INDUSTRIAL',
  'EndToEndInc' = 'END_TO_END_INC',
  'EngilityCorp' = 'ENGILITY_CORP',
  'EngineSystems' = 'ENGINE_SYSTEMS',
  'Entercom' = 'ENTERCOM',
  'Enterprise' = 'ENTERPRISE',
  'EnterpriseHolding' = 'ENTERPRISE_HOLDING',
  'EnterpriseHoldings' = 'ENTERPRISE_HOLDINGS',
  'EnterpriseInformationServicesLlc' = 'ENTERPRISE_INFORMATION_SERVICES_LLC',
  'EnterpriseRentalCar' = 'ENTERPRISE_RENTAL_CAR',
  'EnvironmentalChemistsInc' = 'ENVIRONMENTAL_CHEMISTS_INC',
  'Envision' = 'ENVISION',
  'EquityTitleCompanyLlc' = 'EQUITY_TITLE_COMPANY_LLC',
  'EraRealEstateProfessionals' = 'ERA_REAL_ESTATE_PROFESSIONALS',
  'EraRep' = 'ERA_REP',
  'Ermc' = 'ERMC',
  'Esi' = 'ESI',
  'Esn' = 'ESN',
  'EsnInc' = 'ESN_INC',
  'EspInc' = 'ESP_INC',
  'EsteeLauder' = 'ESTEE_LAUDER',
  'EsteeTruckCompany' = 'ESTEE_TRUCK_COMPANY',
  'EstesExpressLine' = 'ESTES_EXPRESS_LINE',
  'EtheridgeConstruction' = 'ETHERIDGE_CONSTRUCTION',
  'Etired' = 'ETIRED',
  'EureCustomSigns,Inc' = 'EURE_CUSTOM_SIGNS,_INC',
  'EureRentals' = 'EURE_RENTALS',
  'EurofinishLtd' = 'EUROFINISH_LTD',
  'Eurpac' = 'EURPAC',
  'EvansCleanTeam' = 'EVANS_CLEAN_TEAM',
  'EvansDeleivery' = 'EVANS_DELEIVERY',
  'EventDesignConsulting' = 'EVENT_DESIGN_CONSULTING',
  'EverestCollege' = 'EVEREST_COLLEGE',
  'EveriseC3connect' = 'EVERISE_C3CONNECT',
  'EveryDayOccassionsFlorist' = 'EVERY_DAY_OCCASSIONS_FLORIST',
  'Evms' = 'EVMS',
  'EvmsDeptOfSurgery' = 'EVMS_DEPT_OF_SURGERY',
  'EvmsRadiology' = 'EVMS_RADIOLOGY',
  'ExcaliberEnterprisesInc' = 'EXCALIBER_ENTERPRISES_INC',
  'ExcelIntermediate' = 'EXCEL_INTERMEDIATE',
  'ExcelPavingCorp' = 'EXCEL_PAVING_CORP',
  'ExecutiveHealthResources' = 'EXECUTIVE_HEALTH_RESOURCES',
  'ExoticExposure' = 'EXOTIC_EXPOSURE',
  'Exponent' = 'EXPONENT',
  'ExpressCleaning' = 'EXPRESS_CLEANING',
  'ExpressContainerService' = 'EXPRESS_CONTAINER_SERVICE',
  'ExpressContainerSvcsInc' = 'EXPRESS_CONTAINER_SVCS_INC',
  'ExpressFuelsInc' = 'EXPRESS_FUELS_INC',
  'ExpressWash' = 'EXPRESS_WASH',
  'ExxonStopNShop' = 'EXXON_STOP_N_SHOP',
  'EyeCareCenter' = 'EYE_CARE_CENTER',
  'FTWilliamsFar' = 'F_T_WILLIAMS_FAR',
  'FairbanksmorseEngine' = 'FAIRBANKSMORSE_ENGINE',
  'FairfieldInn&Suites' = 'FAIRFIELD_INN_&_SUITES',
  'Fairlead' = 'FAIRLEAD',
  'FairwayIndepMo' = 'FAIRWAY_INDEP_MO',
  'FaithAndSerenityHomeCare' = 'FAITH_AND_SERENITY_HOME_CARE',
  'FaithAndVictoryChristianCe' = 'FAITH_AND_VICTORY_CHRISTIAN_CE',
  'FaithDeliveranceChristianCt' = 'FAITH_DELIVERANCE_CHRISTIAN_CT',
  'FaithWellspring/crmg' = 'FAITH_WELLSPRING/CRMG',
  'FamilyDentistry' = 'FAMILY_DENTISTRY',
  'FamilyDollar' = 'FAMILY_DOLLAR',
  'FamilyRedirectionInstitute' = 'FAMILY_REDIRECTION_INSTITUTE',
  'FamilyRedirectionServices' = 'FAMILY_REDIRECTION_SERVICES',
  'FamousUncleAls' = 'FAMOUS_UNCLE_ALS',
  'FarmBureau' = 'FARM_BUREAU',
  'FarmBureauOfC' = 'FARM_BUREAU_OF_C',
  'FarmFresh' = 'FARM_FRESH',
  'Farmer' = 'FARMER',
  'Farmer/selfEmpl' = 'FARMER/SELF_EMPL',
  'FarmersBank' = 'FARMERS_BANK',
  'Farrugios' = 'FARRUGIOS',
  'Fase' = 'FASE',
  'FashionBug' = 'FASHION_BUG',
  'FastTrackEms' = 'FAST_TRACK_EMS',
  'FastenalCoAndSubsidiaries' = 'FASTENAL_CO_AND_SUBSIDIARIES',
  'Fastsigns' = 'FASTSIGNS',
  'Fastware,Inc' = 'FASTWARE,_INC',
  'FatPhillys' = 'FAT_PHILLYS',
  'FatboyzIceCream&Grill' = 'FATBOYZ_ICE_CREAM_&_GRILL',
  'Faulkner&GravesPc' = 'FAULKNER_&_GRAVES_PC',
  'Fbi' = 'FBI',
  'FciTowers' = 'FCI_TOWERS',
  'Fda' = 'FDA',
  'FedAviationAdmin' = 'FED_AVIATION_ADMIN',
  'FedEx' = 'FED_EX',
  'FedExFreight' = 'FED_EX_FREIGHT',
  'FedGovt' = 'FED_GOVT',
  'FedexFreight' = 'FEDEX_FREIGHT',
  'FedexGround' = 'FEDEX_GROUND',
  'FellowshipBaptistChurch' = 'FELLOWSHIP_BAPTIST_CHURCH',
  'Ferebee&SonInc' = 'FEREBEE_&_SON_INC',
  'FergusonEnterprise,Llc' = 'FERGUSON_ENTERPRISE,_LLC',
  'FergusonEnterprises' = 'FERGUSON_ENTERPRISES',
  'FergusonWaterworksLlc' = 'FERGUSON_WATERWORKS_LLC',
  'Fes' = 'FES',
  'FeyerFord' = 'FEYER_FORD',
  'Fiddlefly' = 'FIDDLEFLY',
  'FidelityTechnologiesCorporation' = 'FIDELITY_TECHNOLOGIES_CORPORATION',
  'FinovaCapital' = 'FINOVA_CAPITAL',
  'Fire&RescueServices' = 'FIRE_&_RESCUE_SERVICES',
  'Fire/lifeSafetyAmerica' = 'FIRE/LIFE_SAFETY_AMERICA',
  'FireDefenseOfVa' = 'FIRE_DEFENSE_OF_VA',
  'FireDepartment' = 'FIRE_DEPARTMENT',
  'Firehouse' = 'FIREHOUSE',
  'Firestone' = 'FIRESTONE',
  'FirstCapitalGrp' = 'FIRST_CAPITAL_GRP',
  'FirstCare,Pc' = 'FIRST_CARE,_PC',
  'FirstCarePc' = 'FIRST_CARE_PC',
  'FirstCarolina' = 'FIRST_CAROLINA',
  'FirstChoice' = 'FIRST_CHOICE',
  'FirstChoiceInHomeCare' = 'FIRST_CHOICE_IN_HOME_CARE',
  'FirstChoiceNurses' = 'FIRST_CHOICE_NURSES',
  'FirstColonialFamilyPractice' = 'FIRST_COLONIAL_FAMILY_PRACTICE',
  'FirstData' = 'FIRST_DATA',
  'FirstDataResource' = 'FIRST_DATA_RESOURCE',
  'FirstEnergyCorp' = 'FIRST_ENERGY_CORP',
  'FirstFinancialGroup' = 'FIRST_FINANCIAL_GROUP',
  'FirstFlightMiddle' = 'FIRST_FLIGHT_MIDDLE',
  'FirstGuarantyMortgageCorporation' = 'FIRST_GUARANTY_MORTGAGE_CORPORATION',
  'FirstTeamHonda' = 'FIRST_TEAM_HONDA',
  'FiscNorfolk' = 'FISC_NORFOLK',
  'FishbonesRawBar&Grille' = 'FISHBONES_RAW_BAR_&_GRILLE',
  'FkcDominionDialysis' = 'FKC_DOMINION_DIALYSIS',
  'FlcNorfolkHazmat' = 'FLC_NORFOLK_HAZMAT',
  'Fleet&IndustrialSupplyCtr' = 'FLEET_&_INDUSTRIAL_SUPPLY_CTR',
  'FleetIndustrialSupplyCtr' = 'FLEET_INDUSTRIAL_SUPPLY_CTR',
  'FleetLogisticCenter' = 'FLEET_LOGISTIC_CENTER',
  'FlexGrmc' = 'FLEX_GRMC',
  'FlextronicsInternational' = 'FLEXTRONICS_INTERNATIONAL',
  'FloorTraderOfChesapeake' = 'FLOOR_TRADER_OF_CHESAPEAKE',
  'FlowersBakingCo' = 'FLOWERS_BAKING_CO',
  'Flowserve' = 'FLOWSERVE',
  'FmcDominionDialysis' = 'FMC_DOMINION_DIALYSIS',
  'FocusInfomatics,Inc.' = 'FOCUS_INFOMATICS,_INC.',
  'FolkCityTatto' = 'FOLK_CITY_TATTO',
  'FoodLion' = 'FOOD_LION',
  'FoodLionKdhNc' = 'FOOD_LION_KDH_NC',
  'FoodbankOfSoutheasternVa' = 'FOODBANK_OF_SOUTHEASTERN_VA',
  'Foodlion' = 'FOODLION',
  'ForKids,Inc' = 'FOR_KIDS,_INC',
  'ForbesHomes' = 'FORBES_HOMES',
  'ForbesPlumbing' = 'FORBES_PLUMBING',
  'ForceProtectionInc' = 'FORCE_PROTECTION_INC',
  'Ford' = 'FORD',
  'Ford-HourlyAc' = 'FORD_-_HOURLY_AC',
  'FordMotorCo' = 'FORD_MOTOR_CO',
  'FordMotorHourl' = 'FORD_MOTOR_HOURL',
  'FordMotors' = 'FORD_MOTORS',
  'ForrestSepticTankContInc' = 'FORREST_SEPTIC_TANK_CONT_INC',
  'FortBragg' = 'FORT_BRAGG',
  'FortStoryChildDevelopmentCenter' = 'FORT_STORY_CHILD_DEVELOPMENT_CENTER',
  'FortStoryFireDepartment' = 'FORT_STORY_FIRE_DEPARTMENT',
  'FortisCollege' = 'FORTIS_COLLEGE',
  'FortisSolutionsGroup' = 'FORTIS_SOLUTIONS_GROUP',
  'FoundationsChil' = 'FOUNDATIONS_CHIL',
  'FoundersInn' = 'FOUNDERS_INN',
  'FoundryUmChurch' = 'FOUNDRY_UM_CHURCH',
  'FountainOfLife' = 'FOUNTAIN_OF_LIFE',
  'FourC' = 'FOUR_C',
  'FourCConstInc' = 'FOUR_C_CONST_INC',
  'FoxRehabilitation' = 'FOX_REHABILITATION',
  'FrankSheffer&Co.' = 'FRANK_SHEFFER_&_CO.',
  'FrankT.WilliamsFarms' = 'FRANK_T._WILLIAMS_FARMS',
  'FrankWilliamsFarms' = 'FRANK_WILLIAMS_FARMS',
  'Franklin-southamptonAreChamberOfCommerce' = 'FRANKLIN-SOUTHAMPTON_ARE_CHAMBER_OF_COMMERCE',
  'FranklinAutoMa' = 'FRANKLIN_AUTO_MA',
  'Frcma' = 'FRCMA',
  'Frcma/vrt' = 'FRCMA/VRT',
  'FreeWillBaptis' = 'FREE_WILL_BAPTIS',
  'FreedomBaptistChurch' = 'FREEDOM_BAPTIST_CHURCH',
  'FreedomFord' = 'FREEDOM_FORD',
  'FreemasonStreetBaptistChurc' = 'FREEMASON_STREET_BAPTIST_CHURC',
  'FreoCorporation' = 'FREO_CORPORATION',
  'FresenionsMedicalCare' = 'FRESENIONS_MEDICAL_CARE',
  'FreseniusKidneyCare' = 'FRESENIUS_KIDNEY_CARE',
  'FriendsOfNorfolkJuvenileCt' = 'FRIENDS_OF_NORFOLK_JUVENILE_CT',
  'FriendshipVetHospital' = 'FRIENDSHIP_VET_HOSPITAL',
  'FriscoRod&Gun' = 'FRISCO_ROD_&_GUN',
  'Frito-laysInc' = 'FRITO-LAYS_INC',
  'FrogIslandSeafood' = 'FROG_ISLAND_SEAFOOD',
  'FrontierAirlines' = 'FRONTIER_AIRLINES',
  'FrontierComm' = 'FRONTIER_COMM',
  'FrontierTechnology' = 'FRONTIER_TECHNOLOGY',
  'Fsap' = 'FSAP',
  'Fsjc' = 'FSJC',
  'FsrlGroupHomes' = 'FSRL_GROUP_HOMES',
  'Fti' = 'FTI',
  'FullTimeStudent' = 'FULL_TIME_STUDENT',
  'FultonStateHospital' = 'FULTON_STATE_HOSPITAL',
  'FumcPreschool' = 'FUMC_PRESCHOOL',
  'FunTours' = 'FUN_TOURS',
  'FunairCorporation' = 'FUNAIR_CORPORATION',
  'FunderburkAutoWholesaler' = 'FUNDERBURK_AUTO_WHOLESALER',
  'FutureTechDispatch' = 'FUTURE_TECH_DISPATCH',
  'G&wAward' = 'G&W_AWARD',
  'G.RayHarrisJr.Farms' = 'G._RAY_HARRIS_JR._FARMS',
  'GEAerospace' = 'G_E_AEROSPACE',
  'GKServices' = 'G_K_SERVICES',
  'GalleryInteriors&PlanDvmt' = 'GALLERY_INTERIORS_&_PLAN_DVMT',
  'GarciaRoofing' = 'GARCIA_ROOFING',
  'GardaWorld' = 'GARDA_WORLD',
  'GardnerEnterprisesInc' = 'GARDNER_ENTERPRISES_INC',
  'GargotecUsaInc.MarineAmeri' = 'GARGOTEC_USA_INC._MARINE_AMERI',
  'GaryDBryanDsd' = 'GARY_D_BRYAN_DSD',
  'GastonBrothers' = 'GASTON_BROTHERS',
  'GastonBrothersUtilities' = 'GASTON_BROTHERS_UTILITIES',
  'GastroAssoc' = 'GASTRO_ASSOC',
  'GatelyCommunicationCo' = 'GATELY_COMMUNICATION_CO',
  'GatesCounty' = 'GATES_COUNTY',
  'GatesCountyEms' = 'GATES_COUNTY_EMS',
  'GatesCountyPublicSchool' = 'GATES_COUNTY_PUBLIC_SCHOOL',
  'GatesCountyPublicSchools' = 'GATES_COUNTY_PUBLIC_SCHOOLS',
  'GatewayBank&T' = 'GATEWAY_BANK_&_T',
  'GatewayBank&Trust' = 'GATEWAY_BANK_&_TRUST',
  'GatewayBank' = 'GATEWAY_BANK',
  'GatewayBankAnd' = 'GATEWAY_BANK_AND',
  'GatewayInn' = 'GATEWAY_INN',
  'GatewayManagement' = 'GATEWAY_MANAGEMENT',
  'GbChildrensCenter' = 'GB_CHILDRENS_CENTER',
  'Gbfwbc' = 'GBFWBC',
  'GcrTires&Service' = 'GCR_TIRES_&_SERVICE',
  'GdIt' = 'GD_IT',
  'GdNasscoNorfolk' = 'GD_NASSCO_NORFOLK',
  'Gdit' = 'GDIT',
  'GeHealthCare' = 'GE_HEALTH_CARE',
  'GeHealthcare' = 'GE_HEALTHCARE',
  'Geico' = 'GEICO',
  'GeicoDirect' = 'GEICO_DIRECT',
  'Gem' = 'GEM',
  'GemmaPowerSystems' = 'GEMMA_POWER_SYSTEMS',
  'GenElectricApplianceCom' = 'GEN_ELECTRIC_APPLIANCE_COM',
  'GenbluLogistics' = 'GENBLU_LOGISTICS',
  'GeneralClynamics' = 'GENERAL_CLYNAMICS',
  'GeneralDymanics' = 'GENERAL_DYMANICS',
  'GeneralDynamicInfoTech' = 'GENERAL_DYNAMIC_INFO_TECH',
  'GeneralDynamics' = 'GENERAL_DYNAMICS',
  'GeneralDynamicsIT' = 'GENERAL_DYNAMICS_I_T',
  'GeneralDynamicsInfoTech' = 'GENERAL_DYNAMICS_INFO_TECH',
  'GeneralDynamicsInformationTechnology' = 'GENERAL_DYNAMICS_INFORMATION_TECHNOLOGY',
  'GeneralDynamies' = 'GENERAL_DYNAMIES',
  'GeneralEle' = 'GENERAL_ELE',
  'GeneralFoamPlasticsCorp' = 'GENERAL_FOAM_PLASTICS_CORP',
  'Genesco' = 'GENESCO',
  'Genesis' = 'GENESIS',
  'GenesisFiber' = 'GENESIS_FIBER',
  'GenesisHealth&Rehab' = 'GENESIS_HEALTH_&_REHAB',
  'GenesisRehabSvcs' = 'GENESIS_REHAB_SVCS',
  'GenesysHomeHealthCare' = 'GENESYS_HOME_HEALTH_CARE',
  'Genetech' = 'GENETECH',
  'GenexServices' = 'GENEX_SERVICES',
  'GenisWomenCare' = 'GENIS_WOMEN_CARE',
  'GentivaHospice' = 'GENTIVA_HOSPICE',
  'GeoquipManufacturingInc' = 'GEOQUIP_MANUFACTURING_INC',
  'GeorgeMasonUniversity' = 'GEORGE_MASON_UNIVERSITY',
  'GeorgianManor-medicationAide' = 'GEORGIAN_MANOR-MEDICATION_AIDE',
  'GermelInc' = 'GERMEL_INC',
  'GetSolution' = 'GET_SOLUTION',
  'GetSolutions' = 'GET_SOLUTIONS',
  'GetSolutions,Inc.' = 'GET_SOLUTIONS,_INC.',
  'Getsco' = 'GETSCO',
  'GflEnvironmental' = 'GFL_ENVIRONMENTAL',
  'Gfp' = 'GFP',
  'GhApplianceRepair' = 'GH_APPLIANCE_REPAIR',
  'GiannasItalianRestaurant' = 'GIANNAS_ITALIAN_RESTAURANT',
  'GibbsAndCox' = 'GIBBS_AND_COX',
  'GigiAndCo' = 'GIGI_AND_CO',
  'Girdanos' = 'GIRDANOS',
  'GirlScoutsOfAmerica' = 'GIRL_SCOUTS_OF_AMERICA',
  'GitGoFoodMart' = 'GIT_GO_FOOD_MART',
  'Givens' = 'GIVENS',
  'GivensImports' = 'GIVENS_IMPORTS',
  'GivensTransportation' = 'GIVENS_TRANSPORTATION',
  'GladstoneSalerno' = 'GLADSTONE_SALERNO',
  'GlassMasters' = 'GLASS_MASTERS',
  'GlasserAndGlasserPlc' = 'GLASSER_AND_GLASSER_PLC',
  'GlebeApiscopalChurch' = 'GLEBE_APISCOPAL_CHURCH',
  'GlennBucherDvmPc' = 'GLENN_BUCHER_DVM_PC',
  'GloAuto' = 'GLO_AUTO',
  'GlobalRecNetwork' = 'GLOBAL_REC_NETWORK',
  'GlobelEng' = 'GLOBEL_ENG',
  'GloriaHolland' = 'GLORIA_HOLLAND',
  'GlorysBakery' = 'GLORYS_BAKERY',
  'GloverLawFirm' = 'GLOVER_LAW_FIRM',
  'GmrTrnascription' = 'GMR_TRNASCRIPTION',
  'Gms' = 'GMS',
  'GoddardSchool' = 'GODDARD_SCHOOL',
  'GodwinCorp' = 'GODWIN_CORP',
  'GodwinPumps' = 'GODWIN_PUMPS',
  'GoldBeltC6' = 'GOLD_BELT_C6',
  'GoldKey' = 'GOLD_KEY',
  'GoldKey/Phr' = 'GOLD_KEY_/_PHR',
  'GoldKeyResorts' = 'GOLD_KEY_RESORTS',
  'GoldbeltCg,Llc' = 'GOLDBELT_CG,_LLC',
  'GoldbewltC6Uscg' = 'GOLDBEWLT_C6_USCG',
  'GoldenStateFoods' = 'GOLDEN_STATE_FOODS',
  'GoldenStepsAba' = 'GOLDEN_STEPS_ABA',
  'GoodEarthHort' = 'GOOD_EARTH_HORT',
  'GoodShepardLutheranChurch' = 'GOOD_SHEPARD_LUTHERAN_CHURCH',
  'Goodman&CoLlc' = 'GOODMAN_&_CO_LLC',
  'GoodmanAllenDonnelly' = 'GOODMAN_ALLEN_DONNELLY',
  'GoodoveOralSurgery' = 'GOODOVE_ORAL_SURGERY',
  'Goodwill' = 'GOODWILL',
  'GoodwillEasternNc' = 'GOODWILL_EASTERN_NC',
  'GordanSheetMetalCo' = 'GORDAN_SHEET_METAL_CO',
  'GordonPaperCo' = 'GORDON_PAPER_CO',
  'GorhanHauling' = 'GORHAN_HAULING',
  'GourmetGang' = 'GOURMET_GANG',
  'Government' = 'GOVERNMENT',
  'GovernmentEmployeesInsuranceCo' = 'GOVERNMENT_EMPLOYEES_INSURANCE_CO',
  'GraceBaptistChurchPastor' = 'GRACE_BAPTIST_CHURCH_PASTOR',
  'GraceBibleChurch' = 'GRACE_BIBLE_CHURCH',
  'GraceOmalleysIrishPub' = 'GRACE_OMALLEYS_IRISH_PUB',
  'GraceWTysonAcctg' = 'GRACE_W_TYSON_ACCTG',
  'GracefulTouchCleaning' = 'GRACEFUL_TOUCH_CLEANING',
  'Gracia&Virgil' = 'GRACIA_&_VIRGIL',
  'GranbyExxon' = 'GRANBY_EXXON',
  'GrandCareHealthcare' = 'GRAND_CARE_HEALTHCARE',
  'GrandFurniture' = 'GRAND_FURNITURE',
  'GrandSlam' = 'GRAND_SLAM',
  'GrandyPrimarySchool' = 'GRANDY_PRIMARY_SCHOOL',
  'GraniteParsons' = 'GRANITE_PARSONS',
  'GrassfieldElementary' = 'GRASSFIELD_ELEMENTARY',
  'GrassfieldMedicalAssociates' = 'GRASSFIELD_MEDICAL_ASSOCIATES',
  'GrassrootLawnAndGardenCare' = 'GRASSROOT_LAWN_AND_GARDEN_CARE',
  'Grassroots' = 'GRASSROOTS',
  'GrassrootsLawn' = 'GRASSROOTS_LAWN',
  'GravesFuneralHome' = 'GRAVES_FUNERAL_HOME',
  'GreatAtlantic' = 'GREAT_ATLANTIC',
  'GreatBridgeAutoService' = 'GREAT_BRIDGE_AUTO_SERVICE',
  'GreatBridgeBaptistChurch' = 'GREAT_BRIDGE_BAPTIST_CHURCH',
  'GreatBridgeChildCare' = 'GREAT_BRIDGE_CHILD_CARE',
  'GreatBridgeChildrensCenter' = 'GREAT_BRIDGE_CHILDRENS_CENTER',
  'GreatBridgeCommCleaning' = 'GREAT_BRIDGE_COMM_CLEANING',
  'GreatBridgeFurniture' = 'GREAT_BRIDGE_FURNITURE',
  'GreatClips' = 'GREAT_CLIPS',
  'GreatHopeBaptistSchool' = 'GREAT_HOPE_BAPTIST_SCHOOL',
  'GreaterMtZion' = 'GREATER_MT_ZION',
  'GreenAcresLandDevelopment' = 'GREEN_ACRES_LAND_DEVELOPMENT',
  'GreenHampton' = 'GREEN_HAMPTON',
  'GreenLawnMemorialGardens' = 'GREEN_LAWN_MEMORIAL_GARDENS',
  'GreenRunHighSchool' = 'GREEN_RUN_HIGH_SCHOOL',
  'GreenbrierChristianAcademy' = 'GREENBRIER_CHRISTIAN_ACADEMY',
  'GreenbrierCountryClub' = 'GREENBRIER_COUNTRY_CLUB',
  'GreenbrierFamilyPractice' = 'GREENBRIER_FAMILY_PRACTICE',
  'GreenbrierMontessoriSchool' = 'GREENBRIER_MONTESSORI_SCHOOL',
  'GreenbrierParkway' = 'GREENBRIER_PARKWAY',
  'GreenbrierRegionalMedCent' = 'GREENBRIER_REGIONAL_MED_CENT',
  'GreenbrierVinylAndGutter' = 'GREENBRIER_VINYL_AND_GUTTER',
  'GreenbrierWholesaleLot' = 'GREENBRIER_WHOLESALE_LOT',
  'GregWhitePlumbingCompany' = 'GREG_WHITE_PLUMBING_COMPANY',
  'GreggoryPolle' = 'GREGGORY_POLLE',
  'GregoryPooleEquipment' = 'GREGORY_POOLE_EQUIPMENT',
  'GregorysHeatingAndCoolingInc.' = 'GREGORYS_HEATING_AND_COOLING_INC.',
  'GregsBaitShack' = 'GREGS_BAIT_SHACK',
  'Greyclee' = 'GREYCLEE',
  'Greystone' = 'GREYSTONE',
  'GreystoneInternational' = 'GREYSTONE_INTERNATIONAL',
  'GriffeyEyeCenter' = 'GRIFFEY_EYE_CENTER',
  'GriggsLumber' = 'GRIGGS_LUMBER',
  'GritsGrill' = 'GRITS_GRILL',
  'Groundworks' = 'GROUNDWORKS',
  'GrubHub' = 'GRUB_HUB',
  'GryphonTechnologies' = 'GRYPHON_TECHNOLOGIES',
  'GryptonTelitNulogies' = 'GRYPTON_TELIT_NULOGIES',
  'GuardianCare' = 'GUARDIAN_CARE',
  'GuardianRealty' = 'GUARDIAN_REALTY',
  'GuardianSewer&Drain' = 'GUARDIAN_SEWER_&_DRAIN',
  'GuestSupply' = 'GUEST_SUPPLY',
  'GuyCLeeManufacturing' = 'GUY_C_LEE_MANUFACTURING',
  'GuyLLeeLumberCo' = 'GUY_L_LEE_LUMBER_CO',
  'GwPeoplesContracting' = 'GW_PEOPLES_CONTRACTING',
  'GynSpecialists' = 'GYN_SPECIALISTS',
  'H&PElectric' = 'H_&_P_ELECTRIC',
  'H&hEnt' = 'H&H_ENT',
  'H&pElectric' = 'H&P_ELECTRIC',
  'H.D.OliverFuneral' = 'H._D._OLIVER_FUNERAL',
  'HEWilliamsCandyCo' = 'H_E_WILLIAMS_CANDY_CO',
  'HIi' = 'H_II',
  'HackworthReprographics' = 'HACKWORTH_REPROGRAPHICS',
  'HaddonHomes,Inc.' = 'HADDON_HOMES,_INC.',
  'HaileyConsutingGroup' = 'HAILEY_CONSUTING_GROUP',
  'HairByCristina' = 'HAIR_BY_CRISTINA',
  'HairCuttery' = 'HAIR_CUTTERY',
  'HairFirstBarberShop' = 'HAIR_FIRST_BARBER_SHOP',
  'HairOfTheDog' = 'HAIR_OF_THE_DOG',
  'HairStyles' = 'HAIR_STYLES',
  'Haircuttery' = 'HAIRCUTTERY',
  'Hairstylist' = 'HAIRSTYLIST',
  'HalMatthewsInsAgency' = 'HAL_MATTHEWS_INS_AGENCY',
  'HallAndNixonRealEstate' = 'HALL_AND_NIXON_REAL_ESTATE',
  'HallAutomotive' = 'HALL_AUTOMOTIVE',
  'HallBodyAndPaint' = 'HALL_BODY_AND_PAINT',
  'HallChevrolet' = 'HALL_CHEVROLET',
  'HallChryslerJeepDodge' = 'HALL_CHRYSLER_JEEP_DODGE',
  'HallFord' = 'HALL_FORD',
  'HallToyotaVaBeach' = 'HALL_TOYOTA_VA_BEACH',
  'Hallmark' = 'HALLMARK',
  'Hampton-newportNewsCsb' = 'HAMPTON-NEWPORT_NEWS_CSB',
  'HamptonCitySchool' = 'HAMPTON_CITY_SCHOOL',
  'HamptonCitySchools' = 'HAMPTON_CITY_SCHOOLS',
  'HamptonInn&Suites' = 'HAMPTON_INN_&_SUITES',
  'HamptonInn' = 'HAMPTON_INN',
  'HamptonMarinaHotel' = 'HAMPTON_MARINA_HOTEL',
  'HamptonMentalHealthAssos' = 'HAMPTON_MENTAL_HEALTH_ASSOS',
  'HamptonNewportNewsCsb' = 'HAMPTON_NEWPORT_NEWS_CSB',
  'HamptonRdsTransit/firestone' = 'HAMPTON_RDS_TRANSIT/FIRESTONE',
  'HamptonRoadsElectricalSply' = 'HAMPTON_ROADS_ELECTRICAL_SPLY',
  'HamptonRoadsProduceDist' = 'HAMPTON_ROADS_PRODUCE_DIST',
  'HamptonRoadsSanitationDistrict' = 'HAMPTON_ROADS_SANITATION_DISTRICT',
  'HamptonRoadsTransit' = 'HAMPTON_ROADS_TRANSIT',
  'HamptonRoadsTransportation' = 'HAMPTON_ROADS_TRANSPORTATION',
  'HamptonUniversity' = 'HAMPTON_UNIVERSITY',
  'HamptonVaMedicalCenter' = 'HAMPTON_VA_MEDICAL_CENTER',
  'HamptonVamc' = 'HAMPTON_VAMC',
  'HamptonVeteranAffairsMedicalCenter' = 'HAMPTON_VETERAN_AFFAIRS_MEDICAL_CENTER',
  'HanDeeHugo#38' = 'HAN_DEE_HUGO_#38',
  'HandNHeart' = 'HAND_N_HEART',
  'HarborEdge' = 'HARBOR_EDGE',
  'HarborPoint' = 'HARBOR_POINT',
  'HarborsideMotel&GiftShop' = 'HARBORSIDE_MOTEL_&_GIFT_SHOP',
  'HarbourHealthcare' = 'HARBOUR_HEALTHCARE',
  'Hardee' = 'HARDEE',
  'Hardees-Camden' = 'HARDEES_-_CAMDEN',
  'HarrArchitecural' = 'HARR_ARCHITECURAL',
  'HarrellsvilleMetalWorks' = 'HARRELLSVILLE_METAL_WORKS',
  'HarrisConnect' = 'HARRIS_CONNECT',
  'HarrisConnectLlc' = 'HARRIS_CONNECT_LLC',
  'HarrisCorp' = 'HARRIS_CORP',
  'HarrisItServices' = 'HARRIS_IT_SERVICES',
  'HarrisTeeter' = 'HARRIS_TEETER',
  'HarrisTeeters' = 'HARRIS_TEETERS',
  'HarrisWelding' = 'HARRIS_WELDING',
  'Hart-leeBuilders' = 'HART-LEE_BUILDERS',
  'Hartford' = 'HARTFORD',
  'HarvestAssemblyOfGod' = 'HARVEST_ASSEMBLY_OF_GOD',
  'HarveyLindsayCommRealEstat' = 'HARVEY_LINDSAY_COMM_REAL_ESTAT',
  'HarveyPoint' = 'HARVEY_POINT',
  'HarveysGarage' = 'HARVEYS_GARAGE',
  'Hassell&Folkes' = 'HASSELL_&_FOLKES',
  'HatcherOrthodontics' = 'HATCHER_ORTHODONTICS',
  'HaynesFurniture' = 'HAYNES_FURNITURE',
  'HayocaCorp' = 'HAYOCA_CORP',
  'HbHunterCo' = 'HB_HUNTER_CO',
  'HbaArchitectureInteriorDesign' = 'HBA_ARCHITECTURE_INTERIOR_DESIGN',
  'HcPublicSchool' = 'HC_PUBLIC_SCHOOL',
  'HdSupply' = 'HD_SUPPLY',
  'HdmAssociates,Inc' = 'HDM_ASSOCIATES,_INC',
  'Hdr' = 'HDR',
  'Headlights' = 'HEADLIGHTS',
  'HeadsUpSprinkl' = 'HEADS_UP_SPRINKL',
  'HealthCarouselLlc/passportUse' = 'HEALTH_CAROUSEL_LLC/PASSPORT_USE',
  'HealthChoiceNetwork' = 'HEALTH_CHOICE_NETWORK',
  'HealthPhysicsCons' = 'HEALTH_PHYSICS_CONS',
  'HealthlinkOfAmerica' = 'HEALTHLINK_OF_AMERICA',
  'HealthnetGovernmentServices' = 'HEALTHNET_GOVERNMENT_SERVICES',
  'HeavnlyHomeHealth' = 'HEAVNLY_HOME_HEALTH',
  'HecoSlingsCorp' = 'HECO_SLINGS_CORP',
  'HendersonAssocInc' = 'HENDERSON_ASSOC_INC',
  'Hepaco' = 'HEPACO',
  'HerLookEnterprises' = 'HER_LOOK_ENTERPRISES',
  'HerbsGreatAmericanHotdogs' = 'HERBS_GREAT_AMERICAN_HOTDOGS',
  'HercRentals' = 'HERC_RENTALS',
  'HerculesRealEstateSvcs' = 'HERCULES_REAL_ESTATE_SVCS',
  'HeritageBusinessStrategies' = 'HERITAGE_BUSINESS_STRATEGIES',
  'HeritageTitle,Ltd.' = 'HERITAGE_TITLE,_LTD.',
  'HermesAbeLtd' = 'HERMES_ABE_LTD',
  'Herrick&Hay,Inc' = 'HERRICK_&_HAY,_INC',
  'HertfordCounty' = 'HERTFORD_COUNTY',
  'HertfordCountySchools' = 'HERTFORD_COUNTY_SCHOOLS',
  'HertfordHousingAuthority' = 'HERTFORD_HOUSING_AUTHORITY',
  'HertfordRecreationCenter' = 'HERTFORD_RECREATION_CENTER',
  'HerticoInc' = 'HERTICO_INC',
  'HessCorp' = 'HESS_CORP',
  'HessOilCorp' = 'HESS_OIL_CORP',
  'HewlettPackard' = 'HEWLETT_PACKARD',
  'HewlettPackardEnterpriseServices' = 'HEWLETT_PACKARD_ENTERPRISE_SERVICES',
  'HiTechRecycling' = 'HI_TECH_RECYCLING',
  'Hickman-ambrose' = 'HICKMAN-AMBROSE',
  'HickoryRidgeCh' = 'HICKORY_RIDGE_CH',
  'HickoryRidgeCommunityChurch' = 'HICKORY_RIDGE_COMMUNITY_CHURCH',
  'HickoryVeteranarianHospital' = 'HICKORY_VETERANARIAN_HOSPITAL',
  'HicksCustomFrame' = 'HICKS_CUSTOM_FRAME',
  'Higgerson&Buch' = 'HIGGERSON_&_BUCH',
  'HiggersonBuchan' = 'HIGGERSON_BUCHAN',
  'HiggersonBuchananInc' = 'HIGGERSON_BUCHANAN_INC',
  'Hii' = 'HII',
  'HillTopExcavationAndConst' = 'HILL_TOP_EXCAVATION_AND_CONST',
  'HillerSystems,Inc' = 'HILLER_SYSTEMS,_INC',
  'HillerSystems,Inc.' = 'HILLER_SYSTEMS,_INC.',
  'HiltonNorfolkAirport' = 'HILTON_NORFOLK_AIRPORT',
  'HkOnTheBay' = 'HK_ON_THE_BAY',
  'Hntb' = 'HNTB',
  'HobbsContracting' = 'HOBBS_CONTRACTING',
  'HobbyLobby' = 'HOBBY_LOBBY',
  'HofferFlowCont' = 'HOFFER_FLOW_CONT',
  'HofferFlowControls' = 'HOFFER_FLOW_CONTROLS',
  'HofheimerFamilyLaw' = 'HOFHEIMER_FAMILY_LAW',
  'Hoggard-eureAssociates' = 'HOGGARD-EURE_ASSOCIATES',
  'HolidayHouseOfPortsmouth' = 'HOLIDAY_HOUSE_OF_PORTSMOUTH',
  'HolidayInn/MotorWorld' = 'HOLIDAY_INN_/_MOTOR_WORLD',
  'HolidayInnExecutiveCtr' = 'HOLIDAY_INN_EXECUTIVE_CTR',
  'HollimanBrownFuneralHome' = 'HOLLIMAN_BROWN_FUNERAL_HOME',
  'HollyRidgeManor' = 'HOLLY_RIDGE_MANOR',
  'HolyFamilyDaySchool' = 'HOLY_FAMILY_DAY_SCHOOL',
  'HolyRedemerByTheSeaCath' = 'HOLY_REDEMER_BY_THE_SEA_CATH',
  'Homaker' = 'HOMAKER',
  'Home' = 'HOME',
  'HomeCraftBuildingAndRemode' = 'HOME_CRAFT_BUILDING_AND_REMODE',
  'HomeDayCare' = 'HOME_DAY_CARE',
  'HomeDepo' = 'HOME_DEPO',
  'HomeLifeCare' = 'HOME_LIFE_CARE',
  'HomeMaker' = 'HOME_MAKER',
  'HomeProPestControl' = 'HOME_PRO_PEST_CONTROL',
  'HomeTheaterInnovations' = 'HOME_THEATER_INNOVATIONS',
  'Homedepot' = 'HOMEDEPOT',
  'HomelandSecuritySolutions' = 'HOMELAND_SECURITY_SOLUTIONS',
  'Homemarker' = 'HOMEMARKER',
  'HoneyDoHomeRepair' = 'HONEY_DO_HOME_REPAIR',
  'HoneyGlobeHairSalon' = 'HONEY_GLOBE_HAIR_SALON',
  'Hootters' = 'HOOTTERS',
  'HopeForLifeRescueinc' = 'HOPE_FOR_LIFE_RESCUEINC',
  'HopeHouseFoundation' = 'HOPE_HOUSE_FOUNDATION',
  'HopeInHomeCare' = 'HOPE_IN_HOME_CARE',
  'HopeSpringVeterinaryHospital' = 'HOPE_SPRING_VETERINARY_HOSPITAL',
  'HorizonIrrigationService' = 'HORIZON_IRRIGATION_SERVICE',
  'HorizonMarine' = 'HORIZON_MARINE',
  'HorizonRealEstate' = 'HORIZON_REAL_ESTATE',
  'Hornthal,Riley,EllisAnMaland' = 'HORNTHAL,_RILEY,_ELLIS_AN_MALAND',
  'Hornthal,Riley,EllisAndMaland,Llp' = 'HORNTHAL,_RILEY,_ELLIS_AND_MALAND,_LLP',
  'HornthalRileyEllisMalandLl' = 'HORNTHAL_RILEY_ELLIS_MALAND_LL',
  'HortonFlooring' = 'HORTON_FLOORING',
  'HotrodderCafe' = 'HOTRODDER_CAFE',
  'HouseAssistant' = 'HOUSE_ASSISTANT',
  'Housewife' = 'HOUSEWIFE',
  'HowardHanna' = 'HOWARD_HANNA',
  'HowardHannaRealEstate' = 'HOWARD_HANNA_REAL_ESTATE',
  'HowardHannahRealEstate' = 'HOWARD_HANNAH_REAL_ESTATE',
  'HowellsMotorFreight' = 'HOWELLS_MOTOR_FREIGHT',
  'HowmetAerospace' = 'HOWMET_AEROSPACE',
  'HoyConstruction' = 'HOY_CONSTRUCTION',
  'HpEnergySolutions' = 'HP_ENERGY_SOLUTIONS',
  'Hq' = 'HQ',
  'HrPlanningDistrictComm' = 'HR_PLANNING_DISTRICT_COMM',
  'HrRegionalJail' = 'HR_REGIONAL_JAIL',
  'Hrcp' = 'HRCP',
  'HrsaIla1248' = 'HRSA_ILA_1248',
  'Hrsd' = 'HRSD',
  'Hrt' = 'HRT',
  'Hsbc' = 'HSBC',
  'HsbcBank' = 'HSBC_BANK',
  'HsbcCardServices' = 'HSBC_CARD_SERVICES',
  'HsbcNorthAmericanHolding' = 'HSBC_NORTH_AMERICAN_HOLDING',
  'HsnQurateRetailGroup' = 'HSN_QURATE_RETAIL_GROUP',
  'HudsonHomeImprovements' = 'HUDSON_HOME_IMPROVEMENTS',
  'HudsonsServiceCenter' = 'HUDSONS_SERVICE_CENTER',
  'HuffPooleMahoneyPc' = 'HUFF_POOLE_MAHONEY_PC',
  'HugoOwensMiddleSchool' = 'HUGO_OWENS_MIDDLE_SCHOOL',
  'HumanResourcesOffice' = 'HUMAN_RESOURCES_OFFICE',
  'HumbleBeginningsChildCare' = 'HUMBLE_BEGINNINGS_CHILD_CARE',
  'HumbleBeginningsChildcare' = 'HUMBLE_BEGINNINGS_CHILDCARE',
  'HunningtonIngalls-NewportNewsShipbuilding' = 'HUNNINGTON_INGALLS-_NEWPORT_NEWS_SHIPBUILDING',
  'HuntingtionIngausIndustrues' = 'HUNTINGTION_INGAUS_INDUSTRUES',
  'HuntingtonIngallInc' = 'HUNTINGTON_INGALL_INC',
  'HuntingtonIngallsInc' = 'HUNTINGTON_INGALLS_INC',
  'HuntingtonIngallsInd' = 'HUNTINGTON_INGALLS_IND',
  'HuntingtonIngallsIndustries' = 'HUNTINGTON_INGALLS_INDUSTRIES',
  'HuntingtonIngallsUndustries' = 'HUNTINGTON_INGALLS_UNDUSTRIES',
  'HuntingtonInglis' = 'HUNTINGTON_INGLIS',
  'HurdleRentals' = 'HURDLE_RENTALS',
  'HurricaneMosRestaurant' = 'HURRICANE_MOS_RESTAURANT',
  'HutchesChev' = 'HUTCHES_CHEV',
  'HydeCorrectionalInstitution' = 'HYDE_CORRECTIONAL_INSTITUTION',
  'HydraulicServiceCo.' = 'HYDRAULIC_SERVICE_CO.',
  'I&OMedicalCenter' = 'I_&_O_MEDICAL_CENTER',
  'I.L.A.Local#1248' = 'I._L._A._LOCAL_#1248',
  'I.l.a.' = 'I.L.A.',
  'IGotYourCrabs' = 'I_GOT_YOUR_CRABS',
  'IbexGlobal' = 'IBEX_GLOBAL',
  'IbrPlasmaCenter' = 'IBR_PLASMA_CENTER',
  'IciServices' = 'ICI_SERVICES',
  'Icms,Inc' = 'ICMS,_INC',
  'Icpta' = 'ICPTA',
  'Ics' = 'ICS',
  'IcwSchool' = 'ICW_SCHOOL',
  'IdaBarbourEarlyLearning' = 'IDA_BARBOUR_EARLY_LEARNING',
  'Idamerica' = 'IDAMERICA',
  'IdexxLabs' = 'IDEXX_LABS',
  'IesCommercial' = 'IES_COMMERCIAL',
  'IesCommercialSuffolk' = 'IES_COMMERCIAL_SUFFOLK',
  'Ihg' = 'IHG',
  'Ihop' = 'IHOP',
  'IhopRestaurant' = 'IHOP_RESTAURANT',
  'Iip' = 'IIP',
  'Il2000' = 'IL2000',
  'Ila' = 'ILA',
  'Ila1248' = 'ILA_1248',
  'IlaLocal1624' = 'ILA_LOCAL_1624',
  'IlaLocal1970' = 'ILA_LOCAL_1970',
  'IlaLocal970' = 'ILA_LOCAL_970',
  'Imac&Associates' = 'IMAC_&_ASSOCIATES',
  'Imagine-one' = 'IMAGINE-ONE',
  'ImmanuelChristianLc' = 'IMMANUEL_CHRISTIAN_LC',
  'ImoGear' = 'IMO_GEAR',
  'ImsGear' = 'IMS_GEAR',
  'InHomeClinical' = 'IN_HOME_CLINICAL',
  'InTransit' = 'IN_TRANSIT',
  'Inat' = 'INAT',
  'IndependentCareHealthBenefitTrust' = 'INDEPENDENT_CARE_HEALTH_BENEFIT_TRUST',
  'IndependentContractor' = 'INDEPENDENT_CONTRACTOR',
  'IndependentTitle' = 'INDEPENDENT_TITLE',
  'IndianCreekCorrectionalCtr' = 'INDIAN_CREEK_CORRECTIONAL_CTR',
  'IndianRiverResidentialCare' = 'INDIAN_RIVER_RESIDENTIAL_CARE',
  'IndividualsFirstInc' = 'INDIVIDUALS_FIRST_INC',
  'IndoorAirSystems' = 'INDOOR_AIR_SYSTEMS',
  'IndustrialDieselInc' = 'INDUSTRIAL_DIESEL_INC',
  'InfantToddlerConnection/norf' = 'INFANT_TODDLER_CONNECTION/NORF',
  'IngeContracting' = 'INGE_CONTRACTING',
  'IngramAutoMall' = 'INGRAM_AUTO_MALL',
  'IngramsAutoMall' = 'INGRAMS_AUTO_MALL',
  'InletFitness' = 'INLET_FITNESS',
  'InlinePlastics' = 'INLINE_PLASTICS',
  'InmotionHosting' = 'INMOTION_HOSTING',
  'InnSeasonsResorts' = 'INN_SEASONS_RESORTS',
  'InnerHarmony' = 'INNER_HARMONY',
  'Innervisions' = 'INNERVISIONS',
  'InomedicInc' = 'INOMEDIC_INC',
  'InsourceEmployerSolutionsInc' = 'INSOURCE_EMPLOYER_SOLUTIONS_INC',
  'InstantSystems' = 'INSTANT_SYSTEMS',
  'IntagratedFamilyServices' = 'INTAGRATED_FAMILY_SERVICES',
  'IntechMarineService' = 'INTECH_MARINE_SERVICE',
  'IntechMarineServices' = 'INTECH_MARINE_SERVICES',
  'IntegrityHomeHealthcare' = 'INTEGRITY_HOME_HEALTHCARE',
  'Intellectechs' = 'INTELLECTECHS',
  'Intellectechs,Inc' = 'INTELLECTECHS,_INC',
  'Inter-opt' = 'INTER-OPT',
  'IntercaostalExpedited&Del.' = 'INTERCAOSTAL_EXPEDITED_&_DEL.',
  'IntercostalMarineInc' = 'INTERCOSTAL_MARINE_INC',
  'InterdynAka' = 'INTERDYN_AKA',
  'IntergrityHomeHealthCare' = 'INTERGRITY_HOME_HEALTH_CARE',
  'InterimHealthC' = 'INTERIM_HEALTH_C',
  'InterimHealthcare' = 'INTERIM_HEALTHCARE',
  'InteriorsByH&W' = 'INTERIORS_BY_H_&_W',
  'InteriorsByH&w' = 'INTERIORS_BY_H&W',
  'InteriorsByH&wInc' = 'INTERIORS_BY_H&W_INC',
  'InternationalCo' = 'INTERNATIONAL_CO',
  'InternationalPaper' = 'INTERNATIONAL_PAPER',
  'InternationalUnionOfOperatingEngineers' = 'INTERNATIONAL_UNION_OF_OPERATING_ENGINEERS',
  'InterstateBrandsCorp' = 'INTERSTATE_BRANDS_CORP',
  'IntracoastalMar' = 'INTRACOASTAL_MAR',
  'IntrepidHospice' = 'INTREPID_HOSPICE',
  'Intuit' = 'INTUIT',
  'Invirotech' = 'INVIROTECH',
  'InvisionDesign' = 'INVISION_DESIGN',
  'InvivoCorp' = 'INVIVO_CORP',
  'IonMediaNetworks' = 'ION_MEDIA_NETWORKS',
  'IpaWorldwide' = 'IPA_WORLDWIDE',
  'Iqvia' = 'IQVIA',
  'IrisCNanceInsAgInc' = 'IRIS_C_NANCE_INS_AG_INC',
  'IrwinsPharmacy' = 'IRWINS_PHARMACY',
  'IslandExpertees' = 'ISLAND_EXPERTEES',
  'IslandHopperShuttle' = 'ISLAND_HOPPER_SHUTTLE',
  'IsleOfWightCounty' = 'ISLE_OF_WIGHT_COUNTY',
  'IsleOfWightPublicSchools' = 'ISLE_OF_WIGHT_PUBLIC_SCHOOLS',
  'IsleOfWrightCounty' = 'ISLE_OF_WRIGHT_COUNTY',
  'Issues&Answers' = 'ISSUES_&_ANSWERS',
  'ItCorp' = 'IT_CORP',
  'ItsASign' = 'ITS_A_SIGN',
  'ItsElectric' = 'ITS_ELECTRIC',
  'ItzaBoutzaPizza' = 'ITZA_BOUTZA_PIZZA',
  'IvorVeterinaryClinic' = 'IVOR_VETERINARY_CLINIC',
  'IvyRehabPhysicalTherapy' = 'IVY_REHAB_PHYSICAL_THERAPY',
  'J&MTruckingC' = 'J_&_M_TRUCKING_C',
  'J&REnterprises' = 'J_&_R_ENTERPRISES',
  'J&mOutdoorEquipment' = 'J&M_OUTDOOR_EQUIPMENT',
  'J&mRepairService' = 'J&M_REPAIR_SERVICE',
  'JCPenney' = 'J_C_PENNEY',
  'JCPenneys' = 'J_C_PENNEYS',
  'JEKellyElectric' = 'J_E_KELLY_ELECTRIC',
  'JFSchoch' = 'J_F_SCHOCH',
  'JHenryHollandCo' = 'J_HENRY_HOLLAND_CO',
  'JTSureSave' = 'J_T_SURE_SAVE',
  'JaSandersoInc' = 'JA_SANDERSO_INC',
  'JacksonLewisPc' = 'JACKSON_LEWIS_PC',
  'JacksonMemorialBaptistChurc' = 'JACKSON_MEMORIAL_BAPTIST_CHURC',
  'Jacobs' = 'JACOBS',
  'JalbertEnvironmentalInc' = 'JALBERT_ENVIRONMENTAL_INC',
  'JamesAndersonCo' = 'JAMES_ANDERSON_CO',
  'JamesBarryRobinson' = 'JAMES_BARRY_ROBINSON',
  'JamesBrooksConstruction' = 'JAMES_BROOKS_CONSTRUCTION',
  'JamesConstruction' = 'JAMES_CONSTRUCTION',
  'JamesRiverTransportation' = 'JAMES_RIVER_TRANSPORTATION',
  'JarvisFarms' = 'JARVIS_FARMS',
  'Jas.WGlover' = 'JAS._W_GLOVER',
  'JazIndustries' = 'JAZ_INDUSTRIES',
  'JbHunt' = 'JB_HUNT',
  'JbhAdvisoryGroup' = 'JBH_ADVISORY_GROUP',
  'JcPenney' = 'JC_PENNEY',
  'JcPenny' = 'JC_PENNY',
  'Jcpenney' = 'JCPENNEY',
  'JeffreysFlorist' = 'JEFFREYS_FLORIST',
  'JenkinsRestorations' = 'JENKINS_RESTORATIONS',
  'JennetteBrothers' = 'JENNETTE_BROTHERS',
  'Jerco' = 'JERCO',
  'JeremyChurchhill' = 'JEREMY_CHURCHHILL',
  'JerryHarrisRemodeling' = 'JERRY_HARRIS_REMODELING',
  'JerrysHeating&Cooling' = 'JERRYS_HEATING_&_COOLING',
  'JerseyCommunityHospital' = 'JERSEY_COMMUNITY_HOSPITAL',
  'Jes' = 'JES',
  'JesFoundationRepair' = 'JES_FOUNDATION_REPAIR',
  'JesseOwensMechCorp' = 'JESSE_OWENS_MECH_CORP',
  'JewelryByGailInc' = 'JEWELRY_BY_GAIL_INC',
  'JewishFamilyServices' = 'JEWISH_FAMILY_SERVICES',
  'JhsAutoCenterInc' = 'JHS_AUTO_CENTER_INC',
  'JiffyLub' = 'JIFFY_LUB',
  'JimbosJumbos' = 'JIMBOS_JUMBOS',
  'JimmyJohns' = 'JIMMY_JOHNS',
  'Jinhok,Llc' = 'JINHOK,_LLC',
  'JkHillAndAssociatesInc' = 'JK_HILL_AND_ASSOCIATES_INC',
  'JlGriffinHauling' = 'JL_GRIFFIN_HAULING',
  'Jo-kellyInc' = 'JO-KELLY_INC',
  'JoAnnEvansCleanTeam' = 'JO_ANN_EVANS_CLEAN_TEAM',
  'JoEvansCleanTeam' = 'JO_EVANS_CLEAN_TEAM',
  'JoanSmith' = 'JOAN_SMITH',
  'JoeCoyleConstructionInc' = 'JOE_COYLE_CONSTRUCTION_INC',
  'JoeLambJrAndAssocates' = 'JOE_LAMB_JR_AND_ASSOCATES',
  'JoesCrabShack' = 'JOES_CRAB_SHACK',
  'JohnEdwardsPestControl' = 'JOHN_EDWARDS_PEST_CONTROL',
  'JohnThomas' = 'JOHN_THOMAS',
  'JohnYWrightCo' = 'JOHN_Y_WRIGHT_CO',
  'JohnYancey' = 'JOHN_YANCEY',
  'JohnnieF.(fnp-bc)Lawrimore' = 'JOHNNIE_F._(FNP-BC)_LAWRIMORE',
  'JohnsBrothers' = 'JOHNS_BROTHERS',
  'JohnsBrothersSecurity' = 'JOHNS_BROTHERS_SECURITY',
  'JohnsHopkinsUniversity' = 'JOHNS_HOPKINS_UNIVERSITY',
  'Johnson&Johnso' = 'JOHNSON_&_JOHNSO',
  'Johnson,Mirmiran&Thompson' = 'JOHNSON,_MIRMIRAN_&_THOMPSON',
  'JohnsonControl' = 'JOHNSON_CONTROL',
  'JohnsonControls' = 'JOHNSON_CONTROLS',
  'JohnsonElectricCo' = 'JOHNSON_ELECTRIC_CO',
  'JohnstonSupply' = 'JOHNSTON_SUPPLY',
  'JointChiefsOfStaff' = 'JOINT_CHIEFS_OF_STAFF',
  'JoloProLlc' = 'JOLO_PRO_LLC',
  'Jones&FrankCorp' = 'JONES_&_FRANK_CORP',
  'JonesFamilyDentistry' = 'JONES_FAMILY_DENTISTRY',
  'JonesGrocAndS' = 'JONES_GROC_AND_S',
  'JonesIndustrialSupply' = 'JONES_INDUSTRIAL_SUPPLY',
  'JonesWalkerAndLake' = 'JONES_WALKER_AND_LAKE',
  'JordanYoungInstitute' = 'JORDAN_YOUNG_INSTITUTE',
  'JosephMenzieInc' = 'JOSEPH_MENZIE_INC',
  'JosephSmithLtd' = 'JOSEPH_SMITH_LTD',
  'JoyHomeCare' = 'JOY_HOME_CARE',
  'JoynersMechanical' = 'JOYNERS_MECHANICAL',
  'JpHarveyEngineeringSolution' = 'JP_HARVEY_ENGINEERING_SOLUTION',
  'JtPlumbing' = 'JT_PLUMBING',
  'JulianSwain' = 'JULIAN_SWAIN',
  'JumboJumbo' = 'JUMBO_JUMBO',
  'JuniperCocktails' = 'JUNIPER_COCKTAILS',
  'JusticeCenterPc' = 'JUSTICE_CENTER_PC',
  'K&kPainting' = 'K&K_PAINTING',
  'K-9LawnCareInc.' = 'K-9_LAWN_CARE_INC.',
  'K9' = 'K_9',
  'KMart' = 'K_MART',
  'KaiserCustomImages' = 'KAISER_CUSTOM_IMAGES',
  'Kalfus&Nachman' = 'KALFUS_&_NACHMAN',
  'Kalman&Company' = 'KALMAN_&_COMPANY',
  'KangInc' = 'KANG_INC',
  'KangarooExpress' = 'KANGAROO_EXPRESS',
  'Kangroo' = 'KANGROO',
  'KantarMedia' = 'KANTAR_MEDIA',
  'KantorMedia' = 'KANTOR_MEDIA',
  'KaplanUniversity' = 'KAPLAN_UNIVERSITY',
  'KathyParks' = 'KATHY_PARKS',
  'KathysKreations' = 'KATHYS_KREATIONS',
  'KatmaiGovernmentServices' = 'KATMAI_GOVERNMENT_SERVICES',
  'Kaufman&Canoles' = 'KAUFMAN_&_CANOLES',
  'KecuraMedical' = 'KECURA_MEDICAL',
  'KefferRealty' = 'KEFFER_REALTY',
  'KellamMechanical' = 'KELLAM_MECHANICAL',
  'KellerWilliamsRealty' = 'KELLER_WILLIAMS_REALTY',
  'KelloggSupplyCompany' = 'KELLOGG_SUPPLY_COMPANY',
  'KelloggsSupply' = 'KELLOGGS_SUPPLY',
  'KellyEducation' = 'KELLY_EDUCATION',
  'Kellys' = 'KELLYS',
  'KempsvilleBehavioralHealth' = 'KEMPSVILLE_BEHAVIORAL_HEALTH',
  'KempsvilleBuilders' = 'KEMPSVILLE_BUILDERS',
  'KempsvilleBuildingMaintance' = 'KEMPSVILLE_BUILDING_MAINTANCE',
  'KempsvilleCenter' = 'KEMPSVILLE_CENTER',
  'KempsvilleChristianChurch' = 'KEMPSVILLE_CHRISTIAN_CHURCH',
  'KempsvilleCounter' = 'KEMPSVILLE_COUNTER',
  'KempsvilleVeterinaryHospital' = 'KEMPSVILLE_VETERINARY_HOSPITAL',
  'KennyJutrus' = 'KENNY_JUTRUS',
  'KennysElectric' = 'KENNYS_ELECTRIC',
  'KermaMedProductsInc' = 'KERMA_MED_PRODUCTS_INC',
  'KernTechnologyGroup' = 'KERN_TECHNOLOGY_GROUP',
  'KesariInc' = 'KESARI_INC',
  'KeystoneShippin' = 'KEYSTONE_SHIPPIN',
  'Kfc' = 'KFC',
  'Khols' = 'KHOLS',
  'Kid-n-play' = 'KID-N-PLAY',
  'KidsFirst,Inc' = 'KIDS_FIRST,_INC',
  'KidsKollege' = 'KIDS_KOLLEGE',
  'KillDevilDiesel' = 'KILL_DEVIL_DIESEL',
  'KillDevilHills' = 'KILL_DEVIL_HILLS',
  'Kimley-horn' = 'KIMLEY-HORN',
  'KimleyHornAndAssoc.' = 'KIMLEY_HORN_AND_ASSOC.',
  'KimnachFord' = 'KIMNACH_FORD',
  'KimsMaintenance' = 'KIMS_MAINTENANCE',
  'KinderCareEducation' = 'KINDER_CARE_EDUCATION',
  'KinderMorgan' = 'KINDER_MORGAN',
  'KinderMorganTerminalskindercare' = 'KINDER_MORGAN_TERMINALSKINDERCARE',
  'KindomLifeMinistries' = 'KINDOM_LIFE_MINISTRIES',
  'KindredHealthcare' = 'KINDRED_HEALTHCARE',
  'KindredHomeCare' = 'KINDRED_HOME_CARE',
  'KingstreeGroup' = 'KINGSTREE_GROUP',
  'Kinley-horn&AssocInc' = 'KINLEY-HORN_&_ASSOC_INC',
  'KirbyOffShoreMarine' = 'KIRBY_OFF_SHORE_MARINE',
  'KirbyOffshore' = 'KIRBY_OFFSHORE',
  'Kis' = 'KIS',
  'KitchenConcepts' = 'KITCHEN_CONCEPTS',
  'KitcoFiberOptics' = 'KITCO_FIBER_OPTICS',
  'KittyHawkKites' = 'KITTY_HAWK_KITES',
  'KittyHawkMedthodistChurch' = 'KITTY_HAWK_MEDTHODIST_CHURCH',
  'KittyHawkMethodistChurch' = 'KITTY_HAWK_METHODIST_CHURCH',
  'KlocksHandyman' = 'KLOCKS_HANDYMAN',
  'Knapp&Lowman,p' = 'KNAPP_&_LOWMAN,P',
  'KnottsIslandMarket' = 'KNOTTS_ISLAND_MARKET',
  'KnowledgeLearningCtr' = 'KNOWLEDGE_LEARNING_CTR',
  'KnowlesConstruction' = 'KNOWLES_CONSTRUCTION',
  'KonikoffDenistry' = 'KONIKOFF_DENISTRY',
  'KonikoffDentistry' = 'KONIKOFF_DENTISTRY',
  'KonikoffFamily' = 'KONIKOFF_FAMILY',
  'KonikoffFamilyDentistry' = 'KONIKOFF_FAMILY_DENTISTRY',
  'Kpcds' = 'KPCDS',
  'KpmInc' = 'KPM_INC',
  'KratosDefense' = 'KRATOS_DEFENSE',
  'KrispyKreme' = 'KRISPY_KREME',
  'Kroger' = 'KROGER',
  'Krogers' = 'KROGERS',
  'Kwat' = 'KWAT',
  'KwatEnterprisesCorp' = 'KWAT_ENTERPRISES_CORP',
  'L-3Technologies' = 'L-3_TECHNOLOGIES',
  'L-3com/dpa' = 'L-3COM/DPA',
  'L.a.Nails' = 'L.A._NAILS',
  'L3Comm' = 'L3_COMM',
  'L3Communications' = 'L3_COMMUNICATIONS',
  'L3ServicesInc' = 'L3_SERVICES_INC',
  'L3Unidyne' = 'L3_UNIDYNE',
  'LAndRInc(self)' = 'L_AND_R_INC_(SELF)',
  'LEBallance' = 'L_E_BALLANCE',
  'LaBellaItalia' = 'LA_BELLA_ITALIA',
  'LaHair' = 'LA_HAIR',
  'LabCorp' = 'LAB_CORP',
  'LabCorpOfAmerica' = 'LAB_CORP_OF_AMERICA',
  'LabOneDentalLabs' = 'LAB_ONE_DENTAL_LABS',
  'Labcorp' = 'LABCORP',
  'LabelsBuyersLlc' = 'LABELS_BUYERS_LLC',
  'LabelsUnlimited' = 'LABELS_UNLIMITED',
  'LafbContractor' = 'LAFB_CONTRACTOR',
  'LagunaBakery' = 'LAGUNA_BAKERY',
  'LakeDrummondBaptistChurch' = 'LAKE_DRUMMOND_BAPTIST_CHURCH',
  'LakePrinceWoods' = 'LAKE_PRINCE_WOODS',
  'LakeTaylorTransCareHosp' = 'LAKE_TAYLOR_TRANS_CARE_HOSP',
  'LakeTaylorTransitional' = 'LAKE_TAYLOR_TRANSITIONAL',
  'LambertsCableSplicing' = 'LAMBERTS_CABLE_SPLICING',
  'Land-o-sunDairi' = 'LAND-O-SUN_DAIRI',
  'LandmarkCommunications' = 'LANDMARK_COMMUNICATIONS',
  'LandmarkHotelGroup' = 'LANDMARK_HOTEL_GROUP',
  'LandmarkMedia' = 'LANDMARK_MEDIA',
  'LandmarkPropertyServicesInc' = 'LANDMARK_PROPERTY_SERVICES_INC',
  'Landsafe,ABankOfAmericaCo' = 'LANDSAFE,_A_BANK_OF_AMERICA_CO',
  'LandworksUnlimitedInc' = 'LANDWORKS_UNLIMITED_INC',
  'LaneBryant' = 'LANE_BRYANT',
  'Langley&Mcdonald' = 'LANGLEY_&_MCDONALD',
  'LangleyFederalCreditUnion' = 'LANGLEY_FEDERAL_CREDIT_UNION',
  'LangleyNasa' = 'LANGLEY_NASA',
  'LarryLegumMd' = 'LARRY_LEGUM_MD',
  'LasalleSolutions' = 'LASALLE_SOLUTIONS',
  'LasershipDeliver' = 'LASERSHIP_DELIVER',
  'LastingCoastlineInc' = 'LASTING_COASTLINE_INC',
  'LathamPoolProducts' = 'LATHAM_POOL_PRODUCTS',
  'LaunchManagementServices' = 'LAUNCH_MANAGEMENT_SERVICES',
  'LawOfcOfJamesBMelton' = 'LAW_OFC_OF_JAMES_B_MELTON',
  'LawOfficeOfDavidPearline' = 'LAW_OFFICE_OF_DAVID_PEARLINE',
  'LawnCare' = 'LAWN_CARE',
  'LawrenceCompanies' = 'LAWRENCE_COMPANIES',
  'LawrencePaintingCorp' = 'LAWRENCE_PAINTING_CORP',
  'LawrencePharmacy' = 'LAWRENCE_PHARMACY',
  'LawsonReality' = 'LAWSON_REALITY',
  'LawsonRealty' = 'LAWSON_REALTY',
  'LazorShot' = 'LAZOR_SHOT',
  'LcbEnterprisesOfHertford' = 'LCB_ENTERPRISES_OF_HERTFORD',
  'LeBleuOfObx' = 'LE_BLEU_OF_OBX',
  'LearSieglerServices' = 'LEAR_SIEGLER_SERVICES',
  'LeareSiegler' = 'LEARE_SIEGLER',
  'LearningCareGroup' = 'LEARNING_CARE_GROUP',
  'LearysAlignment' = 'LEARYS_ALIGNMENT',
  'LeeInsurance' = 'LEE_INSURANCE',
  'LegacyHomeSvc' = 'LEGACY_HOME_SVC',
  'LegalAidOfNc' = 'LEGAL_AID_OF_NC',
  'LegalResources' = 'LEGAL_RESOURCES',
  'LegedimDendrite' = 'LEGEDIM_DENDRITE',
  'LegumsHeating&Cooling' = 'LEGUMS_HEATING_&_COOLING',
  'Leidos' = 'LEIDOS',
  'LeighHallAssistedLiving' = 'LEIGH_HALL_ASSISTED_LIVING',
  'LelandEnterprize' = 'LELAND_ENTERPRIZE',
  'Lendmark' = 'LENDMARK',
  'LenoresHairGallery' = 'LENORES_HAIR_GALLERY',
  'LeoJohnsContractor' = 'LEO_JOHNS_CONTRACTOR',
  'LetTheSunshineIn' = 'LET_THE_SUNSHINE_IN',
  'LewisGarage' = 'LEWIS_GARAGE',
  'LewisTreesInc' = 'LEWIS_TREES_INC',
  'LexemStrategy' = 'LEXEM_STRATEGY',
  'LibertyChristianFellowship' = 'LIBERTY_CHRISTIAN_FELLOWSHIP',
  'LibertyMutual' = 'LIBERTY_MUTUAL',
  'LibertyMutualGroupInc' = 'LIBERTY_MUTUAL_GROUP_INC',
  'LibertyTaxCorpOfc' = 'LIBERTY_TAX_CORP_OFC',
  'LibertyTaxServ' = 'LIBERTY_TAX_SERV',
  'LibertyTaxService' = 'LIBERTY_TAX_SERVICE',
  'LicensePlateAg' = 'LICENSE_PLATE_AG',
  'Lids' = 'LIDS',
  'LiebherrMining' = 'LIEBHERR_MINING',
  'LifeCycle' = 'LIFE_CYCLE',
  'LifeCycleEngineering' = 'LIFE_CYCLE_ENGINEERING',
  'LifeNetHealth' = 'LIFE_NET_HEALTH',
  'LifeTouchNatlStudio' = 'LIFE_TOUCH_NATL_STUDIO',
  'LifenetHealth' = 'LIFENET_HEALTH',
  'Lifetouch' = 'LIFETOUCH',
  'LifetouchNationalStudio' = 'LIFETOUCH_NATIONAL_STUDIO',
  'LifetouchNatlSchoolStudios' = 'LIFETOUCH_NATL_SCHOOL_STUDIOS',
  'LifetouchNatlSchoolsStudio' = 'LIFETOUCH_NATL_SCHOOLS_STUDIO',
  'Lightgrid' = 'LIGHTGRID',
  'LighthousePtRetirementApts' = 'LIGHTHOUSE_PT_RETIREMENT_APTS',
  'LightningTransportation' = 'LIGHTNING_TRANSPORTATION',
  'Lincare' = 'LINCARE',
  'LincolnFinancialServiceslincolnHeritageLifeInsCo' = 'LINCOLN_FINANCIAL_SERVICESLINCOLN_HERITAGE_LIFE_INS_CO',
  'LincolnMilitaryHousing' = 'LINCOLN_MILITARY_HOUSING',
  'Lindab' = 'LINDAB',
  'LindabInc' = 'LINDAB_INC',
  'LindenmeyrMonroe' = 'LINDENMEYR_MONROE',
  'LinkBeltConstructionEquip' = 'LINK_BELT_CONSTRUCTION_EQUIP',
  'Linkbelt' = 'LINKBELT',
  'LinxIndustries' = 'LINX_INDUSTRIES',
  'LinxxGlobalSolutions' = 'LINXX_GLOBAL_SOLUTIONS',
  'LionsEyeBank' = 'LIONS_EYE_BANK',
  'LiptonTea' = 'LIPTON_TEA',
  'LiquidInvestments' = 'LIQUID_INVESTMENTS',
  'LittleCaesars' = 'LITTLE_CAESARS',
  'LittleCaesarsPizza' = 'LITTLE_CAESARS_PIZZA',
  'LittleCeasars' = 'LITTLE_CEASARS',
  'LittleCreekSvcCtr' = 'LITTLE_CREEK_SVC_CTR',
  'LivingstonIntl' = 'LIVINGSTON_INTL',
  'LkcSystems' = 'LKC_SYSTEMS',
  'LkqNorfolk' = 'LKQ_NORFOLK',
  'LlFlooring' = 'LL_FLOORING',
  'Lnss/shutterfly' = 'LNSS/SHUTTERFLY',
  'LoanCare' = 'LOAN_CARE',
  'Loancare' = 'LOANCARE',
  'Local1248' = 'LOCAL_1248',
  'LockheedMartin' = 'LOCKHEED_MARTIN',
  'LockheedMartinTechSvcs' = 'LOCKHEED_MARTIN_TECH_SVCS',
  'LocksideBar&Grille' = 'LOCKSIDE_BAR_&_GRILLE',
  'Logistics2020' = 'LOGISTICS_2020',
  'Londment' = 'LONDMENT',
  'LondonBridgeMo' = 'LONDON_BRIDGE_MO',
  'LoneStarCafe' = 'LONE_STAR_CAFE',
  'LongAndFoster' = 'LONG_AND_FOSTER',
  'LonghornConstruction' = 'LONGHORN_CONSTRUCTION',
  'LonghornSteakhouse' = 'LONGHORN_STEAKHOUSE',
  'LongsInc.' = 'LONGS_INC.',
  'Longshoreman' = 'LONGSHOREMAN',
  'LookingAfterPuppyBoxers' = 'LOOKING_AFTER_PUPPY_BOXERS',
  'LostTreasureGolf' = 'LOST_TREASURE_GOLF',
  'LouisEgglestonCtr' = 'LOUIS_EGGLESTON_CTR',
  'LouisaCountyPublicSchools' = 'LOUISA_COUNTY_PUBLIC_SCHOOLS',
  'LowerCurrituckFireRescue' = 'LOWER_CURRITUCK_FIRE_RESCUE',
  'Lowes86' = 'LOWES_86',
  'LowesHomeCenter' = 'LOWES_HOME_CENTER',
  'LowesHomeImprovement' = 'LOWES_HOME_IMPROVEMENT',
  'LowesLossPrevention' = 'LOWES_LOSS_PREVENTION',
  'LoyalSource' = 'LOYAL_SOURCE',
  'Lpi' = 'LPI',
  'LpiTechService' = 'LPI_TECH_SERVICE',
  'LpiTechnicalServices' = 'LPI_TECHNICAL_SERVICES',
  'LplFinancial' = 'LPL_FINANCIAL',
  'Lpn' = 'LPN',
  'LprTransportation' = 'LPR_TRANSPORTATION',
  'LsTechnologies' = 'LS_TECHNOLOGIES',
  'Lsi' = 'LSI',
  'LtdHospitalityGroup' = 'LTD_HOSPITALITY_GROUP',
  'LtdManagement' = 'LTD_MANAGEMENT',
  'LtoManagementCo' = 'LTO_MANAGEMENT_CO',
  'LunaInc' = 'LUNA_INC',
  'Luxottica' = 'LUXOTTICA',
  'LwssFamilyDentistry' = 'LWSS_FAMILY_DENTISTRY',
  'LynnhavenCove' = 'LYNNHAVEN_COVE',
  'LyonShipyard' = 'LYON_SHIPYARD',
  'M&LConstruction' = 'M_&_L_CONSTRUCTION',
  'M&WConstruction' = 'M_&_W_CONSTRUCTION',
  'M&gElectronics' = 'M&G_ELECTRONICS',
  'M&mEnterprises' = 'M&M_ENTERPRISES',
  'M&r' = 'M&R',
  'M&sConcepts' = 'M&S_CONCEPTS',
  'M-3Electric' = 'M_-3_ELECTRIC',
  'M-3ElectricCo' = 'M-3_ELECTRIC_CO',
  'M3Electric' = 'M3_ELECTRIC',
  'M3ElectricCo' = 'M3_ELECTRIC_CO',
  'MacarthurCenter' = 'MACARTHUR_CENTER',
  'MacdonaldGlennonInc' = 'MACDONALD_GLENNON_INC',
  'MackeysFerrySawmill' = 'MACKEYS_FERRY_SAWMILL',
  'Macs' = 'MACS',
  'Macsons' = 'MACSONS',
  'Macys' = 'MACYS',
  'MaerskLineLtd' = 'MAERSK_LINE_LTD',
  'Maets' = 'MAETS',
  'MagellanFederal' = 'MAGELLAN_FEDERAL',
  'MagellanHealth' = 'MAGELLAN_HEALTH',
  'MagicSudsLaundromat' = 'MAGIC_SUDS_LAUNDROMAT',
  'MagnumEnterprisesInc' = 'MAGNUM_ENTERPRISES_INC',
  'MagnumOpusTechnologiesInc' = 'MAGNUM_OPUS_TECHNOLOGIES_INC',
  'MaidPro' = 'MAID_PRO',
  'MailWerks' = 'MAIL_WERKS',
  'Mailwerks' = 'MAILWERKS',
  'MainStreetDaycareAndPreschool' = 'MAIN_STREET_DAYCARE_AND_PRESCHOOL',
  'MainstayConstC' = 'MAINSTAY_CONST_C',
  'MainstreetDaycare&Preschool' = 'MAINSTREET_DAYCARE_&_PRESCHOOL',
  'MamaJeansCafe' = 'MAMA_JEANS_CAFE',
  'ManerCare' = 'MANER_CARE',
  'Manhattans' = 'MANHATTANS',
  'Manificus' = 'MANIFICUS',
  'MannCustomBoats' = 'MANN_CUSTOM_BOATS',
  'ManncoEquipmentInc' = 'MANNCO_EQUIPMENT_INC',
  'ManorSchools' = 'MANOR_SCHOOLS',
  'MantechIntlCo' = 'MANTECH_INTL_CO',
  'MapComminicationsInc' = 'MAP_COMMINICATIONS_INC',
  'MapCommunications' = 'MAP_COMMUNICATIONS',
  'MarcomServices' = 'MARCOM_SERVICES',
  'MargaretGaglione' = 'MARGARET_GAGLIONE',
  'Margie&Rays' = 'MARGIE_&_RAYS',
  'MarineChemistServiceInc' = 'MARINE_CHEMIST_SERVICE_INC',
  'MarineContracti' = 'MARINE_CONTRACTI',
  'MarineEnvironmentalServices' = 'MARINE_ENVIRONMENTAL_SERVICES',
  'MarineHydraulicsInc' = 'MARINE_HYDRAULICS_INC',
  'MarineRepairServices' = 'MARINE_REPAIR_SERVICES',
  'MarineSystemsInc' = 'MARINE_SYSTEMS_INC',
  'MarionRPeterson' = 'MARION_R_PETERSON',
  'MarkIiiSystems' = 'MARK_III_SYSTEMS',
  'MarkLevinOffice' = 'MARK_LEVIN_OFFICE',
  'MarkRomanSr' = 'MARK_ROMAN_SR',
  'MarkesmanGroup' = 'MARKESMAN_GROUP',
  'MarketMuscles' = 'MARKET_MUSCLES',
  'MarksGolfCourse' = 'MARKS_GOLF_COURSE',
  'MarksMobileElectric' = 'MARKS_MOBILE_ELECTRIC',
  'Marmc' = 'MARMC',
  'MarriottInternational' = 'MARRIOTT_INTERNATIONAL',
  'MartinCommunityCollege' = 'MARTIN_COMMUNITY_COLLEGE',
  'MarxgolfCarts' = 'MARXGOLF_CARTS',
  'MaryKayConsultant' = 'MARY_KAY_CONSULTANT',
  'MaryKayCosmetics' = 'MARY_KAY_COSMETICS',
  'MaryviewFamilyBirthCenter' = 'MARYVIEW_FAMILY_BIRTH_CENTER',
  'MaryviewHosp' = 'MARYVIEW_HOSP',
  'MaryviewMedicalCenter' = 'MARYVIEW_MEDICAL_CENTER',
  'MasaCorporation' = 'MASA_CORPORATION',
  'MaseratiOfVaBeach' = 'MASERATI_OF_VA_BEACH',
  'Mason&MasonPllc' = 'MASON_&_MASON_PLLC',
  'MassageEnvy' = 'MASSAGE_ENVY',
  'MassageLuxeHarborView' = 'MASSAGE_LUXE_HARBOR_VIEW',
  'MassimoZanettiBeverageGrp' = 'MASSIMO_ZANETTI_BEVERAGE_GRP',
  'Mastec' = 'MASTEC',
  'MastecInc' = 'MASTEC_INC',
  'MasterToolRepairInc' = 'MASTER_TOOL_REPAIR_INC',
  'MatthewGlassman' = 'MATTHEW_GLASSMAN',
  'MatthewSKitchensBuilder,Llc' = 'MATTHEW_S_KITCHENS_BUILDER,_LLC',
  'Maws' = 'MAWS',
  'MaxRadioOfTheCarolinas' = 'MAX_RADIO_OF_THE_CAROLINAS',
  'MaximHealthcareServices' = 'MAXIM_HEALTHCARE_SERVICES',
  'MaximHealthcareSvcs' = 'MAXIM_HEALTHCARE_SVCS',
  'MaximumHair' = 'MAXIMUM_HAIR',
  'Mayes' = 'MAYES',
  'Mbp' = 'MBP',
  'Mbs' = 'MBS',
  'MccManagementGroup' = 'MCC_MANAGEMENT_GROUP',
  'MccalebMetzlerInc' = 'MCCALEB_METZLER_INC',
  'MccallisterTowing' = 'MCCALLISTER_TOWING',
  'MccalliumTestingLab' = 'MCCALLIUM_TESTING_LAB',
  'MccallumTestingLab' = 'MCCALLUM_TESTING_LAB',
  'Mcclung-logan' = 'MCCLUNG-LOGAN',
  'MccordsLandscaping' = 'MCCORDS_LANDSCAPING',
  'McdonoughMarineService' = 'MCDONOUGH_MARINE_SERVICE',
  'McgregorNsaInc' = 'MCGREGOR_NSA_INC',
  'McharronPeanutCompany' = 'MCHARRON_PEANUT_COMPANY',
  'McintyreConstruction' = 'MCINTYRE_CONSTRUCTION',
  'MckeanDefenseGroup' = 'MCKEAN_DEFENSE_GROUP',
  'MckownPressureWash' = 'MCKOWN_PRESSURE_WASH',
  'McleanContracting' = 'MCLEAN_CONTRACTING',
  'McleanContractingCo.' = 'MCLEAN_CONTRACTING_CO.',
  'McoTransport' = 'MCO_TRANSPORT',
  'McphersonDesignGroup' = 'MCPHERSON_DESIGN_GROUP',
  'McphersonDesignGroupPc' = 'MCPHERSON_DESIGN_GROUP_PC',
  'MdLandscaping' = 'MD_LANDSCAPING',
  'MdlAmericaInc' = 'MDL_AMERICA_INC',
  'Mdv/spartannash' = 'MDV/SPARTANNASH',
  'MdvNashFinchSpartanNash' = 'MDV_NASH_FINCH_SPARTAN_NASH',
  'MdvSpartan/Nash' = 'MDV_SPARTAN_/_NASH',
  'MeaAlofaAutismSupportCenter' = 'MEA_ALOFA_AUTISM_SUPPORT_CENTER',
  'MeadsHomebuilders' = 'MEADS_HOMEBUILDERS',
  'MedEmporium' = 'MED_EMPORIUM',
  'MedEquipmentDistributors' = 'MED_EQUIPMENT_DISTRIBUTORS',
  'Medellia' = 'MEDELLIA',
  'MediaCommunications' = 'MEDIA_COMMUNICATIONS',
  'Mediacom' = 'MEDIACOM',
  'Medicaid' = 'MEDICAID',
  'MedicalFacilitiesOfAmerica' = 'MEDICAL_FACILITIES_OF_AMERICA',
  'MedicalServicesOfAmericaIn' = 'MEDICAL_SERVICES_OF_AMERICA_IN',
  'MedicalStaffingSolutions' = 'MEDICAL_STAFFING_SOLUTIONS',
  'MedicalTemporariesInc' = 'MEDICAL_TEMPORARIES_INC',
  'MedicalTemps' = 'MEDICAL_TEMPS',
  'MedicalTranspor' = 'MEDICAL_TRANSPOR',
  'MedicalTransport' = 'MEDICAL_TRANSPORT',
  'MehenryMgtGroup' = 'MEHENRY_MGT_GROUP',
  'MeherrinAg&Chemical' = 'MEHERRIN_AG&_CHEMICAL',
  'MelissaBurkley,Od' = 'MELISSA_BURKLEY,_OD',
  'MemoriaPress' = 'MEMORIA_PRESS',
  'MerchantMarine' = 'MERCHANT_MARINE',
  'MerchantsAuto' = 'MERCHANTS_AUTO',
  'MerchantsTire' = 'MERCHANTS_TIRE',
  'MerchantsTire,' = 'MERCHANTS_TIRE,',
  'MerchantsTireA' = 'MERCHANTS_TIRE_A',
  'MerchantsTireAndAutoCenter' = 'MERCHANTS_TIRE_AND_AUTO_CENTER',
  'MerckAndCoInc' = 'MERCK_AND_CO_INC',
  'MercyBonSecours' = 'MERCY_BON_SECOURS',
  'MerrillLynch' = 'MERRILL_LYNCH',
  'MerryMaids' = 'MERRY_MAIDS',
  'MessiahPreschool' = 'MESSIAH_PRESCHOOL',
  'Met' = 'MET',
  'MetaSourcers' = 'META_SOURCERS',
  'MetalBuildingM' = 'METAL_BUILDING_M',
  'MetalConcepts' = 'METAL_CONCEPTS',
  'MetalTech' = 'METAL_TECH',
  'MetlifeBank' = 'METLIFE_BANK',
  'MetroMachine' = 'METRO_MACHINE',
  'MetroMachineCorp' = 'METRO_MACHINE_CORP',
  'MetroMachineInc' = 'METRO_MACHINE_INC',
  'MetroMechinical' = 'METRO_MECHINICAL',
  'MetroRentals' = 'METRO_RENTALS',
  'MetroTowing' = 'METRO_TOWING',
  'MgtSolutionsOfVa' = 'MGT_SOLUTIONS_OF_VA',
  'Mhi' = 'MHI',
  'MhiInc' = 'MHI_INC',
  'MhiShipRepair' = 'MHI_SHIP_REPAIR',
  'MicarCollisionCenter' = 'MICAR_COLLISION_CENTER',
  'MichaelMartzMd' = 'MICHAEL_MARTZ_MD',
  'MichaelRMartzMd' = 'MICHAEL_R_MARTZ_MD',
  'MichaelSifeuIn' = 'MICHAEL_SIFEU_IN',
  'MichaelTurckDentalOffice' = 'MICHAEL_TURCK_DENTAL_OFFICE',
  'Michaels' = 'MICHAELS',
  'Mid-atlanticWas' = 'MID-ATLANTIC_WAS',
  'MidAtlanticCoInc' = 'MID_ATLANTIC_CO_INC',
  'MidAtlanticCoatingsInc' = 'MID_ATLANTIC_COATINGS_INC',
  'MidAtlanticMaintenance' = 'MID_ATLANTIC_MAINTENANCE',
  'MidAtlanticPetroleum' = 'MID_ATLANTIC_PETROLEUM',
  'MidAtlanticPetroleumService' = 'MID_ATLANTIC_PETROLEUM_SERVICE',
  'MidAtlanticProfessionalsInc.' = 'MID_ATLANTIC_PROFESSIONALS_INC.',
  'MidInc' = 'MID_INC',
  'MidatlanticBusinessCommunica' = 'MIDATLANTIC_BUSINESS_COMMUNICA',
  'MidgetsCleaningService' = 'MIDGETS_CLEANING_SERVICE',
  'Midgett,Preti,Olansen' = 'MIDGETT,_PRETI,_OLANSEN',
  'MidgettCleaning' = 'MIDGETT_CLEANING',
  'MidgettRealty' = 'MIDGETT_REALTY',
  'MidlandGssJv' = 'MIDLAND_GSS_JV',
  'MidwayAuto' = 'MIDWAY_AUTO',
  'MidwayAutomotive' = 'MIDWAY_AUTOMOTIVE',
  'MidwayVetHospital' = 'MIDWAY_VET_HOSPITAL',
  'MidwayVeternaryHospital' = 'MIDWAY_VETERNARY_HOSPITAL',
  'MightyMaids' = 'MIGHTY_MAIDS',
  'MikeBostic' = 'MIKE_BOSTIC',
  'MikeDumanAutoSales' = 'MIKE_DUMAN_AUTO_SALES',
  'MileOne' = 'MILE_ONE',
  'MilestonesChildDevelopementCtr' = 'MILESTONES_CHILD_DEVELOPEMENT_CTR',
  'Military' = 'MILITARY',
  'Military/active' = 'MILITARY/ACTIVE',
  'MilitaryRetiree' = 'MILITARY_RETIREE',
  'MilitarySeacommand' = 'MILITARY_SEACOMMAND',
  'MilitarySealiftCommand' = 'MILITARY_SEALIFT_COMMAND',
  'MillEndCarpetShop' = 'MILL_END_CARPET_SHOP',
  'MillerEnergy' = 'MILLER_ENERGY',
  'MillersWaterfrontRest' = 'MILLERS_WATERFRONT_REST',
  'MillsMarine&ShipRepair' = 'MILLS_MARINE_&_SHIP_REPAIR',
  'MiniPriceStorage' = 'MINI_PRICE_STORAGE',
  'Minister/busDriver' = 'MINISTER/BUS_DRIVER',
  'MinistryOfEducation' = 'MINISTRY_OF_EDUCATION',
  'Minor' = 'MINOR',
  'Minton&Roberson' = 'MINTON_&_ROBERSON',
  'MintonAndRoberson' = 'MINTON_AND_ROBERSON',
  'MiracleEar' = 'MIRACLE_EAR',
  'MiraclesBehavioralCenter' = 'MIRACLES_BEHAVIORAL_CENTER',
  'MissionToMilitary' = 'MISSION_TO_MILITARY',
  'MissionairesOnSpecialAsgn' = 'MISSIONAIRES_ON_SPECIAL_ASGN',
  'MissionsToMilitary' = 'MISSIONS_TO_MILITARY',
  'MisterJims' = 'MISTER_JIMS',
  'Mitsubishi' = 'MITSUBISHI',
  'MitsubishiChemical' = 'MITSUBISHI_CHEMICAL',
  'MitsubishiPlasticsCompositeAmerica' = 'MITSUBISHI_PLASTICS_COMPOSITE_AMERICA',
  'MmGunter' = 'MM_GUNTER',
  'Mmcg' = 'MMCG',
  'MnkUnlimited' = 'MNK_UNLIMITED',
  'MntGileadMissionaryBaptist' = 'MNT_GILEAD_MISSIONARY_BAPTIST',
  'MobileContainerService' = 'MOBILE_CONTAINER_SERVICE',
  'MobileOneCourier' = 'MOBILE_ONE_COURIER',
  'MobileOneCourrier' = 'MOBILE_ONE_COURRIER',
  'ModPizza' = 'MOD_PIZZA',
  'MohibGhobrialMd' = 'MOHIB_GHOBRIAL_MD',
  'Monarch' = 'MONARCH',
  'Monarch,Inc' = 'MONARCH,_INC',
  'MonarchBank' = 'MONARCH_BANK',
  'MonarchHeritageClub' = 'MONARCH_HERITAGE_CLUB',
  'MonarchHomeFunding' = 'MONARCH_HOME_FUNDING',
  'MonarchSupplyCoInc' = 'MONARCH_SUPPLY_CO_INC',
  'MoneysworthLinens' = 'MONEYSWORTH_LINENS',
  'MontessoriAcademyOfVa' = 'MONTESSORI_ACADEMY_OF_VA',
  'MoodyLawFirm' = 'MOODY_LAW_FIRM',
  'MoradTowingCorp' = 'MORAD_TOWING_CORP',
  'MoraleWelfareRecreation' = 'MORALE_WELFARE_RECREATION',
  'MoranTowingInc' = 'MORAN_TOWING_INC',
  'MoranTugsInc' = 'MORAN_TUGS_INC',
  'MorganTowing' = 'MORGAN_TOWING',
  'MorrisEnterprises' = 'MORRIS_ENTERPRISES',
  'MorrisFarmMarket' = 'MORRIS_FARM_MARKET',
  'MortgageConnect' = 'MORTGAGE_CONNECT',
  'MosElectric' = 'MOS_ELECTRIC',
  'MoseberthChicken&Bbq' = 'MOSEBERTH_CHICKEN_&_BBQ',
  'MoseleyArchitects' = 'MOSELEY_ARCHITECTS',
  'Moss&Assoc.' = 'MOSS&_ASSOC.',
  'MothersMorningOut' = 'MOTHERS_MORNING_OUT',
  'MotorWorks' = 'MOTOR_WORKS',
  'MountLebanon' = 'MOUNT_LEBANON',
  'Mov/nashFinctt' = 'MOV/NASH_FINCTT',
  'MovementMortgage' = 'MOVEMENT_MORTGAGE',
  'MoyockA/g' = 'MOYOCK_A/G',
  'MoyockAnimalHo' = 'MOYOCK_ANIMAL_HO',
  'MoyockAnimalHospital' = 'MOYOCK_ANIMAL_HOSPITAL',
  'MoyockAutomotiv' = 'MOYOCK_AUTOMOTIV',
  'MoyockAutomotive' = 'MOYOCK_AUTOMOTIVE',
  'MoyockBaptistChurch' = 'MOYOCK_BAPTIST_CHURCH',
  'MoyockBaptistChurchPreschool' = 'MOYOCK_BAPTIST_CHURCH_PRESCHOOL',
  'MoyockElem' = 'MOYOCK_ELEM',
  'MoyockElem.School' = 'MOYOCK_ELEM._SCHOOL',
  'MoyockElemSchool' = 'MOYOCK_ELEM_SCHOOL',
  'MoyockElementar' = 'MOYOCK_ELEMENTAR',
  'MoyockElementry' = 'MOYOCK_ELEMENTRY',
  'MoyockFireDept' = 'MOYOCK_FIRE_DEPT',
  'MoyockGardens' = 'MOYOCK_GARDENS',
  'MoyockMethodistChurch' = 'MOYOCK_METHODIST_CHURCH',
  'MoyockMiddleSchool' = 'MOYOCK_MIDDLE_SCHOOL',
  'MoyockPostOffi' = 'MOYOCK_POST_OFFI',
  'MoyockUmc' = 'MOYOCK_UMC',
  'MoyockUnitedMethodistChurch' = 'MOYOCK_UNITED_METHODIST_CHURCH',
  'MpServices' = 'MP_SERVICES',
  'MrJimsSubs' = 'MR_JIMS_SUBS',
  'MrLusChineseResturant' = 'MR_LUS_CHINESE_RESTURANT',
  'MrgConstruction' = 'MRG_CONSTRUCTION',
  'MriDiagnostic' = 'MRI_DIAGNOSTIC',
  'MsPerfection' = 'MS_PERFECTION',
  'Msa' = 'MSA',
  'Msa/albermarleHomeHealth' = 'MSA/ALBERMARLE_HOME_HEALTH',
  'Msc' = 'MSC',
  'Msc-dod' = 'MSC-DOD',
  'Msco' = 'MSCO',
  'Msfsc' = 'MSFSC',
  'Msi' = 'MSI',
  'MslLlc' = 'MSL_LLC',
  'Mssb' = 'MSSB',
  'Mt.LebanonBaptistChurch' = 'MT._LEBANON_BAPTIST_CHURCH',
  'MtLebanonBaptistChurch' = 'MT_LEBANON_BAPTIST_CHURCH',
  'MtPleasantClinicalAssoc' = 'MT_PLEASANT_CLINICAL_ASSOC',
  'MtPleasantFamilyPractice' = 'MT_PLEASANT_FAMILY_PRACTICE',
  'MtPleasantMetChurch' = 'MT_PLEASANT_MET_CHURCH',
  'MtgileadMissionaryBaptistCh' = 'MTGILEAD_MISSIONARY_BAPTIST_CH',
  'MulberryTrucking' = 'MULBERRY_TRUCKING',
  'Mumc' = 'MUMC',
  'MurphyBrownLlc' = 'MURPHY_BROWN_LLC',
  'MurrayNixonFishery' = 'MURRAY_NIXON_FISHERY',
  'Murrays' = 'MURRAYS',
  'MustardSeedAcademy' = 'MUSTARD_SEED_ACADEMY',
  'MutualDistributing' = 'MUTUAL_DISTRIBUTING',
  'MwbProduce' = 'MWB_PRODUCE',
  'Mwr' = 'MWR',
  'Mwr,nsa' = 'MWR,NSA',
  'MyPrintShop' = 'MY_PRINT_SHOP',
  'MycAssociates' = 'MYC_ASSOCIATES',
  'Myriad' = 'MYRIAD',
  'MystiqueSalon&DaySpa' = 'MYSTIQUE_SALON_&_DAY_SPA',
  'MythicsInc' = 'MYTHICS_INC',
  'Mzb-usa' = 'MZB-USA',
  'N.cAquariumSociety' = 'N.C_AQUARIUM_SOCIETY',
  'N/a' = 'N/A',
  'N/a..' = 'N/A..',
  'NAndSRailroad' = 'N_AND_S_RAILROAD',
  'Na' = 'NA',
  'NaascoNorfolk' = 'NAASCO_NORFOLK',
  'Nabisco' = 'NABISCO',
  'Nag,Llc' = 'NAG,_LLC',
  'NagMarine' = 'NAG_MARINE',
  'NancyChandlerAssoc' = 'NANCY_CHANDLER_ASSOC',
  'Nanny' = 'NANNY',
  'NansemondPointe' = 'NANSEMOND_POINTE',
  'NansemondSuffolkAcademy' = 'NANSEMOND_SUFFOLK_ACADEMY',
  'Napa' = 'NAPA',
  'NapaAutoParts' = 'NAPA_AUTO_PARTS',
  'NapolitanoEnterprise' = 'NAPOLITANO_ENTERPRISE',
  'NasaLangleyResearchCenter' = 'NASA_LANGLEY_RESEARCH_CENTER',
  'NascarTechinicalInstitute' = 'NASCAR_TECHINICAL_INSTITUTE',
  'NationalAudubonSociety' = 'NATIONAL_AUDUBON_SOCIETY',
  'NationalCarRental' = 'NATIONAL_CAR_RENTAL',
  'NationalCounselingGroup' = 'NATIONAL_COUNSELING_GROUP',
  'NationalFatherhoodInitiative' = 'NATIONAL_FATHERHOOD_INITIATIVE',
  'NationalInstituteForLearningDevelopment' = 'NATIONAL_INSTITUTE_FOR_LEARNING_DEVELOPMENT',
  'NationalOptometry' = 'NATIONAL_OPTOMETRY',
  'NationalParkService' = 'NATIONAL_PARK_SERVICE',
  'NationalRightToWork' = 'NATIONAL_RIGHT_TO_WORK',
  'NationalUnionFireInsur.Co' = 'NATIONAL_UNION_FIRE_INSUR._CO',
  'NationalVision' = 'NATIONAL_VISION',
  'Nationwide' = 'NATIONWIDE',
  'NationwideInc' = 'NATIONWIDE_INC',
  'NationwidePlaster' = 'NATIONWIDE_PLASTER',
  'NatlNavyMedicalCenter' = 'NATL_NAVY_MEDICAL_CENTER',
  'NaturalAndCulturalResources4800' = 'NATURAL_AND_CULTURAL_RESOURCES_4800',
  'NaturalElementsSpa/salon' = 'NATURAL_ELEMENTS_SPA/SALON',
  'NavFac' = 'NAV_FAC',
  'Navac' = 'NAVAC',
  'NavalAirStation' = 'NAVAL_AIR_STATION',
  'NavalAirTerminal' = 'NAVAL_AIR_TERMINAL',
  'NavalBase' = 'NAVAL_BASE',
  'NavalDentalCenter' = 'NAVAL_DENTAL_CENTER',
  'NavalDentalClinic' = 'NAVAL_DENTAL_CLINIC',
  'NavalFacilities' = 'NAVAL_FACILITIES',
  'NavalMedCtr&SentaraVb' = 'NAVAL_MED_CTR_&_SENTARA_VB',
  'NavalMedCtrPo' = 'NAVAL_MED_CTR_PO',
  'NavalMedicalCenter' = 'NAVAL_MEDICAL_CENTER',
  'NavalMedicalCenterPortsmouth' = 'NAVAL_MEDICAL_CENTER_PORTSMOUTH',
  'NavalSeaSystemsCommand' = 'NAVAL_SEA_SYSTEMS_COMMAND',
  'NavalSpecialWarfairDevelopmentGroup' = 'NAVAL_SPECIAL_WARFAIR_DEVELOPMENT_GROUP',
  'NavalStation' = 'NAVAL_STATION',
  'NavalSupplyCenter' = 'NAVAL_SUPPLY_CENTER',
  'NavelNetworkWa' = 'NAVEL_NETWORK_WA',
  'Navfac' = 'NAVFAC',
  'NavfacAtlantic' = 'NAVFAC_ATLANTIC',
  'NavfacMidAtlantic' = 'NAVFAC_MID_ATLANTIC',
  'NavfacMidlant' = 'NAVFAC_MIDLANT',
  'NavfacMidlantNnsy' = 'NAVFAC_MIDLANT_NNSY',
  'NavfacMidlantic' = 'NAVFAC_MIDLANTIC',
  'Navfnctmidlant' = 'NAVFNCTMIDLANT',
  'Navfoe' = 'NAVFOE',
  'Navsupflc-n' = 'NAVSUPFLC-N',
  'Navy&MareinePublicHealth' = 'NAVY_&_MAREINE_PUBLIC_HEALTH',
  'Navy&MarineCorpPublicHealthCenter' = 'NAVY_&_MARINE_CORP_PUBLIC_HEALTH_CENTER',
  'Navy' = 'NAVY',
  'NavyCdc' = 'NAVY_CDC',
  'NavyExchange' = 'NAVY_EXCHANGE',
  'NavyExchange-oceana' = 'NAVY_EXCHANGE-OCEANA',
  'NavyExchangePortsmouth' = 'NAVY_EXCHANGE_PORTSMOUTH',
  'NavyExchangeSvcCommand' = 'NAVY_EXCHANGE_SVC_COMMAND',
  'NavyExchangeVending' = 'NAVY_EXCHANGE_VENDING',
  'NavyFedCreditUnion' = 'NAVY_FED_CREDIT_UNION',
  'NavyFederalCre' = 'NAVY_FEDERAL_CRE',
  'NavyGatewayInn&Suites' = 'NAVY_GATEWAY_INN_&_SUITES',
  'NavyGatewayInns&Suites' = 'NAVY_GATEWAY_INNS_&_SUITES',
  'NavyMedicalCenter' = 'NAVY_MEDICAL_CENTER',
  'NavyPublicWorksDept' = 'NAVY_PUBLIC_WORKS_DEPT',
  'NavyRefionMidTlanticFire&EmergencyServices' = 'NAVY_REFION_MID_TLANTIC_FIRE_&_EMERGENCY_SERVICES',
  'NavyRegionMid-atlantic' = 'NAVY_REGION_MID-ATLANTIC',
  'NavyRegionalFi' = 'NAVY_REGIONAL_FI',
  'NbHardyCo' = 'NB_HARDY_CO',
  'NcArmyNationalGuard' = 'NC_ARMY_NATIONAL_GUARD',
  'NcAssocOfCountyCom' = 'NC_ASSOC_OF_COUNTY_COM',
  'NcCooperativeExtension' = 'NC_COOPERATIVE_EXTENSION',
  'NcDepartmentOf' = 'NC_DEPARTMENT_OF',
  'NcDepartmentOfAdultCorrection' = 'NC_DEPARTMENT_OF_ADULT_CORRECTION',
  'NcDepartmentOfCorrections' = 'NC_DEPARTMENT_OF_CORRECTIONS',
  'NcDeptOfPublicSafety' = 'NC_DEPT_OF_PUBLIC_SAFETY',
  'NcDivisionMarineFisheries' = 'NC_DIVISION_MARINE_FISHERIES',
  'NcDot' = 'NC_DOT',
  'NcDps' = 'NC_DPS',
  'NcFarmBureauSupportSers' = 'NC_FARM_BUREAU_SUPPORT_SERS',
  'NcFerryHatteras' = 'NC_FERRY_HATTERAS',
  'NcLeague' = 'NC_LEAGUE',
  'NcLeagueTownOfKillDevilHills' = 'NC_LEAGUE_TOWN_OF_KILL_DEVIL_HILLS',
  'NcPerryDivisionDept' = 'NC_PERRY_DIVISION_DEPT',
  'NcProbationAndParole' = 'NC_PROBATION_AND_PAROLE',
  'NcSchool' = 'NC_SCHOOL',
  'NcSuperiorLimo' = 'NC_SUPERIOR_LIMO',
  'NcWildlifeResourcesCommission' = 'NC_WILDLIFE_RESOURCES_COMMISSION',
  'Ncba' = 'NCBA',
  'Ncces' = 'NCCES',
  'Ncdor' = 'NCDOR',
  'Ncdot' = 'NCDOT',
  'Ncdps' = 'NCDPS',
  'Ncis' = 'NCIS',
  'Nclm' = 'NCLM',
  'NclmCountOfCamden' = 'NCLM_COUNT_OF_CAMDEN',
  'Ndcdc' = 'NDCDC',
  'Neaaat' = 'NEAAAT',
  'NecorSteel' = 'NECOR_STEEL',
  'NeighborcarePharmacy' = 'NEIGHBORCARE_PHARMACY',
  'NeighborhoodHarvest' = 'NEIGHBORHOOD_HARVEST',
  'NelsonsPlbg,I' = 'NELSONS_PLBG,_I',
  'NevroCorp' = 'NEVRO_CORP',
  'NewCityChinese' = 'NEW_CITY_CHINESE',
  'NewCommunityTemple' = 'NEW_COMMUNITY_TEMPLE',
  'NewGenerationDaycare' = 'NEW_GENERATION_DAYCARE',
  'NewImageLandscaping' = 'NEW_IMAGE_LANDSCAPING',
  'NewLifeAcademy' = 'NEW_LIFE_ACADEMY',
  'NewLifeAssemlyOfGodOfElizabethCity' = 'NEW_LIFE_ASSEMLY_OF_GOD_OF_ELIZABETH_CITY',
  'NewLifeProvidenceChurch' = 'NEW_LIFE_PROVIDENCE_CHURCH',
  'NewMtVernonBaptistChurch' = 'NEW_MT_VERNON_BAPTIST_CHURCH',
  'NewRiverElectric' = 'NEW_RIVER_ELECTRIC',
  'NewRiverTaphouse' = 'NEW_RIVER_TAPHOUSE',
  'NewportNewShipbuilding' = 'NEWPORT_NEW_SHIPBUILDING',
  'NewportNewShipbulling' = 'NEWPORT_NEW_SHIPBULLING',
  'NewportNewsFireDept' = 'NEWPORT_NEWS_FIRE_DEPT',
  'NewportNewsShipbuilding' = 'NEWPORT_NEWS_SHIPBUILDING',
  'NewportNewsShipyard' = 'NEWPORT_NEWS_SHIPYARD',
  'NexCom' = 'NEX_COM',
  'NexOceana' = 'NEX_OCEANA',
  'Nexcen' = 'NEXCEN',
  'Nexcom' = 'NEXCOM',
  'Nexcom/uniformS' = 'NEXCOM/UNIFORM_S',
  'NextCare' = 'NEXT_CARE',
  'NextLevelHospital' = 'NEXT_LEVEL_HOSPITAL',
  'Nfcu' = 'NFCU',
  'Nfis' = 'NFIS',
  'NfkParks&Rec' = 'NFK_PARKS_&_REC',
  'Ngc' = 'NGC',
  'NgisAtNorthwestNavalBase' = 'NGIS_AT_NORTHWEST_NAVAL_BASE',
  'Ngk' = 'NGK',
  'Nhra' = 'NHRA',
  'NiagonaNationalInc' = 'NIAGONA_NATIONAL_INC',
  'NickyOverman' = 'NICKY_OVERMAN',
  'NissanOfElizabethCity' = 'NISSAN_OF_ELIZABETH_CITY',
  'NittoDenkoAutomotive' = 'NITTO_DENKO_AUTOMOTIVE',
  'NixonHardware' = 'NIXON_HARDWARE',
  'Nlmi' = 'NLMI',
  'Nmawc' = 'NMAWC',
  'Nmcp' = 'NMCP',
  'Nmsy' = 'NMSY',
  'NnShipyardDispensary' = 'NN_SHIPYARD_DISPENSARY',
  'Nnps' = 'NNPS',
  'Nnsshipyard' = 'NNSSHIPYARD',
  'Nnsy' = 'NNSY',
  'Noaa' = 'NOAA',
  'Noaa-usDeptOfCommerce' = 'NOAA-US_DEPT_OF_COMMERCE',
  'NoblisMsd' = 'NOBLIS_MSD',
  'None' = 'NONE',
  'NoneListed' = 'NONE_LISTED',
  'NorSouthernCorp' = 'NOR_SOUTHERN_CORP',
  'Norandex' = 'NORANDEX',
  'Nordstrom' = 'NORDSTROM',
  'NordstromRack' = 'NORDSTROM_RACK',
  'NorfCommBoard' = 'NORF_COMM_BOARD',
  'NorfDeptOfHumanServices' = 'NORF_DEPT_OF_HUMAN_SERVICES',
  'NorfNavalShipyard' = 'NORF_NAVAL_SHIPYARD',
  'Norfolk&Southern' = 'NORFOLK_&_SOUTHERN',
  'NorfolkAcademy' = 'NORFOLK_ACADEMY',
  'NorfolkAndSouthern' = 'NORFOLK_AND_SOUTHERN',
  'NorfolkBanannaDist' = 'NORFOLK_BANANNA_DIST',
  'NorfolkCommServiceBoard' = 'NORFOLK_COMM_SERVICE_BOARD',
  'NorfolkCsb' = 'NORFOLK_CSB',
  'NorfolkDredging' = 'NORFOLK_DREDGING',
  'NorfolkFire&Rescue' = 'NORFOLK_FIRE_&_RESCUE',
  'NorfolkFireRescue' = 'NORFOLK_FIRE_RESCUE',
  'NorfolkFireResue' = 'NORFOLK_FIRE_RESUE',
  'NorfolkGeneralHospital' = 'NORFOLK_GENERAL_HOSPITAL',
  'NorfolkHealthcare&Rehab' = 'NORFOLK_HEALTHCARE_&_REHAB',
  'NorfolkHealthcareCenter' = 'NORFOLK_HEALTHCARE_CENTER',
  'NorfolkHousing&DevelopmentAuthority' = 'NORFOLK_HOUSING_&_DEVELOPMENT_AUTHORITY',
  'NorfolkHumanServices' = 'NORFOLK_HUMAN_SERVICES',
  'NorfolkInternationalTerminals' = 'NORFOLK_INTERNATIONAL_TERMINALS',
  'NorfolkJuvenile&domesticCt' = 'NORFOLK_JUVENILE&DOMESTIC_CT',
  'NorfolkMachineAndWelding' = 'NORFOLK_MACHINE_AND_WELDING',
  'NorfolkNavalAi' = 'NORFOLK_NAVAL_AI',
  'NorfolkNavalBase' = 'NORFOLK_NAVAL_BASE',
  'NorfolkNavalSh' = 'NORFOLK_NAVAL_SH',
  'NorfolkNavalShipYard' = 'NORFOLK_NAVAL_SHIP_YARD',
  'NorfolkNavalShipyard' = 'NORFOLK_NAVAL_SHIPYARD',
  'NorfolkNavalShipyare' = 'NORFOLK_NAVAL_SHIPYARE',
  'NorfolkNavalShipyarrd' = 'NORFOLK_NAVAL_SHIPYARRD',
  'NorfolkPoliceDept' = 'NORFOLK_POLICE_DEPT',
  'NorfolkPortsmouthBeltline' = 'NORFOLK_PORTSMOUTH_BELTLINE',
  'NorfolkPublicHealth' = 'NORFOLK_PUBLIC_HEALTH',
  'NorfolkPublicLibrary' = 'NORFOLK_PUBLIC_LIBRARY',
  'NorfolkPublicSchools' = 'NORFOLK_PUBLIC_SCHOOLS',
  'NorfolkSheriff' = 'NORFOLK_SHERIFF',
  'NorfolkSheriffOffice' = 'NORFOLK_SHERIFF_OFFICE',
  'NorfolkSheriffsOffice' = 'NORFOLK_SHERIFFS_OFFICE',
  'NorfolkSouthern' = 'NORFOLK_SOUTHERN',
  'NorfolkSouthernCorp' = 'NORFOLK_SOUTHERN_CORP',
  'NorfolkSouthernRailroad' = 'NORFOLK_SOUTHERN_RAILROAD',
  'NorfolkSouthernRailway' = 'NORFOLK_SOUTHERN_RAILWAY',
  'NorfolkStateUn' = 'NORFOLK_STATE_UN',
  'NorfolkStateUniversity' = 'NORFOLK_STATE_UNIVERSITY',
  'NorfolkTruckCenter' = 'NORFOLK_TRUCK_CENTER',
  'NorfolkYacht&CountryClub' = 'NORFOLK_YACHT_&_COUNTRY_CLUB',
  'NorfolkZoo-volunteer' = 'NORFOLK_ZOO-VOLUNTEER',
  'NorfplkNavalShip' = 'NORFPLK_NAVAL_SHIP',
  'NorgeLandworks' = 'NORGE_LANDWORKS',
  'NoritsuAmericaCorporation' = 'NORITSU_AMERICA_CORPORATION',
  'NorolkCommunitySvcsBrd' = 'NOROLK_COMMUNITY_SVCS_BRD',
  'NorthBeachScvsInc' = 'NORTH_BEACH_SCVS_INC',
  'NorthCarolinaAssociationOfEducators' = 'NORTH_CAROLINA_ASSOCIATION_OF_EDUCATORS',
  'NorthCarolinaCorrectionalFacility' = 'NORTH_CAROLINA_CORRECTIONAL_FACILITY',
  'NorthCarolinaDeptOfTransportation' = 'NORTH_CAROLINA_DEPT_OF_TRANSPORTATION',
  'NorthCarolinaPublicSchools' = 'NORTH_CAROLINA_PUBLIC_SCHOOLS',
  'NorthWestContractors,Inc' = 'NORTH_WEST_CONTRACTORS,_INC',
  'NortheastAbelmarleGroup' = 'NORTHEAST_ABELMARLE_GROUP',
  'NortheastAlbemarleGroup' = 'NORTHEAST_ALBEMARLE_GROUP',
  'NortheasterOb/gyn' = 'NORTHEASTER_OB/GYN',
  'Northeastern,Inc' = 'NORTHEASTERN,_INC',
  'NortheasternFlooringInc' = 'NORTHEASTERN_FLOORING_INC',
  'NortheasternLawnCare' = 'NORTHEASTERN_LAWN_CARE',
  'NortheasternOb/gyn' = 'NORTHEASTERN_OB/GYN',
  'NortheasternProfessional' = 'NORTHEASTERN_PROFESSIONAL',
  'NorthropGrummanShipbuilding' = 'NORTHROP_GRUMMAN_SHIPBUILDING',
  'NorthropGrummanTs' = 'NORTHROP_GRUMMAN_TS',
  'NorthrupGrumman' = 'NORTHRUP_GRUMMAN',
  'NorthrupGrummon' = 'NORTHRUP_GRUMMON',
  'NorthwestAnnexBase' = 'NORTHWEST_ANNEX_BASE',
  'NorthwestAnnexMarinerCenter' = 'NORTHWEST_ANNEX_MARINER_CENTER',
  'NorthwestCdc' = 'NORTHWEST_CDC',
  'NorthwestWeldingAssociates' = 'NORTHWEST_WELDING_ASSOCIATES',
  'NorthwestYouthCenter' = 'NORTHWEST_YOUTH_CENTER',
  'NorvaPaintingInc' = 'NORVA_PAINTING_INC',
  'Not' = 'NOT',
  'NotEmp' = 'NOT_EMP',
  'NotEmpkloyed' = 'NOT_EMPKLOYED',
  'NotGiven' = 'NOT_GIVEN',
  'NotListed' = 'NOT_LISTED',
  'NotWorking' = 'NOT_WORKING',
  'NotWorkingAtThisTime' = 'NOT_WORKING_AT_THIS_TIME',
  'Notable' = 'NOTABLE',
  'NovantHealth' = 'NOVANT_HEALTH',
  'NovoNordisk' = 'NOVO_NORDISK',
  'NowcareMedCtr' = 'NOWCARE_MED_CTR',
  'NowcareMedicalCenter' = 'NOWCARE_MEDICAL_CENTER',
  'Npase' = 'NPASE',
  'NpcPizzaHut' = 'NPC_PIZZA_HUT',
  'Nrha' = 'NRHA',
  'Nrmafes' = 'NRMAFES',
  'Nssa-rmc' = 'NSSA-RMC',
  'Nssarmc' = 'NSSARMC',
  'Nsu' = 'NSU',
  'Nswdg' = 'NSWDG',
  'Nta' = 'NTA',
  'Nterone' = 'NTERONE',
  'Ntersol' = 'NTERSOL',
  'NtpConstr.' = 'NTP_CONSTR.',
  'Nu-quality' = 'NU-QUALITY',
  'Nucor' = 'NUCOR',
  'NucorSteel' = 'NUCOR_STEEL',
  'Numotion' = 'NUMOTION',
  'NurseFinders' = 'NURSE_FINDERS',
  'NursesEtc.' = 'NURSES_ETC.',
  'Nuwc' = 'NUWC',
  'Nycpd' = 'NYCPD',
  'NykLogistics' = 'NYK_LOGISTICS',
  'OakGroveBaptistChurch' = 'OAK_GROVE_BAPTIST_CHURCH',
  'OakGroveHealthAndRehab' = 'OAK_GROVE_HEALTH_AND_REHAB',
  'OakGroveUmc' = 'OAK_GROVE_UMC',
  'OakleaSimpsonSecruity' = 'OAKLEA_SIMPSON_SECRUITY',
  'ObbcoSafety&Supply' = 'OBBCO_SAFETY_&_SUPPLY',
  'ObhUrgentCare' = 'OBH_URGENT_CARE',
  'Obhc' = 'OBHC',
  'ObiciAmbulatorySurgeryCenter' = 'OBICI_AMBULATORY_SURGERY_CENTER',
  'ObiciHospital' = 'OBICI_HOSPITAL',
  'ObxAmusements' = 'OBX_AMUSEMENTS',
  'ObxBlueRealtySvcs' = 'OBX_BLUE_REALTY_SVCS',
  'ObxHospital' = 'OBX_HOSPITAL',
  'ObxOralSurgery' = 'OBX_ORAL_SURGERY',
  'ObxServicesLcc' = 'OBX_SERVICES_LCC',
  'ObxWaterpark' = 'OBX_WATERPARK',
  'OccupTherapySvc' = 'OCCUP_THERAPY_SVC',
  'Oce' = 'OCE',
  'OceanAirElem' = 'OCEAN_AIR_ELEM',
  'OceanBeachClub' = 'OCEAN_BEACH_CLUB',
  'OceanMarine' = 'OCEAN_MARINE',
  'OceanMarineServices' = 'OCEAN_MARINE_SERVICES',
  'OceanTumblers' = 'OCEAN_TUMBLERS',
  'OceanaAppliance' = 'OCEANA_APPLIANCE',
  'OceanaCommisary' = 'OCEANA_COMMISARY',
  'OceanaCommissary' = 'OCEANA_COMMISSARY',
  'OceaneeringIncInt' = 'OCEANEERING_INC_INT',
  'OceaneeringInternational' = 'OCEANEERING_INTERNATIONAL',
  'OceaneeringInternationalInc' = 'OCEANEERING_INTERNATIONAL_INC',
  'OceanfrontGrill' = 'OCEANFRONT_GRILL',
  'OchrNorfolk' = 'OCHR_NORFOLK',
  'OctapharmPlasma' = 'OCTAPHARM_PLASMA',
  'OctapharmaPlasma' = 'OCTAPHARMA_PLASMA',
  'Odi' = 'ODI',
  'Odu' = 'ODU',
  'OduResearchFoundation' = 'ODU_RESEARCH_FOUNDATION',
  'OduUniversityPublications' = 'ODU_UNIVERSITY_PUBLICATIONS',
  'OdysseyHealthCare' = 'ODYSSEY_HEALTH_CARE',
  'OdysseyHospice' = 'ODYSSEY_HOSPICE',
  'Oessco' = 'OESSCO',
  'OfficeMax' = 'OFFICE_MAX',
  'OgdenPaymentSolutions' = 'OGDEN_PAYMENT_SOLUTIONS',
  'OilEquipmentSales' = 'OIL_EQUIPMENT_SALES',
  'OilEquipmentSalesServices' = 'OIL_EQUIPMENT_SALES_SERVICES',
  'OldConvMart' = 'OLD_CONV_MART',
  'OldDominion' = 'OLD_DOMINION',
  'OldDominionResearchFndtn' = 'OLD_DOMINION_RESEARCH_FNDTN',
  'OldDominionTruckLeasing' = 'OLD_DOMINION_TRUCK_LEASING',
  'OldDominionUniversity' = 'OLD_DOMINION_UNIVERSITY',
  'OldDominionUniversityVab' = 'OLD_DOMINION_UNIVERSITY_VAB',
  'OldPathsBaptist' = 'OLD_PATHS_BAPTIST',
  'OldPointNationalBank' = 'OLD_POINT_NATIONAL_BANK',
  'OldPointeNationalBank' = 'OLD_POINTE_NATIONAL_BANK',
  'OldTownePublicHouse' = 'OLD_TOWNE_PUBLIC_HOUSE',
  'OldWorldProvis' = 'OLD_WORLD_PROVIS',
  'OldsAuto' = 'OLDS_AUTO',
  'OldsAutoParts' = 'OLDS_AUTO_PARTS',
  'OldsAutoSupply' = 'OLDS_AUTO_SUPPLY',
  'OleFox' = 'OLE_FOX',
  'OliveGarden' = 'OLIVE_GARDEN',
  'OlliesBargainOutlets' = 'OLLIES_BARGAIN_OUTLETS',
  'OmarsCarriageHouse' = 'OMARS_CARRIAGE_HOUSE',
  'OmegaWorldTravel' = 'OMEGA_WORLD_TRAVEL',
  'OmvMedicalInc' = 'OMV_MEDICAL_INC',
  'OnTimeMarketingCorp' = 'ON_TIME_MARKETING_CORP',
  'OneLifeFitness' = 'ONE_LIFE_FITNESS',
  'OneSteelRecycling' = 'ONE_STEEL_RECYCLING',
  'Onyx' = 'ONYX',
  'OpenMinds' = 'OPEN_MINDS',
  'OperationBlessing' = 'OPERATION_BLESSING',
  'OpticianRetired' = 'OPTICIAN_RETIRED',
  'OptimaHealth' = 'OPTIMA_HEALTH',
  'Optum360' = 'OPTUM_360',
  'Oracle' = 'ORACLE',
  'OracleInc' = 'ORACLE_INC',
  'OreilyDistribution' = 'OREILY_DISTRIBUTION',
  'OrfAirport' = 'ORF_AIRPORT',
  'OrionContracors' = 'ORION_CONTRACORS',
  'OrkinPestControl' = 'ORKIN_PEST_CONTROL',
  'OrthopaedicAndSpineCenter' = 'ORTHOPAEDIC_AND_SPINE_CENTER',
  'OscarSmithMiddleSchool' = 'OSCAR_SMITH_MIDDLE_SCHOOL',
  'Osesco' = 'OSESCO',
  'OsmoseUtilitiesServicesInc' = 'OSMOSE_UTILITIES_SERVICES_INC',
  'OstTrucking' = 'OST_TRUCKING',
  'OurLady' = 'OUR_LADY',
  'OurLadyOfPerpetualHelp' = 'OUR_LADY_OF_PERPETUAL_HELP',
  'OutbackRentABarn,Inc' = 'OUTBACK_RENT_A_BARN,_INC',
  'OutbackSteakHouse' = 'OUTBACK_STEAK_HOUSE',
  'OutdoorDesigners' = 'OUTDOOR_DESIGNERS',
  'OuterBanksAutotech' = 'OUTER_BANKS_AUTOTECH',
  'OuterBanksBlueRealty' = 'OUTER_BANKS_BLUE_REALTY',
  'OuterBanksBrewStation' = 'OUTER_BANKS_BREW_STATION',
  'OuterBanksElevator' = 'OUTER_BANKS_ELEVATOR',
  'OuterBanksHealth' = 'OUTER_BANKS_HEALTH',
  'OuterBanksHeatingAndCoolin' = 'OUTER_BANKS_HEATING_AND_COOLIN',
  'OuterBanksHosp' = 'OUTER_BANKS_HOSP',
  'OuterBanksHospital' = 'OUTER_BANKS_HOSPITAL',
  'OuterBanksMontessoriCollective' = 'OUTER_BANKS_MONTESSORI_COLLECTIVE',
  'OuterBanksOrtho' = 'OUTER_BANKS_ORTHO',
  'OuterBanksWomensCare' = 'OUTER_BANKS_WOMENS_CARE',
  'OuterBarrierConstruction' = 'OUTER_BARRIER_CONSTRUCTION',
  'OutlawsRideAndCustom' = 'OUTLAWS_RIDE_AND_CUSTOM',
  'OverheadDoorCoOfNorfolk' = 'OVERHEAD_DOOR_CO_OF_NORFOLK',
  'OvmFinancial,Inc' = 'OVM_FINANCIAL,_INC',
  'OwnRealEstate' = 'OWN_REAL_ESTATE',
  'P&sHomeHealthcareSolutions' = 'P&S_HOME_HEALTHCARE_SOLUTIONS',
  'P.l.Chesson' = 'P.L._CHESSON',
  'PaceCollaborative' = 'PACE_COLLABORATIVE',
  'PacificaSeniorLiving' = 'PACIFICA_SENIOR_LIVING',
  'PaintersPerfection' = 'PAINTERS_PERFECTION',
  'Paintworx' = 'PAINTWORX',
  'PaleHorseCoffee' = 'PALE_HORSE_COFFEE',
  'PalladianPartners' = 'PALLADIAN_PARTNERS',
  'PalladianPartners-PortsmoutNaval' = 'PALLADIAN_PARTNERS_-_PORTSMOUT_NAVAL',
  'PanasonicCustomer' = 'PANASONIC_CUSTOMER',
  'PanasonicCustomerCallCenter' = 'PANASONIC_CUSTOMER_CALL_CENTER',
  'PanelingFactory' = 'PANELING_FACTORY',
  'PaneraBread' = 'PANERA_BREAD',
  'PapaJohns' = 'PAPA_JOHNS',
  'PapaJohnsPizza' = 'PAPA_JOHNS_PIZZA',
  'ParadisePools' = 'PARADISE_POOLS',
  'ParadiseSunroom' = 'PARADISE_SUNROOM',
  'ParagonSystems,Inc.' = 'PARAGON_SYSTEMS,_INC.',
  'ParagrineSystems' = 'PARAGRINE_SYSTEMS',
  'Paramount' = 'PARAMOUNT',
  'ParamountIndustries' = 'PARAMOUNT_INDUSTRIES',
  'PariserDermatology' = 'PARISER_DERMATOLOGY',
  'ParkerDardenInc' = 'PARKER_DARDEN_INC',
  'ParkerReigleInsurance' = 'PARKER_REIGLE_INSURANCE',
  'ParkviewElementrySchool' = 'PARKVIEW_ELEMENTRY_SCHOOL',
  'ParkwayGrading' = 'PARKWAY_GRADING',
  'ParsonInc' = 'PARSON_INC',
  'PartTime' = 'PART_TIME',
  'PartyCity' = 'PARTY_CITY',
  'PasqotankCountySchoolSystem' = 'PASQOTANK_COUNTY_SCHOOL_SYSTEM',
  'PasqoutankCountyPublicSchools' = 'PASQOUTANK_COUNTY_PUBLIC_SCHOOLS',
  'PasqoutankCountySchools' = 'PASQOUTANK_COUNTY_SCHOOLS',
  'PasquatankCorrectionInst' = 'PASQUATANK_CORRECTION_INST',
  'Pasquotank-camdenEms' = 'PASQUOTANK-CAMDEN_EMS',
  'Pasquotank/camden911Dispatcher' = 'PASQUOTANK/CAMDEN_911_DISPATCHER',
  'Pasquotank/camdenEms' = 'PASQUOTANK/CAMDEN_EMS',
  'PasquotankAnimalHospital' = 'PASQUOTANK_ANIMAL_HOSPITAL',
  'PasquotankCityWater' = 'PASQUOTANK_CITY_WATER',
  'PasquotankCo.Schools' = 'PASQUOTANK_CO._SCHOOLS',
  'PasquotankCorrection' = 'PASQUOTANK_CORRECTION',
  'PasquotankCount' = 'PASQUOTANK_COUNT',
  'PasquotankCountu' = 'PASQUOTANK_COUNTU',
  'PasquotankCounty' = 'PASQUOTANK_COUNTY',
  'PasquotankCountyClerkOfCourt' = 'PASQUOTANK_COUNTY_CLERK_OF_COURT',
  'PasquotankCountyEms' = 'PASQUOTANK_COUNTY_EMS',
  'PasquotankCountyHealthDept' = 'PASQUOTANK_COUNTY_HEALTH_DEPT',
  'PasquotankCountyLibrary' = 'PASQUOTANK_COUNTY_LIBRARY',
  'PasquotankCountyPublicSchoolsElizabethCity' = 'PASQUOTANK_COUNTY_PUBLIC_SCHOOLS_ELIZABETH_CITY',
  'PasquotankCountySchools' = 'PASQUOTANK_COUNTY_SCHOOLS',
  'PasquotankCountySheriffOffice' = 'PASQUOTANK_COUNTY_SHERIFF_OFFICE',
  'PasquotankCountySherriffs' = 'PASQUOTANK_COUNTY_SHERRIFFS',
  'PasquotankCtyRegOfDeeds' = 'PASQUOTANK_CTY_REG_OF_DEEDS',
  'PasquotankDds' = 'PASQUOTANK_DDS',
  'PasquotankDss' = 'PASQUOTANK_DSS',
  'PasquotankEms' = 'PASQUOTANK_EMS',
  'PasquotankPubli' = 'PASQUOTANK_PUBLI',
  'PasquotankSheriffsOffice' = 'PASQUOTANK_SHERIFFS_OFFICE',
  'PasqutankPrison' = 'PASQUTANK_PRISON',
  'PatientAdvocateFoundation' = 'PATIENT_ADVOCATE_FOUNDATION',
  'PatientFirst' = 'PATIENT_FIRST',
  'PatientFirstIndianRiverRd' = 'PATIENT_FIRST_INDIAN_RIVER_RD',
  'PatriotPoolsOfVa' = 'PATRIOT_POOLS_OF_VA',
  'PatsSeafood' = 'PATS_SEAFOOD',
  'PattersonCo' = 'PATTERSON_CO',
  'PattisonCaulkingCo' = 'PATTISON_CAULKING_CO',
  'PaulDCampCommunityCollege' = 'PAUL_D_CAMP_COMMUNITY_COLLEGE',
  'PaulkAndPaulkInc' = 'PAULK_AND_PAULK_INC',
  'PaxtonCompany' = 'PAXTON_COMPANY',
  'Payless' = 'PAYLESS',
  'Paylocity' = 'PAYLOCITY',
  'PcaGroup' = 'PCA_GROUP',
  'PcaNuscriptRx' = 'PCA_NUSCRIPT_RX',
  'Pcmc' = 'PCMC',
  'Pcsi' = 'PCSI',
  'PeacefulWaters' = 'PEACEFUL_WATERS',
  'Peaklogix' = 'PEAKLOGIX',
  'PediatricPartnerOfHmptnRds' = 'PEDIATRIC_PARTNER_OF_HMPTN_RDS',
  'PediatricsAssoc' = 'PEDIATRICS_ASSOC',
  'Peerless' = 'PEERLESS',
  'Pemcco' = 'PEMCCO',
  'Pender&CowardPc' = 'PENDER_&_COWARD_PC',
  'PeninsulaHonda' = 'PENINSULA_HONDA',
  'PeninsulaInstitute/commHlth' = 'PENINSULA_INSTITUTE/COMM_HLTH',
  'PennacleRealty' = 'PENNACLE_REALTY',
  'PeoplesAuctions' = 'PEOPLES_AUCTIONS',
  'PeoplesCleanersInc' = 'PEOPLES_CLEANERS_INC',
  'Pepboys' = 'PEPBOYS',
  'Pepper&Co' = 'PEPPER_&_CO',
  'Pepsi' = 'PEPSI',
  'PepsiBottlingV' = 'PEPSI_BOTTLING_V',
  'PepsiBottlingVentures' = 'PEPSI_BOTTLING_VENTURES',
  'PerdueFarmInc' = 'PERDUE_FARM_INC',
  'PerdueFarms' = 'PERDUE_FARMS',
  'PerdueGrainOilseed' = 'PERDUE_GRAIN_OILSEED',
  'PeregrineTechnicalSolutions' = 'PEREGRINE_TECHNICAL_SOLUTIONS',
  'PerenialContractors' = 'PERENIAL_CONTRACTORS',
  'PerfectEventRentals' = 'PERFECT_EVENT_RENTALS',
  'PerquimansCountyDss' = 'PERQUIMANS_COUNTY_DSS',
  'PerquimansCountyEms' = 'PERQUIMANS_COUNTY_EMS',
  'PerquimansCountyHighSchool' = 'PERQUIMANS_COUNTY_HIGH_SCHOOL',
  'PerquimansCountyManager' = 'PERQUIMANS_COUNTY_MANAGER',
  'PerquimansCountySchools' = 'PERQUIMANS_COUNTY_SCHOOLS',
  'PerquimansCountyWater' = 'PERQUIMANS_COUNTY_WATER',
  'PerquminsCountySchools' = 'PERQUMINS_COUNTY_SCHOOLS',
  'PerryAutoGroup' = 'PERRY_AUTO_GROUP',
  'PerryBuick' = 'PERRY_BUICK',
  'PerryGlassCo' = 'PERRY_GLASS_CO',
  'PersonalTouchHomeCare' = 'PERSONAL_TOUCH_HOME_CARE',
  'Perspecta,Inc' = 'PERSPECTA,_INC',
  'PetSmart' = 'PET_SMART',
  'PetSuites' = 'PET_SUITES',
  'PetWay' = 'PET_WAY',
  'Peta' = 'PETA',
  'Petco' = 'PETCO',
  'PeterMitrevEyeCenter' = 'PETER_MITREV_EYE_CENTER',
  'PeterT.Nicholl' = 'PETER_T._NICHOLL',
  'Peters&WhiteConstruction' = 'PETERS_&_WHITE_CONSTRUCTION',
  'Pfizer,Inc' = 'PFIZER,_INC',
  'PfsFoodService' = 'PFS_FOOD_SERVICE',
  'PhMechanical' = 'PH_MECHANICAL',
  'PhilipLRussoJrPc' = 'PHILIP_L_RUSSO_JR_PC',
  'Philips' = 'PHILIPS',
  'PhilipsHealthcare' = 'PHILIPS_HEALTHCARE',
  'PhillipsAndPeters' = 'PHILLIPS_AND_PETERS',
  'PhillipsMercedesBenz' = 'PHILLIPS_MERCEDES_BENZ',
  'PhoenixGroup' = 'PHOENIX_GROUP',
  'Physician' = 'PHYSICIAN',
  'PictureMe' = 'PICTURE_ME',
  'PiedmontServiceGroup' = 'PIEDMONT_SERVICE_GROUP',
  'Pigtails&Crewcuts' = 'PIGTAILS_&_CREWCUTS',
  'PilmoorMethodistChurch' = 'PILMOOR_METHODIST_CHURCH',
  'PilmoorUnitedMethodistChurch' = 'PILMOOR_UNITED_METHODIST_CHURCH',
  'PinnacleHomeCare,Inc' = 'PINNACLE_HOME_CARE,_INC',
  'PinnicleHomeCare' = 'PINNICLE_HOME_CARE',
  'PitneyBowes' = 'PITNEY_BOWES',
  'PittmansPharmacy' = 'PITTMANS_PHARMACY',
  'PizzaHut' = 'PIZZA_HUT',
  'Pizzagelli' = 'PIZZAGELLI',
  'PjUnited' = 'PJ_UNITED',
  'PjsThriftStore' = 'PJS_THRIFT_STORE',
  'Planet-pInc' = 'PLANET-P_INC',
  'PlanitTechGroup' = 'PLANIT_TECH_GROUP',
  'PlannedParenthood' = 'PLANNED_PARENTHOOD',
  'PlanningCouncil' = 'PLANNING_COUNCIL',
  'PlantFactoryInteriors' = 'PLANT_FACTORY_INTERIORS',
  'PlasserAmericaCorp' = 'PLASSER_AMERICA_CORP',
  'PlasserAmericanCorp' = 'PLASSER_AMERICAN_CORP',
  'PlasticSurgery&Assoc' = 'PLASTIC_SURGERY_&_ASSOC',
  'PlasticSurgeryAssocOfTdwtr' = 'PLASTIC_SURGERY_ASSOC_OF_TDWTR',
  'PleasantGroveBaptistChurch' = 'PLEASANT_GROVE_BAPTIST_CHURCH',
  'PlexuaWorldwide' = 'PLEXUA_WORLDWIDE',
  'Pmg/e&cEnterprisesInc' = 'PMG/E&C_ENTERPRISES_INC',
  'PncBank' = 'PNC_BANK',
  'Podiatry,Ltd' = 'PODIATRY,_LTD',
  'PollardsChicken' = 'POLLARDS_CHICKEN',
  'PondeerosaInc' = 'PONDEEROSA_INC',
  'Ponit2' = 'PONIT_2',
  'PooleMahoneyPc' = 'POOLE_MAHONEY_PC',
  'PoppysTopDog' = 'POPPYS_TOP_DOG',
  'PopsDinerCo' = 'POPS_DINER_CO',
  'PortAllianceFcu' = 'PORT_ALLIANCE_FCU',
  'PortHealth' = 'PORT_HEALTH',
  'PortNorfolkRetirementCommunity' = 'PORT_NORFOLK_RETIREMENT_COMMUNITY',
  'PortOfNorfolk' = 'PORT_OF_NORFOLK',
  'PortOfVa' = 'PORT_OF_VA',
  'PortOfVirginia' = 'PORT_OF_VIRGINIA',
  'Portco' = 'PORTCO',
  'PortfolioRecovery' = 'PORTFOLIO_RECOVERY',
  'PortfolioRecoveryAssociated' = 'PORTFOLIO_RECOVERY_ASSOCIATED',
  'PortfolioRecoveryAssociates,Llc' = 'PORTFOLIO_RECOVERY_ASSOCIATES,_LLC',
  'PortfolioRecoveryAssos.' = 'PORTFOLIO_RECOVERY_ASSOS.',
  'PortsideHealth&Rehab' = 'PORTSIDE_HEALTH_&_REHAB',
  'PortsmoutPublicSchool' = 'PORTSMOUT_PUBLIC_SCHOOL',
  'PortsmouthChiropracticAndWellnessCenter' = 'PORTSMOUTH_CHIROPRACTIC_AND_WELLNESS_CENTER',
  'PortsmouthChristianSchool' = 'PORTSMOUTH_CHRISTIAN_SCHOOL',
  'PortsmouthCityPublicSchools' = 'PORTSMOUTH_CITY_PUBLIC_SCHOOLS',
  'PortsmouthCitySchools' = 'PORTSMOUTH_CITY_SCHOOLS',
  'PortsmouthCommissary' = 'PORTSMOUTH_COMMISSARY',
  'PortsmouthCommonwealthsAttorney' = 'PORTSMOUTH_COMMONWEALTHS_ATTORNEY',
  'PortsmouthDepartmentOfSocialServices' = 'PORTSMOUTH_DEPARTMENT_OF_SOCIAL_SERVICES',
  'PortsmouthDeptOfHealth' = 'PORTSMOUTH_DEPT_OF_HEALTH',
  'PortsmouthHealthDept' = 'PORTSMOUTH_HEALTH_DEPT',
  'PortsmouthLumberCorp' = 'PORTSMOUTH_LUMBER_CORP',
  'PortsmouthNavalMedicalCenter' = 'PORTSMOUTH_NAVAL_MEDICAL_CENTER',
  'PortsmouthNavalShipyard' = 'PORTSMOUTH_NAVAL_SHIPYARD',
  'PortsmouthPublicSchools' = 'PORTSMOUTH_PUBLIC_SCHOOLS',
  'PortsmouthPublicUtilities' = 'PORTSMOUTH_PUBLIC_UTILITIES',
  'PortsmouthRedevelopmentHousingAuthority' = 'PORTSMOUTH_REDEVELOPMENT_HOUSING_AUTHORITY',
  'PortsmouthSchoolsSystem' = 'PORTSMOUTH_SCHOOLS_SYSTEM',
  'PotomacConferenceSeventh-dayAdventistChurch' = 'POTOMAC_CONFERENCE_SEVENTH-DAY_ADVENTIST_CHURCH',
  'PotomacEnvironmentalInc' = 'POTOMAC_ENVIRONMENTAL_INC',
  'PotomacFamilyDiningGroup' = 'POTOMAC_FAMILY_DINING_GROUP',
  'PowellsMarket' = 'POWELLS_MARKET',
  'PowellsRoadSideMarket' = 'POWELLS_ROAD_SIDE_MARKET',
  'PowellsRoadsideMarket' = 'POWELLS_ROADSIDE_MARKET',
  'PowerElectric' = 'POWER_ELECTRIC',
  'PowhatanNursingHome' = 'POWHATAN_NURSING_HOME',
  'PraGroup' = 'PRA_GROUP',
  'PreciousGiftsEoCenter' = 'PRECIOUS_GIFTS_EO_CENTER',
  'PreconConstruct' = 'PRECON_CONSTRUCT',
  'PreconConstruction' = 'PRECON_CONSTRUCTION',
  'PreconMarine' = 'PRECON_MARINE',
  'PreferredFreezers' = 'PREFERRED_FREEZERS',
  'Premier-divOfW&oSupplyInc' = 'PREMIER-DIV_OF_W&O_SUPPLY_INC',
  'PremierMillwork' = 'PREMIER_MILLWORK',
  'PremierPrimaryCare' = 'PREMIER_PRIMARY_CARE',
  'PremiumRetailServices' = 'PREMIUM_RETAIL_SERVICES',
  'PresidentailAirways' = 'PRESIDENTAIL_AIRWAYS',
  'PresidentalAirways' = 'PRESIDENTAL_AIRWAYS',
  'PresidentialAir' = 'PRESIDENTIAL_AIR',
  'PresidentialAirways' = 'PRESIDENTIAL_AIRWAYS',
  'PresidentialAirwaysInc' = 'PRESIDENTIAL_AIRWAYS_INC',
  'PrideOfNc' = 'PRIDE_OF_NC',
  'PrimeFlight' = 'PRIME_FLIGHT',
  'PrimericaLicensingSuccessCenter' = 'PRIMERICA_LICENSING_SUCCESS_CENTER',
  'PrimoPizza' = 'PRIMO_PIZZA',
  'PrimroseAtCahoonCommons' = 'PRIMROSE_AT_CAHOON_COMMONS',
  'PrincessAnnUrgentCare,Crmg' = 'PRINCESS_ANN_URGENT_CARE,_CRMG',
  'PrincessAnneCountryClub' = 'PRINCESS_ANNE_COUNTRY_CLUB',
  'PrintcraftPress' = 'PRINTCRAFT_PRESS',
  'PriorityAcura' = 'PRIORITY_ACURA',
  'PriorityAutoGroup' = 'PRIORITY_AUTO_GROUP',
  'PriorityChevrolet' = 'PRIORITY_CHEVROLET',
  'PriorityHyunda' = 'PRIORITY_HYUNDA',
  'PriorityHyundai' = 'PRIORITY_HYUNDAI',
  'PriorityPestServices' = 'PRIORITY_PEST_SERVICES',
  'PriorityStaffing' = 'PRIORITY_STAFFING',
  'PriorityToyota' = 'PRIORITY_TOYOTA',
  'PrismMaritime' = 'PRISM_MARITIME',
  'PrismaHealth' = 'PRISMA_HEALTH',
  'PrivateNanny' = 'PRIVATE_NANNY',
  'PriyamLlc' = 'PRIYAM_LLC',
  'ProBuild' = 'PRO_BUILD',
  'ProLog' = 'PRO_LOG',
  'ProRealtyLlc' = 'PRO_REALTY_LLC',
  'ProTowAndRecovery' = 'PRO_TOW_AND_RECOVERY',
  'ProbationAndParoleOffice' = 'PROBATION_AND_PAROLE_OFFICE',
  'ProcreateFertility' = 'PROCREATE_FERTILITY',
  'Proctor&GambleHealthcare' = 'PROCTOR_&_GAMBLE_HEALTHCARE',
  'ProfessionalHeatingAndCooling' = 'PROFESSIONAL_HEATING_AND_COOLING',
  'ProfessionalHvac' = 'PROFESSIONAL_HVAC',
  'ProfessionalPrinting' = 'PROFESSIONAL_PRINTING',
  'Progressive' = 'PROGRESSIVE',
  'ProgressiveLlc' = 'PROGRESSIVE_LLC',
  'PrologixEast' = 'PROLOGIX_EAST',
  'PromedicaHospice' = 'PROMEDICA_HOSPICE',
  'PrometheusSecurityGroupGlobal' = 'PROMETHEUS_SECURITY_GROUP_GLOBAL',
  'Protelnium' = 'PROTELNIUM',
  'ProudInteriors' = 'PROUD_INTERIORS',
  'ProvidenceBapti' = 'PROVIDENCE_BAPTI',
  'ProvidenceChristianSchool' = 'PROVIDENCE_CHRISTIAN_SCHOOL',
  'ProvidenceComputers' = 'PROVIDENCE_COMPUTERS',
  'PrsC3&AviationCo' = 'PRS_C3&_AVIATION_CO',
  'Prudential' = 'PRUDENTIAL',
  'PrudentialRealty' = 'PRUDENTIAL_REALTY',
  'PsdAfloatAtlantic' = 'PSD_AFLOAT_ATLANTIC',
  'PtIsHomeBetween1200-200' = 'PT_IS_HOME_BETWEEN1200-200',
  'PublicDefendersOffice' = 'PUBLIC_DEFENDERS_OFFICE',
  'PublicPartnershipsLlc' = 'PUBLIC_PARTNERSHIPS_LLC',
  'PublicWorkCent' = 'PUBLIC_WORK_CENT',
  'PulmMedOfVaBeach' = 'PULM_MED_OF_VA_BEACH',
  'Pulmonary&CriticalCare' = 'PULMONARY_&_CRITICAL_CARE',
  'PuryearTrucking' = 'PURYEAR_TRUCKING',
  'Qcd' = 'QCD',
  'QedSystem' = 'QED_SYSTEM',
  'QedSystemInc' = 'QED_SYSTEM_INC',
  'QedSystemsInc' = 'QED_SYSTEMS_INC',
  'QedSystemsNc' = 'QED_SYSTEMS_NC',
  'QualityCrabCompanyInc' = 'QUALITY_CRAB_COMPANY_INC',
  'QualityCustomDistribution' = 'QUALITY_CUSTOM_DISTRIBUTION',
  'QualityEquipment,Llc' = 'QUALITY_EQUIPMENT,_LLC',
  'QualityMachine' = 'QUALITY_MACHINE',
  'QualitySuites' = 'QUALITY_SUITES',
  'QuestDiagnostics,Inc' = 'QUEST_DIAGNOSTICS,_INC',
  'QuestRealEstate' = 'QUEST_REAL_ESTATE',
  'QuickPic' = 'QUICK_PIC',
  'QuickTax' = 'QUICK_TAX',
  'Qurate' = 'QURATE',
  'Qvc' = 'QVC',
  'QvcChesapeake' = 'QVC_CHESAPEAKE',
  'QvcChesapeakeInc' = 'QVC_CHESAPEAKE_INC',
  'QvcInc' = 'QVC_INC',
  'QvcNetwork' = 'QVC_NETWORK',
  'QvcSuffolk' = 'QVC_SUFFOLK',
  'R&jHalcombTransInc' = 'R&J_HALCOMB_TRANS_INC',
  'R&kEnterprises' = 'R&K_ENTERPRISES',
  'R&mServices' = 'R&M_SERVICES',
  'R.oGivensSigns' = 'R.O_GIVENS_SIGNS',
  'RDSawyer' = 'R_D_SAWYER',
  'REMichelCo' = 'R_E_MICHEL_CO',
  'RaHoyHeating&Air' = 'RA_HOY_HEATING&_AIR',
  'RadeasLab/OldDominionOrtho' = 'RADEAS_LAB/_OLD_DOMINION_ORTHO',
  'RadiologyServices' = 'RADIOLOGY_SERVICES',
  'RadiologySvcOfHamptonRoads' = 'RADIOLOGY_SVC_OF_HAMPTON_ROADS',
  'RainbowStation' = 'RAINBOW_STATION',
  'RallyStaffing' = 'RALLY_STAFFING',
  'RanchoGrande' = 'RANCHO_GRANDE',
  'RandEnterprises,Inc' = 'RAND_ENTERPRISES,_INC',
  'RandstadInc' = 'RANDSTAD_INC',
  'RandstadUsa' = 'RANDSTAD_USA',
  'RanstadNorthAmerica,Inc' = 'RANSTAD_NORTH_AMERICA,_INC',
  'RanstadSouvright' = 'RANSTAD_SOUVRIGHT',
  'RaoRadiologistsInc' = 'RAO_RADIOLOGISTS_INC',
  'Ratheon' = 'RATHEON',
  'RavenJb' = 'RAVEN_JB',
  'Raytheon' = 'RAYTHEON',
  'RaytheonNcs' = 'RAYTHEON_NCS',
  'RaytheonTechSvcCo' = 'RAYTHEON_TECH_SVC_CO',
  'Raython' = 'RAYTHON',
  'RbComprehensiveDentistry' = 'RB_COMPREHENSIVE_DENTISTRY',
  'RbcBank' = 'RBC_BANK',
  'Rccdc' = 'RCCDC',
  'RdLambert' = 'RD_LAMBERT',
  'RdSawyer' = 'RD_SAWYER',
  'RealEstate' = 'REAL_ESTATE',
  'RealEstateAgent' = 'REAL_ESTATE_AGENT',
  'RealPageInc' = 'REAL_PAGE_INC',
  'Realtor' = 'REALTOR',
  'RealtyExecutives' = 'REALTY_EXECUTIVES',
  'RealtyManagementAssoc' = 'REALTY_MANAGEMENT_ASSOC',
  'RealtySpecialists' = 'REALTY_SPECIALISTS',
  'RedBarnFarms' = 'RED_BARN_FARMS',
  'RedDrumTaphouse' = 'RED_DRUM_TAPHOUSE',
  'RedRobin' = 'RED_ROBIN',
  'RedRobin/oliveGarden' = 'RED_ROBIN/OLIVE_GARDEN',
  'RedRoof' = 'RED_ROOF',
  'RedRoofInn' = 'RED_ROOF_INN',
  'RedeemerLutheranChurch' = 'REDEEMER_LUTHERAN_CHURCH',
  'Rediscovery' = 'REDISCOVERY',
  'RedsPilotCar' = 'REDS_PILOT_CAR',
  'ReedConstruction' = 'REED_CONSTRUCTION',
  'ReefsGrille' = 'REEFS_GRILLE',
  'RegalCinema13' = 'REGAL_CINEMA_13',
  'RegalGroup' = 'REGAL_GROUP',
  'RegalNails' = 'REGAL_NAILS',
  'RegentUniversity' = 'REGENT_UNIVERSITY',
  'Regis' = 'REGIS',
  'RegisHairstylist' = 'REGIS_HAIRSTYLIST',
  'RehabCareBonSecours' = 'REHAB_CARE_BON_SECOURS',
  'Rehabcare' = 'REHABCARE',
  'RehabilitationAssocPc' = 'REHABILITATION_ASSOC_PC',
  'RehobothLearningAcademy' = 'REHOBOTH_LEARNING_ACADEMY',
  'Reitred' = 'REITRED',
  'ReliableTankLine' = 'RELIABLE_TANK_LINE',
  'ReliableTankline' = 'RELIABLE_TANKLINE',
  'RelianceConcrete' = 'RELIANCE_CONCRETE',
  'RelianceStaffing' = 'RELIANCE_STAFFING',
  'Remax' = 'REMAX',
  'RemaxAlliance' = 'REMAX_ALLIANCE',
  'RemaxAlphaRealty' = 'REMAX_ALPHA_REALTY',
  'RemediSeniorCare' = 'REMEDI_SENIOR_CARE',
  'RenaBWrightElementary' = 'RENA_B_WRIGHT_ELEMENTARY',
  'RenhartFoodService' = 'RENHART_FOOD_SERVICE',
  'Rennassance' = 'RENNASSANCE',
  'Require' = 'REQUIRE',
  'ResCare' = 'RES_CARE',
  'RescomPropertyServices' = 'RESCOM_PROPERTY_SERVICES',
  'ResortReality' = 'RESORT_REALITY',
  'ResortRealty' = 'RESORT_REALTY',
  'ResourceResponseLlc' = 'RESOURCE_RESPONSE_LLC',
  'RetailMerchants' = 'RETAIL_MERCHANTS',
  'Retaired' = 'RETAIRED',
  'Retd' = 'RETD',
  'Retired-educator' = 'RETIRED-EDUCATOR',
  'Retired/disabled' = 'RETIRED/DISABLED',
  'RetiredArmy' = 'RETIRED_ARMY',
  'RetiredBanker' = 'RETIRED_BANKER',
  'RetiredBuisness' = 'RETIRED_BUISNESS',
  'RetiredCoastGuard' = 'RETIRED_COAST_GUARD',
  'RetiredDisabled' = 'RETIRED_DISABLED',
  'RetiredElectricalEngineer' = 'RETIRED_ELECTRICAL_ENGINEER',
  'RetiredFederalEmployee' = 'RETIRED_FEDERAL_EMPLOYEE',
  'RetiredFirefighter' = 'RETIRED_FIREFIGHTER',
  'RetiredFireman' = 'RETIRED_FIREMAN',
  'RetiredFordMot' = 'RETIRED_FORD_MOT',
  'RetiredFordMotors' = 'RETIRED_FORD_MOTORS',
  'RetiredGameWarden' = 'RETIRED_GAME_WARDEN',
  'RetiredMd' = 'RETIRED_MD',
  'RetiredMilitary' = 'RETIRED_MILITARY',
  'RetiredNavy' = 'RETIRED_NAVY',
  'RetiredOccupationalTherapist' = 'RETIRED_OCCUPATIONAL_THERAPIST',
  'RetiredPhysicalTherapist' = 'RETIRED_PHYSICAL_THERAPIST',
  'RetiredPreacher' = 'RETIRED_PREACHER',
  'RetiredRailroad' = 'RETIRED_RAILROAD',
  'RetiredRn' = 'RETIRED_RN',
  'RetiredSchoolTeacher' = 'RETIRED_SCHOOL_TEACHER',
  'RetiredSouthwestAirlines' = 'RETIRED_SOUTHWEST_AIRLINES',
  'RetiredTaxColl' = 'RETIRED_TAX_COLL',
  'RetiredTeacher' = 'RETIRED_TEACHER',
  'RetiredU.s.Govt' = 'RETIRED_U.S._GOVT',
  'RetiredUsCoastGuard' = 'RETIRED_US_COAST_GUARD',
  'RetiredUsNavy' = 'RETIRED_US_NAVY',
  'RetiredUsaf' = 'RETIRED_USAF',
  'RetiredUsn' = 'RETIRED_USN',
  'RetiredVaBeachTeacher' = 'RETIRED_VA_BEACH_TEACHER',
  'RetiredVbSchools' = 'RETIRED_VB_SCHOOLS',
  'Retored' = 'RETORED',
  'Retyired' = 'RETYIRED',
  'ReyesHoldings-ReinhartFoodservice' = 'REYES_HOLDINGS_-_REINHART_FOODSERVICE',
  'ReynoldsLandscaping' = 'REYNOLDS_LANDSCAPING',
  'RgElectric' = 'RG_ELECTRIC',
  'Rgs' = 'RGS',
  'RhBuilders' = 'RH_BUILDERS',
  'RichmanSteel' = 'RICHMAN_STEEL',
  'RichmondTrafficControl' = 'RICHMOND_TRAFFIC_CONTROL',
  'RickHendrickCadillac' = 'RICK_HENDRICK_CADILLAC',
  'RickHendrickChevrolet' = 'RICK_HENDRICK_CHEVROLET',
  'RicksHendricksChevy' = 'RICKS_HENDRICKS_CHEVY',
  'RicksHtg&AcInc' = 'RICKS_HTG_&_AC_INC',
  'Ricoh' = 'RICOH',
  'RiconUsa' = 'RICON_USA',
  'RievertTechnologies' = 'RIEVERT_TECHNOLOGIES',
  'Rigel' = 'RIGEL',
  'Rimco' = 'RIMCO',
  'RipleyHeatwoleInc' = 'RIPLEY_HEATWOLE_INC',
  'RiseChristianAcademy' = 'RISE_CHRISTIAN_ACADEMY',
  'Rite-aid' = 'RITE-AID',
  'RiteAid' = 'RITE_AID',
  'RiteAidPharmacy' = 'RITE_AID_PHARMACY',
  'RiteaidPharmacy' = 'RITEAID_PHARMACY',
  'RiverCityDevelopmentCorp' = 'RIVER_CITY_DEVELOPMENT_CORP',
  'RiverCityTrucking' = 'RIVER_CITY_TRUCKING',
  'RiverOakChurch' = 'RIVER_OAK_CHURCH',
  'RiverOakChurchKindergarten' = 'RIVER_OAK_CHURCH_KINDERGARTEN',
  'RiverOfLifeBaptistChurch' = 'RIVER_OF_LIFE_BAPTIST_CHURCH',
  'RiversCasinoPortsmouth' = 'RIVERS_CASINO_PORTSMOUTH',
  'RiversideConvelescentCtr' = 'RIVERSIDE_CONVELESCENT_CTR',
  'RiversideHealthSystem' = 'RIVERSIDE_HEALTH_SYSTEM',
  'RiversideRegionalMedCtr' = 'RIVERSIDE_REGIONAL_MED_CTR',
  'RiversideRegionalMedicalCenter' = 'RIVERSIDE_REGIONAL_MEDICAL_CENTER',
  'RiversideRehabInstitute' = 'RIVERSIDE_REHAB_INSTITUTE',
  'RiversideShoreRehabCtr' = 'RIVERSIDE_SHORE_REHAB_CTR',
  'RiversideWellnessAndFitnessCenter' = 'RIVERSIDE_WELLNESS_AND_FITNESS_CENTER',
  'RjrEliteTrucking' = 'RJR_ELITE_TRUCKING',
  'Rk&k' = 'RK&K',
  'Rndl' = 'RNDL',
  'RnrTireExpress' = 'RNR_TIRE_EXPRESS',
  'RoanokeChowanCommunityCollege' = 'ROANOKE_CHOWAN_COMMUNITY_COLLEGE',
  'RoanokeChowanHospital' = 'ROANOKE_CHOWAN_HOSPITAL',
  'RoanokeIslandAnimalClinic' = 'ROANOKE_ISLAND_ANIMAL_CLINIC',
  'RoanokeIslandFestivalPark' = 'ROANOKE_ISLAND_FESTIVAL_PARK',
  'RobbieParkerContracting' = 'ROBBIE_PARKER_CONTRACTING',
  'RobertB.Hansen,Md' = 'ROBERT_B._HANSEN,_MD',
  'RobertBros' = 'ROBERT_BROS',
  'RobertHalf' = 'ROBERT_HALF',
  'RobertsBroInc' = 'ROBERTS_BRO_INC',
  'RobertsOxygen' = 'ROBERTS_OXYGEN',
  'RobinsFloorService' = 'ROBINS_FLOOR_SERVICE',
  'RockChurch' = 'ROCK_CHURCH',
  'RocketDirectCommInc' = 'ROCKET_DIRECT_COMM_INC',
  'RockwellMedical' = 'ROCKWELL_MEDICAL',
  'RodanFields' = 'RODAN_FIELDS',
  'RogerBrownsResturant' = 'ROGER_BROWNS_RESTURANT',
  'RogersElectricalOfVa' = 'ROGERS_ELECTRICAL_OF_VA',
  'RolandVaultsInc' = 'ROLAND_VAULTS_INC',
  'RollingWoodAcademy' = 'ROLLING_WOOD_ACADEMY',
  'RomeroFamilyPractice' = 'ROMERO_FAMILY_PRACTICE',
  'RomulusMarine' = 'ROMULUS_MARINE',
  'RonPaulSalon' = 'RON_PAUL_SALON',
  'RoofEngineeringCorp' = 'ROOF_ENGINEERING_CORP',
  'Rose&WombleRealty' = 'ROSE_&_WOMBLE_REALTY',
  'Rose-wombleRealty' = 'ROSE-WOMBLE_REALTY',
  'RoseAndWomble' = 'ROSE_AND_WOMBLE',
  'RoseAndWombleRealty' = 'ROSE_AND_WOMBLE_REALTY',
  'RoseWombleRealty' = 'ROSE_WOMBLE_REALTY',
  'RoundtreeFarms' = 'ROUNDTREE_FARMS',
  'RouseSirineAssoc' = 'ROUSE_SIRINE_ASSOC',
  'RoyalFarms' = 'ROYAL_FARMS',
  'RoyalRealtyGroup' = 'ROYAL_REALTY_GROUP',
  'Rp55Group' = 'RP55_GROUP',
  'RrmmArchitects' = 'RRMM_ARCHITECTS',
  'RrmmDesignBuild' = 'RRMM_DESIGN_BUILD',
  'RscEquipment' = 'RSC_EQUIPMENT',
  'RsourceHealthcare' = 'RSOURCE_HEALTHCARE',
  'RubyTuesdayInc' = 'RUBY_TUESDAY_INC',
  'RubyTuesdays' = 'RUBY_TUESDAYS',
  'Rudy&Kelly' = 'RUDY_&_KELLY',
  'Rudy&Kelly-greenbrierPkwy' = 'RUDY_&_KELLY_-GREENBRIER_PKWY',
  'RudyAndKelly' = 'RUDY_AND_KELLY',
  'RudyAndKellyAcademy' = 'RUDY_AND_KELLY_ACADEMY',
  'RummelsAutomotive' = 'RUMMELS_AUTOMOTIVE',
  'RumoursSalon' = 'RUMOURS_SALON',
  'RussellAuto' = 'RUSSELL_AUTO',
  'RussellHastings' = 'RUSSELL_HASTINGS',
  'RussellHeatingAndAc' = 'RUSSELL_HEATING_AND_AC',
  'RussellsHeating&Cooling' = 'RUSSELLS_HEATING_&_COOLING',
  'RutherfordSchools' = 'RUTHERFORD_SCHOOLS',
  'RuthsChrisSteakhouse' = 'RUTHS_CHRIS_STEAKHOUSE',
  'RyanBoylan,Dds' = 'RYAN_BOYLAN,_DDS',
  'RyanJones&AssociatesPlc' = 'RYAN_JONES_&_ASSOCIATES_PLC',
  'Ryckman&Associates' = 'RYCKMAN_&_ASSOCIATES',
  'RyderTruckRent' = 'RYDER_TRUCK_RENT',
  'RylaCorp' = 'RYLA_CORP',
  'S&HFoodService' = 'S_&_H_FOOD_SERVICE',
  'S&NCommunications' = 'S_&_N_COMMUNICATIONS',
  'S&kTechnologies' = 'S&K_TECHNOLOGIES',
  'S.l.NusbaumRealtyCo' = 'S.L._NUSBAUM_REALTY_CO',
  'SLNusbaumInsuranceAgency' = 'S_L_NUSBAUM_INSURANCE_AGENCY',
  'SLNusbaumReality' = 'S_L_NUSBAUM_REALITY',
  'SaberHealthCare' = 'SABER_HEALTH_CARE',
  'SaberHealthcareGroup' = 'SABER_HEALTHCARE_GROUP',
  'Saga' = 'SAGA',
  'Sahm' = 'SAHM',
  'Saic' = 'SAIC',
  'Saic/usmc' = 'SAIC/USMC',
  'SaicCorp' = 'SAIC_CORP',
  'SaintBridesCorrectionalCenter' = 'SAINT_BRIDES_CORRECTIONAL_CENTER',
  'SakuraJapanessResturant' = 'SAKURA_JAPANESS_RESTURANT',
  'SalemHighSchool' = 'SALEM_HIGH_SCHOOL',
  'Sally' = 'SALLY',
  'SallyHussGallery' = 'SALLY_HUSS_GALLERY',
  'SallysBeautySupply' = 'SALLYS_BEAUTY_SUPPLY',
  'SalmonsLogistics' = 'SALMONS_LOGISTICS',
  'SalonFuison' = 'SALON_FUISON',
  'SalowsJewelers' = 'SALOWS_JEWELERS',
  'SalvationArmy' = 'SALVATION_ARMY',
  'SamaritanHouse' = 'SAMARITAN_HOUSE',
  'Samc' = 'SAMC',
  'SamcLaborAndDelivery' = 'SAMC_LABOR_AND_DELIVERY',
  'SamsClub' = 'SAMS_CLUB',
  'SamuelWhitePc' = 'SAMUEL_WHITE_PC',
  'SamuelsChapelP' = 'SAMUELS_CHAPEL_P',
  'SanctuaryRealty@sandbridge' = 'SANCTUARY_REALTY_@SANDBRIDGE',
  'SandblastSoil' = 'SANDBLAST_SOIL',
  'SanderlingInn' = 'SANDERLING_INN',
  'SandyPointCampground' = 'SANDY_POINT_CAMPGROUND',
  'SandysSunSpaShop' = 'SANDYS_SUN_SPA_SHOP',
  'SanstoneHealthAndRehab' = 'SANSTONE_HEALTH_AND_REHAB',
  'Sap' = 'SAP',
  'Sapa' = 'SAPA',
  'SaphageeInc' = 'SAPHAGEE_INC',
  'SaslowsJewelers' = 'SASLOWS_JEWELERS',
  'SassySalon&Spa' = 'SASSY_SALON_&_SPA',
  'SassySalonAndSpa' = 'SASSY_SALON_AND_SPA',
  'SateOfNc' = 'SATE_OF_NC',
  'SatoriMortage' = 'SATORI_MORTAGE',
  'Saunders,Matthews&PfitznerPllc' = 'SAUNDERS,_MATTHEWS_&_PFITZNER_PLLC',
  'SavageSabol&Visser' = 'SAVAGE_SABOL_&_VISSER',
  'SawyersGarage' = 'SAWYERS_GARAGE',
  'SchenkerInc' = 'SCHENKER_INC',
  'SchenkerLogistics' = 'SCHENKER_LOGISTICS',
  'SchneiderElect' = 'SCHNEIDER_ELECT',
  'SciSonsultingServices' = 'SCI_SONSULTING_SERVICES',
  'Science&TechnologyCorp' = 'SCIENCE_&_TECHNOLOGY_CORP',
  'ScientificTechInc' = 'SCIENTIFIC_TECH_INC',
  'ScottHarrisLawn' = 'SCOTT_HARRIS_LAWN',
  'ScottRealty' = 'SCOTT_REALTY',
  'Scvp' = 'SCVP',
  'SdcContracting' = 'SDC_CONTRACTING',
  'SdcGroup' = 'SDC_GROUP',
  'SdrPhotographyLlc' = 'SDR_PHOTOGRAPHY_LLC',
  'SeaCountryHomes' = 'SEA_COUNTRY_HOMES',
  'SeaMeGrow' = 'SEA_ME_GROW',
  'SeaQuentialMarketing' = 'SEA_QUENTIAL_MARKETING',
  'SeaSaltGrill' = 'SEA_SALT_GRILL',
  'SeacoastElectricCo.' = 'SEACOAST_ELECTRIC_CO.',
  'SeafarersInternationalUnion' = 'SEAFARERS_INTERNATIONAL_UNION',
  'Seair' = 'SEAIR',
  'SeairTransportationServices' = 'SEAIR_TRANSPORTATION_SERVICES',
  'Sears' = 'SEARS',
  'SearsHoldingCorp-Kmart' = 'SEARS_HOLDING_CORP-_KMART',
  'SearsHoldings' = 'SEARS_HOLDINGS',
  'Seascape' = 'SEASCAPE',
  'SeashellAcadamy' = 'SEASHELL_ACADAMY',
  'SeasideBuilders' = 'SEASIDE_BUILDERS',
  'SeasideEnvironmental' = 'SEASIDE_ENVIRONMENTAL',
  'SeasideVacations' = 'SEASIDE_VACATIONS',
  'SeasonalHouskeeper' = 'SEASONAL_HOUSKEEPER',
  'SeawardMarineCorp' = 'SEAWARD_MARINE_CORP',
  'Sec' = 'SEC',
  'SecInc' = 'SEC_INC',
  'Secep' = 'SECEP',
  'Secep-nps' = 'SECEP-NPS',
  'Secep/norfPblcSchools/ymca' = 'SECEP/NORF_PBLC_SCHOOLS/YMCA',
  'Seco' = 'SECO',
  'Secu' = 'SECU',
  'SecurewestInternational' = 'SECUREWEST_INTERNATIONAL',
  'SecurityConsultantsInc' = 'SECURITY_CONSULTANTS_INC',
  'SecurityConsultantsInd' = 'SECURITY_CONSULTANTS_IND',
  'SedgwickClaimsManagmentServices,Inc' = 'SEDGWICK_CLAIMS_MANAGMENT_SERVICES,_INC',
  'Segmark' = 'SEGMARK',
  'SelectBankAndTrust' = 'SELECT_BANK_AND_TRUST',
  'SelectPhysicalTherapy' = 'SELECT_PHYSICAL_THERAPY',
  'Self' = 'SELF',
  'Self-employed' = 'SELF-EMPLOYED',
  'Self-employedChildcare' = 'SELF-EMPLOYED_CHILDCARE',
  'Self-writer' = 'SELF-WRITER',
  'SelfAttorney' = 'SELF_ATTORNEY',
  'SelfEmployed-Re/maxAllianc' = 'SELF_EMPLOYED_-_RE/MAX_ALLIANC',
  'SelfEmployed-farmer' = 'SELF_EMPLOYED-FARMER',
  'SelfEmployed-internetSales' = 'SELF_EMPLOYED-INTERNET_SALES',
  'SelfEmployed/surgeon' = 'SELF_EMPLOYED/SURGEON',
  'SelfEmployedNurse' = 'SELF_EMPLOYED_NURSE',
  'SelfEmployedOwner/operator' = 'SELF_EMPLOYED_OWNER/OPERATOR',
  'SelfEmployee' = 'SELF_EMPLOYEE',
  'SelfEmployeed' = 'SELF_EMPLOYEED',
  'SelfEmpolyed' = 'SELF_EMPOLYED',
  'SelfErmployed' = 'SELF_ERMPLOYED',
  'SelfGrafConstruction' = 'SELF_GRAF_CONSTRUCTION',
  'SelfOwnsHorseRanch' = 'SELF_OWNS_HORSE_RANCH',
  'SelfProTow' = 'SELF_PRO_TOW',
  'SelfStantonConstruction' = 'SELF_STANTON_CONSTRUCTION',
  'SeniorSvcsOfSoutheasternVa' = 'SENIOR_SVCS_OF_SOUTHEASTERN_VA',
  'SentarAlbemarleMedicalCenter' = 'SENTAR_ALBEMARLE_MEDICAL_CENTER',
  'Sentara' = 'SENTARA',
  'Sentara-OptimaHealth' = 'SENTARA_-_OPTIMA_HEALTH',
  'SentaraAlbemarie' = 'SENTARA_ALBEMARIE',
  'SentaraAlbemarleMedicalCenter' = 'SENTARA_ALBEMARLE_MEDICAL_CENTER',
  'SentaraAlbemarleMedicalCtr' = 'SENTARA_ALBEMARLE_MEDICAL_CTR',
  'SentaraAlbermarleMedicalCenter' = 'SENTARA_ALBERMARLE_MEDICAL_CENTER',
  'SentaraEmt' = 'SENTARA_EMT',
  'SentaraEnterprise' = 'SENTARA_ENTERPRISE',
  'SentaraFamilyMedicine' = 'SENTARA_FAMILY_MEDICINE',
  'SentaraFamilyPhysicians' = 'SENTARA_FAMILY_PHYSICIANS',
  'SentaraHealth' = 'SENTARA_HEALTH',
  'SentaraHealthCare' = 'SENTARA_HEALTH_CARE',
  'SentaraHeartHospital' = 'SENTARA_HEART_HOSPITAL',
  'SentaraHeathCare' = 'SENTARA_HEATH_CARE',
  'SentaraHomeCare' = 'SENTARA_HOME_CARE',
  'SentaraHospital' = 'SENTARA_HOSPITAL',
  'SentaraLifeCanePace' = 'SENTARA_LIFE_CANE_PACE',
  'SentaraLifeCare' = 'SENTARA_LIFE_CARE',
  'SentaraLifecare' = 'SENTARA_LIFECARE',
  'SentaraMedical' = 'SENTARA_MEDICAL',
  'SentaraMedicalGroup' = 'SENTARA_MEDICAL_GROUP',
  'SentaraNorfolk' = 'SENTARA_NORFOLK',
  'SentaraNorfolkGeneral' = 'SENTARA_NORFOLK_GENERAL',
  'SentaraNorfolkGeneralHosp' = 'SENTARA_NORFOLK_GENERAL_HOSP',
  'SentaraNursing' = 'SENTARA_NURSING',
  'SentaraNursingCenter' = 'SENTARA_NURSING_CENTER',
  'SentaraNursingHome' = 'SENTARA_NURSING_HOME',
  'SentaraObici' = 'SENTARA_OBICI',
  'SentaraOrthopedics' = 'SENTARA_ORTHOPEDICS',
  'SentaraPrincessAnneEd' = 'SENTARA_PRINCESS_ANNE_ED',
  'SentaraPrincessAnneHospital' = 'SENTARA_PRINCESS_ANNE_HOSPITAL',
  'SentaraRockinghamMemorial' = 'SENTARA_ROCKINGHAM_MEMORIAL',
  'SentaraVaBeach' = 'SENTARA_VA_BEACH',
  'SentaraVaBeachGeneralHosp' = 'SENTARA_VA_BEACH_GENERAL_HOSP',
  'SentaraVascularSpecialists' = 'SENTARA_VASCULAR_SPECIALISTS',
  'SentaraVbgh' = 'SENTARA_VBGH',
  'SentaraVirginiaBeachGeneral' = 'SENTARA_VIRGINIA_BEACH_GENERAL',
  'SentrySecuritySystems' = 'SENTRY_SECURITY_SYSTEMS',
  'SenturaVaBchGenHospital' = 'SENTURA_VA_BCH_GEN_HOSPITAL',
  'Serco' = 'SERCO',
  'Serco-na' = 'SERCO-NA',
  'SercoInc' = 'SERCO_INC',
  'SercuritasUsa' = 'SERCURITAS_USA',
  'SerenityPersonalHomeCare' = 'SERENITY_PERSONAL_HOME_CARE',
  'Server' = 'SERVER',
  'ServiceLink' = 'SERVICE_LINK',
  'ServiceMaster' = 'SERVICE_MASTER',
  'ServiceTransferInc' = 'SERVICE_TRANSFER_INC',
  'ServproOfChesapeake' = 'SERVPRO_OF_CHESAPEAKE',
  'Ses-iScienceEngineering' = 'SES-I_SCIENCE_ENGINEERING',
  'Sesi' = 'SESI',
  'SetonYouthShelters' = 'SETON_YOUTH_SHELTERS',
  'Sev1tech' = 'SEV1TECH',
  'SevenEleven' = 'SEVEN_ELEVEN',
  'SevenTwelfthsRealEstate' = 'SEVEN_TWELFTHS_REAL_ESTATE',
  'Sevic' = 'SEVIC',
  'Sevtc' = 'SEVTC',
  'SewellsPointGolfCourse' = 'SEWELLS_POINT_GOLF_COURSE',
  'SewellsPointPolicePrecinct' = 'SEWELLS_POINT_POLICE_PRECINCT',
  'Shapiro&BursonLlp' = 'SHAPIRO_&_BURSON_LLP',
  'ShapiroAndBurs' = 'SHAPIRO_AND_BURS',
  'SharonUmc' = 'SHARON_UMC',
  'SharonUnitedMethodistChurch' = 'SHARON_UNITED_METHODIST_CHURCH',
  'ShaunaLayneRealty' = 'SHAUNA_LAYNE_REALTY',
  'ShawPaint&WallpaperCo.Inc' = 'SHAW_PAINT_&_WALLPAPER_CO._INC',
  'ShearDazzleSalon' = 'SHEAR_DAZZLE_SALON',
  'ShearPerfectionSalon' = 'SHEAR_PERFECTION_SALON',
  'SheepHarney' = 'SHEEP_HARNEY',
  'SheratonOceanfront' = 'SHERATON_OCEANFRONT',
  'SherwinWilliams' = 'SHERWIN_WILLIAMS',
  'ShimadzuMedicalSystem' = 'SHIMADZU_MEDICAL_SYSTEM',
  'ShoeCarnival' = 'SHOE_CARNIVAL',
  'ShooterTrucking' = 'SHOOTER_TRUCKING',
  'ShoreDriveAuto' = 'SHORE_DRIVE_AUTO',
  'ShoreThingCleaningService' = 'SHORE_THING_CLEANING_SERVICE',
  'ShorelineObx' = 'SHORELINE_OBX',
  'ShortysTrucking' = 'SHORTYS_TRUCKING',
  'ShowtimeNetworks' = 'SHOWTIME_NETWORKS',
  'Shs' = 'SHS',
  'SicommNet' = 'SICOMM_NET',
  'SiemensCorporation' = 'SIEMENS_CORPORATION',
  'SignalCorp' = 'SIGNAL_CORP',
  'SignalMutual' = 'SIGNAL_MUTUAL',
  'SignatureFamilyWelthAdvisors' = 'SIGNATURE_FAMILY_WELTH_ADVISORS',
  'SignatureRealty' = 'SIGNATURE_REALTY',
  'SignetEngineering' = 'SIGNET_ENGINEERING',
  'SimcoElectronics' = 'SIMCO_ELECTRONICS',
  'SimisInc.' = 'SIMIS_INC.',
  'SimmonsHeatingAndCoolingInc' = 'SIMMONS_HEATING_AND_COOLING_INC',
  'SimplexGrinnell' = 'SIMPLEX_GRINNELL',
  'SimplyScreening' = 'SIMPLY_SCREENING',
  'SimpsonLandscaping' = 'SIMPSON_LANDSCAPING',
  'Sims' = 'SIMS',
  'SimsMetal' = 'SIMS_METAL',
  'SiteManager' = 'SITE_MANAGER',
  'SitterCompanionHealthcare' = 'SITTER_COMPANION_HEALTHCARE',
  'Siu' = 'SIU',
  'SixJsCorp' = 'SIX_JS_CORP',
  'SizzlingPlatters' = 'SIZZLING_PLATTERS',
  'Skank9' = 'SKANK9',
  'Skanska' = 'SKANSKA',
  'Skills,Inc' = 'SKILLS,_INC',
  'SkillsInc' = 'SKILLS_INC',
  'SkinGoalsLocalEc' = 'SKIN_GOALS_LOCAL_EC',
  'Skye-brynnEnt.inc.' = 'SKYE-BRYNN_ENT.INC.',
  'SlNusbaumRealty' = 'SL_NUSBAUM_REALTY',
  'SlNusbaumRealtyCo' = 'SL_NUSBAUM_REALTY_CO',
  'Sleepys' = 'SLEEPYS',
  'SmartBeginnings' = 'SMART_BEGINNINGS',
  'SmartTrafficCenter' = 'SMART_TRAFFIC_CENTER',
  'Smartbasil' = 'SMARTBASIL',
  'Smashburger' = 'SMASHBURGER',
  'SmbRestaurants' = 'SMB_RESTAURANTS',
  'SmgDedicatedCareCtr' = 'SMG_DEDICATED_CARE_CTR',
  'SmgPccm' = 'SMG_PCCM',
  'Smith&Keene' = 'SMITH_&_KEENE',
  'Smith&KeeneElecSvc' = 'SMITH_&_KEENE_ELEC_SVC',
  'SmithAndKeene' = 'SMITH_AND_KEENE',
  'SmithElectricCo' = 'SMITH_ELECTRIC_CO',
  'SmithKeene' = 'SMITH_KEENE',
  'SmithfieldFoods' = 'SMITHFIELD_FOODS',
  'SmithfieldPacking' = 'SMITHFIELD_PACKING',
  'Smoc' = 'SMOC',
  'Snc-currituck' = 'SNC-CURRITUCK',
  'Sngh' = 'SNGH',
  'Snow' = 'SNOW',
  'Sobran,inc' = 'SOBRAN,INC',
  'SocialSecurityAdministration' = 'SOCIAL_SECURITY_ADMINISTRATION',
  'SocialSecurityDisability' = 'SOCIAL_SECURITY_DISABILITY',
  'SocialServicesStateOfNc' = 'SOCIAL_SERVICES_STATE_OF_NC',
  'Sodexo' = 'SODEXO',
  'Sodexo/chkd' = 'SODEXO/CHKD',
  'SolaSalon' = 'SOLA_SALON',
  'Solenis' = 'SOLENIS',
  'SolidStructureDeckAndFence' = 'SOLID_STRUCTURE_DECK_AND_FENCE',
  'SolidSystemsCadServices' = 'SOLID_SYSTEMS_CAD_SERVICES',
  'SolidThinkingCorp' = 'SOLID_THINKING_CORP',
  'SoloIncorporated' = 'SOLO_INCORPORATED',
  'SolstasLabPartners' = 'SOLSTAS_LAB_PARTNERS',
  'Sonic' = 'SONIC',
  'SorrentinoMarrianiInc' = 'SORRENTINO_MARRIANI_INC',
  'SouthCoastWelding' = 'SOUTH_COAST_WELDING',
  'SouthEasternCommunication' = 'SOUTH_EASTERN_COMMUNICATION',
  'SouthHamptonHandymanService' = 'SOUTH_HAMPTON_HANDYMAN_SERVICE',
  'SouthMillsSupe' = 'SOUTH_MILLS_SUPE',
  'SouthamptonAcademy' = 'SOUTHAMPTON_ACADEMY',
  'SouthamptonCountyPublicSchools' = 'SOUTHAMPTON_COUNTY_PUBLIC_SCHOOLS',
  'SouthamptonCountySchools' = 'SOUTHAMPTON_COUNTY_SCHOOLS',
  'SouthamptonCoutySchool' = 'SOUTHAMPTON_COUTY_SCHOOL',
  'SouthamptonHospital' = 'SOUTHAMPTON_HOSPITAL',
  'SouthamptonMemorialHospital' = 'SOUTHAMPTON_MEMORIAL_HOSPITAL',
  'Southeast4hConferenceCenter' = 'SOUTHEAST_4H_CONFERENCE_CENTER',
  'SoutheastConnections' = 'SOUTHEAST_CONNECTIONS',
  'SoutheastPainCare' = 'SOUTHEAST_PAIN_CARE',
  'SoutheasternFeuls' = 'SOUTHEASTERN_FEULS',
  'SoutheasternFuels' = 'SOUTHEASTERN_FUELS',
  'SoutheasternHealth' = 'SOUTHEASTERN_HEALTH',
  'SoutheasternMechanical' = 'SOUTHEASTERN_MECHANICAL',
  'SoutheasternPublicServAuth' = 'SOUTHEASTERN_PUBLIC_SERV_AUTH',
  'SoutheasternVaTrainingCenter' = 'SOUTHEASTERN_VA_TRAINING_CENTER',
  'SoutheasternVaTrainingCtr' = 'SOUTHEASTERN_VA_TRAINING_CTR',
  'SoutheasternVirginiaHealthSystem' = 'SOUTHEASTERN_VIRGINIA_HEALTH_SYSTEM',
  'SoutheasternVirginiaTrainingCenter' = 'SOUTHEASTERN_VIRGINIA_TRAINING_CENTER',
  'SouthernAutoGroup' = 'SOUTHERN_AUTO_GROUP',
  'SouthernBank' = 'SOUTHERN_BANK',
  'SouthernChryslerJeep' = 'SOUTHERN_CHRYSLER_JEEP',
  'SouthernCompany' = 'SOUTHERN_COMPANY',
  'SouthernDodge' = 'SOUTHERN_DODGE',
  'SouthernHomeExterior' = 'SOUTHERN_HOME_EXTERIOR',
  'SouthernHopeAnimalRescue' = 'SOUTHERN_HOPE_ANIMAL_RESCUE',
  'SouthernHospitality' = 'SOUTHERN_HOSPITALITY',
  'SouthernInsAgencyInc' = 'SOUTHERN_INS_AGENCY_INC',
  'SouthernMade' = 'SOUTHERN_MADE',
  'SouthernMeatPacking' = 'SOUTHERN_MEAT_PACKING',
  'SouthernPacking' = 'SOUTHERN_PACKING',
  'SouthernPump&Tank' = 'SOUTHERN_PUMP_&_TANK',
  'SouthernShoreRealty' = 'SOUTHERN_SHORE_REALTY',
  'SouthernShoresReality' = 'SOUTHERN_SHORES_REALITY',
  'SouthernShoresRealty&Beach' = 'SOUTHERN_SHORES_REALTY_&_BEACH',
  'SouthernShoresRealty' = 'SOUTHERN_SHORES_REALTY',
  'SouthernStatesCoop' = 'SOUTHERN_STATES_COOP',
  'Southland' = 'SOUTHLAND',
  'SouthlandCorp' = 'SOUTHLAND_CORP',
  'SouthlandInc' = 'SOUTHLAND_INC',
  'SouthlandRestur' = 'SOUTHLAND_RESTUR',
  'SouthlandResturant' = 'SOUTHLAND_RESTURANT',
  'SouthlandTrade' = 'SOUTHLAND_TRADE',
  'SouthlandTradeCorporation' = 'SOUTHLAND_TRADE_CORPORATION',
  'SouthlandTrades' = 'SOUTHLAND_TRADES',
  'SouthsideHarleyDavidson' = 'SOUTHSIDE_HARLEY_DAVIDSON',
  'SouthsideRegionalMedicalCenter' = 'SOUTHSIDE_REGIONAL_MEDICAL_CENTER',
  'SouthwestAirlines' = 'SOUTHWEST_AIRLINES',
  'Spankys' = 'SPANKYS',
  'Spawar' = 'SPAWAR',
  'SpawarsyscenAtlantic' = 'SPAWARSYSCEN_ATLANTIC',
  'SpawarsyscenAtlantic/navy' = 'SPAWARSYSCEN_ATLANTIC/NAVY',
  'SpecialtyMarineInc' = 'SPECIALTY_MARINE_INC',
  'SpectrumHealthcare' = 'SPECTRUM_HEALTHCARE',
  'SpectrumLlc' = 'SPECTRUM_LLC',
  'Speedway' = 'SPEEDWAY',
  'SpencerYachts' = 'SPENCER_YACHTS',
  'Spherion' = 'SPHERION',
  'Spheris' = 'SPHERIS',
  'Spine&OrthopedicPainCtr' = 'SPINE_&_ORTHOPEDIC_PAIN_CTR',
  'SpiritOfNorfolk' = 'SPIRIT_OF_NORFOLK',
  'SportsMed' = 'SPORTS_MED',
  'SportsMedOrthopaedicCte' = 'SPORTS_MED_ORTHOPAEDIC_CTE',
  'SportsMedicine&OrthopaedicCenterInc' = 'SPORTS_MEDICINE_&_ORTHOPAEDIC_CENTER_INC',
  'SpratleyMasonryCo' = 'SPRATLEY_MASONRY_CO',
  'SpringArborAssistLiving' = 'SPRING_ARBOR_ASSIST_LIVING',
  'SpringHillSuites' = 'SPRING_HILL_SUITES',
  'SpringLifeBehavioralCare' = 'SPRING_LIFE_BEHAVIORAL_CARE',
  'SpringhillSuites' = 'SPRINGHILL_SUITES',
  'SpringsWindowFashions' = 'SPRINGS_WINDOW_FASHIONS',
  'SprinkleMasonry' = 'SPRINKLE_MASONRY',
  'SpruillAuto' = 'SPRUILL_AUTO',
  'Spsa' = 'SPSA',
  'SraInternational' = 'SRA_INTERNATIONAL',
  'Src' = 'SRC',
  'Ssa' = 'SSA',
  'Sscs' = 'SSCS',
  'Sspi' = 'SSPI',
  'St.BridesCorrectionalCenter' = 'ST._BRIDES_CORRECTIONAL_CENTER',
  'St.JohnsSchoolBoard' = 'ST._JOHNS_SCHOOL_BOARD',
  'St.MatthewsCatholicSchool' = 'ST._MATTHEWS_CATHOLIC_SCHOOL',
  'St.MatthewsSchool' = 'ST._MATTHEWS_SCHOOL',
  'St.ofVaDeptOfChildSupport' = 'ST.OF_VA_DEPT_OF_CHILD_SUPPORT',
  'StBridesCorrectionCenter' = 'ST_BRIDES_CORRECTION_CENTER',
  'StBridesCorrectionCtr' = 'ST_BRIDES_CORRECTION_CTR',
  'StBridesCorrectionalCtr' = 'ST_BRIDES_CORRECTIONAL_CTR',
  'StBridesCorrections' = 'ST_BRIDES_CORRECTIONS',
  'StMarysHomeForDisabledChildren' = 'ST_MARYS_HOME_FOR_DISABLED_CHILDREN',
  'StMatthewsCatholicSchool' = 'ST_MATTHEWS_CATHOLIC_SCHOOL',
  'StMatthewsSchool' = 'ST_MATTHEWS_SCHOOL',
  'StStephen-martyrCathChurch' = 'ST_STEPHEN-MARTYR_CATH_CHURCH',
  'StackhouseNexsen&Turretta' = 'STACKHOUSE_NEXSEN_&_TURRETTA',
  'StanGarfinPublications' = 'STAN_GARFIN_PUBLICATIONS',
  'StandardCalibrations,Inc' = 'STANDARD_CALIBRATIONS,_INC',
  'StandardParking' = 'STANDARD_PARKING',
  'StarPrintingCoInc' = 'STAR_PRINTING_CO_INC',
  'StarrMotors' = 'STARR_MOTORS',
  'StatMedical' = 'STAT_MEDICAL',
  'State' = 'STATE',
  'StateEmployeeCreditUnion' = 'STATE_EMPLOYEE_CREDIT_UNION',
  'StateEmployees' = 'STATE_EMPLOYEES',
  'StateEmployeesCreditUnion' = 'STATE_EMPLOYEES_CREDIT_UNION',
  'StateEmployerCreditUnions' = 'STATE_EMPLOYER_CREDIT_UNIONS',
  'StateFarm' = 'STATE_FARM',
  'StateOfNc' = 'STATE_OF_NC',
  'StateOfNcDistrictAttorneysOffice' = 'STATE_OF_NC_DISTRICT_ATTORNEYS_OFFICE',
  'StateOfNorthCarolina' = 'STATE_OF_NORTH_CAROLINA',
  'StateOfVa(doc)' = 'STATE_OF_VA_(DOC)',
  'StateOfVirginia' = 'STATE_OF_VIRGINIA',
  'StateOfWv' = 'STATE_OF_WV',
  'StatelineBuilders' = 'STATELINE_BUILDERS',
  'StayAtHome' = 'STAY_AT_HOME',
  'StayHome' = 'STAY_HOME',
  'StayHomeMom' = 'STAY_HOME_MOM',
  'StayHomeMomOnSsi' = 'STAY_HOME_MOM_ON_SSI',
  'StaybridgeSuites' = 'STAYBRIDGE_SUITES',
  'Steadfast' = 'STEADFAST',
  'Steamfitters602' = 'STEAMFITTERS_602',
  'SteamfittersLocal602' = 'STEAMFITTERS_LOCAL_602',
  'SteinerBMooreCorp' = 'STEINER_B_MOORE_CORP',
  'StephenAsamDds' = 'STEPHEN_ASAM_DDS',
  'StephenGivandoPc' = 'STEPHEN_GIVANDO_PC',
  'Sterling' = 'STERLING',
  'SteveLoveIns' = 'STEVE_LOVE_INS',
  'SteveTaylorLawService' = 'STEVE_TAYLOR_LAW_SERVICE',
  'Stf' = 'STF',
  'Stihl' = 'STIHL',
  'Stihl,Inc' = 'STIHL,_INC',
  'StihlInc' = 'STIHL_INC',
  'StihlInc.' = 'STIHL_INC.',
  'StihlIncorporated' = 'STIHL_INCORPORATED',
  'Stilwell&Associates' = 'STILWELL_&_ASSOCIATES',
  'StilwellAssociates' = 'STILWELL_ASSOCIATES',
  'StokleysServices' = 'STOKLEYS_SERVICES',
  'StonebridgeSchool' = 'STONEBRIDGE_SCHOOL',
  'StoneyCreek' = 'STONEY_CREEK',
  'StructuralMechanicalInc' = 'STRUCTURAL_MECHANICAL_INC',
  'StructuredHealth' = 'STRUCTURED_HEALTH',
  'StrykerMobileEmergencyRoadsideService' = 'STRYKER_MOBILE_EMERGENCY_ROADSIDE_SERVICE',
  'Studen' = 'STUDEN',
  'Student' = 'STUDENT',
  'Student/homemaker' = 'STUDENT/HOMEMAKER',
  'StudentUniversityOfArizona' = 'STUDENT_UNIVERSITY_OF_ARIZONA',
  'Student`' = 'STUDENT`',
  'StudioEast' = 'STUDIO_EAST',
  'StudioExpress' = 'STUDIO_EXPRESS',
  'StummsHardwareFloors' = 'STUMMS_HARDWARE_FLOORS',
  'StummsHardwood' = 'STUMMS_HARDWOOD',
  'StummsHardwoodFloors' = 'STUMMS_HARDWOOD_FLOORS',
  'Subcom' = 'SUBCOM',
  'SubstanceAbuseRehabPrgm' = 'SUBSTANCE_ABUSE_REHAB_PRGM',
  'SububanGrading&Utilities' = 'SUBUBAN_GRADING_&_UTILITIES',
  'SuburbanChristianChurch' = 'SUBURBAN_CHRISTIAN_CHURCH',
  'SuburbanPropane' = 'SUBURBAN_PROPANE',
  'Subway' = 'SUBWAY',
  'SubwaySandwiches&Salads' = 'SUBWAY_SANDWICHES_&_SALADS',
  'SuccessGroupInternational' = 'SUCCESS_GROUP_INTERNATIONAL',
  'SuezWaterTechnologies' = 'SUEZ_WATER_TECHNOLOGIES',
  'SuffolkContractorInc' = 'SUFFOLK_CONTRACTOR_INC',
  'SuffolkInsurance' = 'SUFFOLK_INSURANCE',
  'SuffolkPediatrics' = 'SUFFOLK_PEDIATRICS',
  'SuffolkPublicSchool' = 'SUFFOLK_PUBLIC_SCHOOL',
  'SuffolkPublicSchools' = 'SUFFOLK_PUBLIC_SCHOOLS',
  'SuffolkRed.&HousingAuth' = 'SUFFOLK_RED._&_HOUSING_AUTH',
  'SuffolkSchools' = 'SUFFOLK_SCHOOLS',
  'Sultra' = 'SULTRA',
  'Sumitomo' = 'SUMITOMO',
  'SumitomoDriveTechnologies' = 'SUMITOMO_DRIVE_TECHNOLOGIES',
  'SumitomoMachineryCorp' = 'SUMITOMO_MACHINERY_CORP',
  'SumitomoMachineryCorpOfAme' = 'SUMITOMO_MACHINERY_CORP_OF_AME',
  'SummitConstructionCorp' = 'SUMMIT_CONSTRUCTION_CORP',
  'SummitDermatologyAndPlasticSurgery' = 'SUMMIT_DERMATOLOGY_AND_PLASTIC_SURGERY',
  'SunGro' = 'SUN_GRO',
  'SunGroHoritculture' = 'SUN_GRO_HORITCULTURE',
  'SunRealty' = 'SUN_REALTY',
  'SunSuitesHotel' = 'SUN_SUITES_HOTEL',
  'SunbeltRentals' = 'SUNBELT_RENTALS',
  'SunbeltRentals,Inc' = 'SUNBELT_RENTALS,_INC',
  'SundaysSunSpaShop' = 'SUNDAYS_SUN_SPA_SHOP',
  'SunnyDayGuides' = 'SUNNY_DAY_GUIDES',
  'SunriseBreakfast' = 'SUNRISE_BREAKFAST',
  'SunriseCleaners' = 'SUNRISE_CLEANERS',
  'SunriseHomeHealth' = 'SUNRISE_HOME_HEALTH',
  'SuperCuts' = 'SUPER_CUTS',
  'SuperiorMarble&Stone' = 'SUPERIOR_MARBLE_&_STONE',
  'SuperiorWaterSystems' = 'SUPERIOR_WATER_SYSTEMS',
  'Supermedia' = 'SUPERMEDIA',
  'Superwalmart' = 'SUPERWALMART',
  'SupplyOneChesapeake' = 'SUPPLY_ONE_CHESAPEAKE',
  'SupplyoneChesapeake' = 'SUPPLYONE_CHESAPEAKE',
  'SupportServicesOfVa' = 'SUPPORT_SERVICES_OF_VA',
  'SupremeCourtOfVa' = 'SUPREME_COURT_OF_VA',
  'SupremeCrabAndSeafood' = 'SUPREME_CRAB_AND_SEAFOOD',
  'SupremePetrolemInc' = 'SUPREME_PETROLEM_INC',
  'SupshipNewportNews' = 'SUPSHIP_NEWPORT_NEWS',
  'SurefoxNorthAmerica' = 'SUREFOX_NORTH_AMERICA',
  'SurfPediatric&Medicine' = 'SURF_PEDIATRIC_&_MEDICINE',
  'SurryCoPublicSchools' = 'SURRY_CO_PUBLIC_SCHOOLS',
  'SutherlandGlobal' = 'SUTHERLAND_GLOBAL',
  'Svp' = 'SVP',
  'SwainAndTemple' = 'SWAIN_AND_TEMPLE',
  'SwainAndTempleInc.' = 'SWAIN_AND_TEMPLE_INC.',
  'SweetOnionTradingCo' = 'SWEET_ONION_TRADING_CO',
  'SwisherInternational' = 'SWISHER_INTERNATIONAL',
  'SycamoreConstrution' = 'SYCAMORE_CONSTRUTION',
  'SylvanLearningCtr' = 'SYLVAN_LEARNING_CTR',
  'SynchronetMarina' = 'SYNCHRONET_MARINA',
  'SyrInc' = 'SYR_INC',
  'SyrMgmtInc' = 'SYR_MGMT_INC',
  'SyscoHamptonRoads' = 'SYSCO_HAMPTON_ROADS',
  'SysmexAmericaInc' = 'SYSMEX_AMERICA_INC',
  'SystemPlantServices' = 'SYSTEM_PLANT_SERVICES',
  'SystemTechnicianForum' = 'SYSTEM_TECHNICIAN_FORUM',
  'T&bsCuisine' = 'T&BS_CUISINE',
  'T-mobile' = 'T-MOBILE',
  'T.ParkerHost,Inc' = 'T._PARKER_HOST,_INC',
  'T.c.CooperElementary' = 'T.C._COOPER_ELEMENTARY',
  'T.j.Maxx' = 'T.J._MAXX',
  'T2Systems-customerService' = 'T2_SYSTEMS-CUSTOMER_SERVICE',
  'TALoving' = 'T_A_LOVING',
  'TASheets' = 'T_A_SHEETS',
  'TComLc' = 'T_COM_LC',
  'TaLoving' = 'TA_LOVING',
  'TabernacleBaptistAcademy' = 'TABERNACLE_BAPTIST_ACADEMY',
  'Tac' = 'TAC',
  'TacRv' = 'TAC_RV',
  'TacoBell(onMaternityLeave)' = 'TACO_BELL_(ON_MATERNITY_LEAVE)',
  'TacoBell,Inc' = 'TACO_BELL,_INC',
  'Talbots' = 'TALBOTS',
  'TaleOfWhaleRest' = 'TALE_OF_WHALE_REST',
  'TanglewoodFarms' = 'TANGLEWOOD_FARMS',
  'TaqueriaLaBahia' = 'TAQUERIA_LA_BAHIA',
  'TaracaPacific,Inc' = 'TARACA_PACIFIC,_INC',
  'TargetCorp' = 'TARGET_CORP',
  'TargetDisCenter' = 'TARGET_DIS_CENTER',
  'TargetDistributions' = 'TARGET_DISTRIBUTIONS',
  'TargetGroup' = 'TARGET_GROUP',
  'TargetInd' = 'TARGET_IND',
  'Tasc' = 'TASC',
  'TasteUnlimited' = 'TASTE_UNLIMITED',
  'TateAppraisal' = 'TATE_APPRAISAL',
  'Tatitlek' = 'TATITLEK',
  'TatitlekCorporation' = 'TATITLEK_CORPORATION',
  'Taylor' = 'TAYLOR',
  'TaylorDoItCenter' = 'TAYLOR_DO_IT_CENTER',
  'TaylorMadeDiagnostic' = 'TAYLOR_MADE_DIAGNOSTIC',
  'TaylorMuellerRealty' = 'TAYLOR_MUELLER_REALTY',
  'TaylorsDoItCenter' = 'TAYLORS_DO_IT_CENTER',
  'TaylorsTotalLook' = 'TAYLORS_TOTAL_LOOK',
  'Tba' = 'TBA',
  'TbcCorp' = 'TBC_CORP',
  'Tcc' = 'TCC',
  'Tcc/self' = 'TCC/SELF',
  'TccAndShhc' = 'TCC_AND_SHHC',
  'Tccw' = 'TCCW',
  'Tci' = 'TCI',
  'Tcmp' = 'TCMP',
  'Tcom,lp' = 'TCOM,LP',
  'Tech24' = 'TECH_24',
  'TechnicalServices,Llc' = 'TECHNICAL_SERVICES,_LLC',
  'Technico' = 'TECHNICO',
  'Tecnico' = 'TECNICO',
  'TecnicoCorp' = 'TECNICO_CORP',
  'TecnicoCorporation' = 'TECNICO_CORPORATION',
  'TeeuwenGhsesLtd' = 'TEEUWEN_GHSES_LTD',
  'TegraGlobal' = 'TEGRA_GLOBAL',
  'TekSystems' = 'TEK_SYSTEMS',
  'TeleConsultantsInc' = 'TELE_CONSULTANTS_INC',
  'Teleconsultants,inc' = 'TELECONSULTANTS,INC',
  'Telephonics' = 'TELEPHONICS',
  'TempAgency' = 'TEMP_AGENCY',
  'TempControlHtg&Ac' = 'TEMP_CONTROL_HTG_&_AC',
  'TempletonProperties' = 'TEMPLETON_PROPERTIES',
  'TenderLovingCare' = 'TENDER_LOVING_CARE',
  'TenderYearsDaycare' = 'TENDER_YEARS_DAYCARE',
  'TetraTechTesoro' = 'TETRA_TECH_TESORO',
  'Tetronix550' = 'TETRONIX_550',
  'TexasRoadhouse' = 'TEXAS_ROADHOUSE',
  'TfcRecycling' = 'TFC_RECYCLING',
  'TgiFridays' = 'TGI_FRIDAYS',
  'TgibMarketing' = 'TGIB_MARKETING',
  'Thalhimer' = 'THALHIMER',
  'TheAcademyOfMusic' = 'THE_ACADEMY_OF_MUSIC',
  'TheAutoConnection' = 'THE_AUTO_CONNECTION',
  'TheBankOfCurr' = 'THE_BANK_OF_CURR',
  'TheBankOfCurrituck' = 'THE_BANK_OF_CURRITUCK',
  'TheBankOfSouthsideVirginia' = 'THE_BANK_OF_SOUTHSIDE_VIRGINIA',
  'TheBar' = 'THE_BAR',
  'TheBarryRobinsonCenter' = 'THE_BARRY_ROBINSON_CENTER',
  'TheBorderStation' = 'THE_BORDER_STATION',
  'TheBreedenCompany' = 'THE_BREEDEN_COMPANY',
  'TheCarExchange' = 'THE_CAR_EXCHANGE',
  'TheCheesecakeFactory' = 'THE_CHEESECAKE_FACTORY',
  'TheChildrensCenter' = 'THE_CHILDRENS_CENTER',
  'TheChristianBroadcastingNetwork' = 'THE_CHRISTIAN_BROADCASTING_NETWORK',
  'TheCollegeOfHealthCareProfession' = 'THE_COLLEGE_OF_HEALTH_CARE_PROFESSION',
  'TheCountyOfCurrituck' = 'THE_COUNTY_OF_CURRITUCK',
  'TheCove' = 'THE_COVE',
  'TheDentalStudioOfHamptonRoads' = 'THE_DENTAL_STUDIO_OF_HAMPTON_ROADS',
  'TheFreshMarkert' = 'THE_FRESH_MARKERT',
  'TheGlassBaronInc' = 'THE_GLASS_BARON_INC',
  'TheGoddardSchool' = 'THE_GODDARD_SCHOOL',
  'TheGroupForWomen' = 'THE_GROUP_FOR_WOMEN',
  'TheHartford' = 'THE_HARTFORD',
  'TheHotTip' = 'THE_HOT_TIP',
  'TheHouseChurch' = 'THE_HOUSE_CHURCH',
  'TheImaGroup' = 'THE_IMA_GROUP',
  'TheKennedyCoOfVa' = 'THE_KENNEDY_CO_OF_VA',
  'TheKennedyCompanyOfVa' = 'THE_KENNEDY_COMPANY_OF_VA',
  'TheLeeGroup' = 'THE_LEE_GROUP',
  'TheLostColony' = 'THE_LOST_COLONY',
  'TheMartinCo' = 'THE_MARTIN_CO',
  'TheMartinCoOfVa' = 'THE_MARTIN_CO_OF_VA',
  'TheMaxxSalon' = 'THE_MAXX_SALON',
  'TheMitreCorp' = 'THE_MITRE_CORP',
  'TheMitreGroup' = 'THE_MITRE_GROUP',
  'TheMoodyLawFirm' = 'THE_MOODY_LAW_FIRM',
  'TheNailLounge' = 'THE_NAIL_LOUNGE',
  'TheNcConferenceOfTheUnitedMethodistChurch' = 'THE_NC_CONFERENCE_OF_THE_UNITED_METHODIST_CHURCH',
  'TheOuterBanksHospital' = 'THE_OUTER_BANKS_HOSPITAL',
  'ThePantryKangaroo' = 'THE_PANTRY_KANGAROO',
  'ThePetersonCo' = 'THE_PETERSON_CO',
  'ThePetway' = 'THE_PETWAY',
  'ThePetwayLlc' = 'THE_PETWAY_LLC',
  'ThePinesGolfCourse' = 'THE_PINES_GOLF_COURSE',
  'ThePlanningCouncil' = 'THE_PLANNING_COUNCIL',
  'ThePointeGolfClub' = 'THE_POINTE_GOLF_CLUB',
  'TheRealEstateGroup' = 'THE_REAL_ESTATE_GROUP',
  'TheRealestateGroup' = 'THE_REALESTATE_GROUP',
  'TheShopper' = 'THE_SHOPPER',
  'TheTherapyNetwork' = 'THE_THERAPY_NETWORK',
  'TheTownOfSouthernShores' = 'THE_TOWN_OF_SOUTHERN_SHORES',
  'TheUpCenter' = 'THE_UP_CENTER',
  'TheUpsCenter' = 'THE_UPS_CENTER',
  'TheUpsStore' = 'THE_UPS_STORE',
  'Thermo-trolSystems' = 'THERMO-TROL_SYSTEMS',
  'ThomasBracket' = 'THOMAS_BRACKET',
  'ThomasMLeeEnterprisesInc' = 'THOMAS_M_LEE_ENTERPRISES_INC',
  'ThomasRuckerWilcoxSavage' = 'THOMAS_RUCKER_WILCOX_SAVAGE',
  'ThompsonHospitality' = 'THOMPSON_HOSPITALITY',
  'ThraneAndThrane' = 'THRANE_AND_THRANE',
  'ThrasherSandCo' = 'THRASHER_SAND_CO',
  'ThreeOaksElementry' = 'THREE_OAKS_ELEMENTRY',
  'ThreeRivers' = 'THREE_RIVERS',
  'ThreeTreesConstInc' = 'THREE_TREES_CONST_INC',
  'ThriftStoreCity' = 'THRIFT_STORE_CITY',
  'ThyssenKruppElevatorCo' = 'THYSSEN_KRUPP_ELEVATOR_CO',
  'TidalCorrosion' = 'TIDAL_CORROSION',
  'TidewaterAcademy' = 'TIDEWATER_ACADEMY',
  'TidewaterAidsComm' = 'TIDEWATER_AIDS_COMM',
  'TidewaterAutoAuction' = 'TIDEWATER_AUTO_AUCTION',
  'TidewaterBevera' = 'TIDEWATER_BEVERA',
  'TidewaterClippers' = 'TIDEWATER_CLIPPERS',
  'TidewaterClippers,Llc' = 'TIDEWATER_CLIPPERS,_LLC',
  'TidewaterCommCollege' = 'TIDEWATER_COMM_COLLEGE',
  'TidewaterCommCollegeNorf' = 'TIDEWATER_COMM_COLLEGE_NORF',
  'TidewaterCommunityCollege' = 'TIDEWATER_COMMUNITY_COLLEGE',
  'TidewaterContra' = 'TIDEWATER_CONTRA',
  'TidewaterCreditServices' = 'TIDEWATER_CREDIT_SERVICES',
  'TidewaterDominionEfcu' = 'TIDEWATER_DOMINION_EFCU',
  'TidewaterEmblemsInc.' = 'TIDEWATER_EMBLEMS_INC.',
  'TidewaterEms' = 'TIDEWATER_EMS',
  'TidewaterEyeCenter' = 'TIDEWATER_EYE_CENTER',
  'TidewaterFiberCorp' = 'TIDEWATER_FIBER_CORP',
  'TidewaterFiberRecycling' = 'TIDEWATER_FIBER_RECYCLING',
  'TidewaterFibre' = 'TIDEWATER_FIBRE',
  'TidewaterFibreCorp' = 'TIDEWATER_FIBRE_CORP',
  'TidewaterFinance' = 'TIDEWATER_FINANCE',
  'TidewaterFinanceCo' = 'TIDEWATER_FINANCE_CO',
  'TidewaterFinanceCompamy' = 'TIDEWATER_FINANCE_COMPAMY',
  'TidewaterFinanceGroup' = 'TIDEWATER_FINANCE_GROUP',
  'TidewaterFleetSupply' = 'TIDEWATER_FLEET_SUPPLY',
  'TidewaterFleetSupplyLlc' = 'TIDEWATER_FLEET_SUPPLY_LLC',
  'TidewaterHomeFunding' = 'TIDEWATER_HOME_FUNDING',
  'TidewaterInsuranceCo' = 'TIDEWATER_INSURANCE_CO',
  'TidewaterKidneySpecialists' = 'TIDEWATER_KIDNEY_SPECIALISTS',
  'TidewaterLandTransportation' = 'TIDEWATER_LAND_TRANSPORTATION',
  'TidewaterMulchAndMaterial' = 'TIDEWATER_MULCH_AND_MATERIAL',
  'TidewaterPastoralCounseling' = 'TIDEWATER_PASTORAL_COUNSELING',
  'TidewaterPediatricConsultant' = 'TIDEWATER_PEDIATRIC_CONSULTANT',
  'TidewaterSew&Vac' = 'TIDEWATER_SEW_&_VAC',
  'TidewaterStaffing' = 'TIDEWATER_STAFFING',
  'TidewaterTec' = 'TIDEWATER_TEC',
  'TidewaterTherapyForChildren' = 'TIDEWATER_THERAPY_FOR_CHILDREN',
  'TidewaterTv' = 'TIDEWATER_TV',
  'Tile&TerrazzoLlc' = 'TILE_&_TERRAZZO_LLC',
  'TillerConst' = 'TILLER_CONST',
  'TimmonsGroup' = 'TIMMONS_GROUP',
  'TipEastLlc' = 'TIP_EAST_LLC',
  'TitanAmerica' = 'TITAN_AMERICA',
  'TkcTechSolutions' = 'TKC_TECH_SOLUTIONS',
  'TmsNeurohealthCenter' = 'TMS_NEUROHEALTH_CENTER',
  'Tnaa' = 'TNAA',
  'Tng' = 'TNG',
  'TobaccoBarn' = 'TOBACCO_BARN',
  'ToddCoyleConstruction' = 'TODD_COYLE_CONSTRUCTION',
  'ToddPharmacy' = 'TODD_PHARMACY',
  'ToddsNorthsidePharmacy' = 'TODDS_NORTHSIDE_PHARMACY',
  'ToddsOfCurritu' = 'TODDS_OF_CURRITU',
  'ToddsPharmacy' = 'TODDS_PHARMACY',
  'Tom' = 'TOM',
  'TomSchlosserPlumbing' = 'TOM_SCHLOSSER_PLUMBING',
  'TopGuardSecurity' = 'TOP_GUARD_SECURITY',
  'TopToBottomCleaning' = 'TOP_TO_BOTTOM_CLEANING',
  'TopguardSecurity' = 'TOPGUARD_SECURITY',
  'TopsideCatering' = 'TOPSIDE_CATERING',
  'TortugasLie' = 'TORTUGAS_LIE',
  'TotalCareForWomen' = 'TOTAL_CARE_FOR_WOMEN',
  'TotalWine' = 'TOTAL_WINE',
  'TotallyDogs' = 'TOTALLY_DOGS',
  'TotallyThai' = 'TOTALLY_THAI',
  'TownBank' = 'TOWN_BANK',
  'TownBankOfCurrituck' = 'TOWN_BANK_OF_CURRITUCK',
  'TownOfCamden' = 'TOWN_OF_CAMDEN',
  'TownOfColumbia' = 'TOWN_OF_COLUMBIA',
  'TownOfHertford' = 'TOWN_OF_HERTFORD',
  'TownOfKillDevilHills' = 'TOWN_OF_KILL_DEVIL_HILLS',
  'TownOfKittyHawk' = 'TOWN_OF_KITTY_HAWK',
  'TownOfNagsHead' = 'TOWN_OF_NAGS_HEAD',
  'TownOfNagsHeadFireChief' = 'TOWN_OF_NAGS_HEAD_FIRE_CHIEF',
  'TownOfSouthernShores' = 'TOWN_OF_SOUTHERN_SHORES',
  'TownOfWindsor' = 'TOWN_OF_WINDSOR',
  'TownOnNagsHead' = 'TOWN_ON_NAGS_HEAD',
  'TowneAutomotive' = 'TOWNE_AUTOMOTIVE',
  'TowneBand' = 'TOWNE_BAND',
  'TowneBank' = 'TOWNE_BANK',
  'TowneBankMortgage' = 'TOWNE_BANK_MORTGAGE',
  'TowneBankOfCurrituck' = 'TOWNE_BANK_OF_CURRITUCK',
  'TowneMortgage' = 'TOWNE_MORTGAGE',
  'Townebank' = 'TOWNEBANK',
  'TownebankMortgage' = 'TOWNEBANK_MORTGAGE',
  'Tpmg' = 'TPMG',
  'TqiSolutionsInc' = 'TQI_SOLUTIONS_INC',
  'TractorSupply' = 'TRACTOR_SUPPLY',
  'TradeTeam' = 'TRADE_TEAM',
  'Tranquest' = 'TRANQUEST',
  'TranquilHouseInn' = 'TRANQUIL_HOUSE_INN',
  'TranquilityManor' = 'TRANQUILITY_MANOR',
  'TransOceanicCableShipCo' = 'TRANS_OCEANIC_CABLE_SHIP_CO',
  'TransTecsCorp' = 'TRANS_TECS_CORP',
  'Transportation' = 'TRANSPORTATION',
  'TranstecsCorp' = 'TRANSTECS_CORP',
  'TranstecsInc' = 'TRANSTECS_INC',
  'TrashFairiesLlc' = 'TRASH_FAIRIES_LLC',
  'TravelodgeHotel' = 'TRAVELODGE_HOTEL',
  'TrcOperator' = 'TRC_OPERATOR',
  'TrcRecycling' = 'TRC_RECYCLING',
  'TreasuresFromTheEarth' = 'TREASURES_FROM_THE_EARTH',
  'TreeWork' = 'TREE_WORK',
  'Tri-countyTelephone' = 'TRI-COUNTY_TELEPHONE',
  'Tri-starElectricInc' = 'TRI-STAR_ELECTRIC_INC',
  'Tri-stateUtilitiesCo' = 'TRI-STATE_UTILITIES_CO',
  'TriCityMaterialsLlc' = 'TRI_CITY_MATERIALS_LLC',
  'TriStarElectric' = 'TRI_STAR_ELECTRIC',
  'Tribune' = 'TRIBUNE',
  'TricarePrimeClinic/boone' = 'TRICARE_PRIME_CLINIC/BOONE',
  'TricomResearch' = 'TRICOM_RESEARCH',
  'TrilliumHealthResources' = 'TRILLIUM_HEALTH_RESOURCES',
  'Trilogy' = 'TRILOGY',
  'Trimpi&Nash' = 'TRIMPI_&_NASH',
  'Trindco' = 'TRINDCO',
  'TrinityChildDevelopment' = 'TRINITY_CHILD_DEVELOPMENT',
  'TrinityDayCare' = 'TRINITY_DAY_CARE',
  'TrintyChildDevelopment' = 'TRINTY_CHILD_DEVELOPMENT',
  'TrioRestaurant' = 'TRIO_RESTAURANT',
  'TripleCanopyInc' = 'TRIPLE_CANOPY_INC',
  'TripleRRanch' = 'TRIPLE_R_RANCH',
  'TrishasBedandB' = 'TRISHAS_BEDAND_B',
  'TropicalSmoothie' = 'TROPICAL_SMOOTHIE',
  'Trt' = 'TRT',
  'Tru' = 'TRU',
  'TruckAccCenter' = 'TRUCK_ACC_CENTER',
  'TruckAccesoryCenter' = 'TRUCK_ACCESORY_CENTER',
  'TruckAccessoryCenter' = 'TRUCK_ACCESSORY_CENTER',
  'TruckEnterprises' = 'TRUCK_ENTERPRISES',
  'TruckRefrigeratior' = 'TRUCK_REFRIGERATIOR',
  'TruckingCo' = 'TRUCKING_CO',
  'TrueImagesSalon' = 'TRUE_IMAGES_SALON',
  'TrueNorthTitle' = 'TRUE_NORTH_TITLE',
  'Trugreen' = 'TRUGREEN',
  'TruittIntermediate' = 'TRUITT_INTERMEDIATE',
  'TrwEnterprizes' = 'TRW_ENTERPRIZES',
  'Tsa' = 'TSA',
  'Tsi,Inc' = 'TSI,_INC',
  'TsteDulcc' = 'TSTE_DULCC',
  'TvWeekly' = 'TV_WEEKLY',
  'Twiddy&Co/coastlandApplianc' = 'TWIDDY_&_CO/COASTLAND_APPLIANC',
  'Twiddy&CoRealtors' = 'TWIDDY_&_CO_REALTORS',
  'Twiddy&Company' = 'TWIDDY_&_COMPANY',
  'TwiffordLawFirm' = 'TWIFFORD_LAW_FIRM',
  'TwifordFuneralHomes' = 'TWIFORD_FUNERAL_HOMES',
  'TwifordLawFirm' = 'TWIFORD_LAW_FIRM',
  'TwifordSpecializedHauling' = 'TWIFORD_SPECIALIZED_HAULING',
  'TymoffMossArchitects' = 'TYMOFF_MOSS_ARCHITECTS',
  'TysingerMotorCo' = 'TYSINGER_MOTOR_CO',
  'U.s.Government' = 'U.S._GOVERNMENT',
  'U.s.PostalServ' = 'U.S._POSTAL_SERV',
  'U.s.Training' = 'U.S._TRAINING',
  'U.sArmy' = 'U.S_ARMY',
  'U.sDistrict' = 'U.S_DISTRICT',
  'U.sGovt' = 'U.S_GOVT',
  'U.sNavy' = 'U.S_NAVY',
  'USCoatGuard' = 'U_S_COAT_GUARD',
  'USTrainingCenter' = 'U_S_TRAINING_CENTER',
  'Uber' = 'UBER',
  'Ubs' = 'UBS',
  'Ufp' = 'UFP',
  'UhaulInternational' = 'UHAUL_INTERNATIONAL',
  'UltraLife' = 'ULTRA_LIFE',
  'Ultralife' = 'ULTRALIFE',
  'Umemployed' = 'UMEMPLOYED',
  'UmemployedAtThisTime' = 'UMEMPLOYED_AT_THIS_TIME',
  'UmployedAtThisTime' = 'UMPLOYED_AT_THIS_TIME',
  'UnFirstCorp' = 'UN_FIRST_CORP',
  'UncChapelHill' = 'UNC_CHAPEL_HILL',
  'UncrexHospital' = 'UNCREX_HOSPITAL',
  'Unemloyed' = 'UNEMLOYED',
  'Unemplyed' = 'UNEMPLYED',
  'Unempolyed' = 'UNEMPOLYED',
  'Unidyine' = 'UNIDYINE',
  'Unidyne' = 'UNIDYNE',
  'UnifiedWomensHealthcare' = 'UNIFIED_WOMENS_HEALTHCARE',
  'UnifirstCorp' = 'UNIFIRST_CORP',
  'Unilever' = 'UNILEVER',
  'UnileverBestFoods' = 'UNILEVER_BEST_FOODS',
  'UniqueImagingSolutions' = 'UNIQUE_IMAGING_SOLUTIONS',
  'UnitedAirlines' = 'UNITED_AIRLINES',
  'UnitedContractorsOfVa' = 'UNITED_CONTRACTORS_OF_VA',
  'UnitedDisposal' = 'UNITED_DISPOSAL',
  'UnitedExteriors' = 'UNITED_EXTERIORS',
  'UnitedHealthcare' = 'UNITED_HEALTHCARE',
  'UnitedJewishFederationOfTidewater' = 'UNITED_JEWISH_FEDERATION_OF_TIDEWATER',
  'UnitedLocal80' = 'UNITED_LOCAL_80',
  'UnitedMedicalEquipment' = 'UNITED_MEDICAL_EQUIPMENT',
  'UnitedMethodistChurch' = 'UNITED_METHODIST_CHURCH',
  'UnitedParcelService' = 'UNITED_PARCEL_SERVICE',
  'UnitedPropertyAssoc' = 'UNITED_PROPERTY_ASSOC',
  'UnitedRentals' = 'UNITED_RENTALS',
  'UnitedStateCoastGuard' = 'UNITED_STATE_COAST_GUARD',
  'UnitedStatesCoast' = 'UNITED_STATES_COAST',
  'UnitedStatesGypsumCo' = 'UNITED_STATES_GYPSUM_CO',
  'UnitedStatesNa' = 'UNITED_STATES_NA',
  'UnitedTurf' = 'UNITED_TURF',
  'UnitedWayLabs' = 'UNITED_WAY_LABS',
  'UnitedWestLabs' = 'UNITED_WEST_LABS',
  'UniversalForestProductsInc' = 'UNIVERSAL_FOREST_PRODUCTS_INC',
  'UniversityOfMemphis' = 'UNIVERSITY_OF_MEMPHIS',
  'UniversityOfPhoenix' = 'UNIVERSITY_OF_PHOENIX',
  'UpCenter' = 'UP_CENTER',
  'Upholstery&More' = 'UPHOLSTERY_&_MORE',
  'UpliftComprehensiveServices' = 'UPLIFT_COMPREHENSIVE_SERVICES',
  'UpsFreight' = 'UPS_FREIGHT',
  'UpsFrt' = 'UPS_FRT',
  'UpscaleRestaurant&Lounge' = 'UPSCALE_RESTAURANT_&_LOUNGE',
  'Upsf' = 'UPSF',
  'UrologyOfVa' = 'UROLOGY_OF_VA',
  'UrologyOfVirginia' = 'UROLOGY_OF_VIRGINIA',
  'Urs' = 'URS',
  'UrsSvcs' = 'URS_SVCS',
  'Us.CoastGuard' = 'US._COAST_GUARD',
  'UsAir' = 'US_AIR',
  'UsAirways' = 'US_AIRWAYS',
  'UsArmyAuditAgency' = 'US_ARMY_AUDIT_AGENCY',
  'UsArmyCorpOfEngineers' = 'US_ARMY_CORP_OF_ENGINEERS',
  'UsArmyCorpsOfEng' = 'US_ARMY_CORPS_OF_ENG',
  'UsArmyCorpsOfEngineers' = 'US_ARMY_CORPS_OF_ENGINEERS',
  'UsAutoParts' = 'US_AUTO_PARTS',
  'UsCoastGuard,m' = 'US_COAST_GUARD,M',
  'UsCoastGuardAviationLogisticsCenter' = 'US_COAST_GUARD_AVIATION_LOGISTICS_CENTER',
  'UsCoastGuardClinic' = 'US_COAST_GUARD_CLINIC',
  'UsCoastGuardExchange' = 'US_COAST_GUARD_EXCHANGE',
  'UsCoastGuardFinanceCenter' = 'US_COAST_GUARD_FINANCE_CENTER',
  'UsCoastGuardFinanceCtr' = 'US_COAST_GUARD_FINANCE_CTR',
  'UsCoastGuardReserve' = 'US_COAST_GUARD_RESERVE',
  'UsCoastGuardRetired' = 'US_COAST_GUARD_RETIRED',
  'UsCoastguardFinanceCenter' = 'US_COASTGUARD_FINANCE_CENTER',
  'UsCoatGuard' = 'US_COAT_GUARD',
  'UsCustom&BorderProtection' = 'US_CUSTOM_&_BORDER_PROTECTION',
  'UsDepartmentOfDefence' = 'US_DEPARTMENT_OF_DEFENCE',
  'UsDepartmentOfDefense' = 'US_DEPARTMENT_OF_DEFENSE',
  'UsDeptOfCommerce/noaa' = 'US_DEPT_OF_COMMERCE/NOAA',
  'UsDeptOfDefense' = 'US_DEPT_OF_DEFENSE',
  'UsDeptOfTheNavy' = 'US_DEPT_OF_THE_NAVY',
  'UsFacilities' = 'US_FACILITIES',
  'UsFedGov' = 'US_FED_GOV',
  'UsFederalReserveUsNavy' = 'US_FEDERAL_RESERVE_US_NAVY',
  'UsFood&DrugAdministration' = 'US_FOOD_&_DRUG_ADMINISTRATION',
  'UsFoods' = 'US_FOODS',
  'UsGovernment' = 'US_GOVERNMENT',
  'UsGovernmentCoastGuardBase' = 'US_GOVERNMENT_COAST_GUARD_BASE',
  'UsGovt' = 'US_GOVT',
  'UsGovt.' = 'US_GOVT.',
  'UsGvmt' = 'US_GVMT',
  'UsGypsumCo' = 'US_GYPSUM_CO',
  'UsHouseOfRepresentatives' = 'US_HOUSE_OF_REPRESENTATIVES',
  'UsMarinaCorp' = 'US_MARINA_CORP',
  'UsMarineCorps' = 'US_MARINE_CORPS',
  'UsMilitary' = 'US_MILITARY',
  'UsNavy,cta,s;amt' = 'US_NAVY_,CTA,S_;AMT',
  'UsNavyCivilServant' = 'US_NAVY_CIVIL_SERVANT',
  'UsNavyFireAndRescue' = 'US_NAVY_FIRE_AND_RESCUE',
  'UsNavyFleetForces' = 'US_NAVY_FLEET_FORCES',
  'UsNavyNavsea' = 'US_NAVY_NAVSEA',
  'UsNavyRetired' = 'US_NAVY_RETIRED',
  'UsOfficeOfPersonnelMgt' = 'US_OFFICE_OF_PERSONNEL_MGT',
  'UsOncologyNetwork' = 'US_ONCOLOGY_NETWORK',
  'UsPack' = 'US_PACK',
  'UsPatent&Trademark' = 'US_PATENT_&_TRADEMARK',
  'UsPits' = 'US_PITS',
  'UsPostOffice' = 'US_POST_OFFICE',
  'UsPostalServic' = 'US_POSTAL_SERVIC',
  'UsSeafarersUnion' = 'US_SEAFARERS_UNION',
  'UsSecurity' = 'US_SECURITY',
  'UsTermiteMoistureControl' = 'US_TERMITE_MOISTURE_CONTROL',
  'UsTraining' = 'US_TRAINING',
  'UsTrainingCenter' = 'US_TRAINING_CENTER',
  'UsTrainingCtr' = 'US_TRAINING_CTR',
  'UsTreasury' = 'US_TREASURY',
  'UsValteck' = 'US_VALTECK',
  'UsWaterWaysTransportation' = 'US_WATER_WAYS_TRANSPORTATION',
  'UsXpress' = 'US_XPRESS',
  'UsaDiscounters' = 'USA_DISCOUNTERS',
  'UsaFoods/TruckDriver' = 'USA_FOODS_/_TRUCK_DRIVER',
  'Usaa' = 'USAA',
  'Usace' = 'USACE',
  'Usaf' = 'USAF',
  'Usafr/cpt' = 'USAFR/CPT',
  'Uscg' = 'USCG',
  'UscgCivilian' = 'USCG_CIVILIAN',
  'UscgCommunityServiceCommand' = 'USCG_COMMUNITY_SERVICE_COMMAND',
  'UscgExchangeSystem' = 'USCG_EXCHANGE_SYSTEM',
  'UscgFinanceCenter' = 'USCG_FINANCE_CENTER',
  'UscgFinanceCtr' = 'USCG_FINANCE_CTR',
  'UscgReserves' = 'USCG_RESERVES',
  'Usda-nrcs' = 'USDA-NRCS',
  'UsgCorporation' = 'USG_CORPORATION',
  'UsiInsurance' = 'USI_INSURANCE',
  'Usis' = 'USIS',
  'UsmcForcesCommand' = 'USMC_FORCES_COMMAND',
  'Usn' = 'USN',
  'Usn/ad' = 'USN/AD',
  'UsnReserve' = 'USN_RESERVE',
  'Uspi' = 'USPI',
  'Usps' = 'USPS',
  'UspsGreerTransport' = 'USPS_GREER_TRANSPORT',
  'Ustc' = 'USTC',
  'UsuiInternationalCorp' = 'USUI_INTERNATIONAL_CORP',
  'UsuiIntlCorp' = 'USUI_INTL_CORP',
  'Utili-serve' = 'UTILI-SERVE',
  'V-dot' = 'V-DOT',
  'V.i.t' = 'V.I.T',
  'Va/ncLineX' = 'VA/NC_LINE_X',
  'VaAquariumMarineScienceCtr' = 'VA_AQUARIUM_MARINE_SCIENCE_CTR',
  'VaBchPublicSchools' = 'VA_BCH_PUBLIC_SCHOOLS',
  'VaBeachBeverag' = 'VA_BEACH_BEVERAG',
  'VaBeachBeverages' = 'VA_BEACH_BEVERAGES',
  'VaBeachCityPublicSchools' = 'VA_BEACH_CITY_PUBLIC_SCHOOLS',
  'VaBeachCitySh' = 'VA_BEACH_CITY_SH',
  'VaBeachFireDe' = 'VA_BEACH_FIRE_DE',
  'VaBeachGenDistCourt' = 'VA_BEACH_GEN_DIST_COURT',
  'VaBeachHumanServices' = 'VA_BEACH_HUMAN_SERVICES',
  'VaBeachMarble' = 'VA_BEACH_MARBLE',
  'VaBeachPsych' = 'VA_BEACH_PSYCH',
  'VaBeachPublic' = 'VA_BEACH_PUBLIC',
  'VaBeachPublicSchools' = 'VA_BEACH_PUBLIC_SCHOOLS',
  'VaBeachSchools' = 'VA_BEACH_SCHOOLS',
  'VaBeachSherriffsOffice' = 'VA_BEACH_SHERRIFFS_OFFICE',
  'VaBeachSpca' = 'VA_BEACH_SPCA',
  'VaCenterForWomen' = 'VA_CENTER_FOR_WOMEN',
  'VaDentalLab' = 'VA_DENTAL_LAB',
  'VaDepartmentOfForestry' = 'VA_DEPARTMENT_OF_FORESTRY',
  'VaDeptOfCorre' = 'VA_DEPT_OF_CORRE',
  'VaDeptOfCorrections' = 'VA_DEPT_OF_CORRECTIONS',
  'VaDeptOfEnvironmentalQlty' = 'VA_DEPT_OF_ENVIRONMENTAL_QLTY',
  'VaDeptOfForensicScience' = 'VA_DEPT_OF_FORENSIC_SCIENCE',
  'VaDeptOfHealt' = 'VA_DEPT_OF_HEALT',
  'VaDeptOfJuvenileJustice' = 'VA_DEPT_OF_JUVENILE_JUSTICE',
  'VaDeptOfLabor' = 'VA_DEPT_OF_LABOR',
  'VaDeptOfTax' = 'VA_DEPT_OF_TAX',
  'VaDeptOfTaxation' = 'VA_DEPT_OF_TAXATION',
  'VaDoc' = 'VA_DOC',
  'VaDominionPowe' = 'VA_DOMINION_POWE',
  'VaDoorInc' = 'VA_DOOR_INC',
  'VaFireDepartment' = 'VA_FIRE_DEPARTMENT',
  'VaHomeTitle&Settlements' = 'VA_HOME_TITLE_&_SETTLEMENTS',
  'VaInternationalTerminals' = 'VA_INTERNATIONAL_TERMINALS',
  'VaInternationlTerminials' = 'VA_INTERNATIONL_TERMINIALS',
  'VaIntlGateway' = 'VA_INTL_GATEWAY',
  'VaIntlTerminal' = 'VA_INTL_TERMINAL',
  'VaLottery' = 'VA_LOTTERY',
  'VaMedCtr' = 'VA_MED_CTR',
  'VaMedicalCenter' = 'VA_MEDICAL_CENTER',
  'VaNaturalGas' = 'VA_NATURAL_GAS',
  'VaOncologyAssoc' = 'VA_ONCOLOGY_ASSOC',
  'VaOphthalmology' = 'VA_OPHTHALMOLOGY',
  'VaOphthamologyAssoc' = 'VA_OPHTHAMOLOGY_ASSOC',
  'VaPaving' = 'VA_PAVING',
  'VaPilotMediaCo' = 'VA_PILOT_MEDIA_CO',
  'VaPortAuthority' = 'VA_PORT_AUTHORITY',
  'VaPower' = 'VA_POWER',
  'VaSmallBusinessSolutions' = 'VA_SMALL_BUSINESS_SOLUTIONS',
  'VaStateDeptOfCorrections' = 'VA_STATE_DEPT_OF_CORRECTIONS',
  'VaStatePolice' = 'VA_STATE_POLICE',
  'VaWesleyanCollege' = 'VA_WESLEYAN_COLLEGE',
  'VaWeslyanCollege' = 'VA_WESLYAN_COLLEGE',
  'VaWholesale' = 'VA_WHOLESALE',
  'VabCitySchools' = 'VAB_CITY_SCHOOLS',
  'VabFireDept' = 'VAB_FIRE_DEPT',
  'VabPublicSchools' = 'VAB_PUBLIC_SCHOOLS',
  'VacationStore' = 'VACATION_STORE',
  'ValiantIntegrateoServices' = 'VALIANT_INTEGRATEO_SERVICES',
  'ValinosClearing' = 'VALINOS_CLEARING',
  'Valionas' = 'VALIONAS',
  'ValkyrieEnterprises' = 'VALKYRIE_ENTERPRISES',
  'ValueAddedDistributorsInc' = 'VALUE_ADDED_DISTRIBUTORS_INC',
  'ValueCityFurniture' = 'VALUE_CITY_FURNITURE',
  'ValueOptions' = 'VALUE_OPTIONS',
  'VanFarms' = 'VAN_FARMS',
  'VanLineBunkering,Inc' = 'VAN_LINE_BUNKERING,_INC',
  'VanceAthleticSupplyCo,Inc' = 'VANCE_ATHLETIC_SUPPLY_CO,_INC',
  'VandanaDhawanMd' = 'VANDANA_DHAWAN_MD',
  'VaneBrothers' = 'VANE_BROTHERS',
  'VaneLineBunkering' = 'VANE_LINE_BUNKERING',
  'VansPizza' = 'VANS_PIZZA',
  'VarietyWholesalers' = 'VARIETY_WHOLESALERS',
  'Variq' = 'VARIQ',
  'VbCityPublicSchools' = 'VB_CITY_PUBLIC_SCHOOLS',
  'VbCitySchools' = 'VB_CITY_SCHOOLS',
  'VbNeptuneFestival' = 'VB_NEPTUNE_FESTIVAL',
  'VbPublicSchools' = 'VB_PUBLIC_SCHOOLS',
  'VbPublicSchools/medLeave' = 'VB_PUBLIC_SCHOOLS/MED_LEAVE',
  'VbcPsCityPublicSchoolsCox' = 'VBC_PS_CITY_PUBLIC_SCHOOLS_COX',
  'Vbcps' = 'VBCPS',
  'Vbps' = 'VBPS',
  'Vcu-mcvp' = 'VCU-MCVP',
  'Vcw' = 'VCW',
  'Vdot' = 'VDOT',
  'VectorCsp' = 'VECTOR_CSP',
  'Velocity' = 'VELOCITY',
  'VentureTours' = 'VENTURE_TOURS',
  'VerizonBusiness' = 'VERIZON_BUSINESS',
  'VerizonCommunications' = 'VERIZON_COMMUNICATIONS',
  'VerizonWireless' = 'VERIZON_WIRELESS',
  'Verizons' = 'VERIZONS',
  'VersabilityResources,Inc' = 'VERSABILITY_RESOURCES,_INC',
  'VeteransOfFore' = 'VETERANS_OF_FORE',
  'Vhb' = 'VHB',
  'Viasys' = 'VIASYS',
  'Vico' = 'VICO',
  'VicoCo' = 'VICO_CO',
  'VicoConstructionCorp' = 'VICO_CONSTRUCTION_CORP',
  'VicoCont.Inc.' = 'VICO_CONT._INC.',
  'VictoryBaptistChurch' = 'VICTORY_BAPTIST_CHURCH',
  'VictoryBowlingLanes' = 'VICTORY_BOWLING_LANES',
  'VictoryChevrolet' = 'VICTORY_CHEVROLET',
  'VictoryChristianSchool' = 'VICTORY_CHRISTIAN_SCHOOL',
  'Victra-verizon' = 'VICTRA-VERIZON',
  'VidantChowanHospital' = 'VIDANT_CHOWAN_HOSPITAL',
  'VidantGeneralSurgery' = 'VIDANT_GENERAL_SURGERY',
  'VidantHealth' = 'VIDANT_HEALTH',
  'VidantMedicalCenter' = 'VIDANT_MEDICAL_CENTER',
  'VidentHealth' = 'VIDENT_HEALTH',
  'ViginiaDermatology' = 'VIGINIA_DERMATOLOGY',
  'VillageBeachClub' = 'VILLAGE_BEACH_CLUB',
  'VillageInn' = 'VILLAGE_INN',
  'VillageRealty' = 'VILLAGE_REALTY',
  'VinickChiropractic' = 'VINICK_CHIROPRACTIC',
  'ViperHairBar' = 'VIPER_HAIR_BAR',
  'VirginiaAbc' = 'VIRGINIA_ABC',
  'VirginiaAir' = 'VIRGINIA_AIR',
  'VirginiaBeachCityPublicSch' = 'VIRGINIA_BEACH_CITY_PUBLIC_SCH',
  'VirginiaBeachCityPublicSchools' = 'VIRGINIA_BEACH_CITY_PUBLIC_SCHOOLS',
  'VirginiaBeachCommunityDevelopmentCorp' = 'VIRGINIA_BEACH_COMMUNITY_DEVELOPMENT_CORP',
  'VirginiaBeachDepartmentOfBehavioralHealth' = 'VIRGINIA_BEACH_DEPARTMENT_OF_BEHAVIORAL_HEALTH',
  'VirginiaBeachPoliceDept' = 'VIRGINIA_BEACH_POLICE_DEPT',
  'VirginiaBeachPublicDefenderOffice' = 'VIRGINIA_BEACH_PUBLIC_DEFENDER_OFFICE',
  'VirginiaBeachPublicSchool' = 'VIRGINIA_BEACH_PUBLIC_SCHOOL',
  'VirginiaBeachPublicSchools' = 'VIRGINIA_BEACH_PUBLIC_SCHOOLS',
  'VirginiaBeachSchool' = 'VIRGINIA_BEACH_SCHOOL',
  'VirginiaBeachSchools' = 'VIRGINIA_BEACH_SCHOOLS',
  'VirginiaConf.UnitedMethodistChurch' = 'VIRGINIA_CONF._UNITED_METHODIST_CHURCH',
  'VirginiaContractorsGroup' = 'VIRGINIA_CONTRACTORS_GROUP',
  'VirginiaDeptOfHealthProfessions' = 'VIRGINIA_DEPT_OF_HEALTH_PROFESSIONS',
  'VirginiaDermatology' = 'VIRGINIA_DERMATOLOGY',
  'VirginiaEyeConsultants' = 'VIRGINIA_EYE_CONSULTANTS',
  'VirginiaHomeForAdults' = 'VIRGINIA_HOME_FOR_ADULTS',
  'VirginiaIndigentDefense' = 'VIRGINIA_INDIGENT_DEFENSE',
  'VirginiaIndigentDefenseCommission' = 'VIRGINIA_INDIGENT_DEFENSE_COMMISSION',
  'VirginiaInternationalTerminal' = 'VIRGINIA_INTERNATIONAL_TERMINAL',
  'VirginiaIntlTerminal' = 'VIRGINIA_INTL_TERMINAL',
  'VirginiaIntlTerminals' = 'VIRGINIA_INTL_TERMINALS',
  'VirginiaMarineResourcesCommission' = 'VIRGINIA_MARINE_RESOURCES_COMMISSION',
  'VirginiaMaterial1Gas' = 'VIRGINIA_MATERIAL_1_GAS',
  'VirginiaMaterials' = 'VIRGINIA_MATERIALS',
  'VirginiaNaturalGas' = 'VIRGINIA_NATURAL_GAS',
  'VirginiaOncologyAssoc' = 'VIRGINIA_ONCOLOGY_ASSOC',
  'VirginiaOncologyAssociates' = 'VIRGINIA_ONCOLOGY_ASSOCIATES',
  'VirginiaOrtho&SpineSpec' = 'VIRGINIA_ORTHO_&_SPINE_SPEC',
  'VirginiaParoleBoard' = 'VIRGINIA_PAROLE_BOARD',
  'VirginiaPaving' = 'VIRGINIA_PAVING',
  'VirginiaPediatricEye' = 'VIRGINIA_PEDIATRIC_EYE',
  'VirginiaPremier' = 'VIRGINIA_PREMIER',
  'VirginiaTip,Llc' = 'VIRGINIA_TIP,_LLC',
  'VirginiaWesleya' = 'VIRGINIA_WESLEYA',
  'VirginiaWesleyanCollege' = 'VIRGINIA_WESLEYAN_COLLEGE',
  'VirginiaWomensWellness' = 'VIRGINIA_WOMENS_WELLNESS',
  'VirginiaZoologicalSociety' = 'VIRGINIA_ZOOLOGICAL_SOCIETY',
  'VirginianPilot' = 'VIRGINIAN_PILOT',
  'VisionscapesLandDesign' = 'VISIONSCAPES_LAND_DESIGN',
  'VisitingAngels' = 'VISITING_ANGELS',
  'Vit&W' = 'VIT_&_W',
  'Vms' = 'VMS',
  'Voa' = 'VOA',
  'VolvoMedAssoc' = 'VOLVO_MED_ASSOC',
  'VolvoPenta' = 'VOLVO_PENTA',
  'VolvoRents' = 'VOLVO_RENTS',
  'VrsCorportation' = 'VRS_CORPORTATION',
  'Vsd,Llc' = 'VSD,_LLC',
  'VsdLlc' = 'VSD_LLC',
  'VtArec' = 'VT_AREC',
  'VtGroup' = 'VT_GROUP',
  'VtMilcom' = 'VT_MILCOM',
  'VulcanMaterials' = 'VULCAN_MATERIALS',
  'VulcanMaterialsCompany' = 'VULCAN_MATERIALS_COMPANY',
  'W&LMailService' = 'W_&_L_MAIL_SERVICE',
  'W.F.Magann' = 'W._F._MAGANN',
  'W.TidewaterComm.ServiceBoa' = 'W._TIDEWATER_COMM._SERVICE_BOA',
  'W.f.MagannCorp' = 'W.F._MAGANN_CORP',
  'W.f.magann' = 'W.F.MAGANN',
  'W.f.magannCorp' = 'W.F.MAGANN_CORP',
  'WECurling' = 'W_E_CURLING',
  'WMJordanCo' = 'W_M_JORDAN_CO',
  'WPTaylor&CoInc' = 'W_P_TAYLOR_&_CO_INC',
  'Wachovia' = 'WACHOVIA',
  'WachoviaBank' = 'WACHOVIA_BANK',
  'WachoviaSecurities' = 'WACHOVIA_SECURITIES',
  'WachoviaWellsFargoCompany' = 'WACHOVIA_WELLS_FARGO_COMPANY',
  'WaffContracting' = 'WAFF_CONTRACTING',
  'WaffelHouse,Inc' = 'WAFFEL_HOUSE,_INC',
  'WaffleHouse' = 'WAFFLE_HOUSE',
  'WagnerMacula&RetinaCenter' = 'WAGNER_MACULA_&_RETINA_CENTER',
  'WainwrightRealEstate' = 'WAINWRIGHT_REAL_ESTATE',
  'WakeCountyDistrictAttorney' = 'WAKE_COUNTY_DISTRICT_ATTORNEY',
  'Wal-mart' = 'WAL-MART',
  'WalMart' = 'WAL_MART',
  'WalfonGroveAmeZionChurch' = 'WALFON_GROVE_AME_ZION_CHURCH',
  'Walgreen' = 'WALGREEN',
  'Walker&LabergeGlassCo' = 'WALKER_&_LABERGE_GLASS_CO',
  'WallaceTechnologies' = 'WALLACE_TECHNOLOGIES',
  'Walmarat' = 'WALMARAT',
  'Walmart/dcdc/compass' = 'WALMART/DCDC/COMPASS',
  'Walmart/medLeave' = 'WALMART/MED_LEAVE',
  'WalmartPharmacy' = 'WALMART_PHARMACY',
  'WalmartSuperCenter' = 'WALMART_SUPER_CENTER',
  'WalmartVision' = 'WALMART_VISION',
  'WaltsBailBonds' = 'WALTS_BAIL_BONDS',
  'WardsCornerPediatrics' = 'WARDS_CORNER_PEDIATRICS',
  'WareInsurance' = 'WARE_INSURANCE',
  'WareOnEarthCommunications' = 'WARE_ON_EARTH_COMMUNICATIONS',
  'WarrenAutoRepair' = 'WARREN_AUTO_REPAIR',
  'WartsilaDefense' = 'WARTSILA_DEFENSE',
  'WashingtonCoNc' = 'WASHINGTON_CO_NC',
  'WastCoast' = 'WAST_COAST',
  'WasteIndustries' = 'WASTE_INDUSTRIES',
  'WasteManagement' = 'WASTE_MANAGEMENT',
  'WasteMgt' = 'WASTE_MGT',
  'WaterHut' = 'WATER_HUT',
  'Watermark' = 'WATERMARK',
  'WaterwayMaterialsRcycling' = 'WATERWAY_MATERIALS_RCYCLING',
  'WaterwaySurvey&Eng' = 'WATERWAY_SURVEY_&_ENG',
  'WatsonElectric' = 'WATSON_ELECTRIC',
  'WatsonElectrica' = 'WATSON_ELECTRICA',
  'WatsonElectricalConstCoLlc' = 'WATSON_ELECTRICAL_CONST_CO_LLC',
  'WatsonPharmaceuticals' = 'WATSON_PHARMACEUTICALS',
  'WaveChurch' = 'WAVE_CHURCH',
  'Wavy-tv' = 'WAVY-TV',
  'Wawa' = 'WAWA',
  'Wb&E' = 'WB_&_E',
  'WbAndEConstCo' = 'WB_AND_E_CONST_CO',
  'WeCareForKids' = 'WE_CARE_FOR_KIDS',
  'WeCurling' = 'WE_CURLING',
  'WeMeiggs&SonLogging' = 'WE_MEIGGS_&_SON_LOGGING',
  'WeatherMakers' = 'WEATHER_MAKERS',
  'WebcoDistributionInc' = 'WEBCO_DISTRIBUTION_INC',
  'WebsterElv' = 'WEBSTER_ELV',
  'Weconnect' = 'WECONNECT',
  'WeeksMarine' = 'WEEKS_MARINE',
  'WeeksvilleElemetry' = 'WEEKSVILLE_ELEMETRY',
  'WeeksvilleGrocery' = 'WEEKSVILLE_GROCERY',
  'WeightWatchersIntl' = 'WEIGHT_WATCHERS_INTL',
  'WeldexSalesCorp' = 'WELDEX_SALES_CORP',
  'Wellpath' = 'WELLPATH',
  'WellpointAmerigroup' = 'WELLPOINT_AMERIGROUP',
  'WellsFargoBank' = 'WELLS_FARGO_BANK',
  'WellsFargoDealerServices' = 'WELLS_FARGO_DEALER_SERVICES',
  'WelshTops' = 'WELSH_TOPS',
  'Wendys' = 'WENDYS',
  'Wercore' = 'WERCORE',
  'West' = 'WEST',
  'WestRock' = 'WEST_ROCK',
  'WesternBranchDiesel' = 'WESTERN_BRANCH_DIESEL',
  'WesternDepartmentOfAging' = 'WESTERN_DEPARTMENT_OF_AGING',
  'WesternTdwtrFreeClinic' = 'WESTERN_TDWTR_FREE_CLINIC',
  'WesternTidewaterCsb' = 'WESTERN_TIDEWATER_CSB',
  'WesternTidewaterHealthDist' = 'WESTERN_TIDEWATER_HEALTH_DIST',
  'WestministerCanterbury' = 'WESTMINISTER_CANTERBURY',
  'WestminsterCanterbury' = 'WESTMINSTER_CANTERBURY',
  'WexfordHealth' = 'WEXFORD_HEALTH',
  'Wheelabrator' = 'WHEELABRATOR',
  'WheelbargerRepairSvc' = 'WHEELBARGER_REPAIR_SVC',
  'WhiteStoneSecurity' = 'WHITE_STONE_SECURITY',
  'WhitehurstSandCompany' = 'WHITEHURST_SAND_COMPANY',
  'WhitehurstSnadCompany' = 'WHITEHURST_SNAD_COMPANY',
  'WhitesGardenCenter' = 'WHITES_GARDEN_CENTER',
  'WhitesNursery&Greenhouses' = 'WHITES_NURSERY_&_GREENHOUSES',
  'WhitesNursery' = 'WHITES_NURSERY',
  'Wilcohess' = 'WILCOHESS',
  'WildBirdUnlimited' = 'WILD_BIRD_UNLIMITED',
  'WildWingCafe' = 'WILD_WING_CAFE',
  'WilekiCorporation' = 'WILEKI_CORPORATION',
  'WilliamE.Wood' = 'WILLIAM_E._WOOD',
  'WilliamE.WoodAndAssoc' = 'WILLIAM_E._WOOD_AND_ASSOC',
  'WilliamEWood&Assoc' = 'WILLIAM_E_WOOD_&_ASSOC',
  'WilliamEWood' = 'WILLIAM_E_WOOD',
  'WilliamHMorganJrAtty' = 'WILLIAM_H_MORGAN_JR_ATTY',
  'WilliamMullins' = 'WILLIAM_MULLINS',
  'WilliamsElectri' = 'WILLIAMS_ELECTRI',
  'WilliamsElectric' = 'WILLIAMS_ELECTRIC',
  'WillieREthridgeSeafoodCompany' = 'WILLIE_R_ETHRIDGE_SEAFOOD_COMPANY',
  'WillsAndWillsPc' = 'WILLS_AND_WILLS_PC',
  'WilsonTrucking' = 'WILSON_TRUCKING',
  'WimcoCorp' = 'WIMCO_CORP',
  'WindborneProductions' = 'WINDBORNE_PRODUCTIONS',
  'WindellFrancisRealty' = 'WINDELL_FRANCIS_REALTY',
  'WindsorGymnastics' = 'WINDSOR_GYMNASTICS',
  'WingEnterprises' = 'WING_ENTERPRISES',
  'Wingate' = 'WINGATE',
  'WinginItCafe' = 'WINGIN_IT_CAFE',
  'WingsAcrossAmerica' = 'WINGS_ACROSS_AMERICA',
  'WinkeOrtho' = 'WINKE_ORTHO',
  'WinnNurseryOfVa' = 'WINN_NURSERY_OF_VA',
  'WinslowMem.NursingCntr' = 'WINSLOW_MEM._NURSING_CNTR',
  'WinslowMemorialHome' = 'WINSLOW_MEMORIAL_HOME',
  'WinslowMemorialNursingCenter' = 'WINSLOW_MEMORIAL_NURSING_CENTER',
  'WinslowNursing' = 'WINSLOW_NURSING',
  'WinsupplyInc' = 'WINSUPPLY_INC',
  'WiseMotors' = 'WISE_MOTORS',
  'WmJordan' = 'WM_JORDAN',
  'WmSchlosser' = 'WM_SCHLOSSER',
  'WmsElec/moyock' = 'WMS_ELEC/MOYOCK',
  'WodaCooperCompanies' = 'WODA_COOPER_COMPANIES',
  'WolcottRiversPc' = 'WOLCOTT_RIVERS_PC',
  'WolfCreekFabrication' = 'WOLF_CREEK_FABRICATION',
  'WoodContractingMechanicalServices' = 'WOOD_CONTRACTING_MECHANICAL_SERVICES',
  'WoodardOrthodontics' = 'WOODARD_ORTHODONTICS',
  'WoodfinOilCo' = 'WOODFIN_OIL_CO',
  'WoodmenOfAmericaLifeIns' = 'WOODMEN_OF_AMERICA_LIFE_INS',
  'WoodwindsPlusInc' = 'WOODWINDS_PLUS_INC',
  'WorkFromHome' = 'WORK_FROM_HOME',
  'WorkersComp' = 'WORKERS_COMP',
  'WorldClassRealty' = 'WORLD_CLASS_REALTY',
  'WorldFuelServices' = 'WORLD_FUEL_SERVICES',
  'WorldOfficeSystemsInc' = 'WORLD_OFFICE_SYSTEMS_INC',
  'WorldTravelHoldings' = 'WORLD_TRAVEL_HOLDINGS',
  'WorldwideTechServices' = 'WORLDWIDE_TECH_SERVICES',
  'Wpm' = 'WPM',
  'WrSystems' = 'WR_SYSTEMS',
  'WrSystemsLtd' = 'WR_SYSTEMS_LTD',
  'WrWinslow' = 'WR_WINSLOW',
  'WrWinslowMemorialHome' = 'WR_WINSLOW_MEMORIAL_HOME',
  'Wright' = 'WRIGHT',
  'WspUsa' = 'WSP_USA',
  'Wtcsb' = 'WTCSB',
  'WtkrTv3' = 'WTKR_TV3',
  'Wyle' = 'WYLE',
  'WyndhamKingsgate' = 'WYNDHAM_KINGSGATE',
  'Xe/presidential' = 'XE/PRESIDENTIAL',
  'XeCompany' = 'XE_COMPANY',
  'XeServices' = 'XE_SERVICES',
  'XeServices/UsTrainingCente' = 'XE_SERVICES/_US_TRAINING_CENTE',
  'XenithBank' = 'XENITH_BANK',
  'Xerox' = 'XEROX',
  'XeroxCorp' = 'XEROX_CORP',
  'XpoDrayage,Inc' = 'XPO_DRAYAGE,_INC',
  'XpoLogistics' = 'XPO_LOGISTICS',
  'XpressTowing' = 'XPRESS_TOWING',
  'XrayImagingOfChesapeake' = 'XRAY_IMAGING_OF_CHESAPEAKE',
  'XylemGoodwinPumps' = 'XYLEM_GOODWIN_PUMPS',
  'XylemWateringSolutions' = 'XYLEM_WATERING_SOLUTIONS',
  'YanaMinaAmerica' = 'YANA_MINA_AMERICA',
  'YardDogsLand&Lawn' = 'YARD_DOGS_LAND_&_LAWN',
  'Ymca' = 'YMCA',
  'YmcaBeforeAndAfter' = 'YMCA_BEFORE_AND_AFTER',
  'YmcaGreatBridge' = 'YMCA_GREAT_BRIDGE',
  'YmcaOfCurrituck' = 'YMCA_OF_CURRITUCK',
  'YmcaOfSoHamptonRds' = 'YMCA_OF_SO_HAMPTON_RDS',
  'YmcaOfSouthHamptonRoads' = 'YMCA_OF_SOUTH_HAMPTON_ROADS',
  'YmcaShr' = 'YMCA_SHR',
  'YnotPizza' = 'YNOT_PIZZA',
  'YorkLabel' = 'YORK_LABEL',
  'YoungWilliamsPc' = 'YOUNG_WILLIAMS_PC',
  'Yrc' = 'YRC',
  'ZeidersEnterprises,Inc' = 'ZEIDERS_ENTERPRISES,_INC',
  'Zenetex' = 'ZENETEX',
  'ZenoraNailSalon' = 'ZENORA_NAIL_SALON',
  'ZepManufacturin' = 'ZEP_MANUFACTURIN',
  'ZerosSubs' = 'ZEROS_SUBS',
  'ZimAmericanIntegShipSvcs' = 'ZIM_AMERICAN_INTEG_SHIP_SVCS',
  'ZimAmericanShippingServices' = 'ZIM_AMERICAN_SHIPPING_SERVICES',
  'ZimShipping' = 'ZIM_SHIPPING',
  'ZimShippingCo' = 'ZIM_SHIPPING_CO',
  'ZimShopping' = 'ZIM_SHOPPING',
  'ZydronLawFirm' = 'ZYDRON_LAW_FIRM',
}

export interface EmployerFormFieldValue {
  employer: Employer;
  employerRaw: string;
}
